// Copyright Exafunction, Inc.
import { Duration, Message, proto3, protoInt64, Timestamp } from "@bufbuild/protobuf";
/**
 * Source of completion generations.
 * NOTE: If adding a new provider source, please make sure to check the following:
 * - getCompletionProviderSourceConfig (exa/api_server/rpcs_completion.go)
 * - isCommandProviderSource (exa/go_utils/codeium_common_utils.go)
 *
 * @generated from enum exa.codeium_common_pb.ProviderSource
 */
export var ProviderSource;
(function (ProviderSource) {
    /**
     * @generated from enum value: PROVIDER_SOURCE_UNSPECIFIED = 0;
     */
    ProviderSource[ProviderSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PROVIDER_SOURCE_AUTOCOMPLETE = 1;
     */
    ProviderSource[ProviderSource["AUTOCOMPLETE"] = 1] = "AUTOCOMPLETE";
    /**
     * @generated from enum value: PROVIDER_SOURCE_CHAT = 2;
     */
    ProviderSource[ProviderSource["CHAT"] = 2] = "CHAT";
    /**
     * @generated from enum value: PROVIDER_SOURCE_COMMAND_GENERATE = 4;
     */
    ProviderSource[ProviderSource["COMMAND_GENERATE"] = 4] = "COMMAND_GENERATE";
    /**
     * @generated from enum value: PROVIDER_SOURCE_COMMAND_EDIT = 5;
     */
    ProviderSource[ProviderSource["COMMAND_EDIT"] = 5] = "COMMAND_EDIT";
    /**
     * NOTE: The external feature this is referring to changed on 2024/08/16.
     * Legacy Supercomplete is fully deprecated.
     *
     * @generated from enum value: PROVIDER_SOURCE_SUPERCOMPLETE = 6;
     */
    ProviderSource[ProviderSource["SUPERCOMPLETE"] = 6] = "SUPERCOMPLETE";
    /**
     * @generated from enum value: PROVIDER_SOURCE_COMMAND_PLAN = 7;
     */
    ProviderSource[ProviderSource["COMMAND_PLAN"] = 7] = "COMMAND_PLAN";
    /**
     * @generated from enum value: PROVIDER_SOURCE_QUERY = 8;
     */
    ProviderSource[ProviderSource["QUERY"] = 8] = "QUERY";
    /**
     * @generated from enum value: PROVIDER_SOURCE_FAST_APPLY = 9;
     */
    ProviderSource[ProviderSource["FAST_APPLY"] = 9] = "FAST_APPLY";
    /**
     * @generated from enum value: PROVIDER_SOURCE_COMMAND_TERMINAL = 10;
     */
    ProviderSource[ProviderSource["COMMAND_TERMINAL"] = 10] = "COMMAND_TERMINAL";
    /**
     * @generated from enum value: PROVIDER_SOURCE_TAB_JUMP = 11;
     */
    ProviderSource[ProviderSource["TAB_JUMP"] = 11] = "TAB_JUMP";
    /**
     * @generated from enum value: PROVIDER_SOURCE_CASCADE = 12;
     */
    ProviderSource[ProviderSource["CASCADE"] = 12] = "CASCADE";
})(ProviderSource || (ProviderSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(ProviderSource)
proto3.util.setEnumType(ProviderSource, "exa.codeium_common_pb.ProviderSource", [
    { no: 0, name: "PROVIDER_SOURCE_UNSPECIFIED" },
    { no: 1, name: "PROVIDER_SOURCE_AUTOCOMPLETE" },
    { no: 2, name: "PROVIDER_SOURCE_CHAT" },
    { no: 4, name: "PROVIDER_SOURCE_COMMAND_GENERATE" },
    { no: 5, name: "PROVIDER_SOURCE_COMMAND_EDIT" },
    { no: 6, name: "PROVIDER_SOURCE_SUPERCOMPLETE" },
    { no: 7, name: "PROVIDER_SOURCE_COMMAND_PLAN" },
    { no: 8, name: "PROVIDER_SOURCE_QUERY" },
    { no: 9, name: "PROVIDER_SOURCE_FAST_APPLY" },
    { no: 10, name: "PROVIDER_SOURCE_COMMAND_TERMINAL" },
    { no: 11, name: "PROVIDER_SOURCE_TAB_JUMP" },
    { no: 12, name: "PROVIDER_SOURCE_CASCADE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.PromptElementKind
 */
export var PromptElementKind;
(function (PromptElementKind) {
    /**
     * @generated from enum value: PROMPT_ELEMENT_KIND_UNSPECIFIED = 0;
     */
    PromptElementKind[PromptElementKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PROMPT_ELEMENT_KIND_FILE_MARKER = 2;
     */
    PromptElementKind[PromptElementKind["FILE_MARKER"] = 2] = "FILE_MARKER";
    /**
     * @generated from enum value: PROMPT_ELEMENT_KIND_OTHER_DOCUMENT = 4;
     */
    PromptElementKind[PromptElementKind["OTHER_DOCUMENT"] = 4] = "OTHER_DOCUMENT";
    /**
     * Text from the main document before the cursor.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_BEFORE_CURSOR = 5;
     */
    PromptElementKind[PromptElementKind["BEFORE_CURSOR"] = 5] = "BEFORE_CURSOR";
    /**
     * Text from the main document after the cursor.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_AFTER_CURSOR = 7;
     */
    PromptElementKind[PromptElementKind["AFTER_CURSOR"] = 7] = "AFTER_CURSOR";
    /**
     * FIM tokens (prefix, middle, suffix but with <| before and |> after).
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_FIM = 8;
     */
    PromptElementKind[PromptElementKind["FIM"] = 8] = "FIM";
    /**
     * @generated from enum value: PROMPT_ELEMENT_KIND_SOT = 9;
     */
    PromptElementKind[PromptElementKind["SOT"] = 9] = "SOT";
    /**
     * @generated from enum value: PROMPT_ELEMENT_KIND_EOT = 10;
     */
    PromptElementKind[PromptElementKind["EOT"] = 10] = "EOT";
    /**
     * Context from context module.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_CODE_CONTEXT_ITEM = 13;
     */
    PromptElementKind[PromptElementKind["CODE_CONTEXT_ITEM"] = 13] = "CODE_CONTEXT_ITEM";
    /**
     * Instruction.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_INSTRUCTION = 14;
     */
    PromptElementKind[PromptElementKind["INSTRUCTION"] = 14] = "INSTRUCTION";
    /**
     * User code selection.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_SELECTION = 15;
     */
    PromptElementKind[PromptElementKind["SELECTION"] = 15] = "SELECTION";
    /**
     * Trajectory step.
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_TRAJECTORY_STEP = 16;
     */
    PromptElementKind[PromptElementKind["TRAJECTORY_STEP"] = 16] = "TRAJECTORY_STEP";
    /**
     * Active document region (prefix + suffix)
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_ACTIVE_DOCUMENT = 17;
     */
    PromptElementKind[PromptElementKind["ACTIVE_DOCUMENT"] = 17] = "ACTIVE_DOCUMENT";
    /**
     * Message that's already been cached
     *
     * @generated from enum value: PROMPT_ELEMENT_KIND_CACHED_MESSAGE = 18;
     */
    PromptElementKind[PromptElementKind["CACHED_MESSAGE"] = 18] = "CACHED_MESSAGE";
})(PromptElementKind || (PromptElementKind = {}));
// Retrieve enum metadata with: proto3.getEnumType(PromptElementKind)
proto3.util.setEnumType(PromptElementKind, "exa.codeium_common_pb.PromptElementKind", [
    { no: 0, name: "PROMPT_ELEMENT_KIND_UNSPECIFIED" },
    { no: 2, name: "PROMPT_ELEMENT_KIND_FILE_MARKER" },
    { no: 4, name: "PROMPT_ELEMENT_KIND_OTHER_DOCUMENT" },
    { no: 5, name: "PROMPT_ELEMENT_KIND_BEFORE_CURSOR" },
    { no: 7, name: "PROMPT_ELEMENT_KIND_AFTER_CURSOR" },
    { no: 8, name: "PROMPT_ELEMENT_KIND_FIM" },
    { no: 9, name: "PROMPT_ELEMENT_KIND_SOT" },
    { no: 10, name: "PROMPT_ELEMENT_KIND_EOT" },
    { no: 13, name: "PROMPT_ELEMENT_KIND_CODE_CONTEXT_ITEM" },
    { no: 14, name: "PROMPT_ELEMENT_KIND_INSTRUCTION" },
    { no: 15, name: "PROMPT_ELEMENT_KIND_SELECTION" },
    { no: 16, name: "PROMPT_ELEMENT_KIND_TRAJECTORY_STEP" },
    { no: 17, name: "PROMPT_ELEMENT_KIND_ACTIVE_DOCUMENT" },
    { no: 18, name: "PROMPT_ELEMENT_KIND_CACHED_MESSAGE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.PromptAnnotationKind
 */
export var PromptAnnotationKind;
(function (PromptAnnotationKind) {
    /**
     * @generated from enum value: PROMPT_ANNOTATION_KIND_UNSPECIFIED = 0;
     */
    PromptAnnotationKind[PromptAnnotationKind["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Code region usable for speculative copy
     *
     * @generated from enum value: PROMPT_ANNOTATION_KIND_COPY = 1;
     */
    PromptAnnotationKind[PromptAnnotationKind["COPY"] = 1] = "COPY";
    /**
     * Prompt cacheable portion of the prompt. This should have
     * byte_offset_start=0 since only prefixes are cacheable.
     *
     * @generated from enum value: PROMPT_ANNOTATION_KIND_PROMPT_CACHE = 2;
     */
    PromptAnnotationKind[PromptAnnotationKind["PROMPT_CACHE"] = 2] = "PROMPT_CACHE";
})(PromptAnnotationKind || (PromptAnnotationKind = {}));
// Retrieve enum metadata with: proto3.getEnumType(PromptAnnotationKind)
proto3.util.setEnumType(PromptAnnotationKind, "exa.codeium_common_pb.PromptAnnotationKind", [
    { no: 0, name: "PROMPT_ANNOTATION_KIND_UNSPECIFIED" },
    { no: 1, name: "PROMPT_ANNOTATION_KIND_COPY" },
    { no: 2, name: "PROMPT_ANNOTATION_KIND_PROMPT_CACHE" },
]);
/**
 * THIS ENUM IS DEPRECATED! Use Unleash directly to create experiments (naming convention: `kebab-case`).
 * TODO: For chat client changes that need ExperimentKey, a temporary hack is to increment the ID in exa/unleash/experiment_key_test.go for CI to pass.
 * Next ID: 330, Previous field: CASCADE_MODEL_HEADER_WARNING
 * buf:lint:ignore ENUM_VALUE_PREFIX
 *
 * @generated from enum exa.codeium_common_pb.ExperimentKey
 */
export var ExperimentKey;
(function (ExperimentKey) {
    /**
     * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
     *
     * @generated from enum value: UNSPECIFIED = 0;
     */
    ExperimentKey[ExperimentKey["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: USE_INTERNAL_CHAT_MODEL = 36;
     */
    ExperimentKey[ExperimentKey["USE_INTERNAL_CHAT_MODEL"] = 36] = "USE_INTERNAL_CHAT_MODEL";
    /**
     * @generated from enum value: RECORD_FILES = 47;
     */
    ExperimentKey[ExperimentKey["RECORD_FILES"] = 47] = "RECORD_FILES";
    /**
     * @generated from enum value: NO_SAMPLER_EARLY_STOP = 48;
     */
    ExperimentKey[ExperimentKey["NO_SAMPLER_EARLY_STOP"] = 48] = "NO_SAMPLER_EARLY_STOP";
    /**
     * Record memory footprint of CM
     *
     * @generated from enum value: CM_MEMORY_TELEMETRY = 53;
     */
    ExperimentKey[ExperimentKey["CM_MEMORY_TELEMETRY"] = 53] = "CM_MEMORY_TELEMETRY";
    /**
     * @generated from enum value: LANGUAGE_SERVER_VERSION = 55;
     */
    ExperimentKey[ExperimentKey["LANGUAGE_SERVER_VERSION"] = 55] = "LANGUAGE_SERVER_VERSION";
    /**
     * @generated from enum value: LANGUAGE_SERVER_AUTO_RELOAD = 56;
     */
    ExperimentKey[ExperimentKey["LANGUAGE_SERVER_AUTO_RELOAD"] = 56] = "LANGUAGE_SERVER_AUTO_RELOAD";
    /**
     * @generated from enum value: ONLY_MULTILINE = 60;
     */
    ExperimentKey[ExperimentKey["ONLY_MULTILINE"] = 60] = "ONLY_MULTILINE";
    /**
     * @generated from enum value: USE_AUTOCOMPLETE_MODEL = 64;
     */
    ExperimentKey[ExperimentKey["USE_AUTOCOMPLETE_MODEL"] = 64] = "USE_AUTOCOMPLETE_MODEL";
    /**
     * @generated from enum value: USE_ATTRIBUTION_FOR_INDIVIDUAL_TIER = 68;
     */
    ExperimentKey[ExperimentKey["USE_ATTRIBUTION_FOR_INDIVIDUAL_TIER"] = 68] = "USE_ATTRIBUTION_FOR_INDIVIDUAL_TIER";
    /**
     * @generated from enum value: CHAT_MODEL_CONFIG = 78;
     */
    ExperimentKey[ExperimentKey["CHAT_MODEL_CONFIG"] = 78] = "CHAT_MODEL_CONFIG";
    /**
     * @generated from enum value: COMMAND_MODEL_CONFIG = 79;
     */
    ExperimentKey[ExperimentKey["COMMAND_MODEL_CONFIG"] = 79] = "COMMAND_MODEL_CONFIG";
    /**
     * @generated from enum value: MIN_IDE_VERSION = 81;
     */
    ExperimentKey[ExperimentKey["MIN_IDE_VERSION"] = 81] = "MIN_IDE_VERSION";
    /**
     * @generated from enum value: API_SERVER_VERBOSE_ERRORS = 84;
     */
    ExperimentKey[ExperimentKey["API_SERVER_VERBOSE_ERRORS"] = 84] = "API_SERVER_VERBOSE_ERRORS";
    /**
     * @generated from enum value: DEFAULT_ENABLE_SEARCH = 86;
     */
    ExperimentKey[ExperimentKey["DEFAULT_ENABLE_SEARCH"] = 86] = "DEFAULT_ENABLE_SEARCH";
    /**
     * @generated from enum value: COLLECT_ONBOARDING_EVENTS = 87;
     */
    ExperimentKey[ExperimentKey["COLLECT_ONBOARDING_EVENTS"] = 87] = "COLLECT_ONBOARDING_EVENTS";
    /**
     * @generated from enum value: COLLECT_EXAMPLE_COMPLETIONS = 88;
     */
    ExperimentKey[ExperimentKey["COLLECT_EXAMPLE_COMPLETIONS"] = 88] = "COLLECT_EXAMPLE_COMPLETIONS";
    /**
     * @generated from enum value: USE_MULTILINE_MODEL = 89;
     */
    ExperimentKey[ExperimentKey["USE_MULTILINE_MODEL"] = 89] = "USE_MULTILINE_MODEL";
    /**
     * @generated from enum value: ATTRIBUTION_KILL_SWITCH = 92;
     */
    ExperimentKey[ExperimentKey["ATTRIBUTION_KILL_SWITCH"] = 92] = "ATTRIBUTION_KILL_SWITCH";
    /**
     * @generated from enum value: FAST_MULTILINE = 94;
     */
    ExperimentKey[ExperimentKey["FAST_MULTILINE"] = 94] = "FAST_MULTILINE";
    /**
     * @generated from enum value: SINGLE_COMPLETION = 95;
     */
    ExperimentKey[ExperimentKey["SINGLE_COMPLETION"] = 95] = "SINGLE_COMPLETION";
    /**
     * @generated from enum value: STOP_FIRST_NON_WHITESPACE_LINE = 96;
     */
    ExperimentKey[ExperimentKey["STOP_FIRST_NON_WHITESPACE_LINE"] = 96] = "STOP_FIRST_NON_WHITESPACE_LINE";
    /**
     * Does nothing right now. If we want to add back, we should add to the API server but make sure
     * the team is allowed to use OpenAI.
     *
     * @generated from enum value: CORTEX_CONFIG = 102;
     */
    ExperimentKey[ExperimentKey["CORTEX_CONFIG"] = 102] = "CORTEX_CONFIG";
    /**
     * @generated from enum value: MODEL_CHAT_11121_VARIANTS = 103;
     */
    ExperimentKey[ExperimentKey["MODEL_CHAT_11121_VARIANTS"] = 103] = "MODEL_CHAT_11121_VARIANTS";
    /**
     * @generated from enum value: INCLUDE_PROMPT_COMPONENTS = 105;
     */
    ExperimentKey[ExperimentKey["INCLUDE_PROMPT_COMPONENTS"] = 105] = "INCLUDE_PROMPT_COMPONENTS";
    /**
     * @generated from enum value: NON_TEAMS_KILL_SWITCH = 106;
     */
    ExperimentKey[ExperimentKey["NON_TEAMS_KILL_SWITCH"] = 106] = "NON_TEAMS_KILL_SWITCH";
    /**
     * @generated from enum value: PERSIST_CODE_TRACKER = 108;
     */
    ExperimentKey[ExperimentKey["PERSIST_CODE_TRACKER"] = 108] = "PERSIST_CODE_TRACKER";
    /**
     * @generated from enum value: API_SERVER_LIVENESS_PROBE = 112;
     */
    ExperimentKey[ExperimentKey["API_SERVER_LIVENESS_PROBE"] = 112] = "API_SERVER_LIVENESS_PROBE";
    /**
     * @generated from enum value: CHAT_COMPLETION_TOKENS_SOFT_LIMIT = 114;
     */
    ExperimentKey[ExperimentKey["CHAT_COMPLETION_TOKENS_SOFT_LIMIT"] = 114] = "CHAT_COMPLETION_TOKENS_SOFT_LIMIT";
    /**
     * @generated from enum value: CHAT_TOKENS_SOFT_LIMIT = 115;
     */
    ExperimentKey[ExperimentKey["CHAT_TOKENS_SOFT_LIMIT"] = 115] = "CHAT_TOKENS_SOFT_LIMIT";
    /**
     * Expects variant with string payload corresponding to duration of fallback timeout in milliseconds.
     *
     * @generated from enum value: DISABLE_COMPLETIONS_CACHE = 118;
     */
    ExperimentKey[ExperimentKey["DISABLE_COMPLETIONS_CACHE"] = 118] = "DISABLE_COMPLETIONS_CACHE";
    /**
     * @generated from enum value: LLAMA3_405B_KILL_SWITCH = 119;
     */
    ExperimentKey[ExperimentKey["LLAMA3_405B_KILL_SWITCH"] = 119] = "LLAMA3_405B_KILL_SWITCH";
    /**
     * @generated from enum value: USE_COMMAND_DOCSTRING_GENERATION = 121;
     */
    ExperimentKey[ExperimentKey["USE_COMMAND_DOCSTRING_GENERATION"] = 121] = "USE_COMMAND_DOCSTRING_GENERATION";
    /**
     * @generated from enum value: ENABLE_SUPERCOMPLETE = 123;
     */
    ExperimentKey[ExperimentKey["ENABLE_SUPERCOMPLETE"] = 123] = "ENABLE_SUPERCOMPLETE";
    /**
     * @generated from enum value: SENTRY = 136;
     */
    ExperimentKey[ExperimentKey["SENTRY"] = 136] = "SENTRY";
    /**
     * @generated from enum value: FAST_SINGLELINE = 144;
     */
    ExperimentKey[ExperimentKey["FAST_SINGLELINE"] = 144] = "FAST_SINGLELINE";
    /**
     * @generated from enum value: R2_LANGUAGE_SERVER_DOWNLOAD = 147;
     */
    ExperimentKey[ExperimentKey["R2_LANGUAGE_SERVER_DOWNLOAD"] = 147] = "R2_LANGUAGE_SERVER_DOWNLOAD";
    /**
     * @generated from enum value: SPLIT_MODEL = 152;
     */
    ExperimentKey[ExperimentKey["SPLIT_MODEL"] = 152] = "SPLIT_MODEL";
    /**
     * @generated from enum value: WINDSURF_SENTRY_SAMPLE_RATE = 198;
     */
    ExperimentKey[ExperimentKey["WINDSURF_SENTRY_SAMPLE_RATE"] = 198] = "WINDSURF_SENTRY_SAMPLE_RATE";
    /**
     * Experiment to perform API server cutoff of inference server responses for
     * GetStreamingCompletions.
     *
     * @generated from enum value: API_SERVER_CUTOFF = 158;
     */
    ExperimentKey[ExperimentKey["API_SERVER_CUTOFF"] = 158] = "API_SERVER_CUTOFF";
    /**
     * @generated from enum value: FAST_SPEED_KILL_SWITCH = 159;
     */
    ExperimentKey[ExperimentKey["FAST_SPEED_KILL_SWITCH"] = 159] = "FAST_SPEED_KILL_SWITCH";
    /**
     * @generated from enum value: PREDICTIVE_MULTILINE = 160;
     */
    ExperimentKey[ExperimentKey["PREDICTIVE_MULTILINE"] = 160] = "PREDICTIVE_MULTILINE";
    /**
     * Supercomplete related keys.
     * Heuristic toggles.
     *
     * Whether or not to use the revert filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_REVERT = 125;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_REVERT"] = 125] = "SUPERCOMPLETE_FILTER_REVERT";
    /**
     * Whether or not to use the prefix match filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_PREFIX_MATCH = 126;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_PREFIX_MATCH"] = 126] = "SUPERCOMPLETE_FILTER_PREFIX_MATCH";
    /**
     * Whether or not to use the score threshold filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_SCORE_THRESHOLD = 127;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_SCORE_THRESHOLD"] = 127] = "SUPERCOMPLETE_FILTER_SCORE_THRESHOLD";
    /**
     * Whether or not to use the insertion cap filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_INSERTION_CAP = 128;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_INSERTION_CAP"] = 128] = "SUPERCOMPLETE_FILTER_INSERTION_CAP";
    /**
     * Whether or not to use the deletion cap filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_DELETION_CAP = 133;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_DELETION_CAP"] = 133] = "SUPERCOMPLETE_FILTER_DELETION_CAP";
    /**
     * Whether or not to use the whitespace only filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_WHITESPACE_ONLY = 156;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_WHITESPACE_ONLY"] = 156] = "SUPERCOMPLETE_FILTER_WHITESPACE_ONLY";
    /**
     * Whether or not to use the noop filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_NO_OP = 170;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_NO_OP"] = 170] = "SUPERCOMPLETE_FILTER_NO_OP";
    /**
     * Whether or not to use the suffix match filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_SUFFIX_MATCH = 176;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_SUFFIX_MATCH"] = 176] = "SUPERCOMPLETE_FILTER_SUFFIX_MATCH";
    /**
     * Whether or not to use the previously shown filter.
     *
     * @generated from enum value: SUPERCOMPLETE_FILTER_PREVIOUSLY_SHOWN = 182;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FILTER_PREVIOUSLY_SHOWN"] = 182] = "SUPERCOMPLETE_FILTER_PREVIOUSLY_SHOWN";
    /**
     * Thresholds.
     *
     * Minimum score threshold for score threshold filter.
     *
     * @generated from enum value: SUPERCOMPLETE_MIN_SCORE = 129;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MIN_SCORE"] = 129] = "SUPERCOMPLETE_MIN_SCORE";
    /**
     * Maximum number of insertions for insertion cap filter.
     *
     * @generated from enum value: SUPERCOMPLETE_MAX_INSERTIONS = 130;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MAX_INSERTIONS"] = 130] = "SUPERCOMPLETE_MAX_INSERTIONS";
    /**
     * Max line radius to select for supercomplete.
     *
     * @generated from enum value: SUPERCOMPLETE_LINE_RADIUS = 131;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_LINE_RADIUS"] = 131] = "SUPERCOMPLETE_LINE_RADIUS";
    /**
     * Max deletions to select for supercomplete.
     *
     * @generated from enum value: SUPERCOMPLETE_MAX_DELETIONS = 132;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MAX_DELETIONS"] = 132] = "SUPERCOMPLETE_MAX_DELETIONS";
    /**
     * Generation related keys.
     *
     * Whether or not to use the current line in supercomplete prompt.
     *
     * @generated from enum value: SUPERCOMPLETE_USE_CURRENT_LINE = 135;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_USE_CURRENT_LINE"] = 135] = "SUPERCOMPLETE_USE_CURRENT_LINE";
    /**
     * Duration of recent edit steps to include in supercomplete prompt.
     *
     * @generated from enum value: SUPERCOMPLETE_RECENT_STEPS_DURATION = 138;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_RECENT_STEPS_DURATION"] = 138] = "SUPERCOMPLETE_RECENT_STEPS_DURATION";
    /**
     * Whether or not to use the code diagnostics in supercomplete prompt.
     *
     * @generated from enum value: SUPERCOMPLETE_USE_CODE_DIAGNOSTICS = 143;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_USE_CODE_DIAGNOSTICS"] = 143] = "SUPERCOMPLETE_USE_CODE_DIAGNOSTICS";
    /**
     * Threshold for severity of diagnostics to include in supercomplete prompt.
     *
     * @generated from enum value: SUPERCOMPLETE_DIAGNOSTIC_SEVERITY_THRESHOLD = 223;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_DIAGNOSTIC_SEVERITY_THRESHOLD"] = 223] = "SUPERCOMPLETE_DIAGNOSTIC_SEVERITY_THRESHOLD";
    /**
     * Top K diagnostics to include in supercomplete prompt.
     *
     * @generated from enum value: SUPERCOMPLETE_CODE_DIAGNOSTICS_TOP_K = 232;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_CODE_DIAGNOSTICS_TOP_K"] = 232] = "SUPERCOMPLETE_CODE_DIAGNOSTICS_TOP_K";
    /**
     * Maximum number of steps to include in the recent edit trajectory.
     *
     * @generated from enum value: SUPERCOMPLETE_MAX_TRAJECTORY_STEPS = 154;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MAX_TRAJECTORY_STEPS"] = 154] = "SUPERCOMPLETE_MAX_TRAJECTORY_STEPS";
    /**
     * @generated from enum value: SUPERCOMPLETE_ON_ACCEPT_ONLY = 157;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_ON_ACCEPT_ONLY"] = 157] = "SUPERCOMPLETE_ON_ACCEPT_ONLY";
    /**
     * Temperature for supercomplete generation.
     *
     * @generated from enum value: SUPERCOMPLETE_TEMPERATURE = 183;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_TEMPERATURE"] = 183] = "SUPERCOMPLETE_TEMPERATURE";
    /**
     * Maximum number of tokens to include in a single step of the recent edit trajectory. Will skip step if exceeds step size.
     *
     * @generated from enum value: SUPERCOMPLETE_MAX_TRAJECTORY_STEP_SIZE = 203;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MAX_TRAJECTORY_STEP_SIZE"] = 203] = "SUPERCOMPLETE_MAX_TRAJECTORY_STEP_SIZE";
    /**
     * If true, supercomplete will not use the cache when you are typing (and will use it on cursor navigation and accept).
     *
     * @generated from enum value: SUPERCOMPLETE_DISABLE_TYPING_CACHE = 231;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_DISABLE_TYPING_CACHE"] = 231] = "SUPERCOMPLETE_DISABLE_TYPING_CACHE";
    /**
     * If true, supercomplete cache will always cause a hit when the state is equal to the original state.
     *
     * @generated from enum value: SUPERCOMPLETE_ALWAYS_USE_CACHE_ON_EQUAL_STATE = 293;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_ALWAYS_USE_CACHE_ON_EQUAL_STATE"] = 293] = "SUPERCOMPLETE_ALWAYS_USE_CACHE_ON_EQUAL_STATE";
    /**
     * If true, supercomplete will not use the parent completion ID when checking the cache.
     *
     * @generated from enum value: SUPERCOMPLETE_CACHE_ON_PARENT_ID_KILL_SWITCH = 297;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_CACHE_ON_PARENT_ID_KILL_SWITCH"] = 297] = "SUPERCOMPLETE_CACHE_ON_PARENT_ID_KILL_SWITCH";
    /**
     * Prune related keys.
     *
     * Whether or not to prune the response.
     *
     * @generated from enum value: SUPERCOMPLETE_PRUNE_RESPONSE = 140;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_PRUNE_RESPONSE"] = 140] = "SUPERCOMPLETE_PRUNE_RESPONSE";
    /**
     * Maximum allowed difference between inserted and deleted lines for the first/last hunk beyond which the first/last hunk diff is pruned.
     *
     * @generated from enum value: SUPERCOMPLETE_PRUNE_MAX_INSERT_DELETE_LINE_DELTA = 141;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_PRUNE_MAX_INSERT_DELETE_LINE_DELTA"] = 141] = "SUPERCOMPLETE_PRUNE_MAX_INSERT_DELETE_LINE_DELTA";
    /**
     * Model selection keys.
     *
     * @generated from enum value: SUPERCOMPLETE_MODEL_CONFIG = 145;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MODEL_CONFIG"] = 145] = "SUPERCOMPLETE_MODEL_CONFIG";
    /**
     * UX related keys.
     *
     * Only displays supercomplete when autocomplete is not shown, which allows it to use tab as the shortcut.
     *
     * @generated from enum value: SUPERCOMPLETE_ON_TAB = 151;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_ON_TAB"] = 151] = "SUPERCOMPLETE_ON_TAB";
    /**
     * @generated from enum value: SUPERCOMPLETE_INLINE_PURE_DELETE = 171;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_INLINE_PURE_DELETE"] = 171] = "SUPERCOMPLETE_INLINE_PURE_DELETE";
    /**
     * Whether to use rich ghost text for inline supercomplete insertions, as opposed to editor decorations (default).
     *
     * @generated from enum value: SUPERCOMPLETE_INLINE_RICH_GHOST_TEXT_INSERTIONS = 218;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_INLINE_RICH_GHOST_TEXT_INSERTIONS"] = 218] = "SUPERCOMPLETE_INLINE_RICH_GHOST_TEXT_INSERTIONS";
    /**
     * @generated from enum value: MODEL_CHAT_19821_VARIANTS = 308;
     */
    ExperimentKey[ExperimentKey["MODEL_CHAT_19821_VARIANTS"] = 308] = "MODEL_CHAT_19821_VARIANTS";
    /**
     * The number of concurrent request supercomplete can have to support FAST_SINGLELINE-type completions
     *
     * @generated from enum value: SUPERCOMPLETE_MAX_CONCURRENT_REQUESTS = 284;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_MAX_CONCURRENT_REQUESTS"] = 284] = "SUPERCOMPLETE_MAX_CONCURRENT_REQUESTS";
    /**
     * Prompt caching deployment for supercomplete. See prompt.proto for more details.
     *
     * @generated from enum value: COMMAND_PROMPT_CACHE_CONFIG = 255;
     */
    ExperimentKey[ExperimentKey["COMMAND_PROMPT_CACHE_CONFIG"] = 255] = "COMMAND_PROMPT_CACHE_CONFIG";
    /**
     * @generated from enum value: CUMULATIVE_PROMPT_CONFIG = 256;
     */
    ExperimentKey[ExperimentKey["CUMULATIVE_PROMPT_CONFIG"] = 256] = "CUMULATIVE_PROMPT_CONFIG";
    /**
     * Cascade config override for tab in the cascade like format.
     * PlannerConfig.TruncationThresholdTokens and CheckpointConfig.MaxTokenLimit should be intmax to avoid undesired truncation.
     *
     * @generated from enum value: CUMULATIVE_PROMPT_CASCADE_CONFIG = 279;
     */
    ExperimentKey[ExperimentKey["CUMULATIVE_PROMPT_CASCADE_CONFIG"] = 279] = "CUMULATIVE_PROMPT_CASCADE_CONFIG";
    /**
     * @generated from enum value: TAB_JUMP_CUMULATIVE_PROMPT_CONFIG = 301;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_CUMULATIVE_PROMPT_CONFIG"] = 301] = "TAB_JUMP_CUMULATIVE_PROMPT_CONFIG";
    /**
     * Completion Speed Experiments.
     *
     * @generated from enum value: COMPLETION_SPEED_SUPERCOMPLETE_CACHE = 207;
     */
    ExperimentKey[ExperimentKey["COMPLETION_SPEED_SUPERCOMPLETE_CACHE"] = 207] = "COMPLETION_SPEED_SUPERCOMPLETE_CACHE";
    /**
     * @generated from enum value: COMPLETION_SPEED_PREDICTIVE_SUPERCOMPLETE = 208;
     */
    ExperimentKey[ExperimentKey["COMPLETION_SPEED_PREDICTIVE_SUPERCOMPLETE"] = 208] = "COMPLETION_SPEED_PREDICTIVE_SUPERCOMPLETE";
    /**
     * @generated from enum value: COMPLETION_SPEED_TAB_JUMP_CACHE = 209;
     */
    ExperimentKey[ExperimentKey["COMPLETION_SPEED_TAB_JUMP_CACHE"] = 209] = "COMPLETION_SPEED_TAB_JUMP_CACHE";
    /**
     * @generated from enum value: COMPLETION_SPEED_PREDICTIVE_TAB_JUMP = 210;
     */
    ExperimentKey[ExperimentKey["COMPLETION_SPEED_PREDICTIVE_TAB_JUMP"] = 210] = "COMPLETION_SPEED_PREDICTIVE_TAB_JUMP";
    /**
     * Whether or not to block tab jump on predictive supercomplete making an edit.
     *
     * @generated from enum value: COMPLETION_SPEED_BLOCK_TAB_JUMP_ON_PREDICTIVE_SUPERCOMPLETE = 294;
     */
    ExperimentKey[ExperimentKey["COMPLETION_SPEED_BLOCK_TAB_JUMP_ON_PREDICTIVE_SUPERCOMPLETE"] = 294] = "COMPLETION_SPEED_BLOCK_TAB_JUMP_ON_PREDICTIVE_SUPERCOMPLETE";
    /**
     * @generated from enum value: JETBRAINS_ENABLE_ONBOARDING = 137;
     */
    ExperimentKey[ExperimentKey["JETBRAINS_ENABLE_ONBOARDING"] = 137] = "JETBRAINS_ENABLE_ONBOARDING";
    /**
     * @generated from enum value: ENABLE_AUTOCOMPLETE_DURING_INTELLISENSE = 146;
     */
    ExperimentKey[ExperimentKey["ENABLE_AUTOCOMPLETE_DURING_INTELLISENSE"] = 146] = "ENABLE_AUTOCOMPLETE_DURING_INTELLISENSE";
    /**
     * @generated from enum value: COMMAND_BOX_ON_TOP = 155;
     */
    ExperimentKey[ExperimentKey["COMMAND_BOX_ON_TOP"] = 155] = "COMMAND_BOX_ON_TOP";
    /**
     * Context-Related Experiments
     *
     * @generated from enum value: CONTEXT_ACTIVE_DOCUMENT_FRACTION = 149;
     */
    ExperimentKey[ExperimentKey["CONTEXT_ACTIVE_DOCUMENT_FRACTION"] = 149] = "CONTEXT_ACTIVE_DOCUMENT_FRACTION";
    /**
     * @generated from enum value: CONTEXT_COMMAND_TRAJECTORY_PROMPT_CONFIG = 150;
     */
    ExperimentKey[ExperimentKey["CONTEXT_COMMAND_TRAJECTORY_PROMPT_CONFIG"] = 150] = "CONTEXT_COMMAND_TRAJECTORY_PROMPT_CONFIG";
    /**
     * @generated from enum value: CONTEXT_FORCE_LOCAL_CONTEXT = 178;
     */
    ExperimentKey[ExperimentKey["CONTEXT_FORCE_LOCAL_CONTEXT"] = 178] = "CONTEXT_FORCE_LOCAL_CONTEXT";
    /**
     * Flag for cross-selling extension users to download Windsurf
     *
     * @generated from enum value: CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF = 220;
     */
    ExperimentKey[ExperimentKey["CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF"] = 220] = "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF";
    /**
     * Fast Apply related
     *
     * @generated from enum value: MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT_VARIANTS = 295;
     */
    ExperimentKey[ExperimentKey["MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT_VARIANTS"] = 295] = "MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT_VARIANTS";
    /**
     * Override the requested autocomplete model on the api server side
     * if server side prompt construction is on.
     *
     * @generated from enum value: USE_AUTOCOMPLETE_MODEL_SERVER_SIDE = 163;
     */
    ExperimentKey[ExperimentKey["USE_AUTOCOMPLETE_MODEL_SERVER_SIDE"] = 163] = "USE_AUTOCOMPLETE_MODEL_SERVER_SIDE";
    /**
     * @generated from enum value: SUPERCOMPLETE_NO_CONTEXT = 165;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_NO_CONTEXT"] = 165] = "SUPERCOMPLETE_NO_CONTEXT";
    /**
     * @generated from enum value: SUPERCOMPLETE_NO_ACTIVE_NODE = 166;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_NO_ACTIVE_NODE"] = 166] = "SUPERCOMPLETE_NO_ACTIVE_NODE";
    /**
     * @generated from enum value: TAB_JUMP_ENABLED = 168;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_ENABLED"] = 168] = "TAB_JUMP_ENABLED";
    /**
     * Dev setting to allow this to render without it interferring with autocomplete & supercomplete.
     *
     * @generated from enum value: TAB_JUMP_ACCEPT_ENABLED = 169;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_ACCEPT_ENABLED"] = 169] = "TAB_JUMP_ACCEPT_ENABLED";
    /**
     * Max selection radius tab jump considers suggestions for
     *
     * @generated from enum value: TAB_JUMP_LINE_RADIUS = 177;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_LINE_RADIUS"] = 177] = "TAB_JUMP_LINE_RADIUS";
    /**
     * Minimum line radius tab jump will show suggestion for
     *
     * @generated from enum value: TAB_JUMP_MIN_FILTER_RADIUS = 197;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_MIN_FILTER_RADIUS"] = 197] = "TAB_JUMP_MIN_FILTER_RADIUS";
    /**
     * Only allow tab jump to be triggered by autocomplete/supercomplete accept
     *
     * @generated from enum value: TAB_JUMP_ON_ACCEPT_ONLY = 205;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_ON_ACCEPT_ONLY"] = 205] = "TAB_JUMP_ON_ACCEPT_ONLY";
    /**
     * Whether to filter jump if there is suggested edit within selection. If unset, will only consider edits outside selection as a jump.
     *
     * @generated from enum value: TAB_JUMP_FILTER_IN_SELECTION = 215;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_IN_SELECTION"] = 215] = "TAB_JUMP_FILTER_IN_SELECTION";
    /**
     * @generated from enum value: TAB_JUMP_MODEL_CONFIG = 237;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_MODEL_CONFIG"] = 237] = "TAB_JUMP_MODEL_CONFIG";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_NO_OP = 238;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_NO_OP"] = 238] = "TAB_JUMP_FILTER_NO_OP";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_REVERT = 239;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_REVERT"] = 239] = "TAB_JUMP_FILTER_REVERT";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_SCORE_THRESHOLD = 240;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_SCORE_THRESHOLD"] = 240] = "TAB_JUMP_FILTER_SCORE_THRESHOLD";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_WHITESPACE_ONLY = 241;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_WHITESPACE_ONLY"] = 241] = "TAB_JUMP_FILTER_WHITESPACE_ONLY";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_INSERTION_CAP = 242;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_INSERTION_CAP"] = 242] = "TAB_JUMP_FILTER_INSERTION_CAP";
    /**
     * @generated from enum value: TAB_JUMP_FILTER_DELETION_CAP = 243;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_FILTER_DELETION_CAP"] = 243] = "TAB_JUMP_FILTER_DELETION_CAP";
    /**
     * @generated from enum value: TAB_JUMP_PRUNE_RESPONSE = 260;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_PRUNE_RESPONSE"] = 260] = "TAB_JUMP_PRUNE_RESPONSE";
    /**
     * @generated from enum value: TAB_JUMP_PRUNE_MAX_INSERT_DELETE_LINE_DELTA = 261;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_PRUNE_MAX_INSERT_DELETE_LINE_DELTA"] = 261] = "TAB_JUMP_PRUNE_MAX_INSERT_DELETE_LINE_DELTA";
    /**
     * Temporary experiment to allow toolcall tabjump models stop early at ReplacementContent stop token.
     *
     * @generated from enum value: TAB_JUMP_STOP_TOKEN_MIDSTREAM = 317;
     */
    ExperimentKey[ExperimentKey["TAB_JUMP_STOP_TOKEN_MIDSTREAM"] = 317] = "TAB_JUMP_STOP_TOKEN_MIDSTREAM";
    /**
     * @generated from enum value: VIEWED_FILE_TRACKER_CONFIG = 211;
     */
    ExperimentKey[ExperimentKey["VIEWED_FILE_TRACKER_CONFIG"] = 211] = "VIEWED_FILE_TRACKER_CONFIG";
    /**
     * Note: this expects a json payload of format map[string]string where
     * Key: the CortexTrajectoryType enum name
     * Value: a json-serialized value of SnapshotToStepsOptions, escaped into a string
     * The value will be proto.Merged into the base SnapshotToStepsOptions. Make sure you understand how proto.Merge rules work.
     * Notably, step_type_allow_list will be appended, not overwritten.
     *
     * @generated from enum value: SNAPSHOT_TO_STEP_OPTIONS_OVERRIDE = 305;
     */
    ExperimentKey[ExperimentKey["SNAPSHOT_TO_STEP_OPTIONS_OVERRIDE"] = 305] = "SNAPSHOT_TO_STEP_OPTIONS_OVERRIDE";
    /**
     * Command for external models, enable streaming text endpoint.
     *
     * @generated from enum value: STREAMING_EXTERNAL_COMMAND = 172;
     */
    ExperimentKey[ExperimentKey["STREAMING_EXTERNAL_COMMAND"] = 172] = "STREAMING_EXTERNAL_COMMAND";
    /**
     * @generated from enum value: USE_SPECIAL_EDIT_CODE_BLOCK = 179;
     */
    ExperimentKey[ExperimentKey["USE_SPECIAL_EDIT_CODE_BLOCK"] = 179] = "USE_SPECIAL_EDIT_CODE_BLOCK";
    /**
     * Cascade related
     *
     * @generated from enum value: ENABLE_SUGGESTED_RESPONSES = 187;
     */
    ExperimentKey[ExperimentKey["ENABLE_SUGGESTED_RESPONSES"] = 187] = "ENABLE_SUGGESTED_RESPONSES";
    /**
     * Note: If PlanModel is specified, then must also set MaxOutputTokens
     *
     * @generated from enum value: CASCADE_BASE_MODEL_ID = 190;
     */
    ExperimentKey[ExperimentKey["CASCADE_BASE_MODEL_ID"] = 190] = "CASCADE_BASE_MODEL_ID";
    /**
     * START: These require a CascadeConfig json payload.
     *
     * @generated from enum value: CASCADE_PLAN_BASED_CONFIG_OVERRIDE = 266;
     */
    ExperimentKey[ExperimentKey["CASCADE_PLAN_BASED_CONFIG_OVERRIDE"] = 266] = "CASCADE_PLAN_BASED_CONFIG_OVERRIDE";
    /**
     * @generated from enum value: CASCADE_GLOBAL_CONFIG_OVERRIDE = 212;
     */
    ExperimentKey[ExperimentKey["CASCADE_GLOBAL_CONFIG_OVERRIDE"] = 212] = "CASCADE_GLOBAL_CONFIG_OVERRIDE";
    /**
     * @generated from enum value: CASCADE_BACKGROUND_RESEARCH_CONFIG_OVERRIDE = 193;
     */
    ExperimentKey[ExperimentKey["CASCADE_BACKGROUND_RESEARCH_CONFIG_OVERRIDE"] = 193] = "CASCADE_BACKGROUND_RESEARCH_CONFIG_OVERRIDE";
    /**
     * END: These require a CascadeConfig json payload.
     *
     * @generated from enum value: CASCADE_ENFORCE_QUOTA = 204;
     */
    ExperimentKey[ExperimentKey["CASCADE_ENFORCE_QUOTA"] = 204] = "CASCADE_ENFORCE_QUOTA";
    /**
     * @generated from enum value: CASCADE_ENABLE_AUTOMATED_MEMORIES = 224;
     */
    ExperimentKey[ExperimentKey["CASCADE_ENABLE_AUTOMATED_MEMORIES"] = 224] = "CASCADE_ENABLE_AUTOMATED_MEMORIES";
    /**
     * @generated from enum value: CASCADE_MEMORY_CONFIG_OVERRIDE = 314;
     */
    ExperimentKey[ExperimentKey["CASCADE_MEMORY_CONFIG_OVERRIDE"] = 314] = "CASCADE_MEMORY_CONFIG_OVERRIDE";
    /**
     * @generated from enum value: CASCADE_USE_REPLACE_CONTENT_EDIT_TOOL = 228;
     */
    ExperimentKey[ExperimentKey["CASCADE_USE_REPLACE_CONTENT_EDIT_TOOL"] = 228] = "CASCADE_USE_REPLACE_CONTENT_EDIT_TOOL";
    /**
     * @generated from enum value: CASCADE_VIEW_FILE_TOOL_CONFIG_OVERRIDE = 258;
     */
    ExperimentKey[ExperimentKey["CASCADE_VIEW_FILE_TOOL_CONFIG_OVERRIDE"] = 258] = "CASCADE_VIEW_FILE_TOOL_CONFIG_OVERRIDE";
    /**
     * Whether to run with the checkpoint_experiment_handler
     *
     * @generated from enum value: CASCADE_USE_EXPERIMENT_CHECKPOINTER = 247;
     */
    ExperimentKey[ExperimentKey["CASCADE_USE_EXPERIMENT_CHECKPOINTER"] = 247] = "CASCADE_USE_EXPERIMENT_CHECKPOINTER";
    /**
     * @generated from enum value: CASCADE_ENABLE_CUSTOM_RECIPES = 236;
     */
    ExperimentKey[ExperimentKey["CASCADE_ENABLE_CUSTOM_RECIPES"] = 236] = "CASCADE_ENABLE_CUSTOM_RECIPES";
    /**
     * @generated from enum value: CASCADE_ENABLE_MCP_TOOLS = 245;
     */
    ExperimentKey[ExperimentKey["CASCADE_ENABLE_MCP_TOOLS"] = 245] = "CASCADE_ENABLE_MCP_TOOLS";
    /**
     * @generated from enum value: CASCADE_AUTO_FIX_LINTS = 275;
     */
    ExperimentKey[ExperimentKey["CASCADE_AUTO_FIX_LINTS"] = 275] = "CASCADE_AUTO_FIX_LINTS";
    /**
     * @generated from enum value: USE_ANTHROPIC_TOKEN_EFFICIENT_TOOLS_BETA = 296;
     */
    ExperimentKey[ExperimentKey["USE_ANTHROPIC_TOKEN_EFFICIENT_TOOLS_BETA"] = 296] = "USE_ANTHROPIC_TOKEN_EFFICIENT_TOOLS_BETA";
    /**
     * @generated from enum value: CASCADE_USER_MEMORIES_IN_SYS_PROMPT = 289;
     */
    ExperimentKey[ExperimentKey["CASCADE_USER_MEMORIES_IN_SYS_PROMPT"] = 289] = "CASCADE_USER_MEMORIES_IN_SYS_PROMPT";
    /**
     * @generated from enum value: CASCADE_ENABLE_PROXY_WEB_SERVER = 290;
     */
    ExperimentKey[ExperimentKey["CASCADE_ENABLE_PROXY_WEB_SERVER"] = 290] = "CASCADE_ENABLE_PROXY_WEB_SERVER";
    /**
     * @generated from enum value: COLLAPSE_ASSISTANT_MESSAGES = 312;
     */
    ExperimentKey[ExperimentKey["COLLAPSE_ASSISTANT_MESSAGES"] = 312] = "COLLAPSE_ASSISTANT_MESSAGES";
    /**
     * @generated from enum value: CASCADE_DEFAULT_MODEL_OVERRIDE = 321;
     */
    ExperimentKey[ExperimentKey["CASCADE_DEFAULT_MODEL_OVERRIDE"] = 321] = "CASCADE_DEFAULT_MODEL_OVERRIDE";
    /**
     * @generated from enum value: ENABLE_SMART_COPY = 181;
     */
    ExperimentKey[ExperimentKey["ENABLE_SMART_COPY"] = 181] = "ENABLE_SMART_COPY";
    /**
     * @generated from enum value: ENABLE_COMMIT_MESSAGE_GENERATION = 185 [deprecated = true];
     * @deprecated
     */
    ExperimentKey[ExperimentKey["ENABLE_COMMIT_MESSAGE_GENERATION"] = 185] = "ENABLE_COMMIT_MESSAGE_GENERATION";
    /**
     * Allow autocomplete to bypass suggestion consistency manager checks
     *
     * @generated from enum value: SKIP_CONSISTENCY_MANAGER = 194;
     */
    ExperimentKey[ExperimentKey["SKIP_CONSISTENCY_MANAGER"] = 194] = "SKIP_CONSISTENCY_MANAGER";
    /**
     * API Server Experiments
     *
     * @generated from enum value: FIREWORKS_ON_DEMAND_DEPLOYMENT = 276;
     */
    ExperimentKey[ExperimentKey["FIREWORKS_ON_DEMAND_DEPLOYMENT"] = 276] = "FIREWORKS_ON_DEMAND_DEPLOYMENT";
    /**
     * Allows HTTP/2 usage in the language server.
     *
     * @generated from enum value: API_SERVER_CLIENT_USE_HTTP_2 = 202;
     */
    ExperimentKey[ExperimentKey["API_SERVER_CLIENT_USE_HTTP_2"] = 202] = "API_SERVER_CLIENT_USE_HTTP_2";
    /**
     * @generated from enum value: AUTOCOMPLETE_DEFAULT_DEBOUNCE_MS = 213;
     */
    ExperimentKey[ExperimentKey["AUTOCOMPLETE_DEFAULT_DEBOUNCE_MS"] = 213] = "AUTOCOMPLETE_DEFAULT_DEBOUNCE_MS";
    /**
     * @generated from enum value: AUTOCOMPLETE_FAST_DEBOUNCE_MS = 214;
     */
    ExperimentKey[ExperimentKey["AUTOCOMPLETE_FAST_DEBOUNCE_MS"] = 214] = "AUTOCOMPLETE_FAST_DEBOUNCE_MS";
    /**
     * @generated from enum value: PROFILING_TELEMETRY_SAMPLE_RATE = 219;
     */
    ExperimentKey[ExperimentKey["PROFILING_TELEMETRY_SAMPLE_RATE"] = 219] = "PROFILING_TELEMETRY_SAMPLE_RATE";
    /**
     * @generated from enum value: STREAM_USER_SHELL_COMMANDS = 225;
     */
    ExperimentKey[ExperimentKey["STREAM_USER_SHELL_COMMANDS"] = 225] = "STREAM_USER_SHELL_COMMANDS";
    /**
     * @generated from enum value: API_SERVER_PROMPT_CACHE_REPLICAS = 307;
     */
    ExperimentKey[ExperimentKey["API_SERVER_PROMPT_CACHE_REPLICAS"] = 307] = "API_SERVER_PROMPT_CACHE_REPLICAS";
    /**
     * @generated from enum value: API_SERVER_ENABLE_MORE_LOGGING = 272;
     */
    ExperimentKey[ExperimentKey["API_SERVER_ENABLE_MORE_LOGGING"] = 272] = "API_SERVER_ENABLE_MORE_LOGGING";
    /**
     * @generated from enum value: COMMAND_INJECT_USER_MEMORIES = 233;
     */
    ExperimentKey[ExperimentKey["COMMAND_INJECT_USER_MEMORIES"] = 233] = "COMMAND_INJECT_USER_MEMORIES";
    /**
     * @generated from enum value: AUTOCOMPLETE_HIDDEN_ERROR_REGEX = 234;
     */
    ExperimentKey[ExperimentKey["AUTOCOMPLETE_HIDDEN_ERROR_REGEX"] = 234] = "AUTOCOMPLETE_HIDDEN_ERROR_REGEX";
    /**
     * @generated from enum value: DISABLE_IDE_COMPLETIONS_DEBOUNCE = 278;
     */
    ExperimentKey[ExperimentKey["DISABLE_IDE_COMPLETIONS_DEBOUNCE"] = 278] = "DISABLE_IDE_COMPLETIONS_DEBOUNCE";
    /**
     * @generated from enum value: COMBINED_MODEL_USE_FULL_INSTRUCTION_FOR_RETRIEVAL = 264;
     */
    ExperimentKey[ExperimentKey["COMBINED_MODEL_USE_FULL_INSTRUCTION_FOR_RETRIEVAL"] = 264] = "COMBINED_MODEL_USE_FULL_INSTRUCTION_FOR_RETRIEVAL";
    /**
     * @generated from enum value: MAX_PAST_TRAJECTORY_TOKENS_FOR_RETRIEVAL = 265;
     */
    ExperimentKey[ExperimentKey["MAX_PAST_TRAJECTORY_TOKENS_FOR_RETRIEVAL"] = 265] = "MAX_PAST_TRAJECTORY_TOKENS_FOR_RETRIEVAL";
    /**
     * @generated from enum value: ENABLE_QUICK_ACTIONS = 250;
     */
    ExperimentKey[ExperimentKey["ENABLE_QUICK_ACTIONS"] = 250] = "ENABLE_QUICK_ACTIONS";
    /**
     * @generated from enum value: QUICK_ACTIONS_WHITELIST_REGEX = 251;
     */
    ExperimentKey[ExperimentKey["QUICK_ACTIONS_WHITELIST_REGEX"] = 251] = "QUICK_ACTIONS_WHITELIST_REGEX";
    /**
     * Deprecated: If this gets turned on, all users on Wave 2 patch of Windsurf gets the new models NUX,
     * even if they don't have any new models (e.g. free users don't see R1 or V3).
     *
     * @generated from enum value: CASCADE_NEW_MODELS_NUX = 259 [deprecated = true];
     * @deprecated
     */
    ExperimentKey[ExperimentKey["CASCADE_NEW_MODELS_NUX"] = 259] = "CASCADE_NEW_MODELS_NUX";
    /**
     * @generated from enum value: CASCADE_NEW_WAVE_2_MODELS_NUX = 270 [deprecated = true];
     * @deprecated
     */
    ExperimentKey[ExperimentKey["CASCADE_NEW_WAVE_2_MODELS_NUX"] = 270] = "CASCADE_NEW_WAVE_2_MODELS_NUX";
    /**
     * @generated from enum value: SUPERCOMPLETE_FAST_DEBOUNCE = 262;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_FAST_DEBOUNCE"] = 262] = "SUPERCOMPLETE_FAST_DEBOUNCE";
    /**
     * @generated from enum value: SUPERCOMPLETE_REGULAR_DEBOUNCE = 263;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_REGULAR_DEBOUNCE"] = 263] = "SUPERCOMPLETE_REGULAR_DEBOUNCE";
    /**
     * @generated from enum value: XML_TOOL_PARSING_MODELS = 268;
     */
    ExperimentKey[ExperimentKey["XML_TOOL_PARSING_MODELS"] = 268] = "XML_TOOL_PARSING_MODELS";
    /**
     * @generated from enum value: SUPERCOMPLETE_DONT_FILTER_MID_STREAMED = 269;
     */
    ExperimentKey[ExperimentKey["SUPERCOMPLETE_DONT_FILTER_MID_STREAMED"] = 269] = "SUPERCOMPLETE_DONT_FILTER_MID_STREAMED";
    /**
     * @generated from enum value: ANNOYANCE_MANAGER_MAX_NAVIGATION_RENDERS = 285;
     */
    ExperimentKey[ExperimentKey["ANNOYANCE_MANAGER_MAX_NAVIGATION_RENDERS"] = 285] = "ANNOYANCE_MANAGER_MAX_NAVIGATION_RENDERS";
    /**
     * @generated from enum value: ANNOYANCE_MANAGER_INLINE_PREVENTION_THRESHOLD_MS = 286;
     */
    ExperimentKey[ExperimentKey["ANNOYANCE_MANAGER_INLINE_PREVENTION_THRESHOLD_MS"] = 286] = "ANNOYANCE_MANAGER_INLINE_PREVENTION_THRESHOLD_MS";
    /**
     * @generated from enum value: ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_INTENTIONAL_REJECTIONS = 287;
     */
    ExperimentKey[ExperimentKey["ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_INTENTIONAL_REJECTIONS"] = 287] = "ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_INTENTIONAL_REJECTIONS";
    /**
     * @generated from enum value: ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_AUTO_REJECTIONS = 288;
     */
    ExperimentKey[ExperimentKey["ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_AUTO_REJECTIONS"] = 288] = "ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_AUTO_REJECTIONS";
    /**
     * Toggle between standard and custom character diff implementations.
     * Custom character diff should use smarter semantic scoring logic to better align with code boundaries.
     *
     * @generated from enum value: USE_CUSTOM_CHARACTER_DIFF = 292;
     */
    ExperimentKey[ExperimentKey["USE_CUSTOM_CHARACTER_DIFF"] = 292] = "USE_CUSTOM_CHARACTER_DIFF";
    /**
     * @generated from enum value: FORCE_NON_OPTIMIZED_DIFF = 298;
     */
    ExperimentKey[ExperimentKey["FORCE_NON_OPTIMIZED_DIFF"] = 298] = "FORCE_NON_OPTIMIZED_DIFF";
    /**
     * Windsurf app deployments.
     *
     * @generated from enum value: CASCADE_WEB_APP_DEPLOYMENTS_ENABLED = 300;
     */
    ExperimentKey[ExperimentKey["CASCADE_WEB_APP_DEPLOYMENTS_ENABLED"] = 300] = "CASCADE_WEB_APP_DEPLOYMENTS_ENABLED";
    /**
     * @generated from enum value: CASCADE_RECIPES_AT_MENTION_VISIBILITY = 316;
     */
    ExperimentKey[ExperimentKey["CASCADE_RECIPES_AT_MENTION_VISIBILITY"] = 316] = "CASCADE_RECIPES_AT_MENTION_VISIBILITY";
    /**
     * @generated from enum value: IMPLICIT_USES_CLIPBOARD = 310;
     */
    ExperimentKey[ExperimentKey["IMPLICIT_USES_CLIPBOARD"] = 310] = "IMPLICIT_USES_CLIPBOARD";
    /**
     * @generated from enum value: DISABLE_SUPERCOMPLETE_PCW = 303;
     */
    ExperimentKey[ExperimentKey["DISABLE_SUPERCOMPLETE_PCW"] = 303] = "DISABLE_SUPERCOMPLETE_PCW";
    /**
     * @generated from enum value: BLOCK_TAB_ON_SHOWN_AUTOCOMPLETE = 304;
     */
    ExperimentKey[ExperimentKey["BLOCK_TAB_ON_SHOWN_AUTOCOMPLETE"] = 304] = "BLOCK_TAB_ON_SHOWN_AUTOCOMPLETE";
    /**
     * Show the web search NUX
     *
     * @generated from enum value: CASCADE_WEB_SEARCH_NUX = 311;
     */
    ExperimentKey[ExperimentKey["CASCADE_WEB_SEARCH_NUX"] = 311] = "CASCADE_WEB_SEARCH_NUX";
    /**
     * Show warnings about models experiencing issues
     *
     * @generated from enum value: MODEL_NOTIFICATIONS = 319;
     */
    ExperimentKey[ExperimentKey["MODEL_NOTIFICATIONS"] = 319] = "MODEL_NOTIFICATIONS";
    /**
     * Show warnings about models experiencing issues
     *
     * @generated from enum value: MODEL_SELECTOR_NUX_COPY = 320;
     */
    ExperimentKey[ExperimentKey["MODEL_SELECTOR_NUX_COPY"] = 320] = "MODEL_SELECTOR_NUX_COPY";
    /**
     * @generated from enum value: CASCADE_TOOL_CALL_PRICING_NUX = 322;
     */
    ExperimentKey[ExperimentKey["CASCADE_TOOL_CALL_PRICING_NUX"] = 322] = "CASCADE_TOOL_CALL_PRICING_NUX";
    /**
     * Show the plugins tab
     *
     * @generated from enum value: CASCADE_PLUGINS_TAB = 323;
     */
    ExperimentKey[ExperimentKey["CASCADE_PLUGINS_TAB"] = 323] = "CASCADE_PLUGINS_TAB";
    /**
     * Gate the Rules category in the @ mention menu
     *
     * @generated from enum value: WAVE_8_RULES_ENABLED = 324;
     */
    ExperimentKey[ExperimentKey["WAVE_8_RULES_ENABLED"] = 324] = "WAVE_8_RULES_ENABLED";
    /**
     * Gate the Knowledge feature
     *
     * @generated from enum value: WAVE_8_KNOWLEDGE_ENABLED = 325;
     */
    ExperimentKey[ExperimentKey["WAVE_8_KNOWLEDGE_ENABLED"] = 325] = "WAVE_8_KNOWLEDGE_ENABLED";
    /**
     * Onboarding flow in Cascade.
     *
     * @generated from enum value: CASCADE_ONBOARDING = 326;
     */
    ExperimentKey[ExperimentKey["CASCADE_ONBOARDING"] = 326] = "CASCADE_ONBOARDING";
    /**
     * Revert unleash flag
     *
     * @generated from enum value: CASCADE_ONBOARDING_REVERT = 327;
     */
    ExperimentKey[ExperimentKey["CASCADE_ONBOARDING_REVERT"] = 327] = "CASCADE_ONBOARDING_REVERT";
    /**
     * Windsurf Browser experiment flags.
     *
     * Used to gate Windsurf Browser Cascade tools and markdown links.
     *
     * @generated from enum value: CASCADE_WINDSURF_BROWSER_TOOLS_ENABLED = 328;
     */
    ExperimentKey[ExperimentKey["CASCADE_WINDSURF_BROWSER_TOOLS_ENABLED"] = 328] = "CASCADE_WINDSURF_BROWSER_TOOLS_ENABLED";
    /**
     * @generated from enum value: CASCADE_MODEL_HEADER_WARNING = 329;
     */
    ExperimentKey[ExperimentKey["CASCADE_MODEL_HEADER_WARNING"] = 329] = "CASCADE_MODEL_HEADER_WARNING";
    /**
     * For unit tests. Not a real experiment.
     *
     * @generated from enum value: TEST_ONLY = 999;
     */
    ExperimentKey[ExperimentKey["TEST_ONLY"] = 999] = "TEST_ONLY";
})(ExperimentKey || (ExperimentKey = {}));
// Retrieve enum metadata with: proto3.getEnumType(ExperimentKey)
proto3.util.setEnumType(ExperimentKey, "exa.codeium_common_pb.ExperimentKey", [
    { no: 0, name: "UNSPECIFIED" },
    { no: 36, name: "USE_INTERNAL_CHAT_MODEL" },
    { no: 47, name: "RECORD_FILES" },
    { no: 48, name: "NO_SAMPLER_EARLY_STOP" },
    { no: 53, name: "CM_MEMORY_TELEMETRY" },
    { no: 55, name: "LANGUAGE_SERVER_VERSION" },
    { no: 56, name: "LANGUAGE_SERVER_AUTO_RELOAD" },
    { no: 60, name: "ONLY_MULTILINE" },
    { no: 64, name: "USE_AUTOCOMPLETE_MODEL" },
    { no: 68, name: "USE_ATTRIBUTION_FOR_INDIVIDUAL_TIER" },
    { no: 78, name: "CHAT_MODEL_CONFIG" },
    { no: 79, name: "COMMAND_MODEL_CONFIG" },
    { no: 81, name: "MIN_IDE_VERSION" },
    { no: 84, name: "API_SERVER_VERBOSE_ERRORS" },
    { no: 86, name: "DEFAULT_ENABLE_SEARCH" },
    { no: 87, name: "COLLECT_ONBOARDING_EVENTS" },
    { no: 88, name: "COLLECT_EXAMPLE_COMPLETIONS" },
    { no: 89, name: "USE_MULTILINE_MODEL" },
    { no: 92, name: "ATTRIBUTION_KILL_SWITCH" },
    { no: 94, name: "FAST_MULTILINE" },
    { no: 95, name: "SINGLE_COMPLETION" },
    { no: 96, name: "STOP_FIRST_NON_WHITESPACE_LINE" },
    { no: 102, name: "CORTEX_CONFIG" },
    { no: 103, name: "MODEL_CHAT_11121_VARIANTS" },
    { no: 105, name: "INCLUDE_PROMPT_COMPONENTS" },
    { no: 106, name: "NON_TEAMS_KILL_SWITCH" },
    { no: 108, name: "PERSIST_CODE_TRACKER" },
    { no: 112, name: "API_SERVER_LIVENESS_PROBE" },
    { no: 114, name: "CHAT_COMPLETION_TOKENS_SOFT_LIMIT" },
    { no: 115, name: "CHAT_TOKENS_SOFT_LIMIT" },
    { no: 118, name: "DISABLE_COMPLETIONS_CACHE" },
    { no: 119, name: "LLAMA3_405B_KILL_SWITCH" },
    { no: 121, name: "USE_COMMAND_DOCSTRING_GENERATION" },
    { no: 123, name: "ENABLE_SUPERCOMPLETE" },
    { no: 136, name: "SENTRY" },
    { no: 144, name: "FAST_SINGLELINE" },
    { no: 147, name: "R2_LANGUAGE_SERVER_DOWNLOAD" },
    { no: 152, name: "SPLIT_MODEL" },
    { no: 198, name: "WINDSURF_SENTRY_SAMPLE_RATE" },
    { no: 158, name: "API_SERVER_CUTOFF" },
    { no: 159, name: "FAST_SPEED_KILL_SWITCH" },
    { no: 160, name: "PREDICTIVE_MULTILINE" },
    { no: 125, name: "SUPERCOMPLETE_FILTER_REVERT" },
    { no: 126, name: "SUPERCOMPLETE_FILTER_PREFIX_MATCH" },
    { no: 127, name: "SUPERCOMPLETE_FILTER_SCORE_THRESHOLD" },
    { no: 128, name: "SUPERCOMPLETE_FILTER_INSERTION_CAP" },
    { no: 133, name: "SUPERCOMPLETE_FILTER_DELETION_CAP" },
    { no: 156, name: "SUPERCOMPLETE_FILTER_WHITESPACE_ONLY" },
    { no: 170, name: "SUPERCOMPLETE_FILTER_NO_OP" },
    { no: 176, name: "SUPERCOMPLETE_FILTER_SUFFIX_MATCH" },
    { no: 182, name: "SUPERCOMPLETE_FILTER_PREVIOUSLY_SHOWN" },
    { no: 129, name: "SUPERCOMPLETE_MIN_SCORE" },
    { no: 130, name: "SUPERCOMPLETE_MAX_INSERTIONS" },
    { no: 131, name: "SUPERCOMPLETE_LINE_RADIUS" },
    { no: 132, name: "SUPERCOMPLETE_MAX_DELETIONS" },
    { no: 135, name: "SUPERCOMPLETE_USE_CURRENT_LINE" },
    { no: 138, name: "SUPERCOMPLETE_RECENT_STEPS_DURATION" },
    { no: 143, name: "SUPERCOMPLETE_USE_CODE_DIAGNOSTICS" },
    { no: 223, name: "SUPERCOMPLETE_DIAGNOSTIC_SEVERITY_THRESHOLD" },
    { no: 232, name: "SUPERCOMPLETE_CODE_DIAGNOSTICS_TOP_K" },
    { no: 154, name: "SUPERCOMPLETE_MAX_TRAJECTORY_STEPS" },
    { no: 157, name: "SUPERCOMPLETE_ON_ACCEPT_ONLY" },
    { no: 183, name: "SUPERCOMPLETE_TEMPERATURE" },
    { no: 203, name: "SUPERCOMPLETE_MAX_TRAJECTORY_STEP_SIZE" },
    { no: 231, name: "SUPERCOMPLETE_DISABLE_TYPING_CACHE" },
    { no: 293, name: "SUPERCOMPLETE_ALWAYS_USE_CACHE_ON_EQUAL_STATE" },
    { no: 297, name: "SUPERCOMPLETE_CACHE_ON_PARENT_ID_KILL_SWITCH" },
    { no: 140, name: "SUPERCOMPLETE_PRUNE_RESPONSE" },
    { no: 141, name: "SUPERCOMPLETE_PRUNE_MAX_INSERT_DELETE_LINE_DELTA" },
    { no: 145, name: "SUPERCOMPLETE_MODEL_CONFIG" },
    { no: 151, name: "SUPERCOMPLETE_ON_TAB" },
    { no: 171, name: "SUPERCOMPLETE_INLINE_PURE_DELETE" },
    { no: 218, name: "SUPERCOMPLETE_INLINE_RICH_GHOST_TEXT_INSERTIONS" },
    { no: 308, name: "MODEL_CHAT_19821_VARIANTS" },
    { no: 284, name: "SUPERCOMPLETE_MAX_CONCURRENT_REQUESTS" },
    { no: 255, name: "COMMAND_PROMPT_CACHE_CONFIG" },
    { no: 256, name: "CUMULATIVE_PROMPT_CONFIG" },
    { no: 279, name: "CUMULATIVE_PROMPT_CASCADE_CONFIG" },
    { no: 301, name: "TAB_JUMP_CUMULATIVE_PROMPT_CONFIG" },
    { no: 207, name: "COMPLETION_SPEED_SUPERCOMPLETE_CACHE" },
    { no: 208, name: "COMPLETION_SPEED_PREDICTIVE_SUPERCOMPLETE" },
    { no: 209, name: "COMPLETION_SPEED_TAB_JUMP_CACHE" },
    { no: 210, name: "COMPLETION_SPEED_PREDICTIVE_TAB_JUMP" },
    { no: 294, name: "COMPLETION_SPEED_BLOCK_TAB_JUMP_ON_PREDICTIVE_SUPERCOMPLETE" },
    { no: 137, name: "JETBRAINS_ENABLE_ONBOARDING" },
    { no: 146, name: "ENABLE_AUTOCOMPLETE_DURING_INTELLISENSE" },
    { no: 155, name: "COMMAND_BOX_ON_TOP" },
    { no: 149, name: "CONTEXT_ACTIVE_DOCUMENT_FRACTION" },
    { no: 150, name: "CONTEXT_COMMAND_TRAJECTORY_PROMPT_CONFIG" },
    { no: 178, name: "CONTEXT_FORCE_LOCAL_CONTEXT" },
    { no: 220, name: "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF" },
    { no: 295, name: "MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT_VARIANTS" },
    { no: 163, name: "USE_AUTOCOMPLETE_MODEL_SERVER_SIDE" },
    { no: 165, name: "SUPERCOMPLETE_NO_CONTEXT" },
    { no: 166, name: "SUPERCOMPLETE_NO_ACTIVE_NODE" },
    { no: 168, name: "TAB_JUMP_ENABLED" },
    { no: 169, name: "TAB_JUMP_ACCEPT_ENABLED" },
    { no: 177, name: "TAB_JUMP_LINE_RADIUS" },
    { no: 197, name: "TAB_JUMP_MIN_FILTER_RADIUS" },
    { no: 205, name: "TAB_JUMP_ON_ACCEPT_ONLY" },
    { no: 215, name: "TAB_JUMP_FILTER_IN_SELECTION" },
    { no: 237, name: "TAB_JUMP_MODEL_CONFIG" },
    { no: 238, name: "TAB_JUMP_FILTER_NO_OP" },
    { no: 239, name: "TAB_JUMP_FILTER_REVERT" },
    { no: 240, name: "TAB_JUMP_FILTER_SCORE_THRESHOLD" },
    { no: 241, name: "TAB_JUMP_FILTER_WHITESPACE_ONLY" },
    { no: 242, name: "TAB_JUMP_FILTER_INSERTION_CAP" },
    { no: 243, name: "TAB_JUMP_FILTER_DELETION_CAP" },
    { no: 260, name: "TAB_JUMP_PRUNE_RESPONSE" },
    { no: 261, name: "TAB_JUMP_PRUNE_MAX_INSERT_DELETE_LINE_DELTA" },
    { no: 317, name: "TAB_JUMP_STOP_TOKEN_MIDSTREAM" },
    { no: 211, name: "VIEWED_FILE_TRACKER_CONFIG" },
    { no: 305, name: "SNAPSHOT_TO_STEP_OPTIONS_OVERRIDE" },
    { no: 172, name: "STREAMING_EXTERNAL_COMMAND" },
    { no: 179, name: "USE_SPECIAL_EDIT_CODE_BLOCK" },
    { no: 187, name: "ENABLE_SUGGESTED_RESPONSES" },
    { no: 190, name: "CASCADE_BASE_MODEL_ID" },
    { no: 266, name: "CASCADE_PLAN_BASED_CONFIG_OVERRIDE" },
    { no: 212, name: "CASCADE_GLOBAL_CONFIG_OVERRIDE" },
    { no: 193, name: "CASCADE_BACKGROUND_RESEARCH_CONFIG_OVERRIDE" },
    { no: 204, name: "CASCADE_ENFORCE_QUOTA" },
    { no: 224, name: "CASCADE_ENABLE_AUTOMATED_MEMORIES" },
    { no: 314, name: "CASCADE_MEMORY_CONFIG_OVERRIDE" },
    { no: 228, name: "CASCADE_USE_REPLACE_CONTENT_EDIT_TOOL" },
    { no: 258, name: "CASCADE_VIEW_FILE_TOOL_CONFIG_OVERRIDE" },
    { no: 247, name: "CASCADE_USE_EXPERIMENT_CHECKPOINTER" },
    { no: 236, name: "CASCADE_ENABLE_CUSTOM_RECIPES" },
    { no: 245, name: "CASCADE_ENABLE_MCP_TOOLS" },
    { no: 275, name: "CASCADE_AUTO_FIX_LINTS" },
    { no: 296, name: "USE_ANTHROPIC_TOKEN_EFFICIENT_TOOLS_BETA" },
    { no: 289, name: "CASCADE_USER_MEMORIES_IN_SYS_PROMPT" },
    { no: 290, name: "CASCADE_ENABLE_PROXY_WEB_SERVER" },
    { no: 312, name: "COLLAPSE_ASSISTANT_MESSAGES" },
    { no: 321, name: "CASCADE_DEFAULT_MODEL_OVERRIDE" },
    { no: 181, name: "ENABLE_SMART_COPY" },
    { no: 185, name: "ENABLE_COMMIT_MESSAGE_GENERATION" },
    { no: 194, name: "SKIP_CONSISTENCY_MANAGER" },
    { no: 276, name: "FIREWORKS_ON_DEMAND_DEPLOYMENT" },
    { no: 202, name: "API_SERVER_CLIENT_USE_HTTP_2" },
    { no: 213, name: "AUTOCOMPLETE_DEFAULT_DEBOUNCE_MS" },
    { no: 214, name: "AUTOCOMPLETE_FAST_DEBOUNCE_MS" },
    { no: 219, name: "PROFILING_TELEMETRY_SAMPLE_RATE" },
    { no: 225, name: "STREAM_USER_SHELL_COMMANDS" },
    { no: 307, name: "API_SERVER_PROMPT_CACHE_REPLICAS" },
    { no: 272, name: "API_SERVER_ENABLE_MORE_LOGGING" },
    { no: 233, name: "COMMAND_INJECT_USER_MEMORIES" },
    { no: 234, name: "AUTOCOMPLETE_HIDDEN_ERROR_REGEX" },
    { no: 278, name: "DISABLE_IDE_COMPLETIONS_DEBOUNCE" },
    { no: 264, name: "COMBINED_MODEL_USE_FULL_INSTRUCTION_FOR_RETRIEVAL" },
    { no: 265, name: "MAX_PAST_TRAJECTORY_TOKENS_FOR_RETRIEVAL" },
    { no: 250, name: "ENABLE_QUICK_ACTIONS" },
    { no: 251, name: "QUICK_ACTIONS_WHITELIST_REGEX" },
    { no: 259, name: "CASCADE_NEW_MODELS_NUX" },
    { no: 270, name: "CASCADE_NEW_WAVE_2_MODELS_NUX" },
    { no: 262, name: "SUPERCOMPLETE_FAST_DEBOUNCE" },
    { no: 263, name: "SUPERCOMPLETE_REGULAR_DEBOUNCE" },
    { no: 268, name: "XML_TOOL_PARSING_MODELS" },
    { no: 269, name: "SUPERCOMPLETE_DONT_FILTER_MID_STREAMED" },
    { no: 285, name: "ANNOYANCE_MANAGER_MAX_NAVIGATION_RENDERS" },
    { no: 286, name: "ANNOYANCE_MANAGER_INLINE_PREVENTION_THRESHOLD_MS" },
    { no: 287, name: "ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_INTENTIONAL_REJECTIONS" },
    { no: 288, name: "ANNOYANCE_MANAGER_INLINE_PREVENTION_MAX_AUTO_REJECTIONS" },
    { no: 292, name: "USE_CUSTOM_CHARACTER_DIFF" },
    { no: 298, name: "FORCE_NON_OPTIMIZED_DIFF" },
    { no: 300, name: "CASCADE_WEB_APP_DEPLOYMENTS_ENABLED" },
    { no: 316, name: "CASCADE_RECIPES_AT_MENTION_VISIBILITY" },
    { no: 310, name: "IMPLICIT_USES_CLIPBOARD" },
    { no: 303, name: "DISABLE_SUPERCOMPLETE_PCW" },
    { no: 304, name: "BLOCK_TAB_ON_SHOWN_AUTOCOMPLETE" },
    { no: 311, name: "CASCADE_WEB_SEARCH_NUX" },
    { no: 319, name: "MODEL_NOTIFICATIONS" },
    { no: 320, name: "MODEL_SELECTOR_NUX_COPY" },
    { no: 322, name: "CASCADE_TOOL_CALL_PRICING_NUX" },
    { no: 323, name: "CASCADE_PLUGINS_TAB" },
    { no: 324, name: "WAVE_8_RULES_ENABLED" },
    { no: 325, name: "WAVE_8_KNOWLEDGE_ENABLED" },
    { no: 326, name: "CASCADE_ONBOARDING" },
    { no: 327, name: "CASCADE_ONBOARDING_REVERT" },
    { no: 328, name: "CASCADE_WINDSURF_BROWSER_TOOLS_ENABLED" },
    { no: 329, name: "CASCADE_MODEL_HEADER_WARNING" },
    { no: 999, name: "TEST_ONLY" },
]);
/**
 * Next ID: 4, Previous field: EXPERIMENT_SOURCE_API_SERVER
 *
 * @generated from enum exa.codeium_common_pb.ExperimentSource
 */
export var ExperimentSource;
(function (ExperimentSource) {
    /**
     * @generated from enum value: EXPERIMENT_SOURCE_UNSPECIFIED = 0;
     */
    ExperimentSource[ExperimentSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EXPERIMENT_SOURCE_EXTENSION = 1;
     */
    ExperimentSource[ExperimentSource["EXTENSION"] = 1] = "EXTENSION";
    /**
     * @generated from enum value: EXPERIMENT_SOURCE_LANGUAGE_SERVER = 2;
     */
    ExperimentSource[ExperimentSource["LANGUAGE_SERVER"] = 2] = "LANGUAGE_SERVER";
    /**
     * @generated from enum value: EXPERIMENT_SOURCE_API_SERVER = 3;
     */
    ExperimentSource[ExperimentSource["API_SERVER"] = 3] = "API_SERVER";
})(ExperimentSource || (ExperimentSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(ExperimentSource)
proto3.util.setEnumType(ExperimentSource, "exa.codeium_common_pb.ExperimentSource", [
    { no: 0, name: "EXPERIMENT_SOURCE_UNSPECIFIED" },
    { no: 1, name: "EXPERIMENT_SOURCE_EXTENSION" },
    { no: 2, name: "EXPERIMENT_SOURCE_LANGUAGE_SERVER" },
    { no: 3, name: "EXPERIMENT_SOURCE_API_SERVER" },
]);
/**
 * Model aliases will resolve to a model. Exact resolution details may vary depending on the situation.
 * The most common scenario is that a user-facing alias is selected, and resolved by the language server.
 * If you want to modify the model alias mapping, remember to also update modelToAliasMap in api_server/rpcs_chat.go
 *
 * @generated from enum exa.codeium_common_pb.ModelAlias
 */
export var ModelAlias;
(function (ModelAlias) {
    /**
     * @generated from enum value: MODEL_ALIAS_UNSPECIFIED = 0;
     */
    ModelAlias[ModelAlias["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MODEL_ALIAS_CASCADE_BASE = 1;
     */
    ModelAlias[ModelAlias["CASCADE_BASE"] = 1] = "CASCADE_BASE";
    /**
     * @generated from enum value: MODEL_ALIAS_VISTA = 3;
     */
    ModelAlias[ModelAlias["VISTA"] = 3] = "VISTA";
    /**
     * @generated from enum value: MODEL_ALIAS_SHAMU = 4;
     */
    ModelAlias[ModelAlias["SHAMU"] = 4] = "SHAMU";
    /**
     * @generated from enum value: MODEL_ALIAS_SWE_1 = 5;
     */
    ModelAlias[ModelAlias["SWE_1"] = 5] = "SWE_1";
    /**
     * @generated from enum value: MODEL_ALIAS_SWE_1_LITE = 6;
     */
    ModelAlias[ModelAlias["SWE_1_LITE"] = 6] = "SWE_1_LITE";
    /**
     * @generated from enum value: MODEL_ALIAS_AUTO = 7;
     */
    ModelAlias[ModelAlias["AUTO"] = 7] = "AUTO";
})(ModelAlias || (ModelAlias = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelAlias)
proto3.util.setEnumType(ModelAlias, "exa.codeium_common_pb.ModelAlias", [
    { no: 0, name: "MODEL_ALIAS_UNSPECIFIED" },
    { no: 1, name: "MODEL_ALIAS_CASCADE_BASE" },
    { no: 3, name: "MODEL_ALIAS_VISTA" },
    { no: 4, name: "MODEL_ALIAS_SHAMU" },
    { no: 5, name: "MODEL_ALIAS_SWE_1" },
    { no: 6, name: "MODEL_ALIAS_SWE_1_LITE" },
    { no: 7, name: "MODEL_ALIAS_AUTO" },
]);
/**
 * Enum value names may be public so use PR number + comment to identify them.
 * When adding a new model enum, also update exa/models/model_config/models.go
 * Next ID: 323, Previous field: MODEL_CLAUDE_4_SONNET_THINKING_OPEN_ROUTER_BYOK
 *
 * @generated from enum exa.codeium_common_pb.Model
 */
export var Model;
(function (Model) {
    /**
     * @generated from enum value: MODEL_UNSPECIFIED = 0;
     */
    Model[Model["MODEL_UNSPECIFIED"] = 0] = "MODEL_UNSPECIFIED";
    /**
     * Embedding models.
     * 141m embedding model.
     *
     * @generated from enum value: MODEL_EMBED_6591 = 20;
     */
    Model[Model["MODEL_EMBED_6591"] = 20] = "MODEL_EMBED_6591";
    /**
     * Autocomplete models.
     * A 10.048B x 1T autocomplete model, with nf4 and CTXFT
     *
     * @generated from enum value: MODEL_8341 = 33;
     */
    Model[Model["MODEL_8341"] = 33] = "MODEL_8341";
    /**
     * A 6B autocomplete model, nf4 quantized, with context, context token, reorder prompt
     *
     * @generated from enum value: MODEL_8528 = 42;
     */
    Model[Model["MODEL_8528"] = 42] = "MODEL_8528";
    /**
     * A 3.1B autocomplete model with CTXFT, nf4
     *
     * @generated from enum value: MODEL_9024 = 41;
     */
    Model[Model["MODEL_9024"] = 41] = "MODEL_9024";
    /**
     * A 3.1B autocomplete model with CTXFT, nf4, up to 16k context
     *
     * @generated from enum value: MODEL_14602 = 112;
     */
    Model[Model["MODEL_14602"] = 112] = "MODEL_14602";
    /**
     * A 10.044B autocomplete model with CTXFT, nf4, up to 16k context
     *
     * @generated from enum value: MODEL_15133 = 115;
     */
    Model[Model["MODEL_15133"] = 115] = "MODEL_15133";
    /**
     * An experimental 3.1B autocomplete model, CTX FT, NF4
     *
     * @generated from enum value: MODEL_15302 = 119;
     */
    Model[Model["MODEL_15302"] = 119] = "MODEL_15302";
    /**
     * An experimental 3.1B autocomplete model, CTX FT, NF4
     *
     * @generated from enum value: MODEL_15335 = 121;
     */
    Model[Model["MODEL_15335"] = 121] = "MODEL_15335";
    /**
     * An experimental 3.1B autocomplete model, base model, nf4
     *
     * @generated from enum value: MODEL_15336 = 122;
     */
    Model[Model["MODEL_15336"] = 122] = "MODEL_15336";
    /**
     * A 6B autocomplete model, ctx ft, nf4, up to 16k context
     *
     * @generated from enum value: MODEL_15931 = 167;
     */
    Model[Model["MODEL_15931"] = 167] = "MODEL_15931";
    /**
     * Query Relevance Models
     * 13b CodeLlama based mquery ft model. Multi-item capable. Requires sot token.
     *
     * @generated from enum value: MODEL_QUERY_9905 = 48;
     */
    Model[Model["MODEL_QUERY_9905"] = 48] = "MODEL_QUERY_9905";
    /**
     * A 8B Llama 3 based mquery ft model. Single-item only. Requires sot token.
     *
     * @generated from enum value: MODEL_QUERY_11791 = 66;
     */
    Model[Model["MODEL_QUERY_11791"] = 66] = "MODEL_QUERY_11791";
    /**
     * Chat Models
     * A 7b combined context-aware chat + command model with int8 quantization. Requires instruct tags.
     * Suitable for both Chat and Command. Trained on preference data. Suitable for Defense.
     *
     * @generated from enum value: MODEL_CHAT_11120 = 57;
     */
    Model[Model["MODEL_CHAT_11120"] = 57] = "MODEL_CHAT_11120";
    /**
     * A 13b combined context-aware chat + command model with int8 quantization. Requires instruct tags.
     * Suitable for both Chat and Command. Trained on preference data.
     *
     * @generated from enum value: MODEL_CHAT_11121 = 58;
     */
    Model[Model["MODEL_CHAT_11121"] = 58] = "MODEL_CHAT_11121";
    /**
     * An 70b Llama 3 based Command model with int8 quantization. Requires instruct tags.
     * Only suitable for Command.
     *
     * @generated from enum value: MODEL_CHAT_12119 = 70;
     */
    Model[Model["MODEL_CHAT_12119"] = 70] = "MODEL_CHAT_12119";
    /**
     * A 7b Mistral based combined context-aware chat + command model with int8 QAT.
     * Continued training on code-english mix with 16k context length.
     * Requires instruct tags. Suitable for both Chat and Command. Suitable for Defense.
     *
     * @generated from enum value: MODEL_CHAT_12121 = 69;
     */
    Model[Model["MODEL_CHAT_12121"] = 69] = "MODEL_CHAT_12121";
    /**
     * An 8b Llama 3 based Command + Chat model with int8 quantization. Requires instruct tags.
     *
     * @generated from enum value: MODEL_CHAT_12437 = 74;
     */
    Model[Model["MODEL_CHAT_12437"] = 74] = "MODEL_CHAT_12437";
    /**
     * A 34b Codellama based Command + Chat with nf4 quantization.
     *
     * @generated from enum value: MODEL_CHAT_12491 = 76;
     */
    Model[Model["MODEL_CHAT_12491"] = 76] = "MODEL_CHAT_12491";
    /**
     * A 34b Codellama based Command + Chat with int8 quantization.
     *
     * @generated from enum value: MODEL_CHAT_12623 = 78;
     */
    Model[Model["MODEL_CHAT_12623"] = 78] = "MODEL_CHAT_12623";
    /**
     * An 8b Llama 3 based Command model with int8 quantization, trained with SFT + DPO + SFT. Requires instruct tags.
     *
     * @generated from enum value: MODEL_CHAT_12950 = 79;
     */
    Model[Model["MODEL_CHAT_12950"] = 79] = "MODEL_CHAT_12950";
    /**
     * A 70b Llama 3 based Command + Chat with fp8 quantization, long context. Requires instruct tags.
     *
     * @generated from enum value: MODEL_CHAT_12968 = 101;
     */
    Model[Model["MODEL_CHAT_12968"] = 101] = "MODEL_CHAT_12968";
    /**
     * An 8b Llama 3 based Command model with int8 quantization, trained on command captured code data. Requires instruct tags.
     *
     * @generated from enum value: MODEL_CHAT_13404 = 102;
     */
    Model[Model["MODEL_CHAT_13404"] = 102] = "MODEL_CHAT_13404";
    /**
     * A 13b Command model with int8 quantization. Requires instruct tags.
     * Trained on preference data and command captured code data. Includes context check SFT stage.
     *
     * @generated from enum value: MODEL_CHAT_13566 = 103;
     */
    Model[Model["MODEL_CHAT_13566"] = 103] = "MODEL_CHAT_13566";
    /**
     * An 8b Llama 3 based Supercomplete model (SFT) with int8 quantization.
     *
     * @generated from enum value: MODEL_CHAT_13930 = 108;
     */
    Model[Model["MODEL_CHAT_13930"] = 108] = "MODEL_CHAT_13930";
    /**
     * A 13b Command model with int8 quantization. Requires instruct tags.
     * Trained on preference data and command captured code data, round 2, with context check SFT stage.
     *
     * @generated from enum value: MODEL_CHAT_14255 = 110;
     */
    Model[Model["MODEL_CHAT_14255"] = 110] = "MODEL_CHAT_14255";
    /**
     * MODEL_CHAT_14255 without the context check SFT stage.
     *
     * @generated from enum value: MODEL_CHAT_14256 = 111;
     */
    Model[Model["MODEL_CHAT_14256"] = 111] = "MODEL_CHAT_14256";
    /**
     * An 8b Llama 3 based Supercomplete model (SFT + DPO) with int8 quantization.
     *
     * @generated from enum value: MODEL_CHAT_14942 = 114;
     */
    Model[Model["MODEL_CHAT_14942"] = 114] = "MODEL_CHAT_14942";
    /**
     * A 10b combined autocomplete as command and supercomplete model, 4k context nf4
     * This needs to be a model chat (despite also being an autocomplete model because getCompletionsForCommandOrSupercomplete checks for it)
     *
     * @generated from enum value: MODEL_CHAT_15305 = 120;
     */
    Model[Model["MODEL_CHAT_15305"] = 120] = "MODEL_CHAT_15305";
    /**
     * A 10b Supercomplete model, 4k context nf4.
     *
     * @generated from enum value: MODEL_CHAT_15600 = 123;
     */
    Model[Model["MODEL_CHAT_15600"] = 123] = "MODEL_CHAT_15600";
    /**
     * A 10b Supercomplete model, 4k context nf4.
     *
     * @generated from enum value: MODEL_CHAT_16801 = 124;
     */
    Model[Model["MODEL_CHAT_16801"] = 124] = "MODEL_CHAT_16801";
    /**
     * 70B Llama 3.1 70b Instruct Chat + Command model with fp8 quantization.
     *
     * @generated from enum value: MODEL_CHAT_16718 = 175;
     */
    Model[Model["MODEL_CHAT_16718"] = 175] = "MODEL_CHAT_16718";
    /**
     * A 6b experimental cursor aware supercomplete (unified) model.
     *
     * @generated from enum value: MODEL_CHAT_15729 = 168;
     */
    Model[Model["MODEL_CHAT_15729"] = 168] = "MODEL_CHAT_15729";
    /**
     * 6b trajectory aware autocomplete in the cursor aware supercomplete (unified task) format.
     *
     * @generated from enum value: MODEL_CHAT_16579 = 173;
     */
    Model[Model["MODEL_CHAT_16579"] = 173] = "MODEL_CHAT_16579";
    /**
     * @generated from enum value: MODEL_CHAT_16579_CRUSOE = 174;
     */
    Model[Model["MODEL_CHAT_16579_CRUSOE"] = 174] = "MODEL_CHAT_16579_CRUSOE";
    /**
     * A 6b unified model.
     *
     * @generated from enum value: MODEL_CHAT_18805 = 181;
     */
    Model[Model["MODEL_CHAT_18805"] = 181] = "MODEL_CHAT_18805";
    /**
     * 6b llama tabjump printlinerange model.
     *
     * @generated from enum value: MODEL_CHAT_18468 = 210;
     */
    Model[Model["MODEL_CHAT_18468"] = 210] = "MODEL_CHAT_18468";
    /**
     * 7b qwen2 tabjump printlinerange model.
     *
     * @generated from enum value: MODEL_CHAT_19484 = 233;
     */
    Model[Model["MODEL_CHAT_19484"] = 233] = "MODEL_CHAT_19484";
    /**
     * 7b qwen2 tabjump printlinerange cascade format
     *
     * @generated from enum value: MODEL_CHAT_20706 = 235;
     */
    Model[Model["MODEL_CHAT_20706"] = 235] = "MODEL_CHAT_20706";
    /**
     * 7b qwen2 tabjump print line range, tab to whole document, cascade format
     *
     * @generated from enum value: MODEL_CHAT_21779 = 245;
     */
    Model[Model["MODEL_CHAT_21779"] = 245] = "MODEL_CHAT_21779";
    /**
     * A 6b unified model with cumulative prompt (only trajectory steps). Deprecated
     *
     * @generated from enum value: MODEL_CHAT_19040 = 211;
     */
    Model[Model["MODEL_CHAT_19040"] = 211] = "MODEL_CHAT_19040";
    /**
     * Tab model with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_19820 = 229;
     */
    Model[Model["MODEL_CHAT_19820"] = 229] = "MODEL_CHAT_19820";
    /**
     * Tab model with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_19821 = 230;
     */
    Model[Model["MODEL_CHAT_19821"] = 230] = "MODEL_CHAT_19821";
    /**
     * @generated from enum value: MODEL_CHAT_19821_CRUSOE = 244;
     */
    Model[Model["MODEL_CHAT_19821_CRUSOE"] = 244] = "MODEL_CHAT_19821_CRUSOE";
    /**
     * same as 19821 but finetuned for changes in step string converter and tool call split. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_23310 = 269;
     */
    Model[Model["MODEL_CHAT_23310"] = 269] = "MODEL_CHAT_23310";
    /**
     * Tab model with the cascade-esque prompt caching focused format. 6b nf4 cl100k
     *
     * @generated from enum value: MODEL_CHAT_19822 = 231;
     */
    Model[Model["MODEL_CHAT_19822"] = 231] = "MODEL_CHAT_19822";
    /**
     * Tab merged model with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_22798 = 255;
     */
    Model[Model["MODEL_CHAT_22798"] = 255] = "MODEL_CHAT_22798";
    /**
     * Tab merged model with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_22799 = 256;
     */
    Model[Model["MODEL_CHAT_22799"] = 256] = "MODEL_CHAT_22799";
    /**
     * Tab merged model tab to whole document with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_22800 = 257;
     */
    Model[Model["MODEL_CHAT_22800"] = 257] = "MODEL_CHAT_22800";
    /**
     * Tab model with the cascade-esque prompt caching focused format. 7b nf4 qwen2
     *
     * @generated from enum value: MODEL_CHAT_23151 = 267;
     */
    Model[Model["MODEL_CHAT_23151"] = 267] = "MODEL_CHAT_23151";
    /**
     * @generated from enum value: MODEL_CHAT_23152 = 268;
     */
    Model[Model["MODEL_CHAT_23152"] = 268] = "MODEL_CHAT_23152";
    /**
     * Cascade research agent, 7b fp8 qwen2
     *
     * @generated from enum value: MODEL_CASCADE_22893 = 270;
     */
    Model[Model["MODEL_CASCADE_22893"] = 270] = "MODEL_CASCADE_22893";
    /**
     * Cascade Planner models
     *
     * @generated from enum value: MODEL_CASCADE_20064 = 225;
     */
    Model[Model["MODEL_CASCADE_20064"] = 225] = "MODEL_CASCADE_20064";
    /**
     * @generated from enum value: MODEL_CASCADE_20065 = 236;
     */
    Model[Model["MODEL_CASCADE_20065"] = 236] = "MODEL_CASCADE_20065";
    /**
     * @generated from enum value: MODEL_CASCADE_20066 = 237;
     */
    Model[Model["MODEL_CASCADE_20066"] = 237] = "MODEL_CASCADE_20066";
    /**
     * @generated from enum value: MODEL_CASCADE_20067 = 238;
     */
    Model[Model["MODEL_CASCADE_20067"] = 238] = "MODEL_CASCADE_20067";
    /**
     * @generated from enum value: MODEL_CASCADE_20068 = 239;
     */
    Model[Model["MODEL_CASCADE_20068"] = 239] = "MODEL_CASCADE_20068";
    /**
     * @generated from enum value: MODEL_CASCADE_20069 = 240;
     */
    Model[Model["MODEL_CASCADE_20069"] = 240] = "MODEL_CASCADE_20069";
    /**
     * Cascade Planner Model (DSV3 Base)
     *
     * @generated from enum value: MODEL_CASCADE_20070 = 250;
     */
    Model[Model["MODEL_CASCADE_20070"] = 250] = "MODEL_CASCADE_20070";
    /**
     * @generated from enum value: MODEL_CASCADE_20071 = 251;
     */
    Model[Model["MODEL_CASCADE_20071"] = 251] = "MODEL_CASCADE_20071";
    /**
     * @generated from enum value: MODEL_CASCADE_20072 = 252;
     */
    Model[Model["MODEL_CASCADE_20072"] = 252] = "MODEL_CASCADE_20072";
    /**
     * @generated from enum value: MODEL_CASCADE_20073 = 253;
     */
    Model[Model["MODEL_CASCADE_20073"] = 253] = "MODEL_CASCADE_20073";
    /**
     * @generated from enum value: MODEL_CASCADE_20074 = 254;
     */
    Model[Model["MODEL_CASCADE_20074"] = 254] = "MODEL_CASCADE_20074";
    /**
     * @generated from enum value: MODEL_CASCADE_20075 = 307;
     */
    Model[Model["MODEL_CASCADE_20075"] = 307] = "MODEL_CASCADE_20075";
    /**
     * @generated from enum value: MODEL_CASCADE_20076 = 308;
     */
    Model[Model["MODEL_CASCADE_20076"] = 308] = "MODEL_CASCADE_20076";
    /**
     * @generated from enum value: MODEL_CASCADE_20077 = 309;
     */
    Model[Model["MODEL_CASCADE_20077"] = 309] = "MODEL_CASCADE_20077";
    /**
     * @generated from enum value: MODEL_CASCADE_20078 = 310;
     */
    Model[Model["MODEL_CASCADE_20078"] = 310] = "MODEL_CASCADE_20078";
    /**
     * @generated from enum value: MODEL_CASCADE_20079 = 311;
     */
    Model[Model["MODEL_CASCADE_20079"] = 311] = "MODEL_CASCADE_20079";
    /**
     * More 72b Cascade Planner Models
     *
     * @generated from enum value: MODEL_CASCADE_20080 = 297;
     */
    Model[Model["MODEL_CASCADE_20080"] = 297] = "MODEL_CASCADE_20080";
    /**
     * @generated from enum value: MODEL_CASCADE_20081 = 298;
     */
    Model[Model["MODEL_CASCADE_20081"] = 298] = "MODEL_CASCADE_20081";
    /**
     * @generated from enum value: MODEL_CASCADE_20082 = 299;
     */
    Model[Model["MODEL_CASCADE_20082"] = 299] = "MODEL_CASCADE_20082";
    /**
     * @generated from enum value: MODEL_CASCADE_20083 = 300;
     */
    Model[Model["MODEL_CASCADE_20083"] = 300] = "MODEL_CASCADE_20083";
    /**
     * @generated from enum value: MODEL_CASCADE_20084 = 301;
     */
    Model[Model["MODEL_CASCADE_20084"] = 301] = "MODEL_CASCADE_20084";
    /**
     * @generated from enum value: MODEL_CASCADE_20085 = 302;
     */
    Model[Model["MODEL_CASCADE_20085"] = 302] = "MODEL_CASCADE_20085";
    /**
     * @generated from enum value: MODEL_CASCADE_20086 = 303;
     */
    Model[Model["MODEL_CASCADE_20086"] = 303] = "MODEL_CASCADE_20086";
    /**
     * @generated from enum value: MODEL_CASCADE_20087 = 304;
     */
    Model[Model["MODEL_CASCADE_20087"] = 304] = "MODEL_CASCADE_20087";
    /**
     * @generated from enum value: MODEL_CASCADE_20088 = 305;
     */
    Model[Model["MODEL_CASCADE_20088"] = 305] = "MODEL_CASCADE_20088";
    /**
     * @generated from enum value: MODEL_CASCADE_20089 = 306;
     */
    Model[Model["MODEL_CASCADE_20089"] = 306] = "MODEL_CASCADE_20089";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_V3_INTERNAL = 247;
     */
    Model[Model["MODEL_DEEPSEEK_V3_INTERNAL"] = 247] = "MODEL_DEEPSEEK_V3_INTERNAL";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_V3_0324_INTERNAL = 248;
     */
    Model[Model["MODEL_DEEPSEEK_V3_0324_INTERNAL"] = 248] = "MODEL_DEEPSEEK_V3_0324_INTERNAL";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_R1_INTERNAL = 249;
     */
    Model[Model["MODEL_DEEPSEEK_R1_INTERNAL"] = 249] = "MODEL_DEEPSEEK_R1_INTERNAL";
    /**
     * PRIVATE ANTHROPIC MODELS allowlisted only for their team
     *
     * @generated from enum value: MODEL_ANTHROPIC_WINDSURF_RESEARCH = 241;
     */
    Model[Model["MODEL_ANTHROPIC_WINDSURF_RESEARCH"] = 241] = "MODEL_ANTHROPIC_WINDSURF_RESEARCH";
    /**
     * @generated from enum value: MODEL_ANTHROPIC_WINDSURF_RESEARCH_THINKING = 242;
     */
    Model[Model["MODEL_ANTHROPIC_WINDSURF_RESEARCH_THINKING"] = 242] = "MODEL_ANTHROPIC_WINDSURF_RESEARCH_THINKING";
    /**
     * Draft models.
     * 1755M context finetuned NF4 draft model for autocomplete.
     *
     * @generated from enum value: MODEL_DRAFT_11408 = 65;
     */
    Model[Model["MODEL_DRAFT_11408"] = 65] = "MODEL_DRAFT_11408";
    /**
     * 1228M chat + command NF4 draft model with llama tokenization and parallel layers.
     * Requires instruct tags.
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_11883 = 67;
     */
    Model[Model["MODEL_DRAFT_CHAT_11883"] = 67] = "MODEL_DRAFT_CHAT_11883";
    /**
     * 1229M chat + command NF4 draft model with llama3 tokenization and parallel layers.
     * Requires instruct tags.
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_12196 = 72;
     */
    Model[Model["MODEL_DRAFT_CHAT_12196"] = 72] = "MODEL_DRAFT_CHAT_12196";
    /**
     * 1229M chat + command NF4 draft model with llama tokenization and sequential layers.
     * Requires instruct tags.
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_12413 = 73;
     */
    Model[Model["MODEL_DRAFT_CHAT_12413"] = 73] = "MODEL_DRAFT_CHAT_12413";
    /**
     * 1229M chat + command NF4 draft model with llama3 tokenization and sequential layers.
     * Requires instruct tags.
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_13175 = 104;
     */
    Model[Model["MODEL_DRAFT_CHAT_13175"] = 104] = "MODEL_DRAFT_CHAT_13175";
    /**
     * Draft tab model for the cascade-esque prompt caching focused format. 1.25b nf4 qwen2
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_19823 = 232;
     */
    Model[Model["MODEL_DRAFT_CHAT_19823"] = 232] = "MODEL_DRAFT_CHAT_19823";
    /**
     * Draft tab model for the cascade-esque prompt caching focused format. 1.25b nf4 qwen2
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_20707 = 243;
     */
    Model[Model["MODEL_DRAFT_CHAT_20707"] = 243] = "MODEL_DRAFT_CHAT_20707";
    /**
     * Draft tab model for merged-model task, cascade-esque prompt caching focused format. 1.25b nf4 qwen2
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_22801 = 258;
     */
    Model[Model["MODEL_DRAFT_CHAT_22801"] = 258] = "MODEL_DRAFT_CHAT_22801";
    /**
     * 19823 but fixed format, intended for 23310. 1.25b nf4 qwen2
     *
     * @generated from enum value: MODEL_DRAFT_CHAT_23508 = 273;
     */
    Model[Model["MODEL_DRAFT_CHAT_23508"] = 273] = "MODEL_DRAFT_CHAT_23508";
    /**
     * Draft cascade model, 1.25b qwen2 fp8
     *
     * @generated from enum value: MODEL_DRAFT_CASCADE_23672 = 274;
     */
    Model[Model["MODEL_DRAFT_CASCADE_23672"] = 274] = "MODEL_DRAFT_CASCADE_23672";
    /**
     * OpenAI Models.
     * Corresponds to "gpt-3.5-turbo". Note as of 20240312 this points to gpt-3.5-turbo-0125.
     * See https://platform.openai.com/docs/models/gpt-3-5
     *
     * @generated from enum value: MODEL_CHAT_3_5_TURBO = 28;
     */
    Model[Model["MODEL_CHAT_3_5_TURBO"] = 28] = "MODEL_CHAT_3_5_TURBO";
    /**
     * Corresponds to "gpt-4".
     * See https://platform.openai.com/docs/models/gpt-4-and-gpt-4-turbo
     *
     * @generated from enum value: MODEL_CHAT_GPT_4 = 30;
     */
    Model[Model["MODEL_CHAT_GPT_4"] = 30] = "MODEL_CHAT_GPT_4";
    /**
     * Corresponds to "gpt-4-1106-preview".
     *
     * @generated from enum value: MODEL_CHAT_GPT_4_1106_PREVIEW = 37;
     */
    Model[Model["MODEL_CHAT_GPT_4_1106_PREVIEW"] = 37] = "MODEL_CHAT_GPT_4_1106_PREVIEW";
    /**
     * Corresponds to "text-embedding-ada-002".
     *
     * @generated from enum value: MODEL_TEXT_EMBEDDING_OPENAI_ADA = 91;
     */
    Model[Model["MODEL_TEXT_EMBEDDING_OPENAI_ADA"] = 91] = "MODEL_TEXT_EMBEDDING_OPENAI_ADA";
    /**
     * Corresponds to "text-embedding-3-small"
     *
     * @generated from enum value: MODEL_TEXT_EMBEDDING_OPENAI_3_SMALL = 163;
     */
    Model[Model["MODEL_TEXT_EMBEDDING_OPENAI_3_SMALL"] = 163] = "MODEL_TEXT_EMBEDDING_OPENAI_3_SMALL";
    /**
     * Corresponds to "text-embedding-3-large"
     *
     * @generated from enum value: MODEL_TEXT_EMBEDDING_OPENAI_3_LARGE = 164;
     */
    Model[Model["MODEL_TEXT_EMBEDDING_OPENAI_3_LARGE"] = 164] = "MODEL_TEXT_EMBEDDING_OPENAI_3_LARGE";
    /**
     * Corresponds to "gpt-4o-2024-05-13".
     *
     * @generated from enum value: MODEL_CHAT_GPT_4O_2024_05_13 = 71;
     */
    Model[Model["MODEL_CHAT_GPT_4O_2024_05_13"] = 71] = "MODEL_CHAT_GPT_4O_2024_05_13";
    /**
     * Corresponds to "gpt-4o-2024-08-06".
     *
     * @generated from enum value: MODEL_CHAT_GPT_4O_2024_08_06 = 109;
     */
    Model[Model["MODEL_CHAT_GPT_4O_2024_08_06"] = 109] = "MODEL_CHAT_GPT_4O_2024_08_06";
    /**
     * Corresponds to "gpt-4o-mini-2024-07-18".
     *
     * @generated from enum value: MODEL_CHAT_GPT_4O_MINI_2024_07_18 = 113;
     */
    Model[Model["MODEL_CHAT_GPT_4O_MINI_2024_07_18"] = 113] = "MODEL_CHAT_GPT_4O_MINI_2024_07_18";
    /**
     * Corresponds to "gpt-4.1-2025-04-14"
     *
     * @generated from enum value: MODEL_CHAT_GPT_4_1_2025_04_14 = 259;
     */
    Model[Model["MODEL_CHAT_GPT_4_1_2025_04_14"] = 259] = "MODEL_CHAT_GPT_4_1_2025_04_14";
    /**
     * Corresponds to "gpt-4.1-mini-2025-04-14"
     *
     * @generated from enum value: MODEL_CHAT_GPT_4_1_MINI_2025_04_14 = 260;
     */
    Model[Model["MODEL_CHAT_GPT_4_1_MINI_2025_04_14"] = 260] = "MODEL_CHAT_GPT_4_1_MINI_2025_04_14";
    /**
     * Corresponds to "gpt-4.1-nano-2025.04-14"
     *
     * @generated from enum value: MODEL_CHAT_GPT_4_1_NANO_2025_04_14 = 261;
     */
    Model[Model["MODEL_CHAT_GPT_4_1_NANO_2025_04_14"] = 261] = "MODEL_CHAT_GPT_4_1_NANO_2025_04_14";
    /**
     * Corresponds to "o1-preview"
     *
     * @generated from enum value: MODEL_CHAT_O1_PREVIEW = 117;
     */
    Model[Model["MODEL_CHAT_O1_PREVIEW"] = 117] = "MODEL_CHAT_O1_PREVIEW";
    /**
     * Corresponds to "o1-mini"
     *
     * @generated from enum value: MODEL_CHAT_O1_MINI = 118;
     */
    Model[Model["MODEL_CHAT_O1_MINI"] = 118] = "MODEL_CHAT_O1_MINI";
    /**
     * Corresponds to "o1"
     *
     * @generated from enum value: MODEL_CHAT_O1 = 170;
     */
    Model[Model["MODEL_CHAT_O1"] = 170] = "MODEL_CHAT_O1";
    /**
     * Corresponds to "o3-mini"
     *
     * @generated from enum value: MODEL_CHAT_O3_MINI = 207;
     */
    Model[Model["MODEL_CHAT_O3_MINI"] = 207] = "MODEL_CHAT_O3_MINI";
    /**
     * Corresponds to "o3-mini-low"
     *
     * @generated from enum value: MODEL_CHAT_O3_MINI_LOW = 213;
     */
    Model[Model["MODEL_CHAT_O3_MINI_LOW"] = 213] = "MODEL_CHAT_O3_MINI_LOW";
    /**
     * Corresponds to "o3-mini-high"
     *
     * @generated from enum value: MODEL_CHAT_O3_MINI_HIGH = 214;
     */
    Model[Model["MODEL_CHAT_O3_MINI_HIGH"] = 214] = "MODEL_CHAT_O3_MINI_HIGH";
    /**
     * Corresponds to "o3-2025-04-16"
     *
     * @generated from enum value: MODEL_CHAT_O3 = 218;
     */
    Model[Model["MODEL_CHAT_O3"] = 218] = "MODEL_CHAT_O3";
    /**
     * Corresponds to "o3-2025-04-16-low"
     *
     * @generated from enum value: MODEL_CHAT_O3_LOW = 262;
     */
    Model[Model["MODEL_CHAT_O3_LOW"] = 262] = "MODEL_CHAT_O3_LOW";
    /**
     * Corresponds to "o3-2025-04-16-high"
     *
     * @generated from enum value: MODEL_CHAT_O3_HIGH = 263;
     */
    Model[Model["MODEL_CHAT_O3_HIGH"] = 263] = "MODEL_CHAT_O3_HIGH";
    /**
     * Corresponds to "o4-mini-2025-04-16"
     *
     * @generated from enum value: MODEL_CHAT_O4_MINI = 264;
     */
    Model[Model["MODEL_CHAT_O4_MINI"] = 264] = "MODEL_CHAT_O4_MINI";
    /**
     * Corresponds to "o4-mini-2025-04-16-low"
     *
     * @generated from enum value: MODEL_CHAT_O4_MINI_LOW = 265;
     */
    Model[Model["MODEL_CHAT_O4_MINI_LOW"] = 265] = "MODEL_CHAT_O4_MINI_LOW";
    /**
     * Corresponds to "o4-mini-2025-04-16-high"
     *
     * @generated from enum value: MODEL_CHAT_O4_MINI_HIGH = 266;
     */
    Model[Model["MODEL_CHAT_O4_MINI_HIGH"] = 266] = "MODEL_CHAT_O4_MINI_HIGH";
    /**
     * Corresponds to "gpt-4.5"
     *
     * @generated from enum value: MODEL_CHAT_GPT_4_5 = 228;
     */
    Model[Model["MODEL_CHAT_GPT_4_5"] = 228] = "MODEL_CHAT_GPT_4_5";
    /**
     * Corresponds to "codex-mini-latest"
     *
     * @generated from enum value: MODEL_CODEX_MINI_LATEST = 287;
     */
    Model[Model["MODEL_CODEX_MINI_LATEST"] = 287] = "MODEL_CODEX_MINI_LATEST";
    /**
     * Corresponds to "codex-mini-latest-low"
     *
     * @generated from enum value: MODEL_CODEX_MINI_LATEST_LOW = 288;
     */
    Model[Model["MODEL_CODEX_MINI_LATEST_LOW"] = 288] = "MODEL_CODEX_MINI_LATEST_LOW";
    /**
     * Corresponds to "codex-mini-latest-high"
     *
     * @generated from enum value: MODEL_CODEX_MINI_LATEST_HIGH = 289;
     */
    Model[Model["MODEL_CODEX_MINI_LATEST_HIGH"] = 289] = "MODEL_CODEX_MINI_LATEST_HIGH";
    /**
     * Corresponds to "o3-pro-2025-06-10"
     *
     * @generated from enum value: MODEL_O3_PRO_2025_06_10 = 294;
     */
    Model[Model["MODEL_O3_PRO_2025_06_10"] = 294] = "MODEL_O3_PRO_2025_06_10";
    /**
     * Corresponds to "o3-pro-2025-06-10-low"
     *
     * @generated from enum value: MODEL_O3_PRO_2025_06_10_LOW = 295;
     */
    Model[Model["MODEL_O3_PRO_2025_06_10_LOW"] = 295] = "MODEL_O3_PRO_2025_06_10_LOW";
    /**
     * Corresponds to "o3-pro-2025-06-10-high"
     *
     * @generated from enum value: MODEL_O3_PRO_2025_06_10_HIGH = 296;
     */
    Model[Model["MODEL_O3_PRO_2025_06_10_HIGH"] = 296] = "MODEL_O3_PRO_2025_06_10_HIGH";
    /**
     * Google Models
     *
     * @generated from enum value: MODEL_GOOGLE_GEMINI_1_0_PRO = 61;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_1_0_PRO"] = 61] = "MODEL_GOOGLE_GEMINI_1_0_PRO";
    /**
     * @generated from enum value: MODEL_GOOGLE_GEMINI_1_5_PRO = 62;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_1_5_PRO"] = 62] = "MODEL_GOOGLE_GEMINI_1_5_PRO";
    /**
     * @generated from enum value: MODEL_GOOGLE_GEMINI_EXP_1206 = 183;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_EXP_1206"] = 183] = "MODEL_GOOGLE_GEMINI_EXP_1206";
    /**
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_0_FLASH = 184;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_0_FLASH"] = 184] = "MODEL_GOOGLE_GEMINI_2_0_FLASH";
    /**
     * Corresponds to "gemini-2.5-pro"
     *
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_PRO = 246;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_PRO"] = 246] = "MODEL_GOOGLE_GEMINI_2_5_PRO";
    /**
     * Corresponds to "gemini-2.5-flash-preview-04-17"
     *
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_04_17 = 272;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_04_17"] = 272] = "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_04_17";
    /**
     * Corresponds to "gemini-2.5-flash-preview-05-20
     *
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20 = 275;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20"] = 275] = "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20";
    /**
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20_THINKING = 276;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20_THINKING"] = 276] = "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20_THINKING";
    /**
     * Corresponds to "gemini-2.5-flash"
     *
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_FLASH = 312;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_FLASH"] = 312] = "MODEL_GOOGLE_GEMINI_2_5_FLASH";
    /**
     * @generated from enum value: MODEL_GOOGLE_GEMINI_2_5_FLASH_THINKING = 313;
     */
    Model[Model["MODEL_GOOGLE_GEMINI_2_5_FLASH_THINKING"] = 313] = "MODEL_GOOGLE_GEMINI_2_5_FLASH_THINKING";
    /**
     * Anthropic Models
     *
     * @generated from enum value: MODEL_CLAUDE_3_OPUS_20240229 = 63;
     */
    Model[Model["MODEL_CLAUDE_3_OPUS_20240229"] = 63] = "MODEL_CLAUDE_3_OPUS_20240229";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_SONNET_20240229 = 64;
     */
    Model[Model["MODEL_CLAUDE_3_SONNET_20240229"] = 64] = "MODEL_CLAUDE_3_SONNET_20240229";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_HAIKU_20240307 = 172;
     */
    Model[Model["MODEL_CLAUDE_3_HAIKU_20240307"] = 172] = "MODEL_CLAUDE_3_HAIKU_20240307";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_5_HAIKU_20241022 = 171;
     */
    Model[Model["MODEL_CLAUDE_3_5_HAIKU_20241022"] = 171] = "MODEL_CLAUDE_3_5_HAIKU_20241022";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_5_SONNET_20240620 = 80;
     */
    Model[Model["MODEL_CLAUDE_3_5_SONNET_20240620"] = 80] = "MODEL_CLAUDE_3_5_SONNET_20240620";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_5_SONNET_20241022 = 166;
     */
    Model[Model["MODEL_CLAUDE_3_5_SONNET_20241022"] = 166] = "MODEL_CLAUDE_3_5_SONNET_20241022";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_20250219 = 226;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_20250219"] = 226] = "MODEL_CLAUDE_3_7_SONNET_20250219";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_20250219_THINKING = 227;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_20250219_THINKING"] = 227] = "MODEL_CLAUDE_3_7_SONNET_20250219_THINKING";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_5_SONNET_BYOK = 284;
     */
    Model[Model["MODEL_CLAUDE_3_5_SONNET_BYOK"] = 284] = "MODEL_CLAUDE_3_5_SONNET_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_BYOK = 285;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_BYOK"] = 285] = "MODEL_CLAUDE_3_7_SONNET_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_OPEN_ROUTER_BYOK = 319;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_OPEN_ROUTER_BYOK"] = 319] = "MODEL_CLAUDE_3_7_SONNET_OPEN_ROUTER_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_THINKING_BYOK = 286;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_THINKING_BYOK"] = 286] = "MODEL_CLAUDE_3_7_SONNET_THINKING_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_3_7_SONNET_THINKING_OPEN_ROUTER_BYOK = 320;
     */
    Model[Model["MODEL_CLAUDE_3_7_SONNET_THINKING_OPEN_ROUTER_BYOK"] = 320] = "MODEL_CLAUDE_3_7_SONNET_THINKING_OPEN_ROUTER_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_OPUS_BYOK = 277;
     */
    Model[Model["MODEL_CLAUDE_4_OPUS_BYOK"] = 277] = "MODEL_CLAUDE_4_OPUS_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_OPUS_THINKING_BYOK = 278;
     */
    Model[Model["MODEL_CLAUDE_4_OPUS_THINKING_BYOK"] = 278] = "MODEL_CLAUDE_4_OPUS_THINKING_BYOK";
    /**
     * Not yet implemented.
     *
     * @generated from enum value: MODEL_CLAUDE_4_OPUS = 290;
     */
    Model[Model["MODEL_CLAUDE_4_OPUS"] = 290] = "MODEL_CLAUDE_4_OPUS";
    /**
     * Not yet implemented.
     *
     * @generated from enum value: MODEL_CLAUDE_4_OPUS_THINKING = 291;
     */
    Model[Model["MODEL_CLAUDE_4_OPUS_THINKING"] = 291] = "MODEL_CLAUDE_4_OPUS_THINKING";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_BYOK = 279;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_BYOK"] = 279] = "MODEL_CLAUDE_4_SONNET_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_OPEN_ROUTER_BYOK = 321;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_OPEN_ROUTER_BYOK"] = 321] = "MODEL_CLAUDE_4_SONNET_OPEN_ROUTER_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_THINKING_BYOK = 280;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_THINKING_BYOK"] = 280] = "MODEL_CLAUDE_4_SONNET_THINKING_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_THINKING_OPEN_ROUTER_BYOK = 322;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_THINKING_OPEN_ROUTER_BYOK"] = 322] = "MODEL_CLAUDE_4_SONNET_THINKING_OPEN_ROUTER_BYOK";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET = 281;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET"] = 281] = "MODEL_CLAUDE_4_SONNET";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_THINKING = 282;
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_THINKING"] = 282] = "MODEL_CLAUDE_4_SONNET_THINKING";
    /**
     * Deprecated fields to maintain backward compatibility for data sources and clients that maintain
     * text-based references to model names.
     *
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_DATABRICKS = 292 [deprecated = true];
     * @deprecated
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_DATABRICKS"] = 292] = "MODEL_CLAUDE_4_SONNET_DATABRICKS";
    /**
     * @generated from enum value: MODEL_CLAUDE_4_SONNET_THINKING_DATABRICKS = 293 [deprecated = true];
     * @deprecated
     */
    Model[Model["MODEL_CLAUDE_4_SONNET_THINKING_DATABRICKS"] = 293] = "MODEL_CLAUDE_4_SONNET_THINKING_DATABRICKS";
    /**
     * Together AI Models
     *
     * @generated from enum value: MODEL_TOGETHERAI_TEXT_EMBEDDING_M2_BERT = 81;
     */
    Model[Model["MODEL_TOGETHERAI_TEXT_EMBEDDING_M2_BERT"] = 81] = "MODEL_TOGETHERAI_TEXT_EMBEDDING_M2_BERT";
    /**
     * @generated from enum value: MODEL_TOGETHERAI_LLAMA_3_1_8B_INSTRUCT = 165;
     */
    Model[Model["MODEL_TOGETHERAI_LLAMA_3_1_8B_INSTRUCT"] = 165] = "MODEL_TOGETHERAI_LLAMA_3_1_8B_INSTRUCT";
    /**
     * Hugging Face Models
     *
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_M2_BERT = 82;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_M2_BERT"] = 82] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_M2_BERT";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_UAE_CODE = 83;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_UAE_CODE"] = 83] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_UAE_CODE";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_BGE = 84;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_BGE"] = 84] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_BGE";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_BLADE = 85;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_BLADE"] = 85] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_BLADE";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_ARCTIC_LARGE = 86;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_ARCTIC_LARGE"] = 86] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_ARCTIC_LARGE";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_E5_BASE = 87;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_E5_BASE"] = 87] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_E5_BASE";
    /**
     * @generated from enum value: MODEL_HUGGING_FACE_TEXT_EMBEDDING_MXBAI = 88;
     */
    Model[Model["MODEL_HUGGING_FACE_TEXT_EMBEDDING_MXBAI"] = 88] = "MODEL_HUGGING_FACE_TEXT_EMBEDDING_MXBAI";
    /**
     * Llama Models
     *
     * @generated from enum value: MODEL_LLAMA_3_1_8B_INSTRUCT = 106;
     */
    Model[Model["MODEL_LLAMA_3_1_8B_INSTRUCT"] = 106] = "MODEL_LLAMA_3_1_8B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_LLAMA_3_1_70B_INSTRUCT = 107;
     */
    Model[Model["MODEL_LLAMA_3_1_70B_INSTRUCT"] = 107] = "MODEL_LLAMA_3_1_70B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_LLAMA_3_1_405B_INSTRUCT = 105;
     */
    Model[Model["MODEL_LLAMA_3_1_405B_INSTRUCT"] = 105] = "MODEL_LLAMA_3_1_405B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_LLAMA_3_3_70B_INSTRUCT = 208;
     */
    Model[Model["MODEL_LLAMA_3_3_70B_INSTRUCT"] = 208] = "MODEL_LLAMA_3_3_70B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_LLAMA_3_3_70B_INSTRUCT_R1 = 209;
     */
    Model[Model["MODEL_LLAMA_3_3_70B_INSTRUCT_R1"] = 209] = "MODEL_LLAMA_3_3_70B_INSTRUCT_R1";
    /**
     * Special model id for the 70b for fast apply with long context
     *
     * @generated from enum value: MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT = 116;
     */
    Model[Model["MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT"] = 116] = "MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT";
    /**
     * Hermes Models
     *
     * @generated from enum value: MODEL_LLAMA_3_1_8B_HERMES_3 = 176;
     */
    Model[Model["MODEL_LLAMA_3_1_8B_HERMES_3"] = 176] = "MODEL_LLAMA_3_1_8B_HERMES_3";
    /**
     * @generated from enum value: MODEL_LLAMA_3_1_70B_HERMES_3 = 177;
     */
    Model[Model["MODEL_LLAMA_3_1_70B_HERMES_3"] = 177] = "MODEL_LLAMA_3_1_70B_HERMES_3";
    /**
     * Qwen Models
     *
     * @generated from enum value: MODEL_QWEN_2_5_7B_INSTRUCT = 178;
     */
    Model[Model["MODEL_QWEN_2_5_7B_INSTRUCT"] = 178] = "MODEL_QWEN_2_5_7B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_QWEN_2_5_32B_INSTRUCT = 179;
     */
    Model[Model["MODEL_QWEN_2_5_32B_INSTRUCT"] = 179] = "MODEL_QWEN_2_5_32B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_QWEN_2_5_72B_INSTRUCT = 180;
     */
    Model[Model["MODEL_QWEN_2_5_72B_INSTRUCT"] = 180] = "MODEL_QWEN_2_5_72B_INSTRUCT";
    /**
     * @generated from enum value: MODEL_QWEN_2_5_32B_INSTRUCT_R1 = 224;
     */
    Model[Model["MODEL_QWEN_2_5_32B_INSTRUCT_R1"] = 224] = "MODEL_QWEN_2_5_32B_INSTRUCT_R1";
    /**
     * Nomic Embedding Models
     *
     * @generated from enum value: MODEL_NOMIC_TEXT_EMBEDDING_V1 = 89;
     */
    Model[Model["MODEL_NOMIC_TEXT_EMBEDDING_V1"] = 89] = "MODEL_NOMIC_TEXT_EMBEDDING_V1";
    /**
     * @generated from enum value: MODEL_NOMIC_TEXT_EMBEDDING_V1_5 = 90;
     */
    Model[Model["MODEL_NOMIC_TEXT_EMBEDDING_V1_5"] = 90] = "MODEL_NOMIC_TEXT_EMBEDDING_V1_5";
    /**
     * vLLM Models
     *
     * @generated from enum value: MODEL_MISTRAL_7B = 77;
     */
    Model[Model["MODEL_MISTRAL_7B"] = 77] = "MODEL_MISTRAL_7B";
    /**
     * @generated from enum value: MODEL_SALESFORCE_EMBEDDING_2R = 99;
     */
    Model[Model["MODEL_SALESFORCE_EMBEDDING_2R"] = 99] = "MODEL_SALESFORCE_EMBEDDING_2R";
    /**
     * a generic vllm model, override the model name in models.go
     *
     * @generated from enum value: MODEL_CUSTOM_VLLM = 182;
     */
    Model[Model["MODEL_CUSTOM_VLLM"] = 182] = "MODEL_CUSTOM_VLLM";
    /**
     * TEI Embedding Models
     *
     * @generated from enum value: MODEL_TEI_BGE_M3 = 92;
     */
    Model[Model["MODEL_TEI_BGE_M3"] = 92] = "MODEL_TEI_BGE_M3";
    /**
     * @generated from enum value: MODEL_TEI_NOMIC_EMBED_TEXT_V1 = 93;
     */
    Model[Model["MODEL_TEI_NOMIC_EMBED_TEXT_V1"] = 93] = "MODEL_TEI_NOMIC_EMBED_TEXT_V1";
    /**
     * @generated from enum value: MODEL_TEI_INTFLOAT_E5_LARGE_INSTRUCT = 94;
     */
    Model[Model["MODEL_TEI_INTFLOAT_E5_LARGE_INSTRUCT"] = 94] = "MODEL_TEI_INTFLOAT_E5_LARGE_INSTRUCT";
    /**
     * @generated from enum value: MODEL_TEI_SNOWFLAKE_ARCTIC_EMBED_L = 95;
     */
    Model[Model["MODEL_TEI_SNOWFLAKE_ARCTIC_EMBED_L"] = 95] = "MODEL_TEI_SNOWFLAKE_ARCTIC_EMBED_L";
    /**
     * @generated from enum value: MODEL_TEI_UAE_CODE_LARGE_V1 = 96;
     */
    Model[Model["MODEL_TEI_UAE_CODE_LARGE_V1"] = 96] = "MODEL_TEI_UAE_CODE_LARGE_V1";
    /**
     * @generated from enum value: MODEL_TEI_B1ADE = 97;
     */
    Model[Model["MODEL_TEI_B1ADE"] = 97] = "MODEL_TEI_B1ADE";
    /**
     * @generated from enum value: MODEL_TEI_WHEREISAI_UAE_LARGE_V1 = 98;
     */
    Model[Model["MODEL_TEI_WHEREISAI_UAE_LARGE_V1"] = 98] = "MODEL_TEI_WHEREISAI_UAE_LARGE_V1";
    /**
     * @generated from enum value: MODEL_TEI_WHEREISAI_UAE_CODE_LARGE_V1 = 100;
     */
    Model[Model["MODEL_TEI_WHEREISAI_UAE_CODE_LARGE_V1"] = 100] = "MODEL_TEI_WHEREISAI_UAE_CODE_LARGE_V1";
    /**
     * External Compatible Models
     *
     * @generated from enum value: MODEL_OPENAI_COMPATIBLE = 200;
     */
    Model[Model["MODEL_OPENAI_COMPATIBLE"] = 200] = "MODEL_OPENAI_COMPATIBLE";
    /**
     * @generated from enum value: MODEL_ANTHROPIC_COMPATIBLE = 201;
     */
    Model[Model["MODEL_ANTHROPIC_COMPATIBLE"] = 201] = "MODEL_ANTHROPIC_COMPATIBLE";
    /**
     * @generated from enum value: MODEL_VERTEX_COMPATIBLE = 202;
     */
    Model[Model["MODEL_VERTEX_COMPATIBLE"] = 202] = "MODEL_VERTEX_COMPATIBLE";
    /**
     * @generated from enum value: MODEL_BEDROCK_COMPATIBLE = 203;
     */
    Model[Model["MODEL_BEDROCK_COMPATIBLE"] = 203] = "MODEL_BEDROCK_COMPATIBLE";
    /**
     * @generated from enum value: MODEL_AZURE_COMPATIBLE = 204;
     */
    Model[Model["MODEL_AZURE_COMPATIBLE"] = 204] = "MODEL_AZURE_COMPATIBLE";
    /**
     * Fireworks Models
     *
     * @generated from enum value: MODEL_DEEPSEEK_V3 = 205;
     */
    Model[Model["MODEL_DEEPSEEK_V3"] = 205] = "MODEL_DEEPSEEK_V3";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_R1 = 206;
     */
    Model[Model["MODEL_DEEPSEEK_R1"] = 206] = "MODEL_DEEPSEEK_R1";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_R1_SLOW = 215;
     */
    Model[Model["MODEL_DEEPSEEK_R1_SLOW"] = 215] = "MODEL_DEEPSEEK_R1_SLOW";
    /**
     * @generated from enum value: MODEL_DEEPSEEK_R1_FAST = 216;
     */
    Model[Model["MODEL_DEEPSEEK_R1_FAST"] = 216] = "MODEL_DEEPSEEK_R1_FAST";
    /**
     * OpenRouter Models
     * a generic open router model, override the model name in models.go
     *
     * @generated from enum value: MODEL_CUSTOM_OPEN_ROUTER = 185;
     */
    Model[Model["MODEL_CUSTOM_OPEN_ROUTER"] = 185] = "MODEL_CUSTOM_OPEN_ROUTER";
    /**
     * xAI Models
     *
     * @generated from enum value: MODEL_XAI_GROK_2 = 212;
     */
    Model[Model["MODEL_XAI_GROK_2"] = 212] = "MODEL_XAI_GROK_2";
    /**
     * @generated from enum value: MODEL_XAI_GROK_3 = 217;
     */
    Model[Model["MODEL_XAI_GROK_3"] = 217] = "MODEL_XAI_GROK_3";
    /**
     * @generated from enum value: MODEL_XAI_GROK_3_MINI_REASONING = 234;
     */
    Model[Model["MODEL_XAI_GROK_3_MINI_REASONING"] = 234] = "MODEL_XAI_GROK_3_MINI_REASONING";
    /**
     * Placeholder models that we don't want to expose (ie. unreleased models, betas). Also enables us to release new models without needing to update the Windsurf client. Should not be used permanently.
     *
     * Earlier release for Gemini 2.5 Pro
     *
     * @generated from enum value: MODEL_PRIVATE_1 = 219;
     */
    Model[Model["MODEL_PRIVATE_1"] = 219] = "MODEL_PRIVATE_1";
    /**
     * Grok 3 with images
     *
     * @generated from enum value: MODEL_PRIVATE_2 = 220;
     */
    Model[Model["MODEL_PRIVATE_2"] = 220] = "MODEL_PRIVATE_2";
    /**
     * GPT 4.1
     *
     * @generated from enum value: MODEL_PRIVATE_3 = 221;
     */
    Model[Model["MODEL_PRIVATE_3"] = 221] = "MODEL_PRIVATE_3";
    /**
     * gpt-4.1-nano-reasoning-alpha-2025-06-26
     *
     * @generated from enum value: MODEL_PRIVATE_4 = 222;
     */
    Model[Model["MODEL_PRIVATE_4"] = 222] = "MODEL_PRIVATE_4";
    /**
     * @generated from enum value: MODEL_PRIVATE_5 = 223;
     */
    Model[Model["MODEL_PRIVATE_5"] = 223] = "MODEL_PRIVATE_5";
    /**
     * @generated from enum value: MODEL_PRIVATE_6 = 314;
     */
    Model[Model["MODEL_PRIVATE_6"] = 314] = "MODEL_PRIVATE_6";
    /**
     * @generated from enum value: MODEL_PRIVATE_7 = 315;
     */
    Model[Model["MODEL_PRIVATE_7"] = 315] = "MODEL_PRIVATE_7";
    /**
     * @generated from enum value: MODEL_PRIVATE_8 = 316;
     */
    Model[Model["MODEL_PRIVATE_8"] = 316] = "MODEL_PRIVATE_8";
    /**
     * @generated from enum value: MODEL_PRIVATE_9 = 317;
     */
    Model[Model["MODEL_PRIVATE_9"] = 317] = "MODEL_PRIVATE_9";
    /**
     * @generated from enum value: MODEL_PRIVATE_10 = 318;
     */
    Model[Model["MODEL_PRIVATE_10"] = 318] = "MODEL_PRIVATE_10";
})(Model || (Model = {}));
// Retrieve enum metadata with: proto3.getEnumType(Model)
proto3.util.setEnumType(Model, "exa.codeium_common_pb.Model", [
    { no: 0, name: "MODEL_UNSPECIFIED" },
    { no: 20, name: "MODEL_EMBED_6591" },
    { no: 33, name: "MODEL_8341" },
    { no: 42, name: "MODEL_8528" },
    { no: 41, name: "MODEL_9024" },
    { no: 112, name: "MODEL_14602" },
    { no: 115, name: "MODEL_15133" },
    { no: 119, name: "MODEL_15302" },
    { no: 121, name: "MODEL_15335" },
    { no: 122, name: "MODEL_15336" },
    { no: 167, name: "MODEL_15931" },
    { no: 48, name: "MODEL_QUERY_9905" },
    { no: 66, name: "MODEL_QUERY_11791" },
    { no: 57, name: "MODEL_CHAT_11120" },
    { no: 58, name: "MODEL_CHAT_11121" },
    { no: 70, name: "MODEL_CHAT_12119" },
    { no: 69, name: "MODEL_CHAT_12121" },
    { no: 74, name: "MODEL_CHAT_12437" },
    { no: 76, name: "MODEL_CHAT_12491" },
    { no: 78, name: "MODEL_CHAT_12623" },
    { no: 79, name: "MODEL_CHAT_12950" },
    { no: 101, name: "MODEL_CHAT_12968" },
    { no: 102, name: "MODEL_CHAT_13404" },
    { no: 103, name: "MODEL_CHAT_13566" },
    { no: 108, name: "MODEL_CHAT_13930" },
    { no: 110, name: "MODEL_CHAT_14255" },
    { no: 111, name: "MODEL_CHAT_14256" },
    { no: 114, name: "MODEL_CHAT_14942" },
    { no: 120, name: "MODEL_CHAT_15305" },
    { no: 123, name: "MODEL_CHAT_15600" },
    { no: 124, name: "MODEL_CHAT_16801" },
    { no: 175, name: "MODEL_CHAT_16718" },
    { no: 168, name: "MODEL_CHAT_15729" },
    { no: 173, name: "MODEL_CHAT_16579" },
    { no: 174, name: "MODEL_CHAT_16579_CRUSOE" },
    { no: 181, name: "MODEL_CHAT_18805" },
    { no: 210, name: "MODEL_CHAT_18468" },
    { no: 233, name: "MODEL_CHAT_19484" },
    { no: 235, name: "MODEL_CHAT_20706" },
    { no: 245, name: "MODEL_CHAT_21779" },
    { no: 211, name: "MODEL_CHAT_19040" },
    { no: 229, name: "MODEL_CHAT_19820" },
    { no: 230, name: "MODEL_CHAT_19821" },
    { no: 244, name: "MODEL_CHAT_19821_CRUSOE" },
    { no: 269, name: "MODEL_CHAT_23310" },
    { no: 231, name: "MODEL_CHAT_19822" },
    { no: 255, name: "MODEL_CHAT_22798" },
    { no: 256, name: "MODEL_CHAT_22799" },
    { no: 257, name: "MODEL_CHAT_22800" },
    { no: 267, name: "MODEL_CHAT_23151" },
    { no: 268, name: "MODEL_CHAT_23152" },
    { no: 270, name: "MODEL_CASCADE_22893" },
    { no: 225, name: "MODEL_CASCADE_20064" },
    { no: 236, name: "MODEL_CASCADE_20065" },
    { no: 237, name: "MODEL_CASCADE_20066" },
    { no: 238, name: "MODEL_CASCADE_20067" },
    { no: 239, name: "MODEL_CASCADE_20068" },
    { no: 240, name: "MODEL_CASCADE_20069" },
    { no: 250, name: "MODEL_CASCADE_20070" },
    { no: 251, name: "MODEL_CASCADE_20071" },
    { no: 252, name: "MODEL_CASCADE_20072" },
    { no: 253, name: "MODEL_CASCADE_20073" },
    { no: 254, name: "MODEL_CASCADE_20074" },
    { no: 307, name: "MODEL_CASCADE_20075" },
    { no: 308, name: "MODEL_CASCADE_20076" },
    { no: 309, name: "MODEL_CASCADE_20077" },
    { no: 310, name: "MODEL_CASCADE_20078" },
    { no: 311, name: "MODEL_CASCADE_20079" },
    { no: 297, name: "MODEL_CASCADE_20080" },
    { no: 298, name: "MODEL_CASCADE_20081" },
    { no: 299, name: "MODEL_CASCADE_20082" },
    { no: 300, name: "MODEL_CASCADE_20083" },
    { no: 301, name: "MODEL_CASCADE_20084" },
    { no: 302, name: "MODEL_CASCADE_20085" },
    { no: 303, name: "MODEL_CASCADE_20086" },
    { no: 304, name: "MODEL_CASCADE_20087" },
    { no: 305, name: "MODEL_CASCADE_20088" },
    { no: 306, name: "MODEL_CASCADE_20089" },
    { no: 247, name: "MODEL_DEEPSEEK_V3_INTERNAL" },
    { no: 248, name: "MODEL_DEEPSEEK_V3_0324_INTERNAL" },
    { no: 249, name: "MODEL_DEEPSEEK_R1_INTERNAL" },
    { no: 241, name: "MODEL_ANTHROPIC_WINDSURF_RESEARCH" },
    { no: 242, name: "MODEL_ANTHROPIC_WINDSURF_RESEARCH_THINKING" },
    { no: 65, name: "MODEL_DRAFT_11408" },
    { no: 67, name: "MODEL_DRAFT_CHAT_11883" },
    { no: 72, name: "MODEL_DRAFT_CHAT_12196" },
    { no: 73, name: "MODEL_DRAFT_CHAT_12413" },
    { no: 104, name: "MODEL_DRAFT_CHAT_13175" },
    { no: 232, name: "MODEL_DRAFT_CHAT_19823" },
    { no: 243, name: "MODEL_DRAFT_CHAT_20707" },
    { no: 258, name: "MODEL_DRAFT_CHAT_22801" },
    { no: 273, name: "MODEL_DRAFT_CHAT_23508" },
    { no: 274, name: "MODEL_DRAFT_CASCADE_23672" },
    { no: 28, name: "MODEL_CHAT_3_5_TURBO" },
    { no: 30, name: "MODEL_CHAT_GPT_4" },
    { no: 37, name: "MODEL_CHAT_GPT_4_1106_PREVIEW" },
    { no: 91, name: "MODEL_TEXT_EMBEDDING_OPENAI_ADA" },
    { no: 163, name: "MODEL_TEXT_EMBEDDING_OPENAI_3_SMALL" },
    { no: 164, name: "MODEL_TEXT_EMBEDDING_OPENAI_3_LARGE" },
    { no: 71, name: "MODEL_CHAT_GPT_4O_2024_05_13" },
    { no: 109, name: "MODEL_CHAT_GPT_4O_2024_08_06" },
    { no: 113, name: "MODEL_CHAT_GPT_4O_MINI_2024_07_18" },
    { no: 259, name: "MODEL_CHAT_GPT_4_1_2025_04_14" },
    { no: 260, name: "MODEL_CHAT_GPT_4_1_MINI_2025_04_14" },
    { no: 261, name: "MODEL_CHAT_GPT_4_1_NANO_2025_04_14" },
    { no: 117, name: "MODEL_CHAT_O1_PREVIEW" },
    { no: 118, name: "MODEL_CHAT_O1_MINI" },
    { no: 170, name: "MODEL_CHAT_O1" },
    { no: 207, name: "MODEL_CHAT_O3_MINI" },
    { no: 213, name: "MODEL_CHAT_O3_MINI_LOW" },
    { no: 214, name: "MODEL_CHAT_O3_MINI_HIGH" },
    { no: 218, name: "MODEL_CHAT_O3" },
    { no: 262, name: "MODEL_CHAT_O3_LOW" },
    { no: 263, name: "MODEL_CHAT_O3_HIGH" },
    { no: 264, name: "MODEL_CHAT_O4_MINI" },
    { no: 265, name: "MODEL_CHAT_O4_MINI_LOW" },
    { no: 266, name: "MODEL_CHAT_O4_MINI_HIGH" },
    { no: 228, name: "MODEL_CHAT_GPT_4_5" },
    { no: 287, name: "MODEL_CODEX_MINI_LATEST" },
    { no: 288, name: "MODEL_CODEX_MINI_LATEST_LOW" },
    { no: 289, name: "MODEL_CODEX_MINI_LATEST_HIGH" },
    { no: 294, name: "MODEL_O3_PRO_2025_06_10" },
    { no: 295, name: "MODEL_O3_PRO_2025_06_10_LOW" },
    { no: 296, name: "MODEL_O3_PRO_2025_06_10_HIGH" },
    { no: 61, name: "MODEL_GOOGLE_GEMINI_1_0_PRO" },
    { no: 62, name: "MODEL_GOOGLE_GEMINI_1_5_PRO" },
    { no: 183, name: "MODEL_GOOGLE_GEMINI_EXP_1206" },
    { no: 184, name: "MODEL_GOOGLE_GEMINI_2_0_FLASH" },
    { no: 246, name: "MODEL_GOOGLE_GEMINI_2_5_PRO" },
    { no: 272, name: "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_04_17" },
    { no: 275, name: "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20" },
    { no: 276, name: "MODEL_GOOGLE_GEMINI_2_5_FLASH_PREVIEW_05_20_THINKING" },
    { no: 312, name: "MODEL_GOOGLE_GEMINI_2_5_FLASH" },
    { no: 313, name: "MODEL_GOOGLE_GEMINI_2_5_FLASH_THINKING" },
    { no: 63, name: "MODEL_CLAUDE_3_OPUS_20240229" },
    { no: 64, name: "MODEL_CLAUDE_3_SONNET_20240229" },
    { no: 172, name: "MODEL_CLAUDE_3_HAIKU_20240307" },
    { no: 171, name: "MODEL_CLAUDE_3_5_HAIKU_20241022" },
    { no: 80, name: "MODEL_CLAUDE_3_5_SONNET_20240620" },
    { no: 166, name: "MODEL_CLAUDE_3_5_SONNET_20241022" },
    { no: 226, name: "MODEL_CLAUDE_3_7_SONNET_20250219" },
    { no: 227, name: "MODEL_CLAUDE_3_7_SONNET_20250219_THINKING" },
    { no: 284, name: "MODEL_CLAUDE_3_5_SONNET_BYOK" },
    { no: 285, name: "MODEL_CLAUDE_3_7_SONNET_BYOK" },
    { no: 319, name: "MODEL_CLAUDE_3_7_SONNET_OPEN_ROUTER_BYOK" },
    { no: 286, name: "MODEL_CLAUDE_3_7_SONNET_THINKING_BYOK" },
    { no: 320, name: "MODEL_CLAUDE_3_7_SONNET_THINKING_OPEN_ROUTER_BYOK" },
    { no: 277, name: "MODEL_CLAUDE_4_OPUS_BYOK" },
    { no: 278, name: "MODEL_CLAUDE_4_OPUS_THINKING_BYOK" },
    { no: 290, name: "MODEL_CLAUDE_4_OPUS" },
    { no: 291, name: "MODEL_CLAUDE_4_OPUS_THINKING" },
    { no: 279, name: "MODEL_CLAUDE_4_SONNET_BYOK" },
    { no: 321, name: "MODEL_CLAUDE_4_SONNET_OPEN_ROUTER_BYOK" },
    { no: 280, name: "MODEL_CLAUDE_4_SONNET_THINKING_BYOK" },
    { no: 322, name: "MODEL_CLAUDE_4_SONNET_THINKING_OPEN_ROUTER_BYOK" },
    { no: 281, name: "MODEL_CLAUDE_4_SONNET" },
    { no: 282, name: "MODEL_CLAUDE_4_SONNET_THINKING" },
    { no: 292, name: "MODEL_CLAUDE_4_SONNET_DATABRICKS" },
    { no: 293, name: "MODEL_CLAUDE_4_SONNET_THINKING_DATABRICKS" },
    { no: 81, name: "MODEL_TOGETHERAI_TEXT_EMBEDDING_M2_BERT" },
    { no: 165, name: "MODEL_TOGETHERAI_LLAMA_3_1_8B_INSTRUCT" },
    { no: 82, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_M2_BERT" },
    { no: 83, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_UAE_CODE" },
    { no: 84, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_BGE" },
    { no: 85, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_BLADE" },
    { no: 86, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_ARCTIC_LARGE" },
    { no: 87, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_E5_BASE" },
    { no: 88, name: "MODEL_HUGGING_FACE_TEXT_EMBEDDING_MXBAI" },
    { no: 106, name: "MODEL_LLAMA_3_1_8B_INSTRUCT" },
    { no: 107, name: "MODEL_LLAMA_3_1_70B_INSTRUCT" },
    { no: 105, name: "MODEL_LLAMA_3_1_405B_INSTRUCT" },
    { no: 208, name: "MODEL_LLAMA_3_3_70B_INSTRUCT" },
    { no: 209, name: "MODEL_LLAMA_3_3_70B_INSTRUCT_R1" },
    { no: 116, name: "MODEL_LLAMA_3_1_70B_INSTRUCT_LONG_CONTEXT" },
    { no: 176, name: "MODEL_LLAMA_3_1_8B_HERMES_3" },
    { no: 177, name: "MODEL_LLAMA_3_1_70B_HERMES_3" },
    { no: 178, name: "MODEL_QWEN_2_5_7B_INSTRUCT" },
    { no: 179, name: "MODEL_QWEN_2_5_32B_INSTRUCT" },
    { no: 180, name: "MODEL_QWEN_2_5_72B_INSTRUCT" },
    { no: 224, name: "MODEL_QWEN_2_5_32B_INSTRUCT_R1" },
    { no: 89, name: "MODEL_NOMIC_TEXT_EMBEDDING_V1" },
    { no: 90, name: "MODEL_NOMIC_TEXT_EMBEDDING_V1_5" },
    { no: 77, name: "MODEL_MISTRAL_7B" },
    { no: 99, name: "MODEL_SALESFORCE_EMBEDDING_2R" },
    { no: 182, name: "MODEL_CUSTOM_VLLM" },
    { no: 92, name: "MODEL_TEI_BGE_M3" },
    { no: 93, name: "MODEL_TEI_NOMIC_EMBED_TEXT_V1" },
    { no: 94, name: "MODEL_TEI_INTFLOAT_E5_LARGE_INSTRUCT" },
    { no: 95, name: "MODEL_TEI_SNOWFLAKE_ARCTIC_EMBED_L" },
    { no: 96, name: "MODEL_TEI_UAE_CODE_LARGE_V1" },
    { no: 97, name: "MODEL_TEI_B1ADE" },
    { no: 98, name: "MODEL_TEI_WHEREISAI_UAE_LARGE_V1" },
    { no: 100, name: "MODEL_TEI_WHEREISAI_UAE_CODE_LARGE_V1" },
    { no: 200, name: "MODEL_OPENAI_COMPATIBLE" },
    { no: 201, name: "MODEL_ANTHROPIC_COMPATIBLE" },
    { no: 202, name: "MODEL_VERTEX_COMPATIBLE" },
    { no: 203, name: "MODEL_BEDROCK_COMPATIBLE" },
    { no: 204, name: "MODEL_AZURE_COMPATIBLE" },
    { no: 205, name: "MODEL_DEEPSEEK_V3" },
    { no: 206, name: "MODEL_DEEPSEEK_R1" },
    { no: 215, name: "MODEL_DEEPSEEK_R1_SLOW" },
    { no: 216, name: "MODEL_DEEPSEEK_R1_FAST" },
    { no: 185, name: "MODEL_CUSTOM_OPEN_ROUTER" },
    { no: 212, name: "MODEL_XAI_GROK_2" },
    { no: 217, name: "MODEL_XAI_GROK_3" },
    { no: 234, name: "MODEL_XAI_GROK_3_MINI_REASONING" },
    { no: 219, name: "MODEL_PRIVATE_1" },
    { no: 220, name: "MODEL_PRIVATE_2" },
    { no: 221, name: "MODEL_PRIVATE_3" },
    { no: 222, name: "MODEL_PRIVATE_4" },
    { no: 223, name: "MODEL_PRIVATE_5" },
    { no: 314, name: "MODEL_PRIVATE_6" },
    { no: 315, name: "MODEL_PRIVATE_7" },
    { no: 316, name: "MODEL_PRIVATE_8" },
    { no: 317, name: "MODEL_PRIVATE_9" },
    { no: 318, name: "MODEL_PRIVATE_10" },
]);
/**
 * buf:lint:ignore ENUM_VALUE_PREFIX
 *
 * @generated from enum exa.codeium_common_pb.PromptElementExclusionReason
 */
export var PromptElementExclusionReason;
(function (PromptElementExclusionReason) {
    /**
     * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
     *
     * @generated from enum value: EXCLUSION_UNSPECIFIED = 0;
     */
    PromptElementExclusionReason[PromptElementExclusionReason["EXCLUSION_UNSPECIFIED"] = 0] = "EXCLUSION_UNSPECIFIED";
    /**
     * Prompt element kind is disabled.
     *
     * @generated from enum value: EXCLUSION_ELEMENT_KIND_DISABLED = 1;
     */
    PromptElementExclusionReason[PromptElementExclusionReason["EXCLUSION_ELEMENT_KIND_DISABLED"] = 1] = "EXCLUSION_ELEMENT_KIND_DISABLED";
    /**
     * Prompt element requires other prompt elements to be present.
     *
     * @generated from enum value: EXCLUSION_ELEMENT_MISSING_DEPENDENCY = 2;
     */
    PromptElementExclusionReason[PromptElementExclusionReason["EXCLUSION_ELEMENT_MISSING_DEPENDENCY"] = 2] = "EXCLUSION_ELEMENT_MISSING_DEPENDENCY";
    /**
     * Out of token budget.
     *
     * @generated from enum value: EXCLUSION_TOKEN_BUDGET = 3;
     */
    PromptElementExclusionReason[PromptElementExclusionReason["EXCLUSION_TOKEN_BUDGET"] = 3] = "EXCLUSION_TOKEN_BUDGET";
    /**
     * Element overlaps with active doc source range.
     *
     * @generated from enum value: EXCLUSION_ACTIVE_SOURCE_OVERLAP = 4;
     */
    PromptElementExclusionReason[PromptElementExclusionReason["EXCLUSION_ACTIVE_SOURCE_OVERLAP"] = 4] = "EXCLUSION_ACTIVE_SOURCE_OVERLAP";
})(PromptElementExclusionReason || (PromptElementExclusionReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(PromptElementExclusionReason)
proto3.util.setEnumType(PromptElementExclusionReason, "exa.codeium_common_pb.PromptElementExclusionReason", [
    { no: 0, name: "EXCLUSION_UNSPECIFIED" },
    { no: 1, name: "EXCLUSION_ELEMENT_KIND_DISABLED" },
    { no: 2, name: "EXCLUSION_ELEMENT_MISSING_DEPENDENCY" },
    { no: 3, name: "EXCLUSION_TOKEN_BUDGET" },
    { no: 4, name: "EXCLUSION_ACTIVE_SOURCE_OVERLAP" },
]);
/**
 * @generated from enum exa.codeium_common_pb.StopReason
 */
export var StopReason;
(function (StopReason) {
    /**
     * @generated from enum value: STOP_REASON_UNSPECIFIED = 0;
     */
    StopReason[StopReason["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Completion stream stopped before completion was finished. Likely due to cancelation.
     *
     * @generated from enum value: STOP_REASON_INCOMPLETE = 1;
     */
    StopReason[StopReason["INCOMPLETE"] = 1] = "INCOMPLETE";
    /**
     * @generated from enum value: STOP_REASON_STOP_PATTERN = 2;
     */
    StopReason[StopReason["STOP_PATTERN"] = 2] = "STOP_PATTERN";
    /**
     * @generated from enum value: STOP_REASON_MAX_TOKENS = 3;
     */
    StopReason[StopReason["MAX_TOKENS"] = 3] = "MAX_TOKENS";
    /**
     * @generated from enum value: STOP_REASON_MIN_LOG_PROB = 4;
     */
    StopReason[StopReason["MIN_LOG_PROB"] = 4] = "MIN_LOG_PROB";
    /**
     * @generated from enum value: STOP_REASON_MAX_NEWLINES = 5;
     */
    StopReason[StopReason["MAX_NEWLINES"] = 5] = "MAX_NEWLINES";
    /**
     * @generated from enum value: STOP_REASON_EXIT_SCOPE = 6;
     */
    StopReason[StopReason["EXIT_SCOPE"] = 6] = "EXIT_SCOPE";
    /**
     * @generated from enum value: STOP_REASON_NONFINITE_LOGIT_OR_PROB = 7;
     */
    StopReason[StopReason["NONFINITE_LOGIT_OR_PROB"] = 7] = "NONFINITE_LOGIT_OR_PROB";
    /**
     * @generated from enum value: STOP_REASON_FIRST_NON_WHITESPACE_LINE = 8;
     */
    StopReason[StopReason["FIRST_NON_WHITESPACE_LINE"] = 8] = "FIRST_NON_WHITESPACE_LINE";
    /**
     * @generated from enum value: STOP_REASON_PARTIAL = 9;
     */
    StopReason[StopReason["PARTIAL"] = 9] = "PARTIAL";
    /**
     * @generated from enum value: STOP_REASON_FUNCTION_CALL = 10;
     */
    StopReason[StopReason["FUNCTION_CALL"] = 10] = "FUNCTION_CALL";
    /**
     * @generated from enum value: STOP_REASON_CONTENT_FILTER = 11;
     */
    StopReason[StopReason["CONTENT_FILTER"] = 11] = "CONTENT_FILTER";
    /**
     * For cursor aware supercomplete, applies to non insertions at the cursor (i.e. non autocompletes).
     *
     * @generated from enum value: STOP_REASON_NON_INSERTION = 12;
     */
    StopReason[StopReason["NON_INSERTION"] = 12] = "NON_INSERTION";
    /**
     * @generated from enum value: STOP_REASON_ERROR = 13;
     */
    StopReason[StopReason["ERROR"] = 13] = "ERROR";
})(StopReason || (StopReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(StopReason)
proto3.util.setEnumType(StopReason, "exa.codeium_common_pb.StopReason", [
    { no: 0, name: "STOP_REASON_UNSPECIFIED" },
    { no: 1, name: "STOP_REASON_INCOMPLETE" },
    { no: 2, name: "STOP_REASON_STOP_PATTERN" },
    { no: 3, name: "STOP_REASON_MAX_TOKENS" },
    { no: 4, name: "STOP_REASON_MIN_LOG_PROB" },
    { no: 5, name: "STOP_REASON_MAX_NEWLINES" },
    { no: 6, name: "STOP_REASON_EXIT_SCOPE" },
    { no: 7, name: "STOP_REASON_NONFINITE_LOGIT_OR_PROB" },
    { no: 8, name: "STOP_REASON_FIRST_NON_WHITESPACE_LINE" },
    { no: 9, name: "STOP_REASON_PARTIAL" },
    { no: 10, name: "STOP_REASON_FUNCTION_CALL" },
    { no: 11, name: "STOP_REASON_CONTENT_FILTER" },
    { no: 12, name: "STOP_REASON_NON_INSERTION" },
    { no: 13, name: "STOP_REASON_ERROR" },
]);
/**
 * @generated from enum exa.codeium_common_pb.FilterReason
 */
export var FilterReason;
(function (FilterReason) {
    /**
     * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
     *
     * @generated from enum value: FILTER_REASON_NONE = 0;
     */
    FilterReason[FilterReason["NONE"] = 0] = "NONE";
    /**
     * Completion stream stopped before completion was finished. Likely due to cancelation.
     *
     * @generated from enum value: FILTER_REASON_INCOMPLETE = 1;
     */
    FilterReason[FilterReason["INCOMPLETE"] = 1] = "INCOMPLETE";
    /**
     * @generated from enum value: FILTER_REASON_EMPTY = 2;
     */
    FilterReason[FilterReason["EMPTY"] = 2] = "EMPTY";
    /**
     * @generated from enum value: FILTER_REASON_REPETITIVE = 3;
     */
    FilterReason[FilterReason["REPETITIVE"] = 3] = "REPETITIVE";
    /**
     * @generated from enum value: FILTER_REASON_DUPLICATE = 4;
     */
    FilterReason[FilterReason["DUPLICATE"] = 4] = "DUPLICATE";
    /**
     * @generated from enum value: FILTER_REASON_LONG_LINE = 5;
     */
    FilterReason[FilterReason["LONG_LINE"] = 5] = "LONG_LINE";
    /**
     * @generated from enum value: FILTER_REASON_COMPLETIONS_CUTOFF = 6;
     */
    FilterReason[FilterReason["COMPLETIONS_CUTOFF"] = 6] = "COMPLETIONS_CUTOFF";
    /**
     * @generated from enum value: FILTER_REASON_ATTRIBUTION = 7;
     */
    FilterReason[FilterReason["ATTRIBUTION"] = 7] = "ATTRIBUTION";
    /**
     * For fast single line.
     * Applied if the completion either does not match the prefix, suffix, is too
     * short, or fully matches the prefix and suffix.
     *
     * @generated from enum value: FILTER_REASON_NON_MATCHING = 8;
     */
    FilterReason[FilterReason["NON_MATCHING"] = 8] = "NON_MATCHING";
    /**
     * For cursor aware supercomplete, filter that applies to non insertions
     * at the cursor (i.e. non autocompletes).
     *
     * @generated from enum value: FILTER_REASON_NON_INSERTION = 9;
     */
    FilterReason[FilterReason["NON_INSERTION"] = 9] = "NON_INSERTION";
})(FilterReason || (FilterReason = {}));
// Retrieve enum metadata with: proto3.getEnumType(FilterReason)
proto3.util.setEnumType(FilterReason, "exa.codeium_common_pb.FilterReason", [
    { no: 0, name: "FILTER_REASON_NONE" },
    { no: 1, name: "FILTER_REASON_INCOMPLETE" },
    { no: 2, name: "FILTER_REASON_EMPTY" },
    { no: 3, name: "FILTER_REASON_REPETITIVE" },
    { no: 4, name: "FILTER_REASON_DUPLICATE" },
    { no: 5, name: "FILTER_REASON_LONG_LINE" },
    { no: 6, name: "FILTER_REASON_COMPLETIONS_CUTOFF" },
    { no: 7, name: "FILTER_REASON_ATTRIBUTION" },
    { no: 8, name: "FILTER_REASON_NON_MATCHING" },
    { no: 9, name: "FILTER_REASON_NON_INSERTION" },
]);
/**
 * @generated from enum exa.codeium_common_pb.AttributionStatus
 */
export var AttributionStatus;
(function (AttributionStatus) {
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_UNSPECIFIED = 0;
     */
    AttributionStatus[AttributionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_NEW_CODE = 1;
     */
    AttributionStatus[AttributionStatus["NEW_CODE"] = 1] = "NEW_CODE";
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_NO_LICENSE = 2;
     */
    AttributionStatus[AttributionStatus["NO_LICENSE"] = 2] = "NO_LICENSE";
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_NONPERMISSIVE = 3;
     */
    AttributionStatus[AttributionStatus["NONPERMISSIVE"] = 3] = "NONPERMISSIVE";
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_PERMISSIVE = 4;
     */
    AttributionStatus[AttributionStatus["PERMISSIVE"] = 4] = "PERMISSIVE";
    /**
     * @generated from enum value: ATTRIBUTION_STATUS_PERMISSIVE_BLOCKED = 5;
     */
    AttributionStatus[AttributionStatus["PERMISSIVE_BLOCKED"] = 5] = "PERMISSIVE_BLOCKED";
})(AttributionStatus || (AttributionStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(AttributionStatus)
proto3.util.setEnumType(AttributionStatus, "exa.codeium_common_pb.AttributionStatus", [
    { no: 0, name: "ATTRIBUTION_STATUS_UNSPECIFIED" },
    { no: 1, name: "ATTRIBUTION_STATUS_NEW_CODE" },
    { no: 2, name: "ATTRIBUTION_STATUS_NO_LICENSE" },
    { no: 3, name: "ATTRIBUTION_STATUS_NONPERMISSIVE" },
    { no: 4, name: "ATTRIBUTION_STATUS_PERMISSIVE" },
    { no: 5, name: "ATTRIBUTION_STATUS_PERMISSIVE_BLOCKED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.EmbeddingPriority
 */
export var EmbeddingPriority;
(function (EmbeddingPriority) {
    /**
     * @generated from enum value: EMBEDDING_PRIORITY_UNSPECIFIED = 0;
     */
    EmbeddingPriority[EmbeddingPriority["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EMBEDDING_PRIORITY_HIGH = 1;
     */
    EmbeddingPriority[EmbeddingPriority["HIGH"] = 1] = "HIGH";
    /**
     * @generated from enum value: EMBEDDING_PRIORITY_LOW = 2;
     */
    EmbeddingPriority[EmbeddingPriority["LOW"] = 2] = "LOW";
})(EmbeddingPriority || (EmbeddingPriority = {}));
// Retrieve enum metadata with: proto3.getEnumType(EmbeddingPriority)
proto3.util.setEnumType(EmbeddingPriority, "exa.codeium_common_pb.EmbeddingPriority", [
    { no: 0, name: "EMBEDDING_PRIORITY_UNSPECIFIED" },
    { no: 1, name: "EMBEDDING_PRIORITY_HIGH" },
    { no: 2, name: "EMBEDDING_PRIORITY_LOW" },
]);
/**
 * @generated from enum exa.codeium_common_pb.EmbeddingPrefix
 */
export var EmbeddingPrefix;
(function (EmbeddingPrefix) {
    /**
     * @generated from enum value: EMBEDDING_PREFIX_UNSPECIFIED = 0;
     */
    EmbeddingPrefix[EmbeddingPrefix["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EMBEDDING_PREFIX_NOMIC_DOCUMENT = 1;
     */
    EmbeddingPrefix[EmbeddingPrefix["NOMIC_DOCUMENT"] = 1] = "NOMIC_DOCUMENT";
    /**
     * @generated from enum value: EMBEDDING_PREFIX_NOMIC_SEARCH = 2;
     */
    EmbeddingPrefix[EmbeddingPrefix["NOMIC_SEARCH"] = 2] = "NOMIC_SEARCH";
    /**
     * @generated from enum value: EMBEDDING_PREFIX_NOMIC_CLASSIFICATION = 3;
     */
    EmbeddingPrefix[EmbeddingPrefix["NOMIC_CLASSIFICATION"] = 3] = "NOMIC_CLASSIFICATION";
    /**
     * @generated from enum value: EMBEDDING_PREFIX_NOMIC_CLUSTERING = 4;
     */
    EmbeddingPrefix[EmbeddingPrefix["NOMIC_CLUSTERING"] = 4] = "NOMIC_CLUSTERING";
})(EmbeddingPrefix || (EmbeddingPrefix = {}));
// Retrieve enum metadata with: proto3.getEnumType(EmbeddingPrefix)
proto3.util.setEnumType(EmbeddingPrefix, "exa.codeium_common_pb.EmbeddingPrefix", [
    { no: 0, name: "EMBEDDING_PREFIX_UNSPECIFIED" },
    { no: 1, name: "EMBEDDING_PREFIX_NOMIC_DOCUMENT" },
    { no: 2, name: "EMBEDDING_PREFIX_NOMIC_SEARCH" },
    { no: 3, name: "EMBEDDING_PREFIX_NOMIC_CLASSIFICATION" },
    { no: 4, name: "EMBEDDING_PREFIX_NOMIC_CLUSTERING" },
]);
/**
 * EmbeddingSource defines the data source of an embedding entry in the index service.
 *
 * @generated from enum exa.codeium_common_pb.EmbeddingSource
 */
export var EmbeddingSource;
(function (EmbeddingSource) {
    /**
     * @generated from enum value: EMBEDDING_SOURCE_UNSPECIFIED = 0;
     */
    EmbeddingSource[EmbeddingSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EMBEDDING_SOURCE_CODE_CONTEXT_ITEM = 1;
     */
    EmbeddingSource[EmbeddingSource["CODE_CONTEXT_ITEM"] = 1] = "CODE_CONTEXT_ITEM";
    /**
     * @generated from enum value: EMBEDDING_SOURCE_COMMIT_INTENT = 2;
     */
    EmbeddingSource[EmbeddingSource["COMMIT_INTENT"] = 2] = "COMMIT_INTENT";
})(EmbeddingSource || (EmbeddingSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(EmbeddingSource)
proto3.util.setEnumType(EmbeddingSource, "exa.codeium_common_pb.EmbeddingSource", [
    { no: 0, name: "EMBEDDING_SOURCE_UNSPECIFIED" },
    { no: 1, name: "EMBEDDING_SOURCE_CODE_CONTEXT_ITEM" },
    { no: 2, name: "EMBEDDING_SOURCE_COMMIT_INTENT" },
]);
/**
 * Authentication source for users on the cloud service.
 *
 * @generated from enum exa.codeium_common_pb.AuthSource
 */
export var AuthSource;
(function (AuthSource) {
    /**
     * buf:lint:ignore ENUM_ZERO_VALUE_SUFFIX
     *
     * @generated from enum value: AUTH_SOURCE_CODEIUM = 0;
     */
    AuthSource[AuthSource["CODEIUM"] = 0] = "CODEIUM";
    /**
     * @generated from enum value: AUTH_SOURCE_DEEPNOTE = 1;
     */
    AuthSource[AuthSource["DEEPNOTE"] = 1] = "DEEPNOTE";
    /**
     * @generated from enum value: AUTH_SOURCE_CODESANDBOX = 2 [deprecated = true];
     * @deprecated
     */
    AuthSource[AuthSource["CODESANDBOX"] = 2] = "CODESANDBOX";
    /**
     * @generated from enum value: AUTH_SOURCE_STACKBLITZ = 3;
     */
    AuthSource[AuthSource["STACKBLITZ"] = 3] = "STACKBLITZ";
    /**
     * @generated from enum value: AUTH_SOURCE_VALTOWN = 4;
     */
    AuthSource[AuthSource["VALTOWN"] = 4] = "VALTOWN";
    /**
     * @generated from enum value: AUTH_SOURCE_HEX = 5;
     */
    AuthSource[AuthSource["HEX"] = 5] = "HEX";
    /**
     * @generated from enum value: AUTH_SOURCE_ZAPIER = 6 [deprecated = true];
     * @deprecated
     */
    AuthSource[AuthSource["ZAPIER"] = 6] = "ZAPIER";
    /**
     * @generated from enum value: AUTH_SOURCE_SUPERBLOCKS = 7;
     */
    AuthSource[AuthSource["SUPERBLOCKS"] = 7] = "SUPERBLOCKS";
    /**
     * @generated from enum value: AUTH_SOURCE_EMBARCADERO = 8;
     */
    AuthSource[AuthSource["EMBARCADERO"] = 8] = "EMBARCADERO";
})(AuthSource || (AuthSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(AuthSource)
proto3.util.setEnumType(AuthSource, "exa.codeium_common_pb.AuthSource", [
    { no: 0, name: "AUTH_SOURCE_CODEIUM" },
    { no: 1, name: "AUTH_SOURCE_DEEPNOTE" },
    { no: 2, name: "AUTH_SOURCE_CODESANDBOX" },
    { no: 3, name: "AUTH_SOURCE_STACKBLITZ" },
    { no: 4, name: "AUTH_SOURCE_VALTOWN" },
    { no: 5, name: "AUTH_SOURCE_HEX" },
    { no: 6, name: "AUTH_SOURCE_ZAPIER" },
    { no: 7, name: "AUTH_SOURCE_SUPERBLOCKS" },
    { no: 8, name: "AUTH_SOURCE_EMBARCADERO" },
]);
/**
 * Next ID = 14
 *
 * @generated from enum exa.codeium_common_pb.EventType
 */
export var EventType;
(function (EventType) {
    /**
     * @generated from enum value: EVENT_TYPE_UNSPECIFIED = 0;
     */
    EventType[EventType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EVENT_TYPE_ENABLE_CODEIUM = 1;
     */
    EventType[EventType["ENABLE_CODEIUM"] = 1] = "ENABLE_CODEIUM";
    /**
     * @generated from enum value: EVENT_TYPE_DISABLE_CODEIUM = 2;
     */
    EventType[EventType["DISABLE_CODEIUM"] = 2] = "DISABLE_CODEIUM";
    /**
     * @generated from enum value: EVENT_TYPE_SHOW_PREVIOUS_COMPLETION = 3;
     */
    EventType[EventType["SHOW_PREVIOUS_COMPLETION"] = 3] = "SHOW_PREVIOUS_COMPLETION";
    /**
     * @generated from enum value: EVENT_TYPE_SHOW_NEXT_COMPLETION = 4;
     */
    EventType[EventType["SHOW_NEXT_COMPLETION"] = 4] = "SHOW_NEXT_COMPLETION";
    /**
     * @generated from enum value: EVENT_TYPE_COPILOT_STATUS = 5;
     */
    EventType[EventType["COPILOT_STATUS"] = 5] = "COPILOT_STATUS";
    /**
     * @generated from enum value: EVENT_TYPE_COMPLETION_SUPPRESSED = 6;
     */
    EventType[EventType["COMPLETION_SUPPRESSED"] = 6] = "COMPLETION_SUPPRESSED";
    /**
     * @generated from enum value: EVENT_TYPE_MEMORY_STATS = 8;
     */
    EventType[EventType["MEMORY_STATS"] = 8] = "MEMORY_STATS";
    /**
     * @generated from enum value: EVENT_TYPE_LOCAL_CONTEXT_RELEVANCE_CHECK = 9;
     */
    EventType[EventType["LOCAL_CONTEXT_RELEVANCE_CHECK"] = 9] = "LOCAL_CONTEXT_RELEVANCE_CHECK";
    /**
     * @generated from enum value: EVENT_TYPE_ACTIVE_EDITOR_CHANGED = 10;
     */
    EventType[EventType["ACTIVE_EDITOR_CHANGED"] = 10] = "ACTIVE_EDITOR_CHANGED";
    /**
     * @generated from enum value: EVENT_TYPE_SHOW_PREVIOUS_CORTEX_STEP = 11;
     */
    EventType[EventType["SHOW_PREVIOUS_CORTEX_STEP"] = 11] = "SHOW_PREVIOUS_CORTEX_STEP";
    /**
     * @generated from enum value: EVENT_TYPE_SHOW_NEXT_CORTEX_STEP = 12;
     */
    EventType[EventType["SHOW_NEXT_CORTEX_STEP"] = 12] = "SHOW_NEXT_CORTEX_STEP";
    /**
     * @generated from enum value: EVENT_TYPE_INDEXER_STATS = 13;
     */
    EventType[EventType["INDEXER_STATS"] = 13] = "INDEXER_STATS";
})(EventType || (EventType = {}));
// Retrieve enum metadata with: proto3.getEnumType(EventType)
proto3.util.setEnumType(EventType, "exa.codeium_common_pb.EventType", [
    { no: 0, name: "EVENT_TYPE_UNSPECIFIED" },
    { no: 1, name: "EVENT_TYPE_ENABLE_CODEIUM" },
    { no: 2, name: "EVENT_TYPE_DISABLE_CODEIUM" },
    { no: 3, name: "EVENT_TYPE_SHOW_PREVIOUS_COMPLETION" },
    { no: 4, name: "EVENT_TYPE_SHOW_NEXT_COMPLETION" },
    { no: 5, name: "EVENT_TYPE_COPILOT_STATUS" },
    { no: 6, name: "EVENT_TYPE_COMPLETION_SUPPRESSED" },
    { no: 8, name: "EVENT_TYPE_MEMORY_STATS" },
    { no: 9, name: "EVENT_TYPE_LOCAL_CONTEXT_RELEVANCE_CHECK" },
    { no: 10, name: "EVENT_TYPE_ACTIVE_EDITOR_CHANGED" },
    { no: 11, name: "EVENT_TYPE_SHOW_PREVIOUS_CORTEX_STEP" },
    { no: 12, name: "EVENT_TYPE_SHOW_NEXT_CORTEX_STEP" },
    { no: 13, name: "EVENT_TYPE_INDEXER_STATS" },
]);
/**
 * @generated from enum exa.codeium_common_pb.SearchResultType
 */
export var SearchResultType;
(function (SearchResultType) {
    /**
     * @generated from enum value: SEARCH_RESULT_TYPE_UNSPECIFIED = 0;
     */
    SearchResultType[SearchResultType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SEARCH_RESULT_TYPE_CLUSTER = 1;
     */
    SearchResultType[SearchResultType["CLUSTER"] = 1] = "CLUSTER";
    /**
     * @generated from enum value: SEARCH_RESULT_TYPE_EXACT = 2;
     */
    SearchResultType[SearchResultType["EXACT"] = 2] = "EXACT";
})(SearchResultType || (SearchResultType = {}));
// Retrieve enum metadata with: proto3.getEnumType(SearchResultType)
proto3.util.setEnumType(SearchResultType, "exa.codeium_common_pb.SearchResultType", [
    { no: 0, name: "SEARCH_RESULT_TYPE_UNSPECIFIED" },
    { no: 1, name: "SEARCH_RESULT_TYPE_CLUSTER" },
    { no: 2, name: "SEARCH_RESULT_TYPE_EXACT" },
]);
/**
 * EmbedType defines what combination of components we encode embeddings for.
 *
 * @generated from enum exa.codeium_common_pb.EmbedType
 */
export var EmbedType;
(function (EmbedType) {
    /**
     * @generated from enum value: EMBED_TYPE_UNSPECIFIED = 0;
     */
    EmbedType[EmbedType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Raw source code of function.
     *
     * @generated from enum value: EMBED_TYPE_RAW_SOURCE = 1;
     */
    EmbedType[EmbedType["RAW_SOURCE"] = 1] = "RAW_SOURCE";
    /**
     * Docstring of function (if it exists).
     *
     * @generated from enum value: EMBED_TYPE_DOCSTRING = 2;
     */
    EmbedType[EmbedType["DOCSTRING"] = 2] = "DOCSTRING";
    /**
     * Function without docstring.
     *
     * @generated from enum value: EMBED_TYPE_FUNCTION = 3;
     */
    EmbedType[EmbedType["FUNCTION"] = 3] = "FUNCTION";
    /**
     * Filepath + nodename of function.
     *
     * @generated from enum value: EMBED_TYPE_NODEPATH = 4;
     */
    EmbedType[EmbedType["NODEPATH"] = 4] = "NODEPATH";
    /**
     * Declaration of function including function name and args.
     *
     * @generated from enum value: EMBED_TYPE_DECLARATION = 5;
     */
    EmbedType[EmbedType["DECLARATION"] = 5] = "DECLARATION";
    /**
     * Chunk of lines parsed with whitespace. Not guaranteed to be semantically complete
     *
     * @generated from enum value: EMBED_TYPE_NAIVE_CHUNK = 6;
     */
    EmbedType[EmbedType["NAIVE_CHUNK"] = 6] = "NAIVE_CHUNK";
    /**
     * "Signature" of a class or a function.
     *
     * @generated from enum value: EMBED_TYPE_SIGNATURE = 7;
     */
    EmbedType[EmbedType["SIGNATURE"] = 7] = "SIGNATURE";
})(EmbedType || (EmbedType = {}));
// Retrieve enum metadata with: proto3.getEnumType(EmbedType)
proto3.util.setEnumType(EmbedType, "exa.codeium_common_pb.EmbedType", [
    { no: 0, name: "EMBED_TYPE_UNSPECIFIED" },
    { no: 1, name: "EMBED_TYPE_RAW_SOURCE" },
    { no: 2, name: "EMBED_TYPE_DOCSTRING" },
    { no: 3, name: "EMBED_TYPE_FUNCTION" },
    { no: 4, name: "EMBED_TYPE_NODEPATH" },
    { no: 5, name: "EMBED_TYPE_DECLARATION" },
    { no: 6, name: "EMBED_TYPE_NAIVE_CHUNK" },
    { no: 7, name: "EMBED_TYPE_SIGNATURE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CompletionSource
 */
export var CompletionSource;
(function (CompletionSource) {
    /**
     * @generated from enum value: COMPLETION_SOURCE_UNSPECIFIED = 0;
     */
    CompletionSource[CompletionSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: COMPLETION_SOURCE_TYPING_AS_SUGGESTED = 1;
     */
    CompletionSource[CompletionSource["TYPING_AS_SUGGESTED"] = 1] = "TYPING_AS_SUGGESTED";
    /**
     * @generated from enum value: COMPLETION_SOURCE_CACHE = 2;
     */
    CompletionSource[CompletionSource["CACHE"] = 2] = "CACHE";
    /**
     * @generated from enum value: COMPLETION_SOURCE_NETWORK = 3;
     */
    CompletionSource[CompletionSource["NETWORK"] = 3] = "NETWORK";
})(CompletionSource || (CompletionSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(CompletionSource)
proto3.util.setEnumType(CompletionSource, "exa.codeium_common_pb.CompletionSource", [
    { no: 0, name: "COMPLETION_SOURCE_UNSPECIFIED" },
    { no: 1, name: "COMPLETION_SOURCE_TYPING_AS_SUGGESTED" },
    { no: 2, name: "COMPLETION_SOURCE_CACHE" },
    { no: 3, name: "COMPLETION_SOURCE_NETWORK" },
]);
/**
 * TODO(nick): migrate more places to use this including adding it to prompt telemetry.
 *
 * @generated from enum exa.codeium_common_pb.CompletionType
 */
export var CompletionType;
(function (CompletionType) {
    /**
     * @generated from enum value: COMPLETION_TYPE_UNSPECIFIED = 0;
     */
    CompletionType[CompletionType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: COMPLETION_TYPE_SINGLE = 1;
     */
    CompletionType[CompletionType["SINGLE"] = 1] = "SINGLE";
    /**
     * @generated from enum value: COMPLETION_TYPE_MULTI = 2;
     */
    CompletionType[CompletionType["MULTI"] = 2] = "MULTI";
    /**
     * @generated from enum value: COMPLETION_TYPE_INLINE_FIM = 3;
     */
    CompletionType[CompletionType["INLINE_FIM"] = 3] = "INLINE_FIM";
    /**
     * @generated from enum value: COMPLETION_TYPE_CASCADE = 4;
     */
    CompletionType[CompletionType["CASCADE"] = 4] = "CASCADE";
})(CompletionType || (CompletionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CompletionType)
proto3.util.setEnumType(CompletionType, "exa.codeium_common_pb.CompletionType", [
    { no: 0, name: "COMPLETION_TYPE_UNSPECIFIED" },
    { no: 1, name: "COMPLETION_TYPE_SINGLE" },
    { no: 2, name: "COMPLETION_TYPE_MULTI" },
    { no: 3, name: "COMPLETION_TYPE_INLINE_FIM" },
    { no: 4, name: "COMPLETION_TYPE_CASCADE" },
]);
/**
 * Every time this list is updated, we should be redeploying the API server
 * since it uses the string representation for BQ.
 *
 * @generated from enum exa.codeium_common_pb.Language
 */
export var Language;
(function (Language) {
    /**
     * @generated from enum value: LANGUAGE_UNSPECIFIED = 0;
     */
    Language[Language["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: LANGUAGE_C = 1;
     */
    Language[Language["C"] = 1] = "C";
    /**
     * @generated from enum value: LANGUAGE_CLOJURE = 2;
     */
    Language[Language["CLOJURE"] = 2] = "CLOJURE";
    /**
     * @generated from enum value: LANGUAGE_COFFEESCRIPT = 3;
     */
    Language[Language["COFFEESCRIPT"] = 3] = "COFFEESCRIPT";
    /**
     * @generated from enum value: LANGUAGE_CPP = 4;
     */
    Language[Language["CPP"] = 4] = "CPP";
    /**
     * @generated from enum value: LANGUAGE_CSHARP = 5;
     */
    Language[Language["CSHARP"] = 5] = "CSHARP";
    /**
     * @generated from enum value: LANGUAGE_CSS = 6;
     */
    Language[Language["CSS"] = 6] = "CSS";
    /**
     * @generated from enum value: LANGUAGE_CUDACPP = 7;
     */
    Language[Language["CUDACPP"] = 7] = "CUDACPP";
    /**
     * @generated from enum value: LANGUAGE_DOCKERFILE = 8;
     */
    Language[Language["DOCKERFILE"] = 8] = "DOCKERFILE";
    /**
     * @generated from enum value: LANGUAGE_GO = 9;
     */
    Language[Language["GO"] = 9] = "GO";
    /**
     * @generated from enum value: LANGUAGE_GROOVY = 10;
     */
    Language[Language["GROOVY"] = 10] = "GROOVY";
    /**
     * @generated from enum value: LANGUAGE_HANDLEBARS = 11;
     */
    Language[Language["HANDLEBARS"] = 11] = "HANDLEBARS";
    /**
     * @generated from enum value: LANGUAGE_HASKELL = 12;
     */
    Language[Language["HASKELL"] = 12] = "HASKELL";
    /**
     * @generated from enum value: LANGUAGE_HCL = 13;
     */
    Language[Language["HCL"] = 13] = "HCL";
    /**
     * @generated from enum value: LANGUAGE_HTML = 14;
     */
    Language[Language["HTML"] = 14] = "HTML";
    /**
     * @generated from enum value: LANGUAGE_INI = 15;
     */
    Language[Language["INI"] = 15] = "INI";
    /**
     * @generated from enum value: LANGUAGE_JAVA = 16;
     */
    Language[Language["JAVA"] = 16] = "JAVA";
    /**
     * @generated from enum value: LANGUAGE_JAVASCRIPT = 17;
     */
    Language[Language["JAVASCRIPT"] = 17] = "JAVASCRIPT";
    /**
     * @generated from enum value: LANGUAGE_JSON = 18;
     */
    Language[Language["JSON"] = 18] = "JSON";
    /**
     * @generated from enum value: LANGUAGE_JULIA = 19;
     */
    Language[Language["JULIA"] = 19] = "JULIA";
    /**
     * @generated from enum value: LANGUAGE_KOTLIN = 20;
     */
    Language[Language["KOTLIN"] = 20] = "KOTLIN";
    /**
     * @generated from enum value: LANGUAGE_LATEX = 21;
     */
    Language[Language["LATEX"] = 21] = "LATEX";
    /**
     * @generated from enum value: LANGUAGE_LESS = 22;
     */
    Language[Language["LESS"] = 22] = "LESS";
    /**
     * @generated from enum value: LANGUAGE_LUA = 23;
     */
    Language[Language["LUA"] = 23] = "LUA";
    /**
     * @generated from enum value: LANGUAGE_MAKEFILE = 24;
     */
    Language[Language["MAKEFILE"] = 24] = "MAKEFILE";
    /**
     * @generated from enum value: LANGUAGE_MARKDOWN = 25;
     */
    Language[Language["MARKDOWN"] = 25] = "MARKDOWN";
    /**
     * @generated from enum value: LANGUAGE_OBJECTIVEC = 26;
     */
    Language[Language["OBJECTIVEC"] = 26] = "OBJECTIVEC";
    /**
     * @generated from enum value: LANGUAGE_OBJECTIVECPP = 27;
     */
    Language[Language["OBJECTIVECPP"] = 27] = "OBJECTIVECPP";
    /**
     * @generated from enum value: LANGUAGE_PERL = 28;
     */
    Language[Language["PERL"] = 28] = "PERL";
    /**
     * @generated from enum value: LANGUAGE_PHP = 29;
     */
    Language[Language["PHP"] = 29] = "PHP";
    /**
     * @generated from enum value: LANGUAGE_PLAINTEXT = 30;
     */
    Language[Language["PLAINTEXT"] = 30] = "PLAINTEXT";
    /**
     * @generated from enum value: LANGUAGE_PROTOBUF = 31;
     */
    Language[Language["PROTOBUF"] = 31] = "PROTOBUF";
    /**
     * @generated from enum value: LANGUAGE_PBTXT = 32;
     */
    Language[Language["PBTXT"] = 32] = "PBTXT";
    /**
     * @generated from enum value: LANGUAGE_PYTHON = 33;
     */
    Language[Language["PYTHON"] = 33] = "PYTHON";
    /**
     * @generated from enum value: LANGUAGE_R = 34;
     */
    Language[Language["R"] = 34] = "R";
    /**
     * @generated from enum value: LANGUAGE_RUBY = 35;
     */
    Language[Language["RUBY"] = 35] = "RUBY";
    /**
     * @generated from enum value: LANGUAGE_RUST = 36;
     */
    Language[Language["RUST"] = 36] = "RUST";
    /**
     * @generated from enum value: LANGUAGE_SASS = 37;
     */
    Language[Language["SASS"] = 37] = "SASS";
    /**
     * @generated from enum value: LANGUAGE_SCALA = 38;
     */
    Language[Language["SCALA"] = 38] = "SCALA";
    /**
     * @generated from enum value: LANGUAGE_SCSS = 39;
     */
    Language[Language["SCSS"] = 39] = "SCSS";
    /**
     * @generated from enum value: LANGUAGE_SHELL = 40;
     */
    Language[Language["SHELL"] = 40] = "SHELL";
    /**
     * @generated from enum value: LANGUAGE_SQL = 41;
     */
    Language[Language["SQL"] = 41] = "SQL";
    /**
     * @generated from enum value: LANGUAGE_STARLARK = 42;
     */
    Language[Language["STARLARK"] = 42] = "STARLARK";
    /**
     * @generated from enum value: LANGUAGE_SWIFT = 43;
     */
    Language[Language["SWIFT"] = 43] = "SWIFT";
    /**
     * @generated from enum value: LANGUAGE_TSX = 44;
     */
    Language[Language["TSX"] = 44] = "TSX";
    /**
     * @generated from enum value: LANGUAGE_TYPESCRIPT = 45;
     */
    Language[Language["TYPESCRIPT"] = 45] = "TYPESCRIPT";
    /**
     * @generated from enum value: LANGUAGE_VISUALBASIC = 46;
     */
    Language[Language["VISUALBASIC"] = 46] = "VISUALBASIC";
    /**
     * @generated from enum value: LANGUAGE_VUE = 47;
     */
    Language[Language["VUE"] = 47] = "VUE";
    /**
     * @generated from enum value: LANGUAGE_XML = 48;
     */
    Language[Language["XML"] = 48] = "XML";
    /**
     * @generated from enum value: LANGUAGE_XSL = 49;
     */
    Language[Language["XSL"] = 49] = "XSL";
    /**
     * @generated from enum value: LANGUAGE_YAML = 50;
     */
    Language[Language["YAML"] = 50] = "YAML";
    /**
     * @generated from enum value: LANGUAGE_SVELTE = 51;
     */
    Language[Language["SVELTE"] = 51] = "SVELTE";
    /**
     * @generated from enum value: LANGUAGE_TOML = 52;
     */
    Language[Language["TOML"] = 52] = "TOML";
    /**
     * @generated from enum value: LANGUAGE_DART = 53;
     */
    Language[Language["DART"] = 53] = "DART";
    /**
     * @generated from enum value: LANGUAGE_RST = 54;
     */
    Language[Language["RST"] = 54] = "RST";
    /**
     * @generated from enum value: LANGUAGE_OCAML = 55;
     */
    Language[Language["OCAML"] = 55] = "OCAML";
    /**
     * @generated from enum value: LANGUAGE_CMAKE = 56;
     */
    Language[Language["CMAKE"] = 56] = "CMAKE";
    /**
     * @generated from enum value: LANGUAGE_PASCAL = 57;
     */
    Language[Language["PASCAL"] = 57] = "PASCAL";
    /**
     * @generated from enum value: LANGUAGE_ELIXIR = 58;
     */
    Language[Language["ELIXIR"] = 58] = "ELIXIR";
    /**
     * @generated from enum value: LANGUAGE_FSHARP = 59;
     */
    Language[Language["FSHARP"] = 59] = "FSHARP";
    /**
     * @generated from enum value: LANGUAGE_LISP = 60;
     */
    Language[Language["LISP"] = 60] = "LISP";
    /**
     * @generated from enum value: LANGUAGE_MATLAB = 61;
     */
    Language[Language["MATLAB"] = 61] = "MATLAB";
    /**
     * @generated from enum value: LANGUAGE_POWERSHELL = 62;
     */
    Language[Language["POWERSHELL"] = 62] = "POWERSHELL";
    /**
     * @generated from enum value: LANGUAGE_SOLIDITY = 63;
     */
    Language[Language["SOLIDITY"] = 63] = "SOLIDITY";
    /**
     * @generated from enum value: LANGUAGE_ADA = 64;
     */
    Language[Language["ADA"] = 64] = "ADA";
    /**
     * @generated from enum value: LANGUAGE_OCAML_INTERFACE = 65;
     */
    Language[Language["OCAML_INTERFACE"] = 65] = "OCAML_INTERFACE";
    /**
     * @generated from enum value: LANGUAGE_TREE_SITTER_QUERY = 66;
     */
    Language[Language["TREE_SITTER_QUERY"] = 66] = "TREE_SITTER_QUERY";
    /**
     * @generated from enum value: LANGUAGE_APL = 67;
     */
    Language[Language["APL"] = 67] = "APL";
    /**
     * @generated from enum value: LANGUAGE_ASSEMBLY = 68;
     */
    Language[Language["ASSEMBLY"] = 68] = "ASSEMBLY";
    /**
     * @generated from enum value: LANGUAGE_COBOL = 69;
     */
    Language[Language["COBOL"] = 69] = "COBOL";
    /**
     * @generated from enum value: LANGUAGE_CRYSTAL = 70;
     */
    Language[Language["CRYSTAL"] = 70] = "CRYSTAL";
    /**
     * @generated from enum value: LANGUAGE_EMACS_LISP = 71;
     */
    Language[Language["EMACS_LISP"] = 71] = "EMACS_LISP";
    /**
     * @generated from enum value: LANGUAGE_ERLANG = 72;
     */
    Language[Language["ERLANG"] = 72] = "ERLANG";
    /**
     * @generated from enum value: LANGUAGE_FORTRAN = 73;
     */
    Language[Language["FORTRAN"] = 73] = "FORTRAN";
    /**
     * @generated from enum value: LANGUAGE_FREEFORM = 74;
     */
    Language[Language["FREEFORM"] = 74] = "FREEFORM";
    /**
     * @generated from enum value: LANGUAGE_GRADLE = 75;
     */
    Language[Language["GRADLE"] = 75] = "GRADLE";
    /**
     * @generated from enum value: LANGUAGE_HACK = 76;
     */
    Language[Language["HACK"] = 76] = "HACK";
    /**
     * @generated from enum value: LANGUAGE_MAVEN = 77;
     */
    Language[Language["MAVEN"] = 77] = "MAVEN";
    /**
     * @generated from enum value: LANGUAGE_M68KASSEMBLY = 78;
     */
    Language[Language["M68KASSEMBLY"] = 78] = "M68KASSEMBLY";
    /**
     * @generated from enum value: LANGUAGE_SAS = 79;
     */
    Language[Language["SAS"] = 79] = "SAS";
    /**
     * @generated from enum value: LANGUAGE_UNIXASSEMBLY = 80;
     */
    Language[Language["UNIXASSEMBLY"] = 80] = "UNIXASSEMBLY";
    /**
     * @generated from enum value: LANGUAGE_VBA = 81;
     */
    Language[Language["VBA"] = 81] = "VBA";
    /**
     * @generated from enum value: LANGUAGE_VIMSCRIPT = 82;
     */
    Language[Language["VIMSCRIPT"] = 82] = "VIMSCRIPT";
    /**
     * @generated from enum value: LANGUAGE_WEBASSEMBLY = 83;
     */
    Language[Language["WEBASSEMBLY"] = 83] = "WEBASSEMBLY";
    /**
     * @generated from enum value: LANGUAGE_BLADE = 84;
     */
    Language[Language["BLADE"] = 84] = "BLADE";
    /**
     * @generated from enum value: LANGUAGE_ASTRO = 85;
     */
    Language[Language["ASTRO"] = 85] = "ASTRO";
    /**
     * @generated from enum value: LANGUAGE_MUMPS = 86;
     */
    Language[Language["MUMPS"] = 86] = "MUMPS";
    /**
     * @generated from enum value: LANGUAGE_GDSCRIPT = 87;
     */
    Language[Language["GDSCRIPT"] = 87] = "GDSCRIPT";
    /**
     * @generated from enum value: LANGUAGE_NIM = 88;
     */
    Language[Language["NIM"] = 88] = "NIM";
    /**
     * @generated from enum value: LANGUAGE_PROLOG = 89;
     */
    Language[Language["PROLOG"] = 89] = "PROLOG";
    /**
     * @generated from enum value: LANGUAGE_MARKDOWN_INLINE = 90;
     */
    Language[Language["MARKDOWN_INLINE"] = 90] = "MARKDOWN_INLINE";
    /**
     * @generated from enum value: LANGUAGE_APEX = 91;
     */
    Language[Language["APEX"] = 91] = "APEX";
})(Language || (Language = {}));
// Retrieve enum metadata with: proto3.getEnumType(Language)
proto3.util.setEnumType(Language, "exa.codeium_common_pb.Language", [
    { no: 0, name: "LANGUAGE_UNSPECIFIED" },
    { no: 1, name: "LANGUAGE_C" },
    { no: 2, name: "LANGUAGE_CLOJURE" },
    { no: 3, name: "LANGUAGE_COFFEESCRIPT" },
    { no: 4, name: "LANGUAGE_CPP" },
    { no: 5, name: "LANGUAGE_CSHARP" },
    { no: 6, name: "LANGUAGE_CSS" },
    { no: 7, name: "LANGUAGE_CUDACPP" },
    { no: 8, name: "LANGUAGE_DOCKERFILE" },
    { no: 9, name: "LANGUAGE_GO" },
    { no: 10, name: "LANGUAGE_GROOVY" },
    { no: 11, name: "LANGUAGE_HANDLEBARS" },
    { no: 12, name: "LANGUAGE_HASKELL" },
    { no: 13, name: "LANGUAGE_HCL" },
    { no: 14, name: "LANGUAGE_HTML" },
    { no: 15, name: "LANGUAGE_INI" },
    { no: 16, name: "LANGUAGE_JAVA" },
    { no: 17, name: "LANGUAGE_JAVASCRIPT" },
    { no: 18, name: "LANGUAGE_JSON" },
    { no: 19, name: "LANGUAGE_JULIA" },
    { no: 20, name: "LANGUAGE_KOTLIN" },
    { no: 21, name: "LANGUAGE_LATEX" },
    { no: 22, name: "LANGUAGE_LESS" },
    { no: 23, name: "LANGUAGE_LUA" },
    { no: 24, name: "LANGUAGE_MAKEFILE" },
    { no: 25, name: "LANGUAGE_MARKDOWN" },
    { no: 26, name: "LANGUAGE_OBJECTIVEC" },
    { no: 27, name: "LANGUAGE_OBJECTIVECPP" },
    { no: 28, name: "LANGUAGE_PERL" },
    { no: 29, name: "LANGUAGE_PHP" },
    { no: 30, name: "LANGUAGE_PLAINTEXT" },
    { no: 31, name: "LANGUAGE_PROTOBUF" },
    { no: 32, name: "LANGUAGE_PBTXT" },
    { no: 33, name: "LANGUAGE_PYTHON" },
    { no: 34, name: "LANGUAGE_R" },
    { no: 35, name: "LANGUAGE_RUBY" },
    { no: 36, name: "LANGUAGE_RUST" },
    { no: 37, name: "LANGUAGE_SASS" },
    { no: 38, name: "LANGUAGE_SCALA" },
    { no: 39, name: "LANGUAGE_SCSS" },
    { no: 40, name: "LANGUAGE_SHELL" },
    { no: 41, name: "LANGUAGE_SQL" },
    { no: 42, name: "LANGUAGE_STARLARK" },
    { no: 43, name: "LANGUAGE_SWIFT" },
    { no: 44, name: "LANGUAGE_TSX" },
    { no: 45, name: "LANGUAGE_TYPESCRIPT" },
    { no: 46, name: "LANGUAGE_VISUALBASIC" },
    { no: 47, name: "LANGUAGE_VUE" },
    { no: 48, name: "LANGUAGE_XML" },
    { no: 49, name: "LANGUAGE_XSL" },
    { no: 50, name: "LANGUAGE_YAML" },
    { no: 51, name: "LANGUAGE_SVELTE" },
    { no: 52, name: "LANGUAGE_TOML" },
    { no: 53, name: "LANGUAGE_DART" },
    { no: 54, name: "LANGUAGE_RST" },
    { no: 55, name: "LANGUAGE_OCAML" },
    { no: 56, name: "LANGUAGE_CMAKE" },
    { no: 57, name: "LANGUAGE_PASCAL" },
    { no: 58, name: "LANGUAGE_ELIXIR" },
    { no: 59, name: "LANGUAGE_FSHARP" },
    { no: 60, name: "LANGUAGE_LISP" },
    { no: 61, name: "LANGUAGE_MATLAB" },
    { no: 62, name: "LANGUAGE_POWERSHELL" },
    { no: 63, name: "LANGUAGE_SOLIDITY" },
    { no: 64, name: "LANGUAGE_ADA" },
    { no: 65, name: "LANGUAGE_OCAML_INTERFACE" },
    { no: 66, name: "LANGUAGE_TREE_SITTER_QUERY" },
    { no: 67, name: "LANGUAGE_APL" },
    { no: 68, name: "LANGUAGE_ASSEMBLY" },
    { no: 69, name: "LANGUAGE_COBOL" },
    { no: 70, name: "LANGUAGE_CRYSTAL" },
    { no: 71, name: "LANGUAGE_EMACS_LISP" },
    { no: 72, name: "LANGUAGE_ERLANG" },
    { no: 73, name: "LANGUAGE_FORTRAN" },
    { no: 74, name: "LANGUAGE_FREEFORM" },
    { no: 75, name: "LANGUAGE_GRADLE" },
    { no: 76, name: "LANGUAGE_HACK" },
    { no: 77, name: "LANGUAGE_MAVEN" },
    { no: 78, name: "LANGUAGE_M68KASSEMBLY" },
    { no: 79, name: "LANGUAGE_SAS" },
    { no: 80, name: "LANGUAGE_UNIXASSEMBLY" },
    { no: 81, name: "LANGUAGE_VBA" },
    { no: 82, name: "LANGUAGE_VIMSCRIPT" },
    { no: 83, name: "LANGUAGE_WEBASSEMBLY" },
    { no: 84, name: "LANGUAGE_BLADE" },
    { no: 85, name: "LANGUAGE_ASTRO" },
    { no: 86, name: "LANGUAGE_MUMPS" },
    { no: 87, name: "LANGUAGE_GDSCRIPT" },
    { no: 88, name: "LANGUAGE_NIM" },
    { no: 89, name: "LANGUAGE_PROLOG" },
    { no: 90, name: "LANGUAGE_MARKDOWN_INLINE" },
    { no: 91, name: "LANGUAGE_APEX" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ChatMessageSource
 */
export var ChatMessageSource;
(function (ChatMessageSource) {
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_UNSPECIFIED = 0;
     */
    ChatMessageSource[ChatMessageSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_USER = 1;
     */
    ChatMessageSource[ChatMessageSource["USER"] = 1] = "USER";
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_SYSTEM = 2;
     */
    ChatMessageSource[ChatMessageSource["SYSTEM"] = 2] = "SYSTEM";
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_UNKNOWN = 3;
     */
    ChatMessageSource[ChatMessageSource["UNKNOWN"] = 3] = "UNKNOWN";
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_TOOL = 4;
     */
    ChatMessageSource[ChatMessageSource["TOOL"] = 4] = "TOOL";
    /**
     * @generated from enum value: CHAT_MESSAGE_SOURCE_SYSTEM_PROMPT = 5;
     */
    ChatMessageSource[ChatMessageSource["SYSTEM_PROMPT"] = 5] = "SYSTEM_PROMPT";
})(ChatMessageSource || (ChatMessageSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(ChatMessageSource)
proto3.util.setEnumType(ChatMessageSource, "exa.codeium_common_pb.ChatMessageSource", [
    { no: 0, name: "CHAT_MESSAGE_SOURCE_UNSPECIFIED" },
    { no: 1, name: "CHAT_MESSAGE_SOURCE_USER" },
    { no: 2, name: "CHAT_MESSAGE_SOURCE_SYSTEM" },
    { no: 3, name: "CHAT_MESSAGE_SOURCE_UNKNOWN" },
    { no: 4, name: "CHAT_MESSAGE_SOURCE_TOOL" },
    { no: 5, name: "CHAT_MESSAGE_SOURCE_SYSTEM_PROMPT" },
]);
/**
 * @generated from enum exa.codeium_common_pb.UserTeamStatus
 */
export var UserTeamStatus;
(function (UserTeamStatus) {
    /**
     * @generated from enum value: USER_TEAM_STATUS_UNSPECIFIED = 0;
     */
    UserTeamStatus[UserTeamStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: USER_TEAM_STATUS_PENDING = 1;
     */
    UserTeamStatus[UserTeamStatus["PENDING"] = 1] = "PENDING";
    /**
     * @generated from enum value: USER_TEAM_STATUS_APPROVED = 2;
     */
    UserTeamStatus[UserTeamStatus["APPROVED"] = 2] = "APPROVED";
    /**
     * @generated from enum value: USER_TEAM_STATUS_REJECTED = 3;
     */
    UserTeamStatus[UserTeamStatus["REJECTED"] = 3] = "REJECTED";
})(UserTeamStatus || (UserTeamStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(UserTeamStatus)
proto3.util.setEnumType(UserTeamStatus, "exa.codeium_common_pb.UserTeamStatus", [
    { no: 0, name: "USER_TEAM_STATUS_UNSPECIFIED" },
    { no: 1, name: "USER_TEAM_STATUS_PENDING" },
    { no: 2, name: "USER_TEAM_STATUS_APPROVED" },
    { no: 3, name: "USER_TEAM_STATUS_REJECTED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TeamsFeatures
 */
export var TeamsFeatures;
(function (TeamsFeatures) {
    /**
     * @generated from enum value: TEAMS_FEATURES_UNSPECIFIED = 0;
     */
    TeamsFeatures[TeamsFeatures["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TEAMS_FEATURES_SSO = 1;
     */
    TeamsFeatures[TeamsFeatures["SSO"] = 1] = "SSO";
    /**
     * @generated from enum value: TEAMS_FEATURES_ATTRIBUTION = 2;
     */
    TeamsFeatures[TeamsFeatures["ATTRIBUTION"] = 2] = "ATTRIBUTION";
    /**
     * @generated from enum value: TEAMS_FEATURES_PHI = 3;
     */
    TeamsFeatures[TeamsFeatures["PHI"] = 3] = "PHI";
    /**
     * @generated from enum value: TEAMS_FEATURES_CORTEX = 4;
     */
    TeamsFeatures[TeamsFeatures["CORTEX"] = 4] = "CORTEX";
    /**
     * @generated from enum value: TEAMS_FEATURES_OPENAI_DISABLED = 5;
     */
    TeamsFeatures[TeamsFeatures["OPENAI_DISABLED"] = 5] = "OPENAI_DISABLED";
    /**
     * @generated from enum value: TEAMS_FEATURES_REMOTE_INDEXING_DISABLED = 6;
     */
    TeamsFeatures[TeamsFeatures["REMOTE_INDEXING_DISABLED"] = 6] = "REMOTE_INDEXING_DISABLED";
    /**
     * @generated from enum value: TEAMS_FEATURES_API_KEY_ENABLED = 7;
     */
    TeamsFeatures[TeamsFeatures["API_KEY_ENABLED"] = 7] = "API_KEY_ENABLED";
})(TeamsFeatures || (TeamsFeatures = {}));
// Retrieve enum metadata with: proto3.getEnumType(TeamsFeatures)
proto3.util.setEnumType(TeamsFeatures, "exa.codeium_common_pb.TeamsFeatures", [
    { no: 0, name: "TEAMS_FEATURES_UNSPECIFIED" },
    { no: 1, name: "TEAMS_FEATURES_SSO" },
    { no: 2, name: "TEAMS_FEATURES_ATTRIBUTION" },
    { no: 3, name: "TEAMS_FEATURES_PHI" },
    { no: 4, name: "TEAMS_FEATURES_CORTEX" },
    { no: 5, name: "TEAMS_FEATURES_OPENAI_DISABLED" },
    { no: 6, name: "TEAMS_FEATURES_REMOTE_INDEXING_DISABLED" },
    { no: 7, name: "TEAMS_FEATURES_API_KEY_ENABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.UserFeatures
 */
export var UserFeatures;
(function (UserFeatures) {
    /**
     * @generated from enum value: USER_FEATURES_UNSPECIFIED = 0;
     */
    UserFeatures[UserFeatures["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: USER_FEATURES_CORTEX = 1;
     */
    UserFeatures[UserFeatures["CORTEX"] = 1] = "CORTEX";
    /**
     * @generated from enum value: USER_FEATURES_CORTEX_TEST = 2;
     */
    UserFeatures[UserFeatures["CORTEX_TEST"] = 2] = "CORTEX_TEST";
})(UserFeatures || (UserFeatures = {}));
// Retrieve enum metadata with: proto3.getEnumType(UserFeatures)
proto3.util.setEnumType(UserFeatures, "exa.codeium_common_pb.UserFeatures", [
    { no: 0, name: "USER_FEATURES_UNSPECIFIED" },
    { no: 1, name: "USER_FEATURES_CORTEX" },
    { no: 2, name: "USER_FEATURES_CORTEX_TEST" },
]);
/**
 * Next ID: 30
 *
 * @generated from enum exa.codeium_common_pb.Permission
 */
export var Permission;
(function (Permission) {
    /**
     * WRITE = CREATE + UPDATE + DELETE
     *
     * @generated from enum value: PERMISSION_UNSPECIFIED = 0;
     */
    Permission[Permission["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Attribution
     *
     * @generated from enum value: PERMISSION_ATTRIBUTION_READ = 1;
     */
    Permission[Permission["ATTRIBUTION_READ"] = 1] = "ATTRIBUTION_READ";
    /**
     * Analytics Permissions
     *
     * @generated from enum value: PERMISSION_ANALYTICS_READ = 2;
     */
    Permission[Permission["ANALYTICS_READ"] = 2] = "ANALYTICS_READ";
    /**
     * License Permission
     * Enterprise-only
     *
     * @generated from enum value: PERMISSION_LICENSE_READ = 3;
     */
    Permission[Permission["LICENSE_READ"] = 3] = "LICENSE_READ";
    /**
     * Team Permission
     *
     * @generated from enum value: PERMISSION_TEAM_USER_READ = 4;
     */
    Permission[Permission["TEAM_USER_READ"] = 4] = "TEAM_USER_READ";
    /**
     * SaaS-only
     *
     * @generated from enum value: PERMISSION_TEAM_USER_UPDATE = 5;
     */
    Permission[Permission["TEAM_USER_UPDATE"] = 5] = "TEAM_USER_UPDATE";
    /**
     * @generated from enum value: PERMISSION_TEAM_USER_DELETE = 6;
     */
    Permission[Permission["TEAM_USER_DELETE"] = 6] = "TEAM_USER_DELETE";
    /**
     * @generated from enum value: PERMISSION_TEAM_USER_INVITE = 17;
     */
    Permission[Permission["TEAM_USER_INVITE"] = 17] = "TEAM_USER_INVITE";
    /**
     * Indexing Permission
     *
     * @generated from enum value: PERMISSION_INDEXING_READ = 7;
     */
    Permission[Permission["INDEXING_READ"] = 7] = "INDEXING_READ";
    /**
     * @generated from enum value: PERMISSION_INDEXING_CREATE = 8;
     */
    Permission[Permission["INDEXING_CREATE"] = 8] = "INDEXING_CREATE";
    /**
     * @generated from enum value: PERMISSION_INDEXING_UPDATE = 9;
     */
    Permission[Permission["INDEXING_UPDATE"] = 9] = "INDEXING_UPDATE";
    /**
     * @generated from enum value: PERMISSION_INDEXING_DELETE = 10;
     */
    Permission[Permission["INDEXING_DELETE"] = 10] = "INDEXING_DELETE";
    /**
     * @generated from enum value: PERMISSION_INDEXING_MANAGEMENT = 27;
     */
    Permission[Permission["INDEXING_MANAGEMENT"] = 27] = "INDEXING_MANAGEMENT";
    /**
     * Finetuning Permission
     * Enterprise-only
     *
     * @generated from enum value: PERMISSION_FINETUNING_READ = 19;
     */
    Permission[Permission["FINETUNING_READ"] = 19] = "FINETUNING_READ";
    /**
     * @generated from enum value: PERMISSION_FINETUNING_CREATE = 20;
     */
    Permission[Permission["FINETUNING_CREATE"] = 20] = "FINETUNING_CREATE";
    /**
     * @generated from enum value: PERMISSION_FINETUNING_UPDATE = 21;
     */
    Permission[Permission["FINETUNING_UPDATE"] = 21] = "FINETUNING_UPDATE";
    /**
     * @generated from enum value: PERMISSION_FINETUNING_DELETE = 22;
     */
    Permission[Permission["FINETUNING_DELETE"] = 22] = "FINETUNING_DELETE";
    /**
     * SSO Permission
     *
     * @generated from enum value: PERMISSION_SSO_READ = 11;
     */
    Permission[Permission["SSO_READ"] = 11] = "SSO_READ";
    /**
     * @generated from enum value: PERMISSION_SSO_WRITE = 12;
     */
    Permission[Permission["SSO_WRITE"] = 12] = "SSO_WRITE";
    /**
     * @generated from enum value: PERMISSION_SERVICE_KEY_READ = 13;
     */
    Permission[Permission["SERVICE_KEY_READ"] = 13] = "SERVICE_KEY_READ";
    /**
     * User can only create api keys they have permission to
     *
     * @generated from enum value: PERMISSION_SERVICE_KEY_CREATE = 14;
     */
    Permission[Permission["SERVICE_KEY_CREATE"] = 14] = "SERVICE_KEY_CREATE";
    /**
     * @generated from enum value: PERMISSION_SERVICE_KEY_UPDATE = 28;
     */
    Permission[Permission["SERVICE_KEY_UPDATE"] = 28] = "SERVICE_KEY_UPDATE";
    /**
     * @generated from enum value: PERMISSION_SERVICE_KEY_DELETE = 15;
     */
    Permission[Permission["SERVICE_KEY_DELETE"] = 15] = "SERVICE_KEY_DELETE";
    /**
     * @generated from enum value: PERMISSION_ROLE_READ = 23;
     */
    Permission[Permission["ROLE_READ"] = 23] = "ROLE_READ";
    /**
     * @generated from enum value: PERMISSION_ROLE_CREATE = 24;
     */
    Permission[Permission["ROLE_CREATE"] = 24] = "ROLE_CREATE";
    /**
     * @generated from enum value: PERMISSION_ROLE_UPDATE = 25;
     */
    Permission[Permission["ROLE_UPDATE"] = 25] = "ROLE_UPDATE";
    /**
     * @generated from enum value: PERMISSION_ROLE_DELETE = 26;
     */
    Permission[Permission["ROLE_DELETE"] = 26] = "ROLE_DELETE";
    /**
     * Billing
     * SaaS-only
     *
     * @generated from enum value: PERMISSION_BILLING_READ = 16;
     */
    Permission[Permission["BILLING_READ"] = 16] = "BILLING_READ";
    /**
     * @generated from enum value: PERMISSION_BILLING_WRITE = 18;
     */
    Permission[Permission["BILLING_WRITE"] = 18] = "BILLING_WRITE";
    /**
     * Enterprise external chat model
     *
     * @generated from enum value: PERMISSION_EXTERNAL_CHAT_UPDATE = 29;
     */
    Permission[Permission["EXTERNAL_CHAT_UPDATE"] = 29] = "EXTERNAL_CHAT_UPDATE";
    /**
     * Team settings
     *
     * @generated from enum value: PERMISSION_TEAM_SETTINGS_READ = 30;
     */
    Permission[Permission["TEAM_SETTINGS_READ"] = 30] = "TEAM_SETTINGS_READ";
    /**
     * @generated from enum value: PERMISSION_TEAM_SETTINGS_UPDATE = 31;
     */
    Permission[Permission["TEAM_SETTINGS_UPDATE"] = 31] = "TEAM_SETTINGS_UPDATE";
})(Permission || (Permission = {}));
// Retrieve enum metadata with: proto3.getEnumType(Permission)
proto3.util.setEnumType(Permission, "exa.codeium_common_pb.Permission", [
    { no: 0, name: "PERMISSION_UNSPECIFIED" },
    { no: 1, name: "PERMISSION_ATTRIBUTION_READ" },
    { no: 2, name: "PERMISSION_ANALYTICS_READ" },
    { no: 3, name: "PERMISSION_LICENSE_READ" },
    { no: 4, name: "PERMISSION_TEAM_USER_READ" },
    { no: 5, name: "PERMISSION_TEAM_USER_UPDATE" },
    { no: 6, name: "PERMISSION_TEAM_USER_DELETE" },
    { no: 17, name: "PERMISSION_TEAM_USER_INVITE" },
    { no: 7, name: "PERMISSION_INDEXING_READ" },
    { no: 8, name: "PERMISSION_INDEXING_CREATE" },
    { no: 9, name: "PERMISSION_INDEXING_UPDATE" },
    { no: 10, name: "PERMISSION_INDEXING_DELETE" },
    { no: 27, name: "PERMISSION_INDEXING_MANAGEMENT" },
    { no: 19, name: "PERMISSION_FINETUNING_READ" },
    { no: 20, name: "PERMISSION_FINETUNING_CREATE" },
    { no: 21, name: "PERMISSION_FINETUNING_UPDATE" },
    { no: 22, name: "PERMISSION_FINETUNING_DELETE" },
    { no: 11, name: "PERMISSION_SSO_READ" },
    { no: 12, name: "PERMISSION_SSO_WRITE" },
    { no: 13, name: "PERMISSION_SERVICE_KEY_READ" },
    { no: 14, name: "PERMISSION_SERVICE_KEY_CREATE" },
    { no: 28, name: "PERMISSION_SERVICE_KEY_UPDATE" },
    { no: 15, name: "PERMISSION_SERVICE_KEY_DELETE" },
    { no: 23, name: "PERMISSION_ROLE_READ" },
    { no: 24, name: "PERMISSION_ROLE_CREATE" },
    { no: 25, name: "PERMISSION_ROLE_UPDATE" },
    { no: 26, name: "PERMISSION_ROLE_DELETE" },
    { no: 16, name: "PERMISSION_BILLING_READ" },
    { no: 18, name: "PERMISSION_BILLING_WRITE" },
    { no: 29, name: "PERMISSION_EXTERNAL_CHAT_UPDATE" },
    { no: 30, name: "PERMISSION_TEAM_SETTINGS_READ" },
    { no: 31, name: "PERMISSION_TEAM_SETTINGS_UPDATE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TeamsTier
 */
export var TeamsTier;
(function (TeamsTier) {
    /**
     * @generated from enum value: TEAMS_TIER_UNSPECIFIED = 0;
     */
    TeamsTier[TeamsTier["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TEAMS_TIER_TEAMS = 1;
     */
    TeamsTier[TeamsTier["TEAMS"] = 1] = "TEAMS";
    /**
     * @generated from enum value: TEAMS_TIER_PRO = 2;
     */
    TeamsTier[TeamsTier["PRO"] = 2] = "PRO";
    /**
     * @generated from enum value: TEAMS_TIER_TRIAL = 9;
     */
    TeamsTier[TeamsTier["TRIAL"] = 9] = "TRIAL";
    /**
     * @generated from enum value: TEAMS_TIER_ENTERPRISE_SAAS = 3;
     */
    TeamsTier[TeamsTier["ENTERPRISE_SAAS"] = 3] = "ENTERPRISE_SAAS";
    /**
     * @generated from enum value: TEAMS_TIER_HYBRID = 4;
     */
    TeamsTier[TeamsTier["HYBRID"] = 4] = "HYBRID";
    /**
     * @generated from enum value: TEAMS_TIER_ENTERPRISE_SELF_HOSTED = 5;
     */
    TeamsTier[TeamsTier["ENTERPRISE_SELF_HOSTED"] = 5] = "ENTERPRISE_SELF_HOSTED";
    /**
     * @generated from enum value: TEAMS_TIER_ENTERPRISE_SELF_SERVE = 10;
     */
    TeamsTier[TeamsTier["ENTERPRISE_SELF_SERVE"] = 10] = "ENTERPRISE_SELF_SERVE";
    /**
     * Deprecated / legacy tiers.
     *
     * @generated from enum value: TEAMS_TIER_WAITLIST_PRO = 6;
     */
    TeamsTier[TeamsTier["WAITLIST_PRO"] = 6] = "WAITLIST_PRO";
    /**
     * @generated from enum value: TEAMS_TIER_TEAMS_ULTIMATE = 7;
     */
    TeamsTier[TeamsTier["TEAMS_ULTIMATE"] = 7] = "TEAMS_ULTIMATE";
    /**
     * @generated from enum value: TEAMS_TIER_PRO_ULTIMATE = 8;
     */
    TeamsTier[TeamsTier["PRO_ULTIMATE"] = 8] = "PRO_ULTIMATE";
})(TeamsTier || (TeamsTier = {}));
// Retrieve enum metadata with: proto3.getEnumType(TeamsTier)
proto3.util.setEnumType(TeamsTier, "exa.codeium_common_pb.TeamsTier", [
    { no: 0, name: "TEAMS_TIER_UNSPECIFIED" },
    { no: 1, name: "TEAMS_TIER_TEAMS" },
    { no: 2, name: "TEAMS_TIER_PRO" },
    { no: 9, name: "TEAMS_TIER_TRIAL" },
    { no: 3, name: "TEAMS_TIER_ENTERPRISE_SAAS" },
    { no: 4, name: "TEAMS_TIER_HYBRID" },
    { no: 5, name: "TEAMS_TIER_ENTERPRISE_SELF_HOSTED" },
    { no: 10, name: "TEAMS_TIER_ENTERPRISE_SELF_SERVE" },
    { no: 6, name: "TEAMS_TIER_WAITLIST_PRO" },
    { no: 7, name: "TEAMS_TIER_TEAMS_ULTIMATE" },
    { no: 8, name: "TEAMS_TIER_PRO_ULTIMATE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ModelProvider
 */
export var ModelProvider;
(function (ModelProvider) {
    /**
     * @generated from enum value: MODEL_PROVIDER_UNSPECIFIED = 0;
     */
    ModelProvider[ModelProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MODEL_PROVIDER_WINDSURF = 1;
     */
    ModelProvider[ModelProvider["WINDSURF"] = 1] = "WINDSURF";
    /**
     * @generated from enum value: MODEL_PROVIDER_OPENAI = 2;
     */
    ModelProvider[ModelProvider["OPENAI"] = 2] = "OPENAI";
    /**
     * @generated from enum value: MODEL_PROVIDER_ANTHROPIC = 3;
     */
    ModelProvider[ModelProvider["ANTHROPIC"] = 3] = "ANTHROPIC";
    /**
     * @generated from enum value: MODEL_PROVIDER_GOOGLE = 4;
     */
    ModelProvider[ModelProvider["GOOGLE"] = 4] = "GOOGLE";
    /**
     * @generated from enum value: MODEL_PROVIDER_XAI = 5;
     */
    ModelProvider[ModelProvider["XAI"] = 5] = "XAI";
    /**
     * @generated from enum value: MODEL_PROVIDER_DEEPSEEK = 6;
     */
    ModelProvider[ModelProvider["DEEPSEEK"] = 6] = "DEEPSEEK";
})(ModelProvider || (ModelProvider = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelProvider)
proto3.util.setEnumType(ModelProvider, "exa.codeium_common_pb.ModelProvider", [
    { no: 0, name: "MODEL_PROVIDER_UNSPECIFIED" },
    { no: 1, name: "MODEL_PROVIDER_WINDSURF" },
    { no: 2, name: "MODEL_PROVIDER_OPENAI" },
    { no: 3, name: "MODEL_PROVIDER_ANTHROPIC" },
    { no: 4, name: "MODEL_PROVIDER_GOOGLE" },
    { no: 5, name: "MODEL_PROVIDER_XAI" },
    { no: 6, name: "MODEL_PROVIDER_DEEPSEEK" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ModelPricingType
 */
export var ModelPricingType;
(function (ModelPricingType) {
    /**
     * @generated from enum value: MODEL_PRICING_TYPE_UNSPECIFIED = 0;
     */
    ModelPricingType[ModelPricingType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Static credit pricing (i.e. 1 prompt credit per message).
     *
     * @generated from enum value: MODEL_PRICING_TYPE_STATIC_CREDIT = 1;
     */
    ModelPricingType[ModelPricingType["STATIC_CREDIT"] = 1] = "STATIC_CREDIT";
    /**
     * API pass-through pricing.
     *
     * @generated from enum value: MODEL_PRICING_TYPE_API = 2;
     */
    ModelPricingType[ModelPricingType["API"] = 2] = "API";
    /**
     * Bring your own key pricing.
     *
     * @generated from enum value: MODEL_PRICING_TYPE_BYOK = 3;
     */
    ModelPricingType[ModelPricingType["BYOK"] = 3] = "BYOK";
})(ModelPricingType || (ModelPricingType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelPricingType)
proto3.util.setEnumType(ModelPricingType, "exa.codeium_common_pb.ModelPricingType", [
    { no: 0, name: "MODEL_PRICING_TYPE_UNSPECIFIED" },
    { no: 1, name: "MODEL_PRICING_TYPE_STATIC_CREDIT" },
    { no: 2, name: "MODEL_PRICING_TYPE_API" },
    { no: 3, name: "MODEL_PRICING_TYPE_BYOK" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TransactionStatus
 */
export var TransactionStatus;
(function (TransactionStatus) {
    /**
     * @generated from enum value: TRANSACTION_STATUS_UNSPECIFIED = 0;
     */
    TransactionStatus[TransactionStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TRANSACTION_STATUS_SUCCEEDED = 1;
     */
    TransactionStatus[TransactionStatus["SUCCEEDED"] = 1] = "SUCCEEDED";
    /**
     * @generated from enum value: TRANSACTION_STATUS_PROCESSING = 2;
     */
    TransactionStatus[TransactionStatus["PROCESSING"] = 2] = "PROCESSING";
    /**
     * @generated from enum value: TRANSACTION_STATUS_FAILED = 3;
     */
    TransactionStatus[TransactionStatus["FAILED"] = 3] = "FAILED";
    /**
     * @generated from enum value: TRANSACTION_STATUS_NO_ACTIVE = 4;
     */
    TransactionStatus[TransactionStatus["NO_ACTIVE"] = 4] = "NO_ACTIVE";
})(TransactionStatus || (TransactionStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(TransactionStatus)
proto3.util.setEnumType(TransactionStatus, "exa.codeium_common_pb.TransactionStatus", [
    { no: 0, name: "TRANSACTION_STATUS_UNSPECIFIED" },
    { no: 1, name: "TRANSACTION_STATUS_SUCCEEDED" },
    { no: 2, name: "TRANSACTION_STATUS_PROCESSING" },
    { no: 3, name: "TRANSACTION_STATUS_FAILED" },
    { no: 4, name: "TRANSACTION_STATUS_NO_ACTIVE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ScmProvider
 */
export var ScmProvider;
(function (ScmProvider) {
    /**
     * @generated from enum value: SCM_PROVIDER_UNSPECIFIED = 0;
     */
    ScmProvider[ScmProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SCM_PROVIDER_GITHUB = 1;
     */
    ScmProvider[ScmProvider["GITHUB"] = 1] = "GITHUB";
    /**
     * @generated from enum value: SCM_PROVIDER_GITLAB = 2;
     */
    ScmProvider[ScmProvider["GITLAB"] = 2] = "GITLAB";
    /**
     * @generated from enum value: SCM_PROVIDER_BITBUCKET = 3;
     */
    ScmProvider[ScmProvider["BITBUCKET"] = 3] = "BITBUCKET";
    /**
     * @generated from enum value: SCM_PROVIDER_AZURE_DEVOPS = 4;
     */
    ScmProvider[ScmProvider["AZURE_DEVOPS"] = 4] = "AZURE_DEVOPS";
})(ScmProvider || (ScmProvider = {}));
// Retrieve enum metadata with: proto3.getEnumType(ScmProvider)
proto3.util.setEnumType(ScmProvider, "exa.codeium_common_pb.ScmProvider", [
    { no: 0, name: "SCM_PROVIDER_UNSPECIFIED" },
    { no: 1, name: "SCM_PROVIDER_GITHUB" },
    { no: 2, name: "SCM_PROVIDER_GITLAB" },
    { no: 3, name: "SCM_PROVIDER_BITBUCKET" },
    { no: 4, name: "SCM_PROVIDER_AZURE_DEVOPS" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ScmType
 */
export var ScmType;
(function (ScmType) {
    /**
     * @generated from enum value: SCM_TYPE_UNSPECIFIED = 0;
     */
    ScmType[ScmType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SCM_TYPE_GIT = 1;
     */
    ScmType[ScmType["GIT"] = 1] = "GIT";
    /**
     * @generated from enum value: SCM_TYPE_PERFORCE = 2;
     */
    ScmType[ScmType["PERFORCE"] = 2] = "PERFORCE";
})(ScmType || (ScmType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ScmType)
proto3.util.setEnumType(ScmType, "exa.codeium_common_pb.ScmType", [
    { no: 0, name: "SCM_TYPE_UNSPECIFIED" },
    { no: 1, name: "SCM_TYPE_GIT" },
    { no: 2, name: "SCM_TYPE_PERFORCE" },
]);
/**
 * CodeContextType is what kind of code this piece of context represents.
 *
 * @generated from enum exa.codeium_common_pb.CodeContextType
 */
export var CodeContextType;
(function (CodeContextType) {
    /**
     * @generated from enum value: CODE_CONTEXT_TYPE_UNSPECIFIED = 0;
     */
    CodeContextType[CodeContextType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Function or Method
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_FUNCTION = 1;
     */
    CodeContextType[CodeContextType["FUNCTION"] = 1] = "FUNCTION";
    /**
     * Class definition
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_CLASS = 2;
     */
    CodeContextType[CodeContextType["CLASS"] = 2] = "CLASS";
    /**
     * Import statement
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_IMPORT = 3;
     */
    CodeContextType[CodeContextType["IMPORT"] = 3] = "IMPORT";
    /**
     * Naive span of lines
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_NAIVE_LINECHUNK = 4;
     */
    CodeContextType[CodeContextType["NAIVE_LINECHUNK"] = 4] = "NAIVE_LINECHUNK";
    /**
     * Function call
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_REFERENCE_FUNCTION = 5;
     */
    CodeContextType[CodeContextType["REFERENCE_FUNCTION"] = 5] = "REFERENCE_FUNCTION";
    /**
     * Class construction
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_REFERENCE_CLASS = 6;
     */
    CodeContextType[CodeContextType["REFERENCE_CLASS"] = 6] = "REFERENCE_CLASS";
    /**
     * An entire file
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_FILE = 7;
     */
    CodeContextType[CodeContextType["FILE"] = 7] = "FILE";
    /**
     * Terminal output
     *
     * @generated from enum value: CODE_CONTEXT_TYPE_TERMINAL = 8;
     */
    CodeContextType[CodeContextType["TERMINAL"] = 8] = "TERMINAL";
})(CodeContextType || (CodeContextType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CodeContextType)
proto3.util.setEnumType(CodeContextType, "exa.codeium_common_pb.CodeContextType", [
    { no: 0, name: "CODE_CONTEXT_TYPE_UNSPECIFIED" },
    { no: 1, name: "CODE_CONTEXT_TYPE_FUNCTION" },
    { no: 2, name: "CODE_CONTEXT_TYPE_CLASS" },
    { no: 3, name: "CODE_CONTEXT_TYPE_IMPORT" },
    { no: 4, name: "CODE_CONTEXT_TYPE_NAIVE_LINECHUNK" },
    { no: 5, name: "CODE_CONTEXT_TYPE_REFERENCE_FUNCTION" },
    { no: 6, name: "CODE_CONTEXT_TYPE_REFERENCE_CLASS" },
    { no: 7, name: "CODE_CONTEXT_TYPE_FILE" },
    { no: 8, name: "CODE_CONTEXT_TYPE_TERMINAL" },
]);
/**
 * CodeContextSource is where a CCI was retrieved from. A CCI can have multiple CodeContextSources.
 *
 * @generated from enum exa.codeium_common_pb.CodeContextSource
 */
export var CodeContextSource;
(function (CodeContextSource) {
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_UNSPECIFIED = 0;
     */
    CodeContextSource[CodeContextSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_OPEN_DOCS = 1;
     */
    CodeContextSource[CodeContextSource["OPEN_DOCS"] = 1] = "OPEN_DOCS";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_SEARCH_RESULT = 2;
     */
    CodeContextSource[CodeContextSource["SEARCH_RESULT"] = 2] = "SEARCH_RESULT";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_IMPORT = 3;
     */
    CodeContextSource[CodeContextSource["IMPORT"] = 3] = "IMPORT";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_LOCAL_DIRECTORY = 4;
     */
    CodeContextSource[CodeContextSource["LOCAL_DIRECTORY"] = 4] = "LOCAL_DIRECTORY";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_LAST_ACTIVE_DOC = 5;
     */
    CodeContextSource[CodeContextSource["LAST_ACTIVE_DOC"] = 5] = "LAST_ACTIVE_DOC";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_ORACLE_ITEMS = 6;
     */
    CodeContextSource[CodeContextSource["ORACLE_ITEMS"] = 6] = "ORACLE_ITEMS";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_PINNED_CONTEXT = 7;
     */
    CodeContextSource[CodeContextSource["PINNED_CONTEXT"] = 7] = "PINNED_CONTEXT";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_RESEARCH_STATE = 8;
     */
    CodeContextSource[CodeContextSource["RESEARCH_STATE"] = 8] = "RESEARCH_STATE";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_GROUND_TRUTH_PLAN_EDIT = 9;
     */
    CodeContextSource[CodeContextSource["GROUND_TRUTH_PLAN_EDIT"] = 9] = "GROUND_TRUTH_PLAN_EDIT";
    /**
     * @generated from enum value: CODE_CONTEXT_SOURCE_COMMIT_GRAPH = 10;
     */
    CodeContextSource[CodeContextSource["COMMIT_GRAPH"] = 10] = "COMMIT_GRAPH";
})(CodeContextSource || (CodeContextSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(CodeContextSource)
proto3.util.setEnumType(CodeContextSource, "exa.codeium_common_pb.CodeContextSource", [
    { no: 0, name: "CODE_CONTEXT_SOURCE_UNSPECIFIED" },
    { no: 1, name: "CODE_CONTEXT_SOURCE_OPEN_DOCS" },
    { no: 2, name: "CODE_CONTEXT_SOURCE_SEARCH_RESULT" },
    { no: 3, name: "CODE_CONTEXT_SOURCE_IMPORT" },
    { no: 4, name: "CODE_CONTEXT_SOURCE_LOCAL_DIRECTORY" },
    { no: 5, name: "CODE_CONTEXT_SOURCE_LAST_ACTIVE_DOC" },
    { no: 6, name: "CODE_CONTEXT_SOURCE_ORACLE_ITEMS" },
    { no: 7, name: "CODE_CONTEXT_SOURCE_PINNED_CONTEXT" },
    { no: 8, name: "CODE_CONTEXT_SOURCE_RESEARCH_STATE" },
    { no: 9, name: "CODE_CONTEXT_SOURCE_GROUND_TRUTH_PLAN_EDIT" },
    { no: 10, name: "CODE_CONTEXT_SOURCE_COMMIT_GRAPH" },
]);
/**
 * Represents different ways of summarizing a given CodeContextItem as a string.
 *
 * @generated from enum exa.codeium_common_pb.ContextSnippetType
 */
export var ContextSnippetType;
(function (ContextSnippetType) {
    /**
     * @generated from enum value: CONTEXT_SNIPPET_TYPE_UNSPECIFIED = 0;
     */
    ContextSnippetType[ContextSnippetType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Raw source corresponding to the snippet line range.
     *
     * @generated from enum value: CONTEXT_SNIPPET_TYPE_RAW_SOURCE = 1;
     */
    ContextSnippetType[ContextSnippetType["RAW_SOURCE"] = 1] = "RAW_SOURCE";
    /**
     * The summarized "signature" of this CodeContextItem. eg. Class def with fields & methods, or function signature.
     *
     * @generated from enum value: CONTEXT_SNIPPET_TYPE_SIGNATURE = 2;
     */
    ContextSnippetType[ContextSnippetType["SIGNATURE"] = 2] = "SIGNATURE";
    /**
     * The summarized "nodepath" of this CodeContextItem.
     *
     * @generated from enum value: CONTEXT_SNIPPET_TYPE_NODEPATH = 3;
     */
    ContextSnippetType[ContextSnippetType["NODEPATH"] = 3] = "NODEPATH";
})(ContextSnippetType || (ContextSnippetType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ContextSnippetType)
proto3.util.setEnumType(ContextSnippetType, "exa.codeium_common_pb.ContextSnippetType", [
    { no: 0, name: "CONTEXT_SNIPPET_TYPE_UNSPECIFIED" },
    { no: 1, name: "CONTEXT_SNIPPET_TYPE_RAW_SOURCE" },
    { no: 2, name: "CONTEXT_SNIPPET_TYPE_SIGNATURE" },
    { no: 3, name: "CONTEXT_SNIPPET_TYPE_NODEPATH" },
]);
/**
 * Represents the different ways of summarizing a given Git commit as a string.
 *
 * @generated from enum exa.codeium_common_pb.CommitIntentType
 */
export var CommitIntentType;
(function (CommitIntentType) {
    /**
     * @generated from enum value: COMMIT_INTENT_TYPE_UNSPECIFIED = 0;
     */
    CommitIntentType[CommitIntentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * The Git commit's raw message.
     *
     * @generated from enum value: COMMIT_INTENT_TYPE_COMMIT_MESSAGE = 1;
     */
    CommitIntentType[CommitIntentType["COMMIT_MESSAGE"] = 1] = "COMMIT_MESSAGE";
})(CommitIntentType || (CommitIntentType = {}));
// Retrieve enum metadata with: proto3.getEnumType(CommitIntentType)
proto3.util.setEnumType(CommitIntentType, "exa.codeium_common_pb.CommitIntentType", [
    { no: 0, name: "COMMIT_INTENT_TYPE_UNSPECIFIED" },
    { no: 1, name: "COMMIT_INTENT_TYPE_COMMIT_MESSAGE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.GpuType
 */
export var GpuType;
(function (GpuType) {
    /**
     * @generated from enum value: GPU_TYPE_UNSPECIFIED = 0;
     */
    GpuType[GpuType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: GPU_TYPE_L4 = 1;
     */
    GpuType[GpuType["L4"] = 1] = "L4";
    /**
     * @generated from enum value: GPU_TYPE_T4 = 2;
     */
    GpuType[GpuType["T4"] = 2] = "T4";
    /**
     * @generated from enum value: GPU_TYPE_A10 = 3;
     */
    GpuType[GpuType["A10"] = 3] = "A10";
    /**
     * @generated from enum value: GPU_TYPE_A100 = 4;
     */
    GpuType[GpuType["A100"] = 4] = "A100";
    /**
     * @generated from enum value: GPU_TYPE_V100 = 5;
     */
    GpuType[GpuType["V100"] = 5] = "V100";
    /**
     * @generated from enum value: GPU_TYPE_A5000 = 6;
     */
    GpuType[GpuType["A5000"] = 6] = "A5000";
})(GpuType || (GpuType = {}));
// Retrieve enum metadata with: proto3.getEnumType(GpuType)
proto3.util.setEnumType(GpuType, "exa.codeium_common_pb.GpuType", [
    { no: 0, name: "GPU_TYPE_UNSPECIFIED" },
    { no: 1, name: "GPU_TYPE_L4" },
    { no: 2, name: "GPU_TYPE_T4" },
    { no: 3, name: "GPU_TYPE_A10" },
    { no: 4, name: "GPU_TYPE_A100" },
    { no: 5, name: "GPU_TYPE_V100" },
    { no: 6, name: "GPU_TYPE_A5000" },
]);
/**
 * Context Inclusion Type
 *
 * @generated from enum exa.codeium_common_pb.ContextInclusionType
 */
export var ContextInclusionType;
(function (ContextInclusionType) {
    /**
     * Default option which asks LLM to include or exclude the context
     *
     * @generated from enum value: CONTEXT_INCLUSION_TYPE_UNSPECIFIED = 0;
     */
    ContextInclusionType[ContextInclusionType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Force LLM to think context is relevant and search for context
     *
     * @generated from enum value: CONTEXT_INCLUSION_TYPE_INCLUDE = 1;
     */
    ContextInclusionType[ContextInclusionType["INCLUDE"] = 1] = "INCLUDE";
    /**
     * Exclude any context
     *
     * @generated from enum value: CONTEXT_INCLUSION_TYPE_EXCLUDE = 2;
     */
    ContextInclusionType[ContextInclusionType["EXCLUDE"] = 2] = "EXCLUDE";
})(ContextInclusionType || (ContextInclusionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ContextInclusionType)
proto3.util.setEnumType(ContextInclusionType, "exa.codeium_common_pb.ContextInclusionType", [
    { no: 0, name: "CONTEXT_INCLUSION_TYPE_UNSPECIFIED" },
    { no: 1, name: "CONTEXT_INCLUSION_TYPE_INCLUDE" },
    { no: 2, name: "CONTEXT_INCLUSION_TYPE_EXCLUDE" },
]);
/**
 * Theme preference for the chat panel
 *
 * @generated from enum exa.codeium_common_pb.ThemePreference
 */
export var ThemePreference;
(function (ThemePreference) {
    /**
     * @generated from enum value: THEME_PREFERENCE_UNSPECIFIED = 0;
     */
    ThemePreference[ThemePreference["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: THEME_PREFERENCE_AUTO = 1;
     */
    ThemePreference[ThemePreference["AUTO"] = 1] = "AUTO";
    /**
     * @generated from enum value: THEME_PREFERENCE_LIGHT = 2;
     */
    ThemePreference[ThemePreference["LIGHT"] = 2] = "LIGHT";
    /**
     * @generated from enum value: THEME_PREFERENCE_DARK = 3;
     */
    ThemePreference[ThemePreference["DARK"] = 3] = "DARK";
})(ThemePreference || (ThemePreference = {}));
// Retrieve enum metadata with: proto3.getEnumType(ThemePreference)
proto3.util.setEnumType(ThemePreference, "exa.codeium_common_pb.ThemePreference", [
    { no: 0, name: "THEME_PREFERENCE_UNSPECIFIED" },
    { no: 1, name: "THEME_PREFERENCE_AUTO" },
    { no: 2, name: "THEME_PREFERENCE_LIGHT" },
    { no: 3, name: "THEME_PREFERENCE_DARK" },
]);
/**
 * Font size for the chat panel
 *
 * @generated from enum exa.codeium_common_pb.FontSize
 */
export var FontSize;
(function (FontSize) {
    /**
     * @generated from enum value: FONT_SIZE_UNSPECIFIED = 0;
     */
    FontSize[FontSize["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: FONT_SIZE_SMALL = 1;
     */
    FontSize[FontSize["SMALL"] = 1] = "SMALL";
    /**
     * @generated from enum value: FONT_SIZE_DEFAULT = 2;
     */
    FontSize[FontSize["DEFAULT"] = 2] = "DEFAULT";
    /**
     * @generated from enum value: FONT_SIZE_LARGE = 3;
     */
    FontSize[FontSize["LARGE"] = 3] = "LARGE";
})(FontSize || (FontSize = {}));
// Retrieve enum metadata with: proto3.getEnumType(FontSize)
proto3.util.setEnumType(FontSize, "exa.codeium_common_pb.FontSize", [
    { no: 0, name: "FONT_SIZE_UNSPECIFIED" },
    { no: 1, name: "FONT_SIZE_SMALL" },
    { no: 2, name: "FONT_SIZE_DEFAULT" },
    { no: 3, name: "FONT_SIZE_LARGE" },
]);
/**
 * Autocomplete Speed for autocomplete display speed
 *
 * @generated from enum exa.codeium_common_pb.AutocompleteSpeed
 */
export var AutocompleteSpeed;
(function (AutocompleteSpeed) {
    /**
     * @generated from enum value: AUTOCOMPLETE_SPEED_UNSPECIFIED = 0;
     */
    AutocompleteSpeed[AutocompleteSpeed["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: AUTOCOMPLETE_SPEED_SLOW = 1;
     */
    AutocompleteSpeed[AutocompleteSpeed["SLOW"] = 1] = "SLOW";
    /**
     * @generated from enum value: AUTOCOMPLETE_SPEED_DEFAULT = 2;
     */
    AutocompleteSpeed[AutocompleteSpeed["DEFAULT"] = 2] = "DEFAULT";
    /**
     * @generated from enum value: AUTOCOMPLETE_SPEED_FAST = 3;
     */
    AutocompleteSpeed[AutocompleteSpeed["FAST"] = 3] = "FAST";
})(AutocompleteSpeed || (AutocompleteSpeed = {}));
// Retrieve enum metadata with: proto3.getEnumType(AutocompleteSpeed)
proto3.util.setEnumType(AutocompleteSpeed, "exa.codeium_common_pb.AutocompleteSpeed", [
    { no: 0, name: "AUTOCOMPLETE_SPEED_UNSPECIFIED" },
    { no: 1, name: "AUTOCOMPLETE_SPEED_SLOW" },
    { no: 2, name: "AUTOCOMPLETE_SPEED_DEFAULT" },
    { no: 3, name: "AUTOCOMPLETE_SPEED_FAST" },
]);
/**
 * Cascade terminal commands auto-execution policy. Before it gets to this policy, we first check:
 * 1. User Deny
 * 2. User Allow
 * 3. System Deny
 * 4. System Allow
 * If it falls through, then we will use this auto-execution policy.
 *
 * @generated from enum exa.codeium_common_pb.CascadeCommandsAutoExecution
 */
export var CascadeCommandsAutoExecution;
(function (CascadeCommandsAutoExecution) {
    /**
     * @generated from enum value: CASCADE_COMMANDS_AUTO_EXECUTION_UNSPECIFIED = 0;
     */
    CascadeCommandsAutoExecution[CascadeCommandsAutoExecution["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Commands will not be auto-executed.
     *
     * @generated from enum value: CASCADE_COMMANDS_AUTO_EXECUTION_OFF = 1;
     */
    CascadeCommandsAutoExecution[CascadeCommandsAutoExecution["OFF"] = 1] = "OFF";
    /**
     * The LLM will decide whether it is safe to auto-execute. This is only available for premium
     * models.
     *
     * @generated from enum value: CASCADE_COMMANDS_AUTO_EXECUTION_AUTO = 2;
     */
    CascadeCommandsAutoExecution[CascadeCommandsAutoExecution["AUTO"] = 2] = "AUTO";
    /**
     * Always auto-execute the command.
     *
     * @generated from enum value: CASCADE_COMMANDS_AUTO_EXECUTION_EAGER = 3;
     */
    CascadeCommandsAutoExecution[CascadeCommandsAutoExecution["EAGER"] = 3] = "EAGER";
})(CascadeCommandsAutoExecution || (CascadeCommandsAutoExecution = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeCommandsAutoExecution)
proto3.util.setEnumType(CascadeCommandsAutoExecution, "exa.codeium_common_pb.CascadeCommandsAutoExecution", [
    { no: 0, name: "CASCADE_COMMANDS_AUTO_EXECUTION_UNSPECIFIED" },
    { no: 1, name: "CASCADE_COMMANDS_AUTO_EXECUTION_OFF" },
    { no: 2, name: "CASCADE_COMMANDS_AUTO_EXECUTION_AUTO" },
    { no: 3, name: "CASCADE_COMMANDS_AUTO_EXECUTION_EAGER" },
]);
/**
 * Current view for the extension
 * TODO(matt): Clarify naming between BRAIN and PLAN.
 *
 * @generated from enum exa.codeium_common_pb.ExtensionPanelTab
 */
export var ExtensionPanelTab;
(function (ExtensionPanelTab) {
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_UNSPECIFIED = 0;
     */
    ExtensionPanelTab[ExtensionPanelTab["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_CHAT = 1;
     */
    ExtensionPanelTab[ExtensionPanelTab["CHAT"] = 1] = "CHAT";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_PROFILE = 2;
     */
    ExtensionPanelTab[ExtensionPanelTab["PROFILE"] = 2] = "PROFILE";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_BRAIN = 4;
     */
    ExtensionPanelTab[ExtensionPanelTab["BRAIN"] = 4] = "BRAIN";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_COMMAND = 5;
     */
    ExtensionPanelTab[ExtensionPanelTab["COMMAND"] = 5] = "COMMAND";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_CORTEX = 6;
     */
    ExtensionPanelTab[ExtensionPanelTab["CORTEX"] = 6] = "CORTEX";
    /**
     * @generated from enum value: EXTENSION_PANEL_TAB_DEBUG = 7;
     */
    ExtensionPanelTab[ExtensionPanelTab["DEBUG"] = 7] = "DEBUG";
})(ExtensionPanelTab || (ExtensionPanelTab = {}));
// Retrieve enum metadata with: proto3.getEnumType(ExtensionPanelTab)
proto3.util.setEnumType(ExtensionPanelTab, "exa.codeium_common_pb.ExtensionPanelTab", [
    { no: 0, name: "EXTENSION_PANEL_TAB_UNSPECIFIED" },
    { no: 1, name: "EXTENSION_PANEL_TAB_CHAT" },
    { no: 2, name: "EXTENSION_PANEL_TAB_PROFILE" },
    { no: 4, name: "EXTENSION_PANEL_TAB_BRAIN" },
    { no: 5, name: "EXTENSION_PANEL_TAB_COMMAND" },
    { no: 6, name: "EXTENSION_PANEL_TAB_CORTEX" },
    { no: 7, name: "EXTENSION_PANEL_TAB_DEBUG" },
]);
/**
 * @generated from enum exa.codeium_common_pb.RememberLastModelSelection
 */
export var RememberLastModelSelection;
(function (RememberLastModelSelection) {
    /**
     * @generated from enum value: REMEMBER_LAST_MODEL_SELECTION_UNSPECIFIED = 0;
     */
    RememberLastModelSelection[RememberLastModelSelection["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: REMEMBER_LAST_MODEL_SELECTION_ENABLED = 1;
     */
    RememberLastModelSelection[RememberLastModelSelection["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: REMEMBER_LAST_MODEL_SELECTION_DISABLED = 2;
     */
    RememberLastModelSelection[RememberLastModelSelection["DISABLED"] = 2] = "DISABLED";
})(RememberLastModelSelection || (RememberLastModelSelection = {}));
// Retrieve enum metadata with: proto3.getEnumType(RememberLastModelSelection)
proto3.util.setEnumType(RememberLastModelSelection, "exa.codeium_common_pb.RememberLastModelSelection", [
    { no: 0, name: "REMEMBER_LAST_MODEL_SELECTION_UNSPECIFIED" },
    { no: 1, name: "REMEMBER_LAST_MODEL_SELECTION_ENABLED" },
    { no: 2, name: "REMEMBER_LAST_MODEL_SELECTION_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CascadeNUXEvent
 */
export var CascadeNUXEvent;
(function (CascadeNUXEvent) {
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_UNSPECIFIED = 0;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_UNSPECIFIED"] = 0] = "CASCADE_NUX_EVENT_UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_DIFF_OVERVIEW = 1;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_DIFF_OVERVIEW"] = 1] = "CASCADE_NUX_EVENT_DIFF_OVERVIEW";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_WEB_SEARCH = 2;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_WEB_SEARCH"] = 2] = "CASCADE_NUX_EVENT_WEB_SEARCH";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_NEW_MODELS_WAVE2 = 3;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_NEW_MODELS_WAVE2"] = 3] = "CASCADE_NUX_EVENT_NEW_MODELS_WAVE2";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_TOOL_CALL = 4;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_TOOL_CALL"] = 4] = "CASCADE_NUX_EVENT_TOOL_CALL";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_MODEL_SELECTOR_NUX = 5;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_MODEL_SELECTOR_NUX"] = 5] = "CASCADE_NUX_EVENT_MODEL_SELECTOR_NUX";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_TOOL_CALL_PRICING_NUX = 6;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_TOOL_CALL_PRICING_NUX"] = 6] = "CASCADE_NUX_EVENT_TOOL_CALL_PRICING_NUX";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_WRITE_CHAT_MODE = 7;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_WRITE_CHAT_MODE"] = 7] = "CASCADE_NUX_EVENT_WRITE_CHAT_MODE";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_REVERT_STEP = 8;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_REVERT_STEP"] = 8] = "CASCADE_NUX_EVENT_REVERT_STEP";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_RULES = 9;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_RULES"] = 9] = "CASCADE_NUX_EVENT_RULES";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_WEB_MENTION = 10;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_WEB_MENTION"] = 10] = "CASCADE_NUX_EVENT_WEB_MENTION";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_BACKGROUND_CASCADE = 11;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_BACKGROUND_CASCADE"] = 11] = "CASCADE_NUX_EVENT_BACKGROUND_CASCADE";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_ANTHROPIC_API_PRICING = 12;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_ANTHROPIC_API_PRICING"] = 12] = "CASCADE_NUX_EVENT_ANTHROPIC_API_PRICING";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_PLAN_MODE = 13;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_PLAN_MODE"] = 13] = "CASCADE_NUX_EVENT_PLAN_MODE";
    /**
     * @generated from enum value: CASCADE_NUX_EVENT_OPEN_BROWSER_URL = 14;
     */
    CascadeNUXEvent[CascadeNUXEvent["CASCADE_NUX_EVENT_OPEN_BROWSER_URL"] = 14] = "CASCADE_NUX_EVENT_OPEN_BROWSER_URL";
})(CascadeNUXEvent || (CascadeNUXEvent = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeNUXEvent)
proto3.util.setEnumType(CascadeNUXEvent, "exa.codeium_common_pb.CascadeNUXEvent", [
    { no: 0, name: "CASCADE_NUX_EVENT_UNSPECIFIED" },
    { no: 1, name: "CASCADE_NUX_EVENT_DIFF_OVERVIEW" },
    { no: 2, name: "CASCADE_NUX_EVENT_WEB_SEARCH" },
    { no: 3, name: "CASCADE_NUX_EVENT_NEW_MODELS_WAVE2" },
    { no: 4, name: "CASCADE_NUX_EVENT_TOOL_CALL" },
    { no: 5, name: "CASCADE_NUX_EVENT_MODEL_SELECTOR_NUX" },
    { no: 6, name: "CASCADE_NUX_EVENT_TOOL_CALL_PRICING_NUX" },
    { no: 7, name: "CASCADE_NUX_EVENT_WRITE_CHAT_MODE" },
    { no: 8, name: "CASCADE_NUX_EVENT_REVERT_STEP" },
    { no: 9, name: "CASCADE_NUX_EVENT_RULES" },
    { no: 10, name: "CASCADE_NUX_EVENT_WEB_MENTION" },
    { no: 11, name: "CASCADE_NUX_EVENT_BACKGROUND_CASCADE" },
    { no: 12, name: "CASCADE_NUX_EVENT_ANTHROPIC_API_PRICING" },
    { no: 13, name: "CASCADE_NUX_EVENT_PLAN_MODE" },
    { no: 14, name: "CASCADE_NUX_EVENT_OPEN_BROWSER_URL" },
]);
/**
 * @generated from enum exa.codeium_common_pb.UserNUXEvent
 */
export var UserNUXEvent;
(function (UserNUXEvent) {
    /**
     * @generated from enum value: USER_NUX_EVENT_UNSPECIFIED = 0;
     */
    UserNUXEvent[UserNUXEvent["USER_NUX_EVENT_UNSPECIFIED"] = 0] = "USER_NUX_EVENT_UNSPECIFIED";
    /**
     * @generated from enum value: USER_NUX_EVENT_DISMISS_WINDSURF_CROSS_SELL = 1;
     */
    UserNUXEvent[UserNUXEvent["USER_NUX_EVENT_DISMISS_WINDSURF_CROSS_SELL"] = 1] = "USER_NUX_EVENT_DISMISS_WINDSURF_CROSS_SELL";
})(UserNUXEvent || (UserNUXEvent = {}));
// Retrieve enum metadata with: proto3.getEnumType(UserNUXEvent)
proto3.util.setEnumType(UserNUXEvent, "exa.codeium_common_pb.UserNUXEvent", [
    { no: 0, name: "USER_NUX_EVENT_UNSPECIFIED" },
    { no: 1, name: "USER_NUX_EVENT_DISMISS_WINDSURF_CROSS_SELL" },
]);
/**
 * Note: Sad that we need to have this here instead of cortex_pb because of a circular dependency on UserSettings.
 * TODO(nmoy): Should move UserSettings proto to its own file so that it can import from all places (including cortex_pb).
 *
 * @generated from enum exa.codeium_common_pb.ConversationalPlannerMode
 */
export var ConversationalPlannerMode;
(function (ConversationalPlannerMode) {
    /**
     * @generated from enum value: CONVERSATIONAL_PLANNER_MODE_UNSPECIFIED = 0;
     */
    ConversationalPlannerMode[ConversationalPlannerMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * aka Write Mode.
     *
     * @generated from enum value: CONVERSATIONAL_PLANNER_MODE_DEFAULT = 1;
     */
    ConversationalPlannerMode[ConversationalPlannerMode["DEFAULT"] = 1] = "DEFAULT";
    /**
     * @generated from enum value: CONVERSATIONAL_PLANNER_MODE_READ_ONLY = 2;
     */
    ConversationalPlannerMode[ConversationalPlannerMode["READ_ONLY"] = 2] = "READ_ONLY";
    /**
     * @generated from enum value: CONVERSATIONAL_PLANNER_MODE_NO_TOOL = 3;
     */
    ConversationalPlannerMode[ConversationalPlannerMode["NO_TOOL"] = 3] = "NO_TOOL";
})(ConversationalPlannerMode || (ConversationalPlannerMode = {}));
// Retrieve enum metadata with: proto3.getEnumType(ConversationalPlannerMode)
proto3.util.setEnumType(ConversationalPlannerMode, "exa.codeium_common_pb.ConversationalPlannerMode", [
    { no: 0, name: "CONVERSATIONAL_PLANNER_MODE_UNSPECIFIED" },
    { no: 1, name: "CONVERSATIONAL_PLANNER_MODE_DEFAULT" },
    { no: 2, name: "CONVERSATIONAL_PLANNER_MODE_READ_ONLY" },
    { no: 3, name: "CONVERSATIONAL_PLANNER_MODE_NO_TOOL" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TabToJump
 */
export var TabToJump;
(function (TabToJump) {
    /**
     * @generated from enum value: TAB_TO_JUMP_UNSPECIFIED = 0;
     */
    TabToJump[TabToJump["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TAB_TO_JUMP_ENABLED = 1;
     */
    TabToJump[TabToJump["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: TAB_TO_JUMP_DISABLED = 2;
     */
    TabToJump[TabToJump["DISABLED"] = 2] = "DISABLED";
})(TabToJump || (TabToJump = {}));
// Retrieve enum metadata with: proto3.getEnumType(TabToJump)
proto3.util.setEnumType(TabToJump, "exa.codeium_common_pb.TabToJump", [
    { no: 0, name: "TAB_TO_JUMP_UNSPECIFIED" },
    { no: 1, name: "TAB_TO_JUMP_ENABLED" },
    { no: 2, name: "TAB_TO_JUMP_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CascadeWebSearchTool
 */
export var CascadeWebSearchTool;
(function (CascadeWebSearchTool) {
    /**
     * @generated from enum value: CASCADE_WEB_SEARCH_TOOL_UNSPECIFIED = 0;
     */
    CascadeWebSearchTool[CascadeWebSearchTool["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_WEB_SEARCH_TOOL_ENABLED = 1;
     */
    CascadeWebSearchTool[CascadeWebSearchTool["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: CASCADE_WEB_SEARCH_TOOL_DISABLED = 2;
     */
    CascadeWebSearchTool[CascadeWebSearchTool["DISABLED"] = 2] = "DISABLED";
})(CascadeWebSearchTool || (CascadeWebSearchTool = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeWebSearchTool)
proto3.util.setEnumType(CascadeWebSearchTool, "exa.codeium_common_pb.CascadeWebSearchTool", [
    { no: 0, name: "CASCADE_WEB_SEARCH_TOOL_UNSPECIFIED" },
    { no: 1, name: "CASCADE_WEB_SEARCH_TOOL_ENABLED" },
    { no: 2, name: "CASCADE_WEB_SEARCH_TOOL_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CascadeRunExtensionCode
 */
export var CascadeRunExtensionCode;
(function (CascadeRunExtensionCode) {
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_UNSPECIFIED = 0;
     */
    CascadeRunExtensionCode[CascadeRunExtensionCode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_ENABLED = 1;
     */
    CascadeRunExtensionCode[CascadeRunExtensionCode["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_DISABLED = 2;
     */
    CascadeRunExtensionCode[CascadeRunExtensionCode["DISABLED"] = 2] = "DISABLED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_ONLY = 3;
     */
    CascadeRunExtensionCode[CascadeRunExtensionCode["ONLY"] = 3] = "ONLY";
})(CascadeRunExtensionCode || (CascadeRunExtensionCode = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeRunExtensionCode)
proto3.util.setEnumType(CascadeRunExtensionCode, "exa.codeium_common_pb.CascadeRunExtensionCode", [
    { no: 0, name: "CASCADE_RUN_EXTENSION_CODE_UNSPECIFIED" },
    { no: 1, name: "CASCADE_RUN_EXTENSION_CODE_ENABLED" },
    { no: 2, name: "CASCADE_RUN_EXTENSION_CODE_DISABLED" },
    { no: 3, name: "CASCADE_RUN_EXTENSION_CODE_ONLY" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CascadeInputAutocomplete
 */
export var CascadeInputAutocomplete;
(function (CascadeInputAutocomplete) {
    /**
     * @generated from enum value: CASCADE_INPUT_AUTOCOMPLETE_UNSPECIFIED = 0;
     */
    CascadeInputAutocomplete[CascadeInputAutocomplete["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_INPUT_AUTOCOMPLETE_ENABLED = 1;
     */
    CascadeInputAutocomplete[CascadeInputAutocomplete["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: CASCADE_INPUT_AUTOCOMPLETE_DISABLED = 2;
     */
    CascadeInputAutocomplete[CascadeInputAutocomplete["DISABLED"] = 2] = "DISABLED";
})(CascadeInputAutocomplete || (CascadeInputAutocomplete = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeInputAutocomplete)
proto3.util.setEnumType(CascadeInputAutocomplete, "exa.codeium_common_pb.CascadeInputAutocomplete", [
    { no: 0, name: "CASCADE_INPUT_AUTOCOMPLETE_UNSPECIFIED" },
    { no: 1, name: "CASCADE_INPUT_AUTOCOMPLETE_ENABLED" },
    { no: 2, name: "CASCADE_INPUT_AUTOCOMPLETE_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CascadeRunExtensionCodeAutoRun
 */
export var CascadeRunExtensionCodeAutoRun;
(function (CascadeRunExtensionCodeAutoRun) {
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_UNSPECIFIED = 0;
     */
    CascadeRunExtensionCodeAutoRun[CascadeRunExtensionCodeAutoRun["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_ENABLED = 1;
     */
    CascadeRunExtensionCodeAutoRun[CascadeRunExtensionCodeAutoRun["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_DISABLED = 2;
     */
    CascadeRunExtensionCodeAutoRun[CascadeRunExtensionCodeAutoRun["DISABLED"] = 2] = "DISABLED";
    /**
     * @generated from enum value: CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_MODEL_DECIDES = 3;
     */
    CascadeRunExtensionCodeAutoRun[CascadeRunExtensionCodeAutoRun["MODEL_DECIDES"] = 3] = "MODEL_DECIDES";
})(CascadeRunExtensionCodeAutoRun || (CascadeRunExtensionCodeAutoRun = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeRunExtensionCodeAutoRun)
proto3.util.setEnumType(CascadeRunExtensionCodeAutoRun, "exa.codeium_common_pb.CascadeRunExtensionCodeAutoRun", [
    { no: 0, name: "CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_UNSPECIFIED" },
    { no: 1, name: "CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_ENABLED" },
    { no: 2, name: "CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_DISABLED" },
    { no: 3, name: "CASCADE_RUN_EXTENSION_CODE_AUTO_RUN_MODEL_DECIDES" },
]);
/**
 * @generated from enum exa.codeium_common_pb.FeatureUsageType
 */
export var FeatureUsageType;
(function (FeatureUsageType) {
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_UNSPECIFIED = 0;
     */
    FeatureUsageType[FeatureUsageType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_CASCADE_BROWSER = 1;
     */
    FeatureUsageType[FeatureUsageType["CASCADE_BROWSER"] = 1] = "CASCADE_BROWSER";
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_CASCADE_WEB_AT_MENTION = 2;
     */
    FeatureUsageType[FeatureUsageType["CASCADE_WEB_AT_MENTION"] = 2] = "CASCADE_WEB_AT_MENTION";
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_CASCADE_REVERT_TO_STEP = 3;
     */
    FeatureUsageType[FeatureUsageType["CASCADE_REVERT_TO_STEP"] = 3] = "CASCADE_REVERT_TO_STEP";
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_CASCADE_CLICK_MODEL_SELECTOR = 4;
     */
    FeatureUsageType[FeatureUsageType["CASCADE_CLICK_MODEL_SELECTOR"] = 4] = "CASCADE_CLICK_MODEL_SELECTOR";
    /**
     * @generated from enum value: FEATURE_USAGE_TYPE_CASCADE_MESSAGE_FEEDBACK = 5;
     */
    FeatureUsageType[FeatureUsageType["CASCADE_MESSAGE_FEEDBACK"] = 5] = "CASCADE_MESSAGE_FEEDBACK";
})(FeatureUsageType || (FeatureUsageType = {}));
// Retrieve enum metadata with: proto3.getEnumType(FeatureUsageType)
proto3.util.setEnumType(FeatureUsageType, "exa.codeium_common_pb.FeatureUsageType", [
    { no: 0, name: "FEATURE_USAGE_TYPE_UNSPECIFIED" },
    { no: 1, name: "FEATURE_USAGE_TYPE_CASCADE_BROWSER" },
    { no: 2, name: "FEATURE_USAGE_TYPE_CASCADE_WEB_AT_MENTION" },
    { no: 3, name: "FEATURE_USAGE_TYPE_CASCADE_REVERT_TO_STEP" },
    { no: 4, name: "FEATURE_USAGE_TYPE_CASCADE_CLICK_MODEL_SELECTOR" },
    { no: 5, name: "FEATURE_USAGE_TYPE_CASCADE_MESSAGE_FEEDBACK" },
]);
/**
 * Client-side specifier for Cascade's plan mode.
 *
 * @generated from enum exa.codeium_common_pb.PlanMode
 */
export var PlanMode;
(function (PlanMode) {
    /**
     * @generated from enum value: PLAN_MODE_UNSPECIFIED = 0;
     */
    PlanMode[PlanMode["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PLAN_MODE_ON = 1;
     */
    PlanMode[PlanMode["ON"] = 1] = "ON";
    /**
     * @generated from enum value: PLAN_MODE_OFF = 2;
     */
    PlanMode[PlanMode["OFF"] = 2] = "OFF";
})(PlanMode || (PlanMode = {}));
// Retrieve enum metadata with: proto3.getEnumType(PlanMode)
proto3.util.setEnumType(PlanMode, "exa.codeium_common_pb.PlanMode", [
    { no: 0, name: "PLAN_MODE_UNSPECIFIED" },
    { no: 1, name: "PLAN_MODE_ON" },
    { no: 2, name: "PLAN_MODE_OFF" },
]);
/**
 * Setting for whether to have Cascade automatically continue when it hits max invocator generations.
 * Note that costs the user the same as if they had initiated the continue action themselves.
 *
 * @generated from enum exa.codeium_common_pb.AutoContinueOnMaxGeneratorInvocations
 */
export var AutoContinueOnMaxGeneratorInvocations;
(function (AutoContinueOnMaxGeneratorInvocations) {
    /**
     * @generated from enum value: AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_UNSPECIFIED = 0;
     */
    AutoContinueOnMaxGeneratorInvocations[AutoContinueOnMaxGeneratorInvocations["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_ENABLED = 1;
     */
    AutoContinueOnMaxGeneratorInvocations[AutoContinueOnMaxGeneratorInvocations["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_DISABLED = 2;
     */
    AutoContinueOnMaxGeneratorInvocations[AutoContinueOnMaxGeneratorInvocations["DISABLED"] = 2] = "DISABLED";
})(AutoContinueOnMaxGeneratorInvocations || (AutoContinueOnMaxGeneratorInvocations = {}));
// Retrieve enum metadata with: proto3.getEnumType(AutoContinueOnMaxGeneratorInvocations)
proto3.util.setEnumType(AutoContinueOnMaxGeneratorInvocations, "exa.codeium_common_pb.AutoContinueOnMaxGeneratorInvocations", [
    { no: 0, name: "AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_UNSPECIFIED" },
    { no: 1, name: "AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_ENABLED" },
    { no: 2, name: "AUTO_CONTINUE_ON_MAX_GENERATOR_INVOCATIONS_DISABLED" },
]);
/**
 * Controls where a NUX is shown to the user
 *
 * @generated from enum exa.codeium_common_pb.CascadeNUXLocation
 */
export var CascadeNUXLocation;
(function (CascadeNUXLocation) {
    /**
     * NUXes with unspecified locations will not be displayed
     *
     * @generated from enum value: CASCADE_NUX_LOCATION_UNSPECIFIED = 0;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_UNSPECIFIED"] = 0] = "CASCADE_NUX_LOCATION_UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_CASCADE_INPUT = 1;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_CASCADE_INPUT"] = 1] = "CASCADE_NUX_LOCATION_CASCADE_INPUT";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_MODEL_SELECTOR = 2;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_MODEL_SELECTOR"] = 2] = "CASCADE_NUX_LOCATION_MODEL_SELECTOR";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_RULES_TAB = 4;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_RULES_TAB"] = 4] = "CASCADE_NUX_LOCATION_RULES_TAB";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_REVERT_STEP = 6;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_REVERT_STEP"] = 6] = "CASCADE_NUX_LOCATION_REVERT_STEP";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_PLAN_MODE = 7;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_PLAN_MODE"] = 7] = "CASCADE_NUX_LOCATION_PLAN_MODE";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_WRITE_CHAT_MODE = 8;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_WRITE_CHAT_MODE"] = 8] = "CASCADE_NUX_LOCATION_WRITE_CHAT_MODE";
    /**
     * @generated from enum value: CASCADE_NUX_LOCATION_TOOLBAR = 9;
     */
    CascadeNUXLocation[CascadeNUXLocation["CASCADE_NUX_LOCATION_TOOLBAR"] = 9] = "CASCADE_NUX_LOCATION_TOOLBAR";
})(CascadeNUXLocation || (CascadeNUXLocation = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeNUXLocation)
proto3.util.setEnumType(CascadeNUXLocation, "exa.codeium_common_pb.CascadeNUXLocation", [
    { no: 0, name: "CASCADE_NUX_LOCATION_UNSPECIFIED" },
    { no: 1, name: "CASCADE_NUX_LOCATION_CASCADE_INPUT" },
    { no: 2, name: "CASCADE_NUX_LOCATION_MODEL_SELECTOR" },
    { no: 4, name: "CASCADE_NUX_LOCATION_RULES_TAB" },
    { no: 6, name: "CASCADE_NUX_LOCATION_REVERT_STEP" },
    { no: 7, name: "CASCADE_NUX_LOCATION_PLAN_MODE" },
    { no: 8, name: "CASCADE_NUX_LOCATION_WRITE_CHAT_MODE" },
    { no: 9, name: "CASCADE_NUX_LOCATION_TOOLBAR" },
]);
/**
 * Custom icons for NUXes
 *
 * @generated from enum exa.codeium_common_pb.CascadeNUXIcon
 */
export var CascadeNUXIcon;
(function (CascadeNUXIcon) {
    /**
     * Unspecified means no icon.
     *
     * @generated from enum value: CASCADE_NUX_ICON_UNSPECIFIED = 0;
     */
    CascadeNUXIcon[CascadeNUXIcon["CASCADE_NUX_ICON_UNSPECIFIED"] = 0] = "CASCADE_NUX_ICON_UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_NUX_ICON_WEB_SEARCH = 1;
     */
    CascadeNUXIcon[CascadeNUXIcon["CASCADE_NUX_ICON_WEB_SEARCH"] = 1] = "CASCADE_NUX_ICON_WEB_SEARCH";
    /**
     * @generated from enum value: CASCADE_NUX_ICON_WINDSURF_BROWSER = 2;
     */
    CascadeNUXIcon[CascadeNUXIcon["CASCADE_NUX_ICON_WINDSURF_BROWSER"] = 2] = "CASCADE_NUX_ICON_WINDSURF_BROWSER";
})(CascadeNUXIcon || (CascadeNUXIcon = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeNUXIcon)
proto3.util.setEnumType(CascadeNUXIcon, "exa.codeium_common_pb.CascadeNUXIcon", [
    { no: 0, name: "CASCADE_NUX_ICON_UNSPECIFIED" },
    { no: 1, name: "CASCADE_NUX_ICON_WEB_SEARCH" },
    { no: 2, name: "CASCADE_NUX_ICON_WINDSURF_BROWSER" },
]);
/**
 * NUXes sometimes have separate triggers to control when they are shown
 * e.g. revert is only shown when the user has sent a message which produces a diff
 *
 * @generated from enum exa.codeium_common_pb.CascadeNUXTrigger
 */
export var CascadeNUXTrigger;
(function (CascadeNUXTrigger) {
    /**
     * Nuxes with unspecified triggers will not require any trigger to be met.
     *
     * @generated from enum value: CASCADE_NUX_TRIGGER_UNSPECIFIED = 0;
     */
    CascadeNUXTrigger[CascadeNUXTrigger["CASCADE_NUX_TRIGGER_UNSPECIFIED"] = 0] = "CASCADE_NUX_TRIGGER_UNSPECIFIED";
    /**
     * @generated from enum value: CASCADE_NUX_TRIGGER_PRODUCED_CODE_DIFF = 1;
     */
    CascadeNUXTrigger[CascadeNUXTrigger["CASCADE_NUX_TRIGGER_PRODUCED_CODE_DIFF"] = 1] = "CASCADE_NUX_TRIGGER_PRODUCED_CODE_DIFF";
    /**
     * @generated from enum value: CASCADE_NUX_TRIGGER_OPEN_BROWSER_URL = 3;
     */
    CascadeNUXTrigger[CascadeNUXTrigger["CASCADE_NUX_TRIGGER_OPEN_BROWSER_URL"] = 3] = "CASCADE_NUX_TRIGGER_OPEN_BROWSER_URL";
    /**
     * @generated from enum value: CASCADE_NUX_TRIGGER_WEB_SEARCH = 4;
     */
    CascadeNUXTrigger[CascadeNUXTrigger["CASCADE_NUX_TRIGGER_WEB_SEARCH"] = 4] = "CASCADE_NUX_TRIGGER_WEB_SEARCH";
})(CascadeNUXTrigger || (CascadeNUXTrigger = {}));
// Retrieve enum metadata with: proto3.getEnumType(CascadeNUXTrigger)
proto3.util.setEnumType(CascadeNUXTrigger, "exa.codeium_common_pb.CascadeNUXTrigger", [
    { no: 0, name: "CASCADE_NUX_TRIGGER_UNSPECIFIED" },
    { no: 1, name: "CASCADE_NUX_TRIGGER_PRODUCED_CODE_DIFF" },
    { no: 3, name: "CASCADE_NUX_TRIGGER_OPEN_BROWSER_URL" },
    { no: 4, name: "CASCADE_NUX_TRIGGER_WEB_SEARCH" },
]);
/**
 * @generated from enum exa.codeium_common_pb.AnnotationsConfig
 */
export var AnnotationsConfig;
(function (AnnotationsConfig) {
    /**
     * @generated from enum value: ANNOTATIONS_CONFIG_UNSPECIFIED = 0;
     */
    AnnotationsConfig[AnnotationsConfig["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: ANNOTATIONS_CONFIG_ENABLED = 1;
     */
    AnnotationsConfig[AnnotationsConfig["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: ANNOTATIONS_CONFIG_DISABLED = 2;
     */
    AnnotationsConfig[AnnotationsConfig["DISABLED"] = 2] = "DISABLED";
})(AnnotationsConfig || (AnnotationsConfig = {}));
// Retrieve enum metadata with: proto3.getEnumType(AnnotationsConfig)
proto3.util.setEnumType(AnnotationsConfig, "exa.codeium_common_pb.AnnotationsConfig", [
    { no: 0, name: "ANNOTATIONS_CONFIG_UNSPECIFIED" },
    { no: 1, name: "ANNOTATIONS_CONFIG_ENABLED" },
    { no: 2, name: "ANNOTATIONS_CONFIG_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.BrowserExperimentalFeaturesConfig
 */
export var BrowserExperimentalFeaturesConfig;
(function (BrowserExperimentalFeaturesConfig) {
    /**
     * @generated from enum value: BROWSER_EXPERIMENTAL_FEATURES_CONFIG_UNSPECIFIED = 0;
     */
    BrowserExperimentalFeaturesConfig[BrowserExperimentalFeaturesConfig["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: BROWSER_EXPERIMENTAL_FEATURES_CONFIG_ENABLED = 1;
     */
    BrowserExperimentalFeaturesConfig[BrowserExperimentalFeaturesConfig["ENABLED"] = 1] = "ENABLED";
    /**
     * @generated from enum value: BROWSER_EXPERIMENTAL_FEATURES_CONFIG_DISABLED = 2;
     */
    BrowserExperimentalFeaturesConfig[BrowserExperimentalFeaturesConfig["DISABLED"] = 2] = "DISABLED";
})(BrowserExperimentalFeaturesConfig || (BrowserExperimentalFeaturesConfig = {}));
// Retrieve enum metadata with: proto3.getEnumType(BrowserExperimentalFeaturesConfig)
proto3.util.setEnumType(BrowserExperimentalFeaturesConfig, "exa.codeium_common_pb.BrowserExperimentalFeaturesConfig", [
    { no: 0, name: "BROWSER_EXPERIMENTAL_FEATURES_CONFIG_UNSPECIFIED" },
    { no: 1, name: "BROWSER_EXPERIMENTAL_FEATURES_CONFIG_ENABLED" },
    { no: 2, name: "BROWSER_EXPERIMENTAL_FEATURES_CONFIG_DISABLED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ModelType
 */
export var ModelType;
(function (ModelType) {
    /**
     * @generated from enum value: MODEL_TYPE_UNSPECIFIED = 0;
     */
    ModelType[ModelType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Includes command models
     *
     * @generated from enum value: MODEL_TYPE_COMPLETION = 1;
     */
    ModelType[ModelType["COMPLETION"] = 1] = "COMPLETION";
    /**
     * @generated from enum value: MODEL_TYPE_CHAT = 2;
     */
    ModelType[ModelType["CHAT"] = 2] = "CHAT";
    /**
     * @generated from enum value: MODEL_TYPE_EMBED = 3;
     */
    ModelType[ModelType["EMBED"] = 3] = "EMBED";
    /**
     * @generated from enum value: MODEL_TYPE_QUERY = 4;
     */
    ModelType[ModelType["QUERY"] = 4] = "QUERY";
})(ModelType || (ModelType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelType)
proto3.util.setEnumType(ModelType, "exa.codeium_common_pb.ModelType", [
    { no: 0, name: "MODEL_TYPE_UNSPECIFIED" },
    { no: 1, name: "MODEL_TYPE_COMPLETION" },
    { no: 2, name: "MODEL_TYPE_CHAT" },
    { no: 3, name: "MODEL_TYPE_EMBED" },
    { no: 4, name: "MODEL_TYPE_QUERY" },
]);
/**
 * Next ID: 28 (previous: API_PROVIDER_DATABRICKS)
 *
 * @generated from enum exa.codeium_common_pb.APIProvider
 */
export var APIProvider;
(function (APIProvider) {
    /**
     * @generated from enum value: API_PROVIDER_UNSPECIFIED = 0;
     */
    APIProvider[APIProvider["API_PROVIDER_UNSPECIFIED"] = 0] = "API_PROVIDER_UNSPECIFIED";
    /**
     * @generated from enum value: API_PROVIDER_INTERNAL = 1;
     */
    APIProvider[APIProvider["API_PROVIDER_INTERNAL"] = 1] = "API_PROVIDER_INTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_OPENAI = 2;
     */
    APIProvider[APIProvider["API_PROVIDER_OPENAI"] = 2] = "API_PROVIDER_OPENAI";
    /**
     * @generated from enum value: API_PROVIDER_GOOGLE_VERTEX = 3;
     */
    APIProvider[APIProvider["API_PROVIDER_GOOGLE_VERTEX"] = 3] = "API_PROVIDER_GOOGLE_VERTEX";
    /**
     * @generated from enum value: API_PROVIDER_ANTHROPIC = 4;
     */
    APIProvider[APIProvider["API_PROVIDER_ANTHROPIC"] = 4] = "API_PROVIDER_ANTHROPIC";
    /**
     * @generated from enum value: API_PROVIDER_VLLM = 5;
     */
    APIProvider[APIProvider["API_PROVIDER_VLLM"] = 5] = "API_PROVIDER_VLLM";
    /**
     * @generated from enum value: API_PROVIDER_TOGETHER_AI = 6;
     */
    APIProvider[APIProvider["API_PROVIDER_TOGETHER_AI"] = 6] = "API_PROVIDER_TOGETHER_AI";
    /**
     * @generated from enum value: API_PROVIDER_HUGGING_FACE = 7;
     */
    APIProvider[APIProvider["API_PROVIDER_HUGGING_FACE"] = 7] = "API_PROVIDER_HUGGING_FACE";
    /**
     * @generated from enum value: API_PROVIDER_NOMIC = 8;
     */
    APIProvider[APIProvider["API_PROVIDER_NOMIC"] = 8] = "API_PROVIDER_NOMIC";
    /**
     * @generated from enum value: API_PROVIDER_TEI = 9;
     */
    APIProvider[APIProvider["API_PROVIDER_TEI"] = 9] = "API_PROVIDER_TEI";
    /**
     * @generated from enum value: API_PROVIDER_OPENAI_COMPATIBLE_EXTERNAL = 10;
     */
    APIProvider[APIProvider["API_PROVIDER_OPENAI_COMPATIBLE_EXTERNAL"] = 10] = "API_PROVIDER_OPENAI_COMPATIBLE_EXTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_ANTHROPIC_COMPATIBLE_EXTERNAL = 11;
     */
    APIProvider[APIProvider["API_PROVIDER_ANTHROPIC_COMPATIBLE_EXTERNAL"] = 11] = "API_PROVIDER_ANTHROPIC_COMPATIBLE_EXTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_VERTEX_COMPATIBLE_EXTERNAL = 12;
     */
    APIProvider[APIProvider["API_PROVIDER_VERTEX_COMPATIBLE_EXTERNAL"] = 12] = "API_PROVIDER_VERTEX_COMPATIBLE_EXTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_BEDROCK_COMPATIBLE_EXTERNAL = 13;
     */
    APIProvider[APIProvider["API_PROVIDER_BEDROCK_COMPATIBLE_EXTERNAL"] = 13] = "API_PROVIDER_BEDROCK_COMPATIBLE_EXTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_AZURE_COMPATIBLE_EXTERNAL = 14;
     */
    APIProvider[APIProvider["API_PROVIDER_AZURE_COMPATIBLE_EXTERNAL"] = 14] = "API_PROVIDER_AZURE_COMPATIBLE_EXTERNAL";
    /**
     * @generated from enum value: API_PROVIDER_ANTHROPIC_BEDROCK = 15;
     */
    APIProvider[APIProvider["API_PROVIDER_ANTHROPIC_BEDROCK"] = 15] = "API_PROVIDER_ANTHROPIC_BEDROCK";
    /**
     * @generated from enum value: API_PROVIDER_FIREWORKS = 16;
     */
    APIProvider[APIProvider["API_PROVIDER_FIREWORKS"] = 16] = "API_PROVIDER_FIREWORKS";
    /**
     * @generated from enum value: API_PROVIDER_OPEN_ROUTER = 17;
     */
    APIProvider[APIProvider["API_PROVIDER_OPEN_ROUTER"] = 17] = "API_PROVIDER_OPEN_ROUTER";
    /**
     * @generated from enum value: API_PROVIDER_XAI = 18;
     */
    APIProvider[APIProvider["API_PROVIDER_XAI"] = 18] = "API_PROVIDER_XAI";
    /**
     * @generated from enum value: API_PROVIDER_ANTHROPIC_BYOK = 20;
     */
    APIProvider[APIProvider["API_PROVIDER_ANTHROPIC_BYOK"] = 20] = "API_PROVIDER_ANTHROPIC_BYOK";
    /**
     * @generated from enum value: API_PROVIDER_CEREBRAS = 21;
     */
    APIProvider[APIProvider["API_PROVIDER_CEREBRAS"] = 21] = "API_PROVIDER_CEREBRAS";
    /**
     * @generated from enum value: API_PROVIDER_XAI_BYOK = 22;
     */
    APIProvider[APIProvider["API_PROVIDER_XAI_BYOK"] = 22] = "API_PROVIDER_XAI_BYOK";
    /**
     * @generated from enum value: API_PROVIDER_GEMINI_OPENAI = 23;
     */
    APIProvider[APIProvider["API_PROVIDER_GEMINI_OPENAI"] = 23] = "API_PROVIDER_GEMINI_OPENAI";
    /**
     * @generated from enum value: API_PROVIDER_GOOGLE_GEMINI = 24;
     */
    APIProvider[APIProvider["API_PROVIDER_GOOGLE_GEMINI"] = 24] = "API_PROVIDER_GOOGLE_GEMINI";
    /**
     * temporarily used to migrate vertex users to the genai sdk client
     *
     * @generated from enum value: API_PROVIDER_GOOGLE_GENAI_VERTEX = 25;
     */
    APIProvider[APIProvider["API_PROVIDER_GOOGLE_GENAI_VERTEX"] = 25] = "API_PROVIDER_GOOGLE_GENAI_VERTEX";
    /**
     * @generated from enum value: API_PROVIDER_ANTHROPIC_VERTEX = 26;
     */
    APIProvider[APIProvider["API_PROVIDER_ANTHROPIC_VERTEX"] = 26] = "API_PROVIDER_ANTHROPIC_VERTEX";
    /**
     * @generated from enum value: API_PROVIDER_DATABRICKS = 27;
     */
    APIProvider[APIProvider["API_PROVIDER_DATABRICKS"] = 27] = "API_PROVIDER_DATABRICKS";
    /**
     * @generated from enum value: API_PROVIDER_OPEN_ROUTER_BYOK = 28;
     */
    APIProvider[APIProvider["API_PROVIDER_OPEN_ROUTER_BYOK"] = 28] = "API_PROVIDER_OPEN_ROUTER_BYOK";
})(APIProvider || (APIProvider = {}));
// Retrieve enum metadata with: proto3.getEnumType(APIProvider)
proto3.util.setEnumType(APIProvider, "exa.codeium_common_pb.APIProvider", [
    { no: 0, name: "API_PROVIDER_UNSPECIFIED" },
    { no: 1, name: "API_PROVIDER_INTERNAL" },
    { no: 2, name: "API_PROVIDER_OPENAI" },
    { no: 3, name: "API_PROVIDER_GOOGLE_VERTEX" },
    { no: 4, name: "API_PROVIDER_ANTHROPIC" },
    { no: 5, name: "API_PROVIDER_VLLM" },
    { no: 6, name: "API_PROVIDER_TOGETHER_AI" },
    { no: 7, name: "API_PROVIDER_HUGGING_FACE" },
    { no: 8, name: "API_PROVIDER_NOMIC" },
    { no: 9, name: "API_PROVIDER_TEI" },
    { no: 10, name: "API_PROVIDER_OPENAI_COMPATIBLE_EXTERNAL" },
    { no: 11, name: "API_PROVIDER_ANTHROPIC_COMPATIBLE_EXTERNAL" },
    { no: 12, name: "API_PROVIDER_VERTEX_COMPATIBLE_EXTERNAL" },
    { no: 13, name: "API_PROVIDER_BEDROCK_COMPATIBLE_EXTERNAL" },
    { no: 14, name: "API_PROVIDER_AZURE_COMPATIBLE_EXTERNAL" },
    { no: 15, name: "API_PROVIDER_ANTHROPIC_BEDROCK" },
    { no: 16, name: "API_PROVIDER_FIREWORKS" },
    { no: 17, name: "API_PROVIDER_OPEN_ROUTER" },
    { no: 18, name: "API_PROVIDER_XAI" },
    { no: 20, name: "API_PROVIDER_ANTHROPIC_BYOK" },
    { no: 21, name: "API_PROVIDER_CEREBRAS" },
    { no: 22, name: "API_PROVIDER_XAI_BYOK" },
    { no: 23, name: "API_PROVIDER_GEMINI_OPENAI" },
    { no: 24, name: "API_PROVIDER_GOOGLE_GEMINI" },
    { no: 25, name: "API_PROVIDER_GOOGLE_GENAI_VERTEX" },
    { no: 26, name: "API_PROVIDER_ANTHROPIC_VERTEX" },
    { no: 27, name: "API_PROVIDER_DATABRICKS" },
    { no: 28, name: "API_PROVIDER_OPEN_ROUTER_BYOK" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ModelStatus
 */
export var ModelStatus;
(function (ModelStatus) {
    /**
     * @generated from enum value: MODEL_STATUS_UNSPECIFIED = 0;
     */
    ModelStatus[ModelStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MODEL_STATUS_INFO = 1;
     */
    ModelStatus[ModelStatus["INFO"] = 1] = "INFO";
    /**
     * @generated from enum value: MODEL_STATUS_WARNING = 2;
     */
    ModelStatus[ModelStatus["WARNING"] = 2] = "WARNING";
})(ModelStatus || (ModelStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(ModelStatus)
proto3.util.setEnumType(ModelStatus, "exa.codeium_common_pb.ModelStatus", [
    { no: 0, name: "MODEL_STATUS_UNSPECIFIED" },
    { no: 1, name: "MODEL_STATUS_INFO" },
    { no: 2, name: "MODEL_STATUS_WARNING" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CodeSource
 */
export var CodeSource;
(function (CodeSource) {
    /**
     * @generated from enum value: CODE_SOURCE_UNSPECIFIED = 0;
     */
    CodeSource[CodeSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Code that is not generated by either the user or Codeium. Generaly used to represent the
     * code existing before a session starts (may be reset to base if state changes greatly).
     *
     * @generated from enum value: CODE_SOURCE_BASE = 1;
     */
    CodeSource[CodeSource["BASE"] = 1] = "BASE";
    /**
     * Code generated by Codeium.
     *
     * @generated from enum value: CODE_SOURCE_CODEIUM = 2;
     */
    CodeSource[CodeSource["CODEIUM"] = 2] = "CODEIUM";
    /**
     * Code generated by the user. Intended to reflect code typed by the user as opposed to larger
     * code changes like copy-paste or find-replace.
     *
     * @generated from enum value: CODE_SOURCE_USER = 3;
     */
    CodeSource[CodeSource["USER"] = 3] = "USER";
    /**
     * Code generated by the user in large (non-typed) code changes like copy-paste or find-replace.
     *
     * @generated from enum value: CODE_SOURCE_USER_LARGE = 4;
     */
    CodeSource[CodeSource["USER_LARGE"] = 4] = "USER_LARGE";
    /**
     * Code generated by an unknown source.
     *
     * @generated from enum value: CODE_SOURCE_UNKNOWN = 5;
     */
    CodeSource[CodeSource["UNKNOWN"] = 5] = "UNKNOWN";
})(CodeSource || (CodeSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(CodeSource)
proto3.util.setEnumType(CodeSource, "exa.codeium_common_pb.CodeSource", [
    { no: 0, name: "CODE_SOURCE_UNSPECIFIED" },
    { no: 1, name: "CODE_SOURCE_BASE" },
    { no: 2, name: "CODE_SOURCE_CODEIUM" },
    { no: 3, name: "CODE_SOURCE_USER" },
    { no: 4, name: "CODE_SOURCE_USER_LARGE" },
    { no: 5, name: "CODE_SOURCE_UNKNOWN" },
]);
/**
 * Next ID: 10
 *
 * @generated from enum exa.codeium_common_pb.DocumentType
 */
export var DocumentType;
(function (DocumentType) {
    /**
     * @generated from enum value: DOCUMENT_TYPE_UNSPECIFIED = 0;
     */
    DocumentType[DocumentType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Slack
     *
     * @generated from enum value: DOCUMENT_TYPE_SLACK_MESSAGE = 1;
     */
    DocumentType[DocumentType["SLACK_MESSAGE"] = 1] = "SLACK_MESSAGE";
    /**
     * @generated from enum value: DOCUMENT_TYPE_SLACK_CHANNEL = 2;
     */
    DocumentType[DocumentType["SLACK_CHANNEL"] = 2] = "SLACK_CHANNEL";
    /**
     * Github
     *
     * @generated from enum value: DOCUMENT_TYPE_GITHUB_ISSUE = 3;
     */
    DocumentType[DocumentType["GITHUB_ISSUE"] = 3] = "GITHUB_ISSUE";
    /**
     * @generated from enum value: DOCUMENT_TYPE_GITHUB_ISSUE_COMMENT = 4;
     */
    DocumentType[DocumentType["GITHUB_ISSUE_COMMENT"] = 4] = "GITHUB_ISSUE_COMMENT";
    /**
     * @generated from enum value: DOCUMENT_TYPE_GITHUB_REPO = 8;
     */
    DocumentType[DocumentType["GITHUB_REPO"] = 8] = "GITHUB_REPO";
    /**
     * Google Drive
     *
     * @generated from enum value: DOCUMENT_TYPE_GOOGLE_DRIVE_FILE = 5;
     */
    DocumentType[DocumentType["GOOGLE_DRIVE_FILE"] = 5] = "GOOGLE_DRIVE_FILE";
    /**
     * @generated from enum value: DOCUMENT_TYPE_GOOGLE_DRIVE_FOLDER = 6;
     */
    DocumentType[DocumentType["GOOGLE_DRIVE_FOLDER"] = 6] = "GOOGLE_DRIVE_FOLDER";
    /**
     * Jira
     *
     * @generated from enum value: DOCUMENT_TYPE_JIRA_ISSUE = 7;
     */
    DocumentType[DocumentType["JIRA_ISSUE"] = 7] = "JIRA_ISSUE";
    /**
     * CCIs
     *
     * @generated from enum value: DOCUMENT_TYPE_CCI = 9;
     */
    DocumentType[DocumentType["CCI"] = 9] = "CCI";
})(DocumentType || (DocumentType = {}));
// Retrieve enum metadata with: proto3.getEnumType(DocumentType)
proto3.util.setEnumType(DocumentType, "exa.codeium_common_pb.DocumentType", [
    { no: 0, name: "DOCUMENT_TYPE_UNSPECIFIED" },
    { no: 1, name: "DOCUMENT_TYPE_SLACK_MESSAGE" },
    { no: 2, name: "DOCUMENT_TYPE_SLACK_CHANNEL" },
    { no: 3, name: "DOCUMENT_TYPE_GITHUB_ISSUE" },
    { no: 4, name: "DOCUMENT_TYPE_GITHUB_ISSUE_COMMENT" },
    { no: 8, name: "DOCUMENT_TYPE_GITHUB_REPO" },
    { no: 5, name: "DOCUMENT_TYPE_GOOGLE_DRIVE_FILE" },
    { no: 6, name: "DOCUMENT_TYPE_GOOGLE_DRIVE_FOLDER" },
    { no: 7, name: "DOCUMENT_TYPE_JIRA_ISSUE" },
    { no: 9, name: "DOCUMENT_TYPE_CCI" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ContextScopeType
 */
export var ContextScopeType;
(function (ContextScopeType) {
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_UNSPECIFIED = 0;
     */
    ContextScopeType[ContextScopeType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_FILE = 1;
     */
    ContextScopeType[ContextScopeType["FILE"] = 1] = "FILE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_DIRECTORY = 2;
     */
    ContextScopeType[ContextScopeType["DIRECTORY"] = 2] = "DIRECTORY";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_REPOSITORY = 3;
     */
    ContextScopeType[ContextScopeType["REPOSITORY"] = 3] = "REPOSITORY";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_CODE_CONTEXT = 4;
     */
    ContextScopeType[ContextScopeType["CODE_CONTEXT"] = 4] = "CODE_CONTEXT";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_CCI_WITH_SUBRANGE = 5;
     */
    ContextScopeType[ContextScopeType["CCI_WITH_SUBRANGE"] = 5] = "CCI_WITH_SUBRANGE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_REPOSITORY_PATH = 6;
     */
    ContextScopeType[ContextScopeType["REPOSITORY_PATH"] = 6] = "REPOSITORY_PATH";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_SLACK = 7;
     */
    ContextScopeType[ContextScopeType["SLACK"] = 7] = "SLACK";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_GITHUB = 8;
     */
    ContextScopeType[ContextScopeType["GITHUB"] = 8] = "GITHUB";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_FILE_LINE_RANGE = 9;
     */
    ContextScopeType[ContextScopeType["FILE_LINE_RANGE"] = 9] = "FILE_LINE_RANGE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_TEXT_BLOCK = 10;
     */
    ContextScopeType[ContextScopeType["TEXT_BLOCK"] = 10] = "TEXT_BLOCK";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_JIRA = 11;
     */
    ContextScopeType[ContextScopeType["JIRA"] = 11] = "JIRA";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_GOOGLE_DRIVE = 12;
     */
    ContextScopeType[ContextScopeType["GOOGLE_DRIVE"] = 12] = "GOOGLE_DRIVE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_CONSOLE_LOG = 13;
     */
    ContextScopeType[ContextScopeType["CONSOLE_LOG"] = 13] = "CONSOLE_LOG";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_DOM_ELEMENT = 14;
     */
    ContextScopeType[ContextScopeType["DOM_ELEMENT"] = 14] = "DOM_ELEMENT";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_RECIPE = 15;
     */
    ContextScopeType[ContextScopeType["RECIPE"] = 15] = "RECIPE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_KNOWLEDGE = 16;
     */
    ContextScopeType[ContextScopeType["KNOWLEDGE"] = 16] = "KNOWLEDGE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_RULE = 17;
     */
    ContextScopeType[ContextScopeType["RULE"] = 17] = "RULE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_MCP_RESOURCE = 18;
     */
    ContextScopeType[ContextScopeType["MCP_RESOURCE"] = 18] = "MCP_RESOURCE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_BROWSER_PAGE = 19;
     */
    ContextScopeType[ContextScopeType["BROWSER_PAGE"] = 19] = "BROWSER_PAGE";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_BROWSER_CODE_BLOCK = 20;
     */
    ContextScopeType[ContextScopeType["BROWSER_CODE_BLOCK"] = 20] = "BROWSER_CODE_BLOCK";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_BROWSER_TEXT = 21;
     */
    ContextScopeType[ContextScopeType["BROWSER_TEXT"] = 21] = "BROWSER_TEXT";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_CONVERSATION = 22;
     */
    ContextScopeType[ContextScopeType["CONVERSATION"] = 22] = "CONVERSATION";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_USER_ACTIVITY = 23;
     */
    ContextScopeType[ContextScopeType["USER_ACTIVITY"] = 23] = "USER_ACTIVITY";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_TERMINAL = 24;
     */
    ContextScopeType[ContextScopeType["TERMINAL"] = 24] = "TERMINAL";
    /**
     * @generated from enum value: CONTEXT_SCOPE_TYPE_GITHUB_PULL_REQUEST = 25;
     */
    ContextScopeType[ContextScopeType["GITHUB_PULL_REQUEST"] = 25] = "GITHUB_PULL_REQUEST";
})(ContextScopeType || (ContextScopeType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ContextScopeType)
proto3.util.setEnumType(ContextScopeType, "exa.codeium_common_pb.ContextScopeType", [
    { no: 0, name: "CONTEXT_SCOPE_TYPE_UNSPECIFIED" },
    { no: 1, name: "CONTEXT_SCOPE_TYPE_FILE" },
    { no: 2, name: "CONTEXT_SCOPE_TYPE_DIRECTORY" },
    { no: 3, name: "CONTEXT_SCOPE_TYPE_REPOSITORY" },
    { no: 4, name: "CONTEXT_SCOPE_TYPE_CODE_CONTEXT" },
    { no: 5, name: "CONTEXT_SCOPE_TYPE_CCI_WITH_SUBRANGE" },
    { no: 6, name: "CONTEXT_SCOPE_TYPE_REPOSITORY_PATH" },
    { no: 7, name: "CONTEXT_SCOPE_TYPE_SLACK" },
    { no: 8, name: "CONTEXT_SCOPE_TYPE_GITHUB" },
    { no: 9, name: "CONTEXT_SCOPE_TYPE_FILE_LINE_RANGE" },
    { no: 10, name: "CONTEXT_SCOPE_TYPE_TEXT_BLOCK" },
    { no: 11, name: "CONTEXT_SCOPE_TYPE_JIRA" },
    { no: 12, name: "CONTEXT_SCOPE_TYPE_GOOGLE_DRIVE" },
    { no: 13, name: "CONTEXT_SCOPE_TYPE_CONSOLE_LOG" },
    { no: 14, name: "CONTEXT_SCOPE_TYPE_DOM_ELEMENT" },
    { no: 15, name: "CONTEXT_SCOPE_TYPE_RECIPE" },
    { no: 16, name: "CONTEXT_SCOPE_TYPE_KNOWLEDGE" },
    { no: 17, name: "CONTEXT_SCOPE_TYPE_RULE" },
    { no: 18, name: "CONTEXT_SCOPE_TYPE_MCP_RESOURCE" },
    { no: 19, name: "CONTEXT_SCOPE_TYPE_BROWSER_PAGE" },
    { no: 20, name: "CONTEXT_SCOPE_TYPE_BROWSER_CODE_BLOCK" },
    { no: 21, name: "CONTEXT_SCOPE_TYPE_BROWSER_TEXT" },
    { no: 22, name: "CONTEXT_SCOPE_TYPE_CONVERSATION" },
    { no: 23, name: "CONTEXT_SCOPE_TYPE_USER_ACTIVITY" },
    { no: 24, name: "CONTEXT_SCOPE_TYPE_TERMINAL" },
    { no: 25, name: "CONTEXT_SCOPE_TYPE_GITHUB_PULL_REQUEST" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CommandRequestSource
 */
export var CommandRequestSource;
(function (CommandRequestSource) {
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_UNSPECIFIED = 0;
     */
    CommandRequestSource[CommandRequestSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_DEFAULT = 1;
     */
    CommandRequestSource[CommandRequestSource["DEFAULT"] = 1] = "DEFAULT";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_FUNCTION_CODE_LENS = 2;
     */
    CommandRequestSource[CommandRequestSource["FUNCTION_CODE_LENS"] = 2] = "FUNCTION_CODE_LENS";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_CLASS_CODE_LENS = 3;
     */
    CommandRequestSource[CommandRequestSource["CLASS_CODE_LENS"] = 3] = "CLASS_CODE_LENS";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_RIGHT_CLICK_REFACTOR = 4;
     */
    CommandRequestSource[CommandRequestSource["RIGHT_CLICK_REFACTOR"] = 4] = "RIGHT_CLICK_REFACTOR";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_SELECTION_HINT_CODE_LENS = 5;
     */
    CommandRequestSource[CommandRequestSource["SELECTION_HINT_CODE_LENS"] = 5] = "SELECTION_HINT_CODE_LENS";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_LINE_HINT_CODE_LENS = 6;
     */
    CommandRequestSource[CommandRequestSource["LINE_HINT_CODE_LENS"] = 6] = "LINE_HINT_CODE_LENS";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_PLAN = 7;
     */
    CommandRequestSource[CommandRequestSource["PLAN"] = 7] = "PLAN";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_FOLLOWUP = 8;
     */
    CommandRequestSource[CommandRequestSource["FOLLOWUP"] = 8] = "FOLLOWUP";
    /**
     * For requests of this type, the client's command instruction prompt should
     * simply be the text to be translated.
     *
     * @generated from enum value: COMMAND_REQUEST_SOURCE_PASTE_AND_TRANSLATE = 9;
     */
    CommandRequestSource[CommandRequestSource["PASTE_AND_TRANSLATE"] = 9] = "PASTE_AND_TRANSLATE";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_SUPERCOMPLETE = 10;
     */
    CommandRequestSource[CommandRequestSource["SUPERCOMPLETE"] = 10] = "SUPERCOMPLETE";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_FUNCTION_DOCSTRING = 11;
     */
    CommandRequestSource[CommandRequestSource["FUNCTION_DOCSTRING"] = 11] = "FUNCTION_DOCSTRING";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_FAST_APPLY = 12;
     */
    CommandRequestSource[CommandRequestSource["FAST_APPLY"] = 12] = "FAST_APPLY";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_TERMINAL = 13;
     */
    CommandRequestSource[CommandRequestSource["TERMINAL"] = 13] = "TERMINAL";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_TAB_JUMP = 14;
     */
    CommandRequestSource[CommandRequestSource["TAB_JUMP"] = 14] = "TAB_JUMP";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_TERMINAL_SUGGESTIONS = 15;
     */
    CommandRequestSource[CommandRequestSource["TERMINAL_SUGGESTIONS"] = 15] = "TERMINAL_SUGGESTIONS";
    /**
     * @generated from enum value: COMMAND_REQUEST_SOURCE_CASCADE_CHAT = 16;
     */
    CommandRequestSource[CommandRequestSource["CASCADE_CHAT"] = 16] = "CASCADE_CHAT";
})(CommandRequestSource || (CommandRequestSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(CommandRequestSource)
proto3.util.setEnumType(CommandRequestSource, "exa.codeium_common_pb.CommandRequestSource", [
    { no: 0, name: "COMMAND_REQUEST_SOURCE_UNSPECIFIED" },
    { no: 1, name: "COMMAND_REQUEST_SOURCE_DEFAULT" },
    { no: 2, name: "COMMAND_REQUEST_SOURCE_FUNCTION_CODE_LENS" },
    { no: 3, name: "COMMAND_REQUEST_SOURCE_CLASS_CODE_LENS" },
    { no: 4, name: "COMMAND_REQUEST_SOURCE_RIGHT_CLICK_REFACTOR" },
    { no: 5, name: "COMMAND_REQUEST_SOURCE_SELECTION_HINT_CODE_LENS" },
    { no: 6, name: "COMMAND_REQUEST_SOURCE_LINE_HINT_CODE_LENS" },
    { no: 7, name: "COMMAND_REQUEST_SOURCE_PLAN" },
    { no: 8, name: "COMMAND_REQUEST_SOURCE_FOLLOWUP" },
    { no: 9, name: "COMMAND_REQUEST_SOURCE_PASTE_AND_TRANSLATE" },
    { no: 10, name: "COMMAND_REQUEST_SOURCE_SUPERCOMPLETE" },
    { no: 11, name: "COMMAND_REQUEST_SOURCE_FUNCTION_DOCSTRING" },
    { no: 12, name: "COMMAND_REQUEST_SOURCE_FAST_APPLY" },
    { no: 13, name: "COMMAND_REQUEST_SOURCE_TERMINAL" },
    { no: 14, name: "COMMAND_REQUEST_SOURCE_TAB_JUMP" },
    { no: 15, name: "COMMAND_REQUEST_SOURCE_TERMINAL_SUGGESTIONS" },
    { no: 16, name: "COMMAND_REQUEST_SOURCE_CASCADE_CHAT" },
]);
/**
 * @generated from enum exa.codeium_common_pb.StatusLevel
 */
export var StatusLevel;
(function (StatusLevel) {
    /**
     * @generated from enum value: STATUS_LEVEL_UNSPECIFIED = 0;
     */
    StatusLevel[StatusLevel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: STATUS_LEVEL_ERROR = 1;
     */
    StatusLevel[StatusLevel["ERROR"] = 1] = "ERROR";
    /**
     * @generated from enum value: STATUS_LEVEL_WARNING = 2;
     */
    StatusLevel[StatusLevel["WARNING"] = 2] = "WARNING";
    /**
     * @generated from enum value: STATUS_LEVEL_INFO = 3;
     */
    StatusLevel[StatusLevel["INFO"] = 3] = "INFO";
    /**
     * @generated from enum value: STATUS_LEVEL_DEBUG = 4;
     */
    StatusLevel[StatusLevel["DEBUG"] = 4] = "DEBUG";
})(StatusLevel || (StatusLevel = {}));
// Retrieve enum metadata with: proto3.getEnumType(StatusLevel)
proto3.util.setEnumType(StatusLevel, "exa.codeium_common_pb.StatusLevel", [
    { no: 0, name: "STATUS_LEVEL_UNSPECIFIED" },
    { no: 1, name: "STATUS_LEVEL_ERROR" },
    { no: 2, name: "STATUS_LEVEL_WARNING" },
    { no: 3, name: "STATUS_LEVEL_INFO" },
    { no: 4, name: "STATUS_LEVEL_DEBUG" },
]);
/**
 * @generated from enum exa.codeium_common_pb.CortexErrorCategory
 */
export var CortexErrorCategory;
(function (CortexErrorCategory) {
    /**
     * @generated from enum value: CORTEX_ERROR_CATEGORY_UNSPECIFIED = 0;
     */
    CortexErrorCategory[CortexErrorCategory["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: CORTEX_ERROR_CATEGORY_OVERALL = 1;
     */
    CortexErrorCategory[CortexErrorCategory["OVERALL"] = 1] = "OVERALL";
    /**
     * @generated from enum value: CORTEX_ERROR_CATEGORY_ACTION_PREPARE = 2;
     */
    CortexErrorCategory[CortexErrorCategory["ACTION_PREPARE"] = 2] = "ACTION_PREPARE";
    /**
     * @generated from enum value: CORTEX_ERROR_CATEGORY_ACTION_APPLY = 3;
     */
    CortexErrorCategory[CortexErrorCategory["ACTION_APPLY"] = 3] = "ACTION_APPLY";
})(CortexErrorCategory || (CortexErrorCategory = {}));
// Retrieve enum metadata with: proto3.getEnumType(CortexErrorCategory)
proto3.util.setEnumType(CortexErrorCategory, "exa.codeium_common_pb.CortexErrorCategory", [
    { no: 0, name: "CORTEX_ERROR_CATEGORY_UNSPECIFIED" },
    { no: 1, name: "CORTEX_ERROR_CATEGORY_OVERALL" },
    { no: 2, name: "CORTEX_ERROR_CATEGORY_ACTION_PREPARE" },
    { no: 3, name: "CORTEX_ERROR_CATEGORY_ACTION_APPLY" },
]);
/**
 * @generated from enum exa.codeium_common_pb.LastUpdateType
 */
export var LastUpdateType;
(function (LastUpdateType) {
    /**
     * @generated from enum value: LAST_UPDATE_TYPE_UNSPECIFIED = 0;
     */
    LastUpdateType[LastUpdateType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: LAST_UPDATE_TYPE_OVERALL = 1;
     */
    LastUpdateType[LastUpdateType["OVERALL"] = 1] = "OVERALL";
    /**
     * @generated from enum value: LAST_UPDATE_TYPE_LAST_AUTOCOMPLETE_USAGE_TIME = 2;
     */
    LastUpdateType[LastUpdateType["LAST_AUTOCOMPLETE_USAGE_TIME"] = 2] = "LAST_AUTOCOMPLETE_USAGE_TIME";
    /**
     * @generated from enum value: LAST_UPDATE_TYPE_LAST_CHAT_USAGE_TIME = 3;
     */
    LastUpdateType[LastUpdateType["LAST_CHAT_USAGE_TIME"] = 3] = "LAST_CHAT_USAGE_TIME";
    /**
     * @generated from enum value: LAST_UPDATE_TYPE_LAST_COMMAND_USAGE_TIME = 4;
     */
    LastUpdateType[LastUpdateType["LAST_COMMAND_USAGE_TIME"] = 4] = "LAST_COMMAND_USAGE_TIME";
})(LastUpdateType || (LastUpdateType = {}));
// Retrieve enum metadata with: proto3.getEnumType(LastUpdateType)
proto3.util.setEnumType(LastUpdateType, "exa.codeium_common_pb.LastUpdateType", [
    { no: 0, name: "LAST_UPDATE_TYPE_UNSPECIFIED" },
    { no: 1, name: "LAST_UPDATE_TYPE_OVERALL" },
    { no: 2, name: "LAST_UPDATE_TYPE_LAST_AUTOCOMPLETE_USAGE_TIME" },
    { no: 3, name: "LAST_UPDATE_TYPE_LAST_CHAT_USAGE_TIME" },
    { no: 4, name: "LAST_UPDATE_TYPE_LAST_COMMAND_USAGE_TIME" },
]);
/**
 * @generated from enum exa.codeium_common_pb.OnboardingActionType
 */
export var OnboardingActionType;
(function (OnboardingActionType) {
    /**
     * @generated from enum value: ONBOARDING_ACTION_TYPE_UNSPECIFIED = 0;
     */
    OnboardingActionType[OnboardingActionType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Accepted an autocomplete
     *
     * @generated from enum value: ONBOARDING_ACTION_TYPE_AUTOCOMPLETE = 1;
     */
    OnboardingActionType[OnboardingActionType["AUTOCOMPLETE"] = 1] = "AUTOCOMPLETE";
    /**
     * Sent a command (no further requirements)
     *
     * @generated from enum value: ONBOARDING_ACTION_TYPE_COMMAND = 2;
     */
    OnboardingActionType[OnboardingActionType["COMMAND"] = 2] = "COMMAND";
    /**
     * Sent a message to chat (no further requirements)
     *
     * @generated from enum value: ONBOARDING_ACTION_TYPE_CHAT = 3;
     */
    OnboardingActionType[OnboardingActionType["CHAT"] = 3] = "CHAT";
})(OnboardingActionType || (OnboardingActionType = {}));
// Retrieve enum metadata with: proto3.getEnumType(OnboardingActionType)
proto3.util.setEnumType(OnboardingActionType, "exa.codeium_common_pb.OnboardingActionType", [
    { no: 0, name: "ONBOARDING_ACTION_TYPE_UNSPECIFIED" },
    { no: 1, name: "ONBOARDING_ACTION_TYPE_AUTOCOMPLETE" },
    { no: 2, name: "ONBOARDING_ACTION_TYPE_COMMAND" },
    { no: 3, name: "ONBOARDING_ACTION_TYPE_CHAT" },
]);
/**
 * @generated from enum exa.codeium_common_pb.SupercompleteTriggerCondition
 */
export var SupercompleteTriggerCondition;
(function (SupercompleteTriggerCondition) {
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_UNSPECIFIED = 0;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_AUTOCOMPLETE_ACCEPT = 1;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["AUTOCOMPLETE_ACCEPT"] = 1] = "AUTOCOMPLETE_ACCEPT";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_CURSOR_LINE_NAVIGATION = 2;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["CURSOR_LINE_NAVIGATION"] = 2] = "CURSOR_LINE_NAVIGATION";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_TYPING = 3;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["TYPING"] = 3] = "TYPING";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_FORCED = 4;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["FORCED"] = 4] = "FORCED";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_ACCEPT = 5;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["TAB_JUMP_ACCEPT"] = 5] = "TAB_JUMP_ACCEPT";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_SUPERCOMPLETE_ACCEPT = 6;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["SUPERCOMPLETE_ACCEPT"] = 6] = "SUPERCOMPLETE_ACCEPT";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_PREDICTIVE = 7;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["TAB_JUMP_PREDICTIVE"] = 7] = "TAB_JUMP_PREDICTIVE";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_AUTOCOMPLETE_PREDICTIVE = 8;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["AUTOCOMPLETE_PREDICTIVE"] = 8] = "AUTOCOMPLETE_PREDICTIVE";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_SUPERCOMPLETE_PREDICTIVE = 9;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["SUPERCOMPLETE_PREDICTIVE"] = 9] = "SUPERCOMPLETE_PREDICTIVE";
    /**
     * @generated from enum value: SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_EDIT = 10;
     */
    SupercompleteTriggerCondition[SupercompleteTriggerCondition["TAB_JUMP_EDIT"] = 10] = "TAB_JUMP_EDIT";
})(SupercompleteTriggerCondition || (SupercompleteTriggerCondition = {}));
// Retrieve enum metadata with: proto3.getEnumType(SupercompleteTriggerCondition)
proto3.util.setEnumType(SupercompleteTriggerCondition, "exa.codeium_common_pb.SupercompleteTriggerCondition", [
    { no: 0, name: "SUPERCOMPLETE_TRIGGER_CONDITION_UNSPECIFIED" },
    { no: 1, name: "SUPERCOMPLETE_TRIGGER_CONDITION_AUTOCOMPLETE_ACCEPT" },
    { no: 2, name: "SUPERCOMPLETE_TRIGGER_CONDITION_CURSOR_LINE_NAVIGATION" },
    { no: 3, name: "SUPERCOMPLETE_TRIGGER_CONDITION_TYPING" },
    { no: 4, name: "SUPERCOMPLETE_TRIGGER_CONDITION_FORCED" },
    { no: 5, name: "SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_ACCEPT" },
    { no: 6, name: "SUPERCOMPLETE_TRIGGER_CONDITION_SUPERCOMPLETE_ACCEPT" },
    { no: 7, name: "SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_PREDICTIVE" },
    { no: 8, name: "SUPERCOMPLETE_TRIGGER_CONDITION_AUTOCOMPLETE_PREDICTIVE" },
    { no: 9, name: "SUPERCOMPLETE_TRIGGER_CONDITION_SUPERCOMPLETE_PREDICTIVE" },
    { no: 10, name: "SUPERCOMPLETE_TRIGGER_CONDITION_TAB_JUMP_EDIT" },
]);
/**
 * Enum representing the different in-IDE product events.
 * Next ID: 229, Last added: WEBSITE_FAILED_LOGIN
 * buf:lint:ignore ENUM_VALUE_PREFIX
 *
 * @generated from enum exa.codeium_common_pb.ProductEventType
 */
export var ProductEventType;
(function (ProductEventType) {
    /**
     * @generated from enum value: EVENT_UNSPECIFIED = 0;
     */
    ProductEventType[ProductEventType["EVENT_UNSPECIFIED"] = 0] = "EVENT_UNSPECIFIED";
    /**
     * Durations Events
     *
     * Fired when IDE editor(s) are interactable
     *
     * @generated from enum value: WINDSURF_EDITOR_READY = 251;
     */
    ProductEventType[ProductEventType["WINDSURF_EDITOR_READY"] = 251] = "WINDSURF_EDITOR_READY";
    /**
     * Fired when windsurf extension activate() is called
     *
     * @generated from enum value: WINDSURF_EXTENSION_START = 253;
     */
    ProductEventType[ProductEventType["WINDSURF_EXTENSION_START"] = 253] = "WINDSURF_EXTENSION_START";
    /**
     * Windsurf Extension Events
     *
     * @generated from enum value: WINDSURF_EXTENSION_ACTIVATED = 32;
     */
    ProductEventType[ProductEventType["WINDSURF_EXTENSION_ACTIVATED"] = 32] = "WINDSURF_EXTENSION_ACTIVATED";
    /**
     * Language Server Events
     *
     * @generated from enum value: LS_DOWNLOAD_START = 1;
     */
    ProductEventType[ProductEventType["LS_DOWNLOAD_START"] = 1] = "LS_DOWNLOAD_START";
    /**
     * @generated from enum value: LS_DOWNLOAD_COMPLETE = 2;
     */
    ProductEventType[ProductEventType["LS_DOWNLOAD_COMPLETE"] = 2] = "LS_DOWNLOAD_COMPLETE";
    /**
     * @generated from enum value: LS_DOWNLOAD_FAILURE = 5;
     */
    ProductEventType[ProductEventType["LS_DOWNLOAD_FAILURE"] = 5] = "LS_DOWNLOAD_FAILURE";
    /**
     * Fired when the Go LS binary starts up
     *
     * @generated from enum value: LS_BINARY_STARTUP = 250;
     */
    ProductEventType[ProductEventType["LS_BINARY_STARTUP"] = 250] = "LS_BINARY_STARTUP";
    /**
     * @generated from enum value: LS_STARTUP = 3;
     */
    ProductEventType[ProductEventType["LS_STARTUP"] = 3] = "LS_STARTUP";
    /**
     * @generated from enum value: LS_FAILURE = 4;
     */
    ProductEventType[ProductEventType["LS_FAILURE"] = 4] = "LS_FAILURE";
    /**
     * Autocomplete Events
     *
     * @generated from enum value: AUTOCOMPLETE_ACCEPTED = 6;
     */
    ProductEventType[ProductEventType["AUTOCOMPLETE_ACCEPTED"] = 6] = "AUTOCOMPLETE_ACCEPTED";
    /**
     * @generated from enum value: AUTOCOMPLETE_ONE_WORD_ACCEPTED = 7;
     */
    ProductEventType[ProductEventType["AUTOCOMPLETE_ONE_WORD_ACCEPTED"] = 7] = "AUTOCOMPLETE_ONE_WORD_ACCEPTED";
    /**
     * Chat Events
     *
     * @generated from enum value: CHAT_MESSAGE_SENT = 8;
     */
    ProductEventType[ProductEventType["CHAT_MESSAGE_SENT"] = 8] = "CHAT_MESSAGE_SENT";
    /**
     * @generated from enum value: CHAT_MENTION_INSERT = 13;
     */
    ProductEventType[ProductEventType["CHAT_MENTION_INSERT"] = 13] = "CHAT_MENTION_INSERT";
    /**
     * @generated from enum value: CHAT_MENTION_MENU_OPEN = 19;
     */
    ProductEventType[ProductEventType["CHAT_MENTION_MENU_OPEN"] = 19] = "CHAT_MENTION_MENU_OPEN";
    /**
     * @generated from enum value: CHAT_OPEN_SETTINGS = 14;
     */
    ProductEventType[ProductEventType["CHAT_OPEN_SETTINGS"] = 14] = "CHAT_OPEN_SETTINGS";
    /**
     * @generated from enum value: CHAT_OPEN_CONTEXT_SETTINGS = 15;
     */
    ProductEventType[ProductEventType["CHAT_OPEN_CONTEXT_SETTINGS"] = 15] = "CHAT_OPEN_CONTEXT_SETTINGS";
    /**
     * @generated from enum value: CHAT_WITH_CODEBASE = 16;
     */
    ProductEventType[ProductEventType["CHAT_WITH_CODEBASE"] = 16] = "CHAT_WITH_CODEBASE";
    /**
     * @generated from enum value: CHAT_NEW_CONVERSATION = 17;
     */
    ProductEventType[ProductEventType["CHAT_NEW_CONVERSATION"] = 17] = "CHAT_NEW_CONVERSATION";
    /**
     * @generated from enum value: CHAT_CHANGE_MODEL = 18;
     */
    ProductEventType[ProductEventType["CHAT_CHANGE_MODEL"] = 18] = "CHAT_CHANGE_MODEL";
    /**
     * @generated from enum value: CHAT_TOGGLE_FOCUS_INSERT_TEXT = 34;
     */
    ProductEventType[ProductEventType["CHAT_TOGGLE_FOCUS_INSERT_TEXT"] = 34] = "CHAT_TOGGLE_FOCUS_INSERT_TEXT";
    /**
     * Chat Entrypoint Events.
     *
     * @generated from enum value: FUNCTION_REFACTOR = 28;
     */
    ProductEventType[ProductEventType["FUNCTION_REFACTOR"] = 28] = "FUNCTION_REFACTOR";
    /**
     * @generated from enum value: EXPLAIN_CODE_BLOCK = 29;
     */
    ProductEventType[ProductEventType["EXPLAIN_CODE_BLOCK"] = 29] = "EXPLAIN_CODE_BLOCK";
    /**
     * @generated from enum value: FUNCTION_ADD_DOCSTRING = 30;
     */
    ProductEventType[ProductEventType["FUNCTION_ADD_DOCSTRING"] = 30] = "FUNCTION_ADD_DOCSTRING";
    /**
     * @generated from enum value: EXPLAIN_PROBLEM = 31;
     */
    ProductEventType[ProductEventType["EXPLAIN_PROBLEM"] = 31] = "EXPLAIN_PROBLEM";
    /**
     * Command Events
     *
     * @generated from enum value: COMMAND_BOX_OPENED = 9;
     */
    ProductEventType[ProductEventType["COMMAND_BOX_OPENED"] = 9] = "COMMAND_BOX_OPENED";
    /**
     * @generated from enum value: COMMAND_SUBMITTED = 10;
     */
    ProductEventType[ProductEventType["COMMAND_SUBMITTED"] = 10] = "COMMAND_SUBMITTED";
    /**
     * @generated from enum value: COMMAND_ACCEPTED = 11;
     */
    ProductEventType[ProductEventType["COMMAND_ACCEPTED"] = 11] = "COMMAND_ACCEPTED";
    /**
     * @generated from enum value: COMMAND_REJECTED = 12;
     */
    ProductEventType[ProductEventType["COMMAND_REJECTED"] = 12] = "COMMAND_REJECTED";
    /**
     * Windsurf Onboarding Events
     *
     * @generated from enum value: WS_ONBOARDING_LANDING_PAGE_OPENED = 20;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_LANDING_PAGE_OPENED"] = 20] = "WS_ONBOARDING_LANDING_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_SETUP_PAGE_OPENED = 21;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_SETUP_PAGE_OPENED"] = 21] = "WS_ONBOARDING_SETUP_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_KEYBINDINGS_PAGE_OPENED = 22;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_KEYBINDINGS_PAGE_OPENED"] = 22] = "WS_ONBOARDING_KEYBINDINGS_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_MIGRATION_SCOPE_PAGE_OPENED = 23;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_MIGRATION_SCOPE_PAGE_OPENED"] = 23] = "WS_ONBOARDING_MIGRATION_SCOPE_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_IMPORT_PAGE_OPENED = 24;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_IMPORT_PAGE_OPENED"] = 24] = "WS_ONBOARDING_IMPORT_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_AUTH_PAGE_OPENED = 25;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_AUTH_PAGE_OPENED"] = 25] = "WS_ONBOARDING_AUTH_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_AUTH_MANUAL_PAGE_OPENED = 26;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_AUTH_MANUAL_PAGE_OPENED"] = 26] = "WS_ONBOARDING_AUTH_MANUAL_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_CHOOSE_THEME_PAGE_OPENED = 35;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_CHOOSE_THEME_PAGE_OPENED"] = 35] = "WS_ONBOARDING_CHOOSE_THEME_PAGE_OPENED";
    /**
     * @generated from enum value: WS_ONBOARDING_COMPLETED = 27;
     */
    ProductEventType[ProductEventType["WS_ONBOARDING_COMPLETED"] = 27] = "WS_ONBOARDING_COMPLETED";
    /**
     * @generated from enum value: WS_SKIPPED_ONBOARDING = 69;
     */
    ProductEventType[ProductEventType["WS_SKIPPED_ONBOARDING"] = 69] = "WS_SKIPPED_ONBOARDING";
    /**
     * @generated from enum value: WS_SETTINGS_PAGE_OPEN = 72;
     */
    ProductEventType[ProductEventType["WS_SETTINGS_PAGE_OPEN"] = 72] = "WS_SETTINGS_PAGE_OPEN";
    /**
     * @generated from enum value: WS_SETTINGS_PAGE_OPEN_WITH_SETTING_FOCUS = 73;
     */
    ProductEventType[ProductEventType["WS_SETTINGS_PAGE_OPEN_WITH_SETTING_FOCUS"] = 73] = "WS_SETTINGS_PAGE_OPEN_WITH_SETTING_FOCUS";
    /**
     * Triggered when the empty workspace page is opened and records information about recent folders shown
     *
     * @generated from enum value: EMPTY_WORKSPACE_PAGE_OPENED = 209;
     */
    ProductEventType[ProductEventType["EMPTY_WORKSPACE_PAGE_OPENED"] = 209] = "EMPTY_WORKSPACE_PAGE_OPENED";
    /**
     * Triggered if the user selects one of the suggested recent folders
     *
     * @generated from enum value: EMPTY_WORKSPACE_PAGE_RECENT_FOLDERS_CLICKED = 210;
     */
    ProductEventType[ProductEventType["EMPTY_WORKSPACE_PAGE_RECENT_FOLDERS_CLICKED"] = 210] = "EMPTY_WORKSPACE_PAGE_RECENT_FOLDERS_CLICKED";
    /**
     * Triggered if the user selects the "Open Folder" button
     *
     * @generated from enum value: EMPTY_WORKSPACE_PAGE_OPEN_FOLDER_CLICKED = 211;
     */
    ProductEventType[ProductEventType["EMPTY_WORKSPACE_PAGE_OPEN_FOLDER_CLICKED"] = 211] = "EMPTY_WORKSPACE_PAGE_OPEN_FOLDER_CLICKED";
    /**
     * Triggered if the user selects the "Generate Project" option
     *
     * @generated from enum value: EMPTY_WORKSPACE_PAGE_GENERATE_PROJECT_CLICKED = 212;
     */
    ProductEventType[ProductEventType["EMPTY_WORKSPACE_PAGE_GENERATE_PROJECT_CLICKED"] = 212] = "EMPTY_WORKSPACE_PAGE_GENERATE_PROJECT_CLICKED";
    /**
     * Feedback Events.
     *
     * @generated from enum value: PROVIDE_FEEDBACK = 33;
     */
    ProductEventType[ProductEventType["PROVIDE_FEEDBACK"] = 33] = "PROVIDE_FEEDBACK";
    /**
     * Cascade Events
     *
     * @generated from enum value: CASCADE_MESSAGE_SENT = 36;
     */
    ProductEventType[ProductEventType["CASCADE_MESSAGE_SENT"] = 36] = "CASCADE_MESSAGE_SENT";
    /**
     * @generated from enum value: WS_OPEN_CASCADE_MEMORIES_PANEL = 38 [deprecated = true];
     * @deprecated
     */
    ProductEventType[ProductEventType["WS_OPEN_CASCADE_MEMORIES_PANEL"] = 38] = "WS_OPEN_CASCADE_MEMORIES_PANEL";
    /**
     * @generated from enum value: PROVIDE_MESSAGE_FEEDBACK = 41;
     */
    ProductEventType[ProductEventType["PROVIDE_MESSAGE_FEEDBACK"] = 41] = "PROVIDE_MESSAGE_FEEDBACK";
    /**
     * @generated from enum value: CASCADE_MEMORY_DELETED = 42;
     */
    ProductEventType[ProductEventType["CASCADE_MEMORY_DELETED"] = 42] = "CASCADE_MEMORY_DELETED";
    /**
     * @generated from enum value: CASCADE_STEP_COMPLETED = 43;
     */
    ProductEventType[ProductEventType["CASCADE_STEP_COMPLETED"] = 43] = "CASCADE_STEP_COMPLETED";
    /**
     * @generated from enum value: ACKNOWLEDGE_CASCADE_CODE_EDIT = 44;
     */
    ProductEventType[ProductEventType["ACKNOWLEDGE_CASCADE_CODE_EDIT"] = 44] = "ACKNOWLEDGE_CASCADE_CODE_EDIT";
    /**
     * @generated from enum value: CASCADE_WEB_TOOLS_OPEN_READ_URL_MARKDOWN = 45;
     */
    ProductEventType[ProductEventType["CASCADE_WEB_TOOLS_OPEN_READ_URL_MARKDOWN"] = 45] = "CASCADE_WEB_TOOLS_OPEN_READ_URL_MARKDOWN";
    /**
     * @generated from enum value: CASCADE_WEB_TOOLS_OPEN_CHUNK_MARKDOWN = 46;
     */
    ProductEventType[ProductEventType["CASCADE_WEB_TOOLS_OPEN_CHUNK_MARKDOWN"] = 46] = "CASCADE_WEB_TOOLS_OPEN_CHUNK_MARKDOWN";
    /**
     * @generated from enum value: CASCADE_MCP_SERVER_INIT = 64;
     */
    ProductEventType[ProductEventType["CASCADE_MCP_SERVER_INIT"] = 64] = "CASCADE_MCP_SERVER_INIT";
    /**
     * @generated from enum value: CASCADE_KNOWLEDGE_BASE_ITEM_OPENED = 113;
     */
    ProductEventType[ProductEventType["CASCADE_KNOWLEDGE_BASE_ITEM_OPENED"] = 113] = "CASCADE_KNOWLEDGE_BASE_ITEM_OPENED";
    /**
     * @generated from enum value: CASCADE_VIEW_LOADED = 119;
     */
    ProductEventType[ProductEventType["CASCADE_VIEW_LOADED"] = 119] = "CASCADE_VIEW_LOADED";
    /**
     * Triggered when a scope item is attached to a user input step
     *
     * @generated from enum value: CASCADE_CONTEXT_SCOPE_ITEM_ATTACHED = 173;
     */
    ProductEventType[ProductEventType["CASCADE_CONTEXT_SCOPE_ITEM_ATTACHED"] = 173] = "CASCADE_CONTEXT_SCOPE_ITEM_ATTACHED";
    /**
     * @generated from enum value: CASCADE_CLICK_EVENT = 65;
     */
    ProductEventType[ProductEventType["CASCADE_CLICK_EVENT"] = 65] = "CASCADE_CLICK_EVENT";
    /**
     * @generated from enum value: CASCADE_IMPRESSION_EVENT = 67;
     */
    ProductEventType[ProductEventType["CASCADE_IMPRESSION_EVENT"] = 67] = "CASCADE_IMPRESSION_EVENT";
    /**
     * Title Bar Events
     *
     * @generated from enum value: OPEN_CHANGELOG = 37;
     */
    ProductEventType[ProductEventType["OPEN_CHANGELOG"] = 37] = "OPEN_CHANGELOG";
    /**
     * Third-party App Events
     *
     * @generated from enum value: CURSOR_DETECTED = 39;
     */
    ProductEventType[ProductEventType["CURSOR_DETECTED"] = 39] = "CURSOR_DETECTED";
    /**
     * @generated from enum value: VSCODE_DETECTED = 40;
     */
    ProductEventType[ProductEventType["VSCODE_DETECTED"] = 40] = "VSCODE_DETECTED";
    /**
     * @generated from enum value: JETBRAINS_DETECTED = 153;
     */
    ProductEventType[ProductEventType["JETBRAINS_DETECTED"] = 153] = "JETBRAINS_DETECTED";
    /**
     * @generated from enum value: CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_CLICK = 47;
     */
    ProductEventType[ProductEventType["CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_CLICK"] = 47] = "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_CLICK";
    /**
     * @generated from enum value: CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_NUDGE_IMPRESSION = 48;
     */
    ProductEventType[ProductEventType["CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_NUDGE_IMPRESSION"] = 48] = "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_NUDGE_IMPRESSION";
    /**
     * Triggered when a user clicks "Send all to Cascade" in Windsurf's Problems Tab
     *
     * @generated from enum value: WS_PROBLEMS_TAB_SEND_ALL_TO_CASCADE = 49;
     */
    ProductEventType[ProductEventType["WS_PROBLEMS_TAB_SEND_ALL_TO_CASCADE"] = 49] = "WS_PROBLEMS_TAB_SEND_ALL_TO_CASCADE";
    /**
     * Triggered when a user clicks "Send to Cascade" in Windsurf's Problems Tab for a single file
     *
     * @generated from enum value: WS_PROBLEMS_TAB_SEND_ALL_IN_FILE_TO_CASCADE = 50;
     */
    ProductEventType[ProductEventType["WS_PROBLEMS_TAB_SEND_ALL_IN_FILE_TO_CASCADE"] = 50] = "WS_PROBLEMS_TAB_SEND_ALL_IN_FILE_TO_CASCADE";
    /**
     * Deprecated because there are now multiple ways to do file nav from the Cascade bar and this event is not very meaningful;
     * We should implement more granular events for each of these actions if we care.
     * We may want to deprecate the others as well.
     *
     * @generated from enum value: WS_CASCADE_BAR_FILE_NAV = 51 [deprecated = true];
     * @deprecated
     */
    ProductEventType[ProductEventType["WS_CASCADE_BAR_FILE_NAV"] = 51] = "WS_CASCADE_BAR_FILE_NAV";
    /**
     * @generated from enum value: WS_CASCADE_BAR_HUNK_NAV = 52;
     */
    ProductEventType[ProductEventType["WS_CASCADE_BAR_HUNK_NAV"] = 52] = "WS_CASCADE_BAR_HUNK_NAV";
    /**
     * @generated from enum value: WS_CASCADE_BAR_ACCEPT_FILE = 53;
     */
    ProductEventType[ProductEventType["WS_CASCADE_BAR_ACCEPT_FILE"] = 53] = "WS_CASCADE_BAR_ACCEPT_FILE";
    /**
     * @generated from enum value: WS_CASCADE_BAR_REJECT_FILE = 54;
     */
    ProductEventType[ProductEventType["WS_CASCADE_BAR_REJECT_FILE"] = 54] = "WS_CASCADE_BAR_REJECT_FILE";
    /**
     * Triggered when the user opens the custom app icon modal
     *
     * @generated from enum value: WS_CUSTOM_APP_ICON_MODAL_OPEN = 55;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_MODAL_OPEN"] = 55] = "WS_CUSTOM_APP_ICON_MODAL_OPEN";
    /**
     * Triggered when the user selects a custom app icon
     *
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_CLASSIC = 56;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_CLASSIC"] = 56] = "WS_CUSTOM_APP_ICON_SELECT_CLASSIC";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_CLASSIC_LIGHT = 57;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_CLASSIC_LIGHT"] = 57] = "WS_CUSTOM_APP_ICON_SELECT_CLASSIC_LIGHT";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_RETRO = 58;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_RETRO"] = 58] = "WS_CUSTOM_APP_ICON_SELECT_RETRO";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_BLUEPRINT = 59;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_BLUEPRINT"] = 59] = "WS_CUSTOM_APP_ICON_SELECT_BLUEPRINT";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_HAND_DRAWN = 60;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_HAND_DRAWN"] = 60] = "WS_CUSTOM_APP_ICON_SELECT_HAND_DRAWN";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_SUNSET = 61;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_SUNSET"] = 61] = "WS_CUSTOM_APP_ICON_SELECT_SUNSET";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_VALENTINE = 66;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_VALENTINE"] = 66] = "WS_CUSTOM_APP_ICON_SELECT_VALENTINE";
    /**
     * @generated from enum value: WS_CUSTOM_APP_ICON_SELECT_PIXEL_SURF = 82;
     */
    ProductEventType[ProductEventType["WS_CUSTOM_APP_ICON_SELECT_PIXEL_SURF"] = 82] = "WS_CUSTOM_APP_ICON_SELECT_PIXEL_SURF";
    /**
     * Triggered when the user enters the MCP tab in the Cascade Evergreen Toolbar
     *
     * @generated from enum value: ENTERED_MCP_TOOLBAR_TAB = 63;
     */
    ProductEventType[ProductEventType["ENTERED_MCP_TOOLBAR_TAB"] = 63] = "ENTERED_MCP_TOOLBAR_TAB";
    /**
     * Triggered when the user clicks the "Configure" button in the MCP toolbar
     *
     * @generated from enum value: CLICKED_TO_CONFIGURE_MCP = 62;
     */
    ProductEventType[ProductEventType["CLICKED_TO_CONFIGURE_MCP"] = 62] = "CLICKED_TO_CONFIGURE_MCP";
    /**
     * Triggered when windsurf user updates the user settings
     *
     * @generated from enum value: WS_SETTINGS_UPDATED = 68;
     */
    ProductEventType[ProductEventType["WS_SETTINGS_UPDATED"] = 68] = "WS_SETTINGS_UPDATED";
    /**
     * Browser Preview Events
     *
     * @generated from enum value: BROWSER_PREVIEW_DOM_ELEMENT = 70;
     */
    ProductEventType[ProductEventType["BROWSER_PREVIEW_DOM_ELEMENT"] = 70] = "BROWSER_PREVIEW_DOM_ELEMENT";
    /**
     * @generated from enum value: BROWSER_PREVIEW_CONSOLE_OUTPUT = 71;
     */
    ProductEventType[ProductEventType["BROWSER_PREVIEW_CONSOLE_OUTPUT"] = 71] = "BROWSER_PREVIEW_CONSOLE_OUTPUT";
    /**
     * @generated from enum value: WS_SETTINGS_CHANGED_BY_USER = 74;
     */
    ProductEventType[ProductEventType["WS_SETTINGS_CHANGED_BY_USER"] = 74] = "WS_SETTINGS_CHANGED_BY_USER";
    /**
     * Triggered when the user clicks the "Generate Commit Message" button in the SCM panel
     *
     * @generated from enum value: WS_GENERATE_COMMIT_MESSAGE_CLICKED = 75;
     */
    ProductEventType[ProductEventType["WS_GENERATE_COMMIT_MESSAGE_CLICKED"] = 75] = "WS_GENERATE_COMMIT_MESSAGE_CLICKED";
    /**
     * Triggered when the user clicks the "Generate Commit Message" button in the SCM panel and an error occurs
     *
     * @generated from enum value: WS_GENERATE_COMMIT_MESSAGE_ERRORED = 76;
     */
    ProductEventType[ProductEventType["WS_GENERATE_COMMIT_MESSAGE_ERRORED"] = 76] = "WS_GENERATE_COMMIT_MESSAGE_ERRORED";
    /**
     * Triggered when the user clicks the "Commit" button in the SCM panel
     *
     * @generated from enum value: WS_CLICKED_COMMIT_FROM_SCM_PANEL = 77;
     */
    ProductEventType[ProductEventType["WS_CLICKED_COMMIT_FROM_SCM_PANEL"] = 77] = "WS_CLICKED_COMMIT_FROM_SCM_PANEL";
    /**
     * Triggered when the user clicks to cancel a generate commit message request
     *
     * @generated from enum value: WS_CANCELED_GENERATE_COMMIT_MESSAGE = 79;
     */
    ProductEventType[ProductEventType["WS_CANCELED_GENERATE_COMMIT_MESSAGE"] = 79] = "WS_CANCELED_GENERATE_COMMIT_MESSAGE";
    /**
     * Triggered when the user is using a dev extension
     *
     * @generated from enum value: USING_DEV_EXTENSION = 78;
     */
    ProductEventType[ProductEventType["USING_DEV_EXTENSION"] = 78] = "USING_DEV_EXTENSION";
    /**
     * App Deployment Events
     *
     * @generated from enum value: WS_APP_DEPLOYMENT_CREATE_PROJECT = 80;
     */
    ProductEventType[ProductEventType["WS_APP_DEPLOYMENT_CREATE_PROJECT"] = 80] = "WS_APP_DEPLOYMENT_CREATE_PROJECT";
    /**
     * @generated from enum value: WS_APP_DEPLOYMENT_DEPLOY_PROJECT = 81;
     */
    ProductEventType[ProductEventType["WS_APP_DEPLOYMENT_DEPLOY_PROJECT"] = 81] = "WS_APP_DEPLOYMENT_DEPLOY_PROJECT";
    /**
     * Triggered when the user clicks buttons on the Cascade active conversation dropdown
     * Triggered when the user opens the active conversation dropdown.
     *
     * @generated from enum value: CASCADE_OPEN_ACTIVE_CONVERSATION_DROPDOWN = 114;
     */
    ProductEventType[ProductEventType["CASCADE_OPEN_ACTIVE_CONVERSATION_DROPDOWN"] = 114] = "CASCADE_OPEN_ACTIVE_CONVERSATION_DROPDOWN";
    /**
     * Triggered when the user enters a conversation via the dropdown.
     *
     * @generated from enum value: CASCADE_SELECT_ACTIVE_CONVERSATION_ON_DROPDOWN = 115;
     */
    ProductEventType[ProductEventType["CASCADE_SELECT_ACTIVE_CONVERSATION_ON_DROPDOWN"] = 115] = "CASCADE_SELECT_ACTIVE_CONVERSATION_ON_DROPDOWN";
    /**
     * Triggered when the user focuses a new conversation on the dropdown.
     *
     * @generated from enum value: CASCADE_NAVIGATE_ACTIVE_CONVERSATION_ON_DROPDOWN = 122;
     */
    ProductEventType[ProductEventType["CASCADE_NAVIGATE_ACTIVE_CONVERSATION_ON_DROPDOWN"] = 122] = "CASCADE_NAVIGATE_ACTIVE_CONVERSATION_ON_DROPDOWN";
    /**
     * Triggered when the user snoozes a conversation in the dropdown.
     *
     * @generated from enum value: CASCADE_SNOOZE_CONVERSATION_ON_DROPDOWN = 123;
     */
    ProductEventType[ProductEventType["CASCADE_SNOOZE_CONVERSATION_ON_DROPDOWN"] = 123] = "CASCADE_SNOOZE_CONVERSATION_ON_DROPDOWN";
    /**
     * Triggered when the user shows/hides the notification popup.
     *
     * @generated from enum value: CASCADE_TOGGLE_NOTIFICATION_ON_DROPDOWN = 124;
     */
    ProductEventType[ProductEventType["CASCADE_TOGGLE_NOTIFICATION_ON_DROPDOWN"] = 124] = "CASCADE_TOGGLE_NOTIFICATION_ON_DROPDOWN";
    /**
     * Triggered when the user enters a conversation via the notification popup.
     *
     * @generated from enum value: CASCADE_SELECT_NOTIFICATION_ON_DROPDOWN = 125;
     */
    ProductEventType[ProductEventType["CASCADE_SELECT_NOTIFICATION_ON_DROPDOWN"] = 125] = "CASCADE_SELECT_NOTIFICATION_ON_DROPDOWN";
    /**
     * Triggered when the user views a new notification in the notification popup.
     *
     * @generated from enum value: CASCADE_NAVIGATE_NOTIFICATION_ON_DROPDOWN = 126;
     */
    ProductEventType[ProductEventType["CASCADE_NAVIGATE_NOTIFICATION_ON_DROPDOWN"] = 126] = "CASCADE_NAVIGATE_NOTIFICATION_ON_DROPDOWN";
    /**
     * Triggered when the user dismisses a notification in the notification popup.
     *
     * @generated from enum value: CASCADE_DISMISS_NOTIFICATION_ON_DROPDOWN = 127;
     */
    ProductEventType[ProductEventType["CASCADE_DISMISS_NOTIFICATION_ON_DROPDOWN"] = 127] = "CASCADE_DISMISS_NOTIFICATION_ON_DROPDOWN";
    /**
     * Triggered when a user clicks "Copy Link" from the conversation share modal.
     *
     * @generated from enum value: CASCADE_TRAJECTORY_SHARE_COPY_LINK = 137;
     */
    ProductEventType[ProductEventType["CASCADE_TRAJECTORY_SHARE_COPY_LINK"] = 137] = "CASCADE_TRAJECTORY_SHARE_COPY_LINK";
    /**
     * Triggered when a user clicks "Create Link" from the conversation share modal.
     *
     * @generated from enum value: CASCADE_TRAJECTORY_SHARE_CREATE_LINK = 138;
     */
    ProductEventType[ProductEventType["CASCADE_TRAJECTORY_SHARE_CREATE_LINK"] = 138] = "CASCADE_TRAJECTORY_SHARE_CREATE_LINK";
    /**
     * Triggered when a user switches tabs on the "Customizations" panel.
     *
     * @generated from enum value: CASCADE_CUSTOMIZATIONS_TAB_CHANGE = 139;
     */
    ProductEventType[ProductEventType["CASCADE_CUSTOMIZATIONS_TAB_CHANGE"] = 139] = "CASCADE_CUSTOMIZATIONS_TAB_CHANGE";
    /**
     * Triggered when a user opens a workflow from the panel.
     *
     * @generated from enum value: CASCADE_WORKFLOW_OPEN = 140;
     */
    ProductEventType[ProductEventType["CASCADE_WORKFLOW_OPEN"] = 140] = "CASCADE_WORKFLOW_OPEN";
    /**
     * Triggered when a user clicks "Create Workflow" from the panel.
     *
     * @generated from enum value: CASCADE_NEW_WORKFLOW_CLICKED = 141;
     */
    ProductEventType[ProductEventType["CASCADE_NEW_WORKFLOW_CLICKED"] = 141] = "CASCADE_NEW_WORKFLOW_CLICKED";
    /**
     * Triggered when a user clicks "Create Global Workflow" from the panel.
     *
     * @generated from enum value: CASCADE_NEW_GLOBAL_WORKFLOW_CLICKED = 184;
     */
    ProductEventType[ProductEventType["CASCADE_NEW_GLOBAL_WORKFLOW_CLICKED"] = 184] = "CASCADE_NEW_GLOBAL_WORKFLOW_CLICKED";
    /**
     * Triggered when a user clicks "Refresh Workflows" from the panel.
     *
     * @generated from enum value: CASCADE_WORKFLOW_REFRESH_CLICKED = 142;
     */
    ProductEventType[ProductEventType["CASCADE_WORKFLOW_REFRESH_CLICKED"] = 142] = "CASCADE_WORKFLOW_REFRESH_CLICKED";
    /**
     * Triggered when a user opens a rule from the panel.
     *
     * @generated from enum value: CASCADE_RULE_OPEN = 143;
     */
    ProductEventType[ProductEventType["CASCADE_RULE_OPEN"] = 143] = "CASCADE_RULE_OPEN";
    /**
     * Triggered when a user clicks "Create Rule" from the panel.
     *
     * @generated from enum value: CASCADE_NEW_RULE_CLICKED = 144;
     */
    ProductEventType[ProductEventType["CASCADE_NEW_RULE_CLICKED"] = 144] = "CASCADE_NEW_RULE_CLICKED";
    /**
     * Triggered when a user clicks "Create Global Rules" from the panel.
     *
     * @generated from enum value: CASCADE_NEW_GLOBAL_RULE_CLICKED = 145;
     */
    ProductEventType[ProductEventType["CASCADE_NEW_GLOBAL_RULE_CLICKED"] = 145] = "CASCADE_NEW_GLOBAL_RULE_CLICKED";
    /**
     * Triggered when a user clicks "Refresh Rules" from the panel.
     *
     * @generated from enum value: CASCADE_RULE_REFRESH_CLICKED = 146;
     */
    ProductEventType[ProductEventType["CASCADE_RULE_REFRESH_CLICKED"] = 146] = "CASCADE_RULE_REFRESH_CLICKED";
    /**
     * Triggered when a user clicks "Import From Cursor" from the rules panel.
     *
     * @generated from enum value: CASCADE_IMPORT_RULES_FROM_CURSOR_CLICKED = 147;
     */
    ProductEventType[ProductEventType["CASCADE_IMPORT_RULES_FROM_CURSOR_CLICKED"] = 147] = "CASCADE_IMPORT_RULES_FROM_CURSOR_CLICKED";
    /**
     * Triggered when the command palette "Import rules from Cursor" is used.
     * Note that the "Import From Cursor" button will bring up this command palette which will trigger this (the trigger is on command palette selection not enter)
     *
     * @generated from enum value: WS_IMPORT_CURSOR_RULES_COMMAND_PALETTE = 152;
     */
    ProductEventType[ProductEventType["WS_IMPORT_CURSOR_RULES_COMMAND_PALETTE"] = 152] = "WS_IMPORT_CURSOR_RULES_COMMAND_PALETTE";
    /**
     * Cascade Changes Overview Events
     *
     * @generated from enum value: CASCADE_CHANGES_ACCEPT_ALL = 83;
     */
    ProductEventType[ProductEventType["CASCADE_CHANGES_ACCEPT_ALL"] = 83] = "CASCADE_CHANGES_ACCEPT_ALL";
    /**
     * @generated from enum value: CASCADE_CHANGES_REJECT_ALL = 84;
     */
    ProductEventType[ProductEventType["CASCADE_CHANGES_REJECT_ALL"] = 84] = "CASCADE_CHANGES_REJECT_ALL";
    /**
     * @generated from enum value: CASCADE_MEMORIES_EDIT = 85;
     */
    ProductEventType[ProductEventType["CASCADE_MEMORIES_EDIT"] = 85] = "CASCADE_MEMORIES_EDIT";
    /**
     * @generated from enum value: CASCADE_MEMORIES_VIEW = 86;
     */
    ProductEventType[ProductEventType["CASCADE_MEMORIES_VIEW"] = 86] = "CASCADE_MEMORIES_VIEW";
    /**
     * Shortcut Events
     *
     * @generated from enum value: KEYBOARD_SHORTCUT = 136;
     */
    ProductEventType[ProductEventType["KEYBOARD_SHORTCUT"] = 136] = "KEYBOARD_SHORTCUT";
    /**
     * Cascade @ Mention Events
     *
     * @generated from enum value: CASCADE_INSERT_AT_MENTION = 87;
     */
    ProductEventType[ProductEventType["CASCADE_INSERT_AT_MENTION"] = 87] = "CASCADE_INSERT_AT_MENTION";
    /**
     * Triggered when a step in a Cascade trajectory errors.
     *
     * @generated from enum value: CASCADE_ERROR_STEP = 120;
     */
    ProductEventType[ProductEventType["CASCADE_ERROR_STEP"] = 120] = "CASCADE_ERROR_STEP";
    /**
     * Triggered when the user clicks on a suggested response given by a Cascade SuggestedResponses step
     *
     * @generated from enum value: CASCADE_SUGGESTED_RESPONSES_SUGGESTION_CLICKED = 121;
     */
    ProductEventType[ProductEventType["CASCADE_SUGGESTED_RESPONSES_SUGGESTION_CLICKED"] = 121] = "CASCADE_SUGGESTED_RESPONSES_SUGGESTION_CLICKED";
    /**
     * Cascade Plugin Panel Events
     *
     * Triggered when the user opens the Cascade Plugin Panel (in Cascade)
     *
     * @generated from enum value: CASCADE_PLUGIN_PANEL_OPENED = 128;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_PANEL_OPENED"] = 128] = "CASCADE_PLUGIN_PANEL_OPENED";
    /**
     * Triggered when the user opens a single Plugin Page (in IDE)
     *
     * @generated from enum value: CASCADE_PLUGIN_PAGE_OPENED = 129;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_PAGE_OPENED"] = 129] = "CASCADE_PLUGIN_PAGE_OPENED";
    /**
     * Triggered when the user installs a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_INSTALLED = 130;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_INSTALLED"] = 130] = "CASCADE_PLUGIN_INSTALLED";
    /**
     * Triggered when the user disables a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_DISABLED = 131;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_DISABLED"] = 131] = "CASCADE_PLUGIN_DISABLED";
    /**
     * Triggered when the user enables a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_ENABLED = 132;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_ENABLED"] = 132] = "CASCADE_PLUGIN_ENABLED";
    /**
     * Triggered when the user encounters an error while installing a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_INSTALLATION_ERROR = 133;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_INSTALLATION_ERROR"] = 133] = "CASCADE_PLUGIN_INSTALLATION_ERROR";
    /**
     * Triggered when the user enables a specific tool in a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_TOOL_ENABLED = 134;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_TOOL_ENABLED"] = 134] = "CASCADE_PLUGIN_TOOL_ENABLED";
    /**
     * Triggered when the user disables a specific tool in a plugin
     *
     * @generated from enum value: CASCADE_PLUGIN_TOOL_DISABLED = 135;
     */
    ProductEventType[ProductEventType["CASCADE_PLUGIN_TOOL_DISABLED"] = 135] = "CASCADE_PLUGIN_TOOL_DISABLED";
    /**
     * Website Events
     *
     * @generated from enum value: WEBSITE_NOT_FOUND_PAGE = 88;
     */
    ProductEventType[ProductEventType["WEBSITE_NOT_FOUND_PAGE"] = 88] = "WEBSITE_NOT_FOUND_PAGE";
    /**
     * Triggered when the redirect screen is pending for longer than a certain number of seconds.
     *
     * @generated from enum value: WEBSITE_AUTH_REDIRECT_LONG_WAIT = 89;
     */
    ProductEventType[ProductEventType["WEBSITE_AUTH_REDIRECT_LONG_WAIT"] = 89] = "WEBSITE_AUTH_REDIRECT_LONG_WAIT";
    /**
     * Triggered when there was an error with the AuthLayout redirect screen.
     *
     * @generated from enum value: WEBSITE_AUTH_REDIRECT_ERROR = 90;
     */
    ProductEventType[ProductEventType["WEBSITE_AUTH_REDIRECT_ERROR"] = 90] = "WEBSITE_AUTH_REDIRECT_ERROR";
    /**
     * Triggered when the user successfully redirects to an extension or application.
     *
     * @generated from enum value: WEBSITE_AUTH_REDIRECT_SUCCESS = 112;
     */
    ProductEventType[ProductEventType["WEBSITE_AUTH_REDIRECT_SUCCESS"] = 112] = "WEBSITE_AUTH_REDIRECT_SUCCESS";
    /**
     * Website onboarding/account events
     *
     * Triggered when the user visits a page
     *
     * @generated from enum value: WEBSITE_PAGE_VISIT = 175;
     */
    ProductEventType[ProductEventType["WEBSITE_PAGE_VISIT"] = 175] = "WEBSITE_PAGE_VISIT";
    /**
     * Triggered after the user inputs name and email for a new account
     *
     * @generated from enum value: WEBSITE_SIGNUP_INFO = 176;
     */
    ProductEventType[ProductEventType["WEBSITE_SIGNUP_INFO"] = 176] = "WEBSITE_SIGNUP_INFO";
    /**
     * Website plan/payment events
     *
     * Triggered when user goes to payment page for a new plan
     *
     * @generated from enum value: WEBSITE_START_PLAN_CHECKOUT = 177;
     */
    ProductEventType[ProductEventType["WEBSITE_START_PLAN_CHECKOUT"] = 177] = "WEBSITE_START_PLAN_CHECKOUT";
    /**
     * Triggered when user goes to page to update payment method
     *
     * @generated from enum value: WEBSITE_START_UPDATE_PAYMENT = 202;
     */
    ProductEventType[ProductEventType["WEBSITE_START_UPDATE_PAYMENT"] = 202] = "WEBSITE_START_UPDATE_PAYMENT";
    /**
     * Triggered when user goes to page to view invoices
     *
     * @generated from enum value: WEBSITE_START_VIEW_INVOICES = 203;
     */
    ProductEventType[ProductEventType["WEBSITE_START_VIEW_INVOICES"] = 203] = "WEBSITE_START_VIEW_INVOICES";
    /**
     * Triggered when user views a lecture in university page
     *
     * @generated from enum value: WEBSITE_UNIVERSITY_LECTURE_VIEW = 214;
     */
    ProductEventType[ProductEventType["WEBSITE_UNIVERSITY_LECTURE_VIEW"] = 214] = "WEBSITE_UNIVERSITY_LECTURE_VIEW";
    /**
     * Triggered when a user tries to log in with a self-hosted enterprise email domain.
     *
     * @generated from enum value: WEBSITE_DISALLOW_ENTERPRISE_LOGIN = 224;
     */
    ProductEventType[ProductEventType["WEBSITE_DISALLOW_ENTERPRISE_LOGIN"] = 224] = "WEBSITE_DISALLOW_ENTERPRISE_LOGIN";
    /**
     * Triggered when a user already belongs to a team with SSO setup.
     *
     * @generated from enum value: WEBSITE_SSO_LOGIN_REDIRECT = 225;
     */
    ProductEventType[ProductEventType["WEBSITE_SSO_LOGIN_REDIRECT"] = 225] = "WEBSITE_SSO_LOGIN_REDIRECT";
    /**
     * Triggered when a user tries to login with Google.
     *
     * @generated from enum value: WEBSITE_ATTEMPT_TO_LOGIN = 226;
     */
    ProductEventType[ProductEventType["WEBSITE_ATTEMPT_TO_LOGIN"] = 226] = "WEBSITE_ATTEMPT_TO_LOGIN";
    /**
     * Triggered when a user successfully logs in. Note that this may not trigger due to router replace race conditions.
     *
     * @generated from enum value: WEBSITE_SUCCESSFUL_LOGIN = 227;
     */
    ProductEventType[ProductEventType["WEBSITE_SUCCESSFUL_LOGIN"] = 227] = "WEBSITE_SUCCESSFUL_LOGIN";
    /**
     * Triggered when a user fails to login.
     *
     * @generated from enum value: WEBSITE_FAILED_LOGIN = 228;
     */
    ProductEventType[ProductEventType["WEBSITE_FAILED_LOGIN"] = 228] = "WEBSITE_FAILED_LOGIN";
    /**
     * Jetbrains Events
     *
     * @generated from enum value: JB_OPEN_PLAN_INFO = 91;
     */
    ProductEventType[ProductEventType["JB_OPEN_PLAN_INFO"] = 91] = "JB_OPEN_PLAN_INFO";
    /**
     * @generated from enum value: JB_SNOOZE_PLUGIN = 92 [deprecated = true];
     * @deprecated
     */
    ProductEventType[ProductEventType["JB_SNOOZE_PLUGIN"] = 92] = "JB_SNOOZE_PLUGIN";
    /**
     * @generated from enum value: JB_TOGGLE_PLUGIN_STATUS = 93 [deprecated = true];
     * @deprecated
     */
    ProductEventType[ProductEventType["JB_TOGGLE_PLUGIN_STATUS"] = 93] = "JB_TOGGLE_PLUGIN_STATUS";
    /**
     * @generated from enum value: JB_SWITCH_CHANNEL = 94;
     */
    ProductEventType[ProductEventType["JB_SWITCH_CHANNEL"] = 94] = "JB_SWITCH_CHANNEL";
    /**
     * @generated from enum value: JB_OPEN_SETTINGS = 95;
     */
    ProductEventType[ProductEventType["JB_OPEN_SETTINGS"] = 95] = "JB_OPEN_SETTINGS";
    /**
     * @generated from enum value: JB_PLUGIN_LOG_IN = 96;
     */
    ProductEventType[ProductEventType["JB_PLUGIN_LOG_IN"] = 96] = "JB_PLUGIN_LOG_IN";
    /**
     * @generated from enum value: JB_PLUGIN_LOG_OUT = 97;
     */
    ProductEventType[ProductEventType["JB_PLUGIN_LOG_OUT"] = 97] = "JB_PLUGIN_LOG_OUT";
    /**
     * @generated from enum value: JB_OPEN_QUICK_REFERENCE = 98;
     */
    ProductEventType[ProductEventType["JB_OPEN_QUICK_REFERENCE"] = 98] = "JB_OPEN_QUICK_REFERENCE";
    /**
     * @generated from enum value: JB_EDIT_KEYBOARD_SHORTCUTS = 99;
     */
    ProductEventType[ProductEventType["JB_EDIT_KEYBOARD_SHORTCUTS"] = 99] = "JB_EDIT_KEYBOARD_SHORTCUTS";
    /**
     * @generated from enum value: JB_CASCADE_BAR_CASCADE_ICON = 100;
     */
    ProductEventType[ProductEventType["JB_CASCADE_BAR_CASCADE_ICON"] = 100] = "JB_CASCADE_BAR_CASCADE_ICON";
    /**
     * @generated from enum value: JB_CASCADE_BAR_FILE_NAV = 101;
     */
    ProductEventType[ProductEventType["JB_CASCADE_BAR_FILE_NAV"] = 101] = "JB_CASCADE_BAR_FILE_NAV";
    /**
     * @generated from enum value: JB_CASCADE_BAR_HUNK_NAV = 102;
     */
    ProductEventType[ProductEventType["JB_CASCADE_BAR_HUNK_NAV"] = 102] = "JB_CASCADE_BAR_HUNK_NAV";
    /**
     * @generated from enum value: JB_CASCADE_BAR_ACCEPT_FILE = 103;
     */
    ProductEventType[ProductEventType["JB_CASCADE_BAR_ACCEPT_FILE"] = 103] = "JB_CASCADE_BAR_ACCEPT_FILE";
    /**
     * @generated from enum value: JB_CASCADE_BAR_REJECT_FILE = 104;
     */
    ProductEventType[ProductEventType["JB_CASCADE_BAR_REJECT_FILE"] = 104] = "JB_CASCADE_BAR_REJECT_FILE";
    /**
     * @generated from enum value: JB_INLAY_HUNK_ACCEPT = 105;
     */
    ProductEventType[ProductEventType["JB_INLAY_HUNK_ACCEPT"] = 105] = "JB_INLAY_HUNK_ACCEPT";
    /**
     * @generated from enum value: JB_INLAY_HUNK_REJECT = 106;
     */
    ProductEventType[ProductEventType["JB_INLAY_HUNK_REJECT"] = 106] = "JB_INLAY_HUNK_REJECT";
    /**
     * @generated from enum value: JB_DIFF_RE_RENDER = 107;
     */
    ProductEventType[ProductEventType["JB_DIFF_RE_RENDER"] = 107] = "JB_DIFF_RE_RENDER";
    /**
     * @generated from enum value: JB_ONBOARDING_OPENED = 108;
     */
    ProductEventType[ProductEventType["JB_ONBOARDING_OPENED"] = 108] = "JB_ONBOARDING_OPENED";
    /**
     * @generated from enum value: JB_ONBOARDING_COMPLETED = 109;
     */
    ProductEventType[ProductEventType["JB_ONBOARDING_COMPLETED"] = 109] = "JB_ONBOARDING_COMPLETED";
    /**
     * @generated from enum value: JB_ONBOARDING_SKIPPED = 110;
     */
    ProductEventType[ProductEventType["JB_ONBOARDING_SKIPPED"] = 110] = "JB_ONBOARDING_SKIPPED";
    /**
     * @generated from enum value: JB_ONBOARDING_LEARN_MORE = 111;
     */
    ProductEventType[ProductEventType["JB_ONBOARDING_LEARN_MORE"] = 111] = "JB_ONBOARDING_LEARN_MORE";
    /**
     * @generated from enum value: JB_DIFF_RESOLUTION_ERRORED = 116;
     */
    ProductEventType[ProductEventType["JB_DIFF_RESOLUTION_ERRORED"] = 116] = "JB_DIFF_RESOLUTION_ERRORED";
    /**
     * @generated from enum value: JB_ACKNOWLEDGE_CODE_EDIT_ERRORED = 117;
     */
    ProductEventType[ProductEventType["JB_ACKNOWLEDGE_CODE_EDIT_ERRORED"] = 117] = "JB_ACKNOWLEDGE_CODE_EDIT_ERRORED";
    /**
     * @generated from enum value: JB_OPEN_SETTINGS_NOTIFICATION = 118;
     */
    ProductEventType[ProductEventType["JB_OPEN_SETTINGS_NOTIFICATION"] = 118] = "JB_OPEN_SETTINGS_NOTIFICATION";
    /**
     * @generated from enum value: JB_MCP_ADD_SERVER = 148;
     */
    ProductEventType[ProductEventType["JB_MCP_ADD_SERVER"] = 148] = "JB_MCP_ADD_SERVER";
    /**
     * @generated from enum value: JB_MCP_SAVE_CONFIG = 149;
     */
    ProductEventType[ProductEventType["JB_MCP_SAVE_CONFIG"] = 149] = "JB_MCP_SAVE_CONFIG";
    /**
     * @generated from enum value: JB_MCP_EXPAND_TOOLS = 150;
     */
    ProductEventType[ProductEventType["JB_MCP_EXPAND_TOOLS"] = 150] = "JB_MCP_EXPAND_TOOLS";
    /**
     * @generated from enum value: JB_DISABLE_AUTOGEN_MEMORY = 151;
     */
    ProductEventType[ProductEventType["JB_DISABLE_AUTOGEN_MEMORY"] = 151] = "JB_DISABLE_AUTOGEN_MEMORY";
    /**
     * @generated from enum value: JB_TOGGLE_AUTOCOMPLETE = 154;
     */
    ProductEventType[ProductEventType["JB_TOGGLE_AUTOCOMPLETE"] = 154] = "JB_TOGGLE_AUTOCOMPLETE";
    /**
     * @generated from enum value: JB_LOGIN_MANUAL_AUTH_TOKEN = 174;
     */
    ProductEventType[ProductEventType["JB_LOGIN_MANUAL_AUTH_TOKEN"] = 174] = "JB_LOGIN_MANUAL_AUTH_TOKEN";
    /**
     * @generated from enum value: JB_AUTO_UPDATED = 179;
     */
    ProductEventType[ProductEventType["JB_AUTO_UPDATED"] = 179] = "JB_AUTO_UPDATED";
    /**
     * @generated from enum value: JB_DRAG_DROP_FILE = 182;
     */
    ProductEventType[ProductEventType["JB_DRAG_DROP_FILE"] = 182] = "JB_DRAG_DROP_FILE";
    /**
     * @generated from enum value: JB_AUTO_OPEN_CHAT_WINDOW = 183;
     */
    ProductEventType[ProductEventType["JB_AUTO_OPEN_CHAT_WINDOW"] = 183] = "JB_AUTO_OPEN_CHAT_WINDOW";
    /**
     * Triggered when we force-exit a hanging terminal command in Windsurf; part of terminal integration debugging/workarounds
     *
     * @generated from enum value: WS_TERMINAL_INTEGRATION_FORCE_EXIT = 155;
     */
    ProductEventType[ProductEventType["WS_TERMINAL_INTEGRATION_FORCE_EXIT"] = 155] = "WS_TERMINAL_INTEGRATION_FORCE_EXIT";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_ITEM_CREATED = 156;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_ITEM_CREATED"] = 156] = "KNOWLEDGE_BASE_ITEM_CREATED";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_ITEM_EDITED = 157;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_ITEM_EDITED"] = 157] = "KNOWLEDGE_BASE_ITEM_EDITED";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_ITEM_DELETED = 158;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_ITEM_DELETED"] = 158] = "KNOWLEDGE_BASE_ITEM_DELETED";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_ITEM_READ = 159;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_ITEM_READ"] = 159] = "KNOWLEDGE_BASE_ITEM_READ";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_CONNECTION_CREATE = 160;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_CONNECTION_CREATE"] = 160] = "KNOWLEDGE_BASE_CONNECTION_CREATE";
    /**
     * @generated from enum value: KNOWLEDGE_BASE_CONNECTION_REMOVE = 161;
     */
    ProductEventType[ProductEventType["KNOWLEDGE_BASE_CONNECTION_REMOVE"] = 161] = "KNOWLEDGE_BASE_CONNECTION_REMOVE";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_AUTO_RUN_COMMANDS = 162;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_AUTO_RUN_COMMANDS"] = 162] = "TEAM_CONFIG_TOGGLE_AUTO_RUN_COMMANDS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_MCP_SERVERS = 163;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_MCP_SERVERS"] = 163] = "TEAM_CONFIG_TOGGLE_MCP_SERVERS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_APP_DEPLOYMENTS = 164;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_APP_DEPLOYMENTS"] = 164] = "TEAM_CONFIG_TOGGLE_APP_DEPLOYMENTS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_SANDBOX_APP_DEPLOYMENTS = 165;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_SANDBOX_APP_DEPLOYMENTS"] = 165] = "TEAM_CONFIG_TOGGLE_SANDBOX_APP_DEPLOYMENTS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_TEAMS_APP_DEPLOYMENTS = 166;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_TEAMS_APP_DEPLOYMENTS"] = 166] = "TEAM_CONFIG_TOGGLE_TEAMS_APP_DEPLOYMENTS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_GITHUB_REVIEWS = 167;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_GITHUB_REVIEWS"] = 167] = "TEAM_CONFIG_TOGGLE_GITHUB_REVIEWS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_GITHUB_DESCRIPTION_EDITS = 168;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_GITHUB_DESCRIPTION_EDITS"] = 168] = "TEAM_CONFIG_TOGGLE_GITHUB_DESCRIPTION_EDITS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_PR_REVIEW_GUIDELINES = 169;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_PR_REVIEW_GUIDELINES"] = 169] = "TEAM_CONFIG_TOGGLE_PR_REVIEW_GUIDELINES";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_PR_DESCRIPTION_GUIDELINES = 170;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_PR_DESCRIPTION_GUIDELINES"] = 170] = "TEAM_CONFIG_TOGGLE_PR_DESCRIPTION_GUIDELINES";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_INDIVIDUAL_LEVEL_ANALYTICS = 171;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_INDIVIDUAL_LEVEL_ANALYTICS"] = 171] = "TEAM_CONFIG_TOGGLE_INDIVIDUAL_LEVEL_ANALYTICS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_CONVERSATION_SHARING = 172;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_CONVERSATION_SHARING"] = 172] = "TEAM_CONFIG_TOGGLE_CONVERSATION_SHARING";
    /**
     * @generated from enum value: TEAM_CONFIG_UPDATE_MCP_SERVERS = 178;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_UPDATE_MCP_SERVERS"] = 178] = "TEAM_CONFIG_UPDATE_MCP_SERVERS";
    /**
     * @generated from enum value: TEAM_CONFIG_TOGGLE_GITHUB_AUTO_REVIEWS = 207;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_TOGGLE_GITHUB_AUTO_REVIEWS"] = 207] = "TEAM_CONFIG_TOGGLE_GITHUB_AUTO_REVIEWS";
    /**
     * @generated from enum value: TEAM_CONFIG_UPDATE_TOP_UP_SETTINGS = 213;
     */
    ProductEventType[ProductEventType["TEAM_CONFIG_UPDATE_TOP_UP_SETTINGS"] = 213] = "TEAM_CONFIG_UPDATE_TOP_UP_SETTINGS";
    /**
     * Browser
     *
     * @generated from enum value: BROWSER_OPEN = 180;
     */
    ProductEventType[ProductEventType["BROWSER_OPEN"] = 180] = "BROWSER_OPEN";
    /**
     * @generated from enum value: CASCADE_WEB_TOOLS_OPEN_BROWSER_MARKDOWN = 181;
     */
    ProductEventType[ProductEventType["CASCADE_WEB_TOOLS_OPEN_BROWSER_MARKDOWN"] = 181] = "CASCADE_WEB_TOOLS_OPEN_BROWSER_MARKDOWN";
    /**
     * @generated from enum value: BROWSER_PAGE_LOAD_SUCCESS = 206;
     */
    ProductEventType[ProductEventType["BROWSER_PAGE_LOAD_SUCCESS"] = 206] = "BROWSER_PAGE_LOAD_SUCCESS";
    /**
     * @generated from enum value: BROWSER_TOOLBAR_INSERT_PAGE_MENTION = 208;
     */
    ProductEventType[ProductEventType["BROWSER_TOOLBAR_INSERT_PAGE_MENTION"] = 208] = "BROWSER_TOOLBAR_INSERT_PAGE_MENTION";
    /**
     * @generated from enum value: BROWSER_INSERT_TEXT_CONTENT = 215;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_TEXT_CONTENT"] = 215] = "BROWSER_INSERT_TEXT_CONTENT";
    /**
     * @generated from enum value: BROWSER_INSERT_SCREENSHOT = 216;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_SCREENSHOT"] = 216] = "BROWSER_INSERT_SCREENSHOT";
    /**
     * @generated from enum value: BROWSER_INSERT_CODE_BLOCK = 217;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_CODE_BLOCK"] = 217] = "BROWSER_INSERT_CODE_BLOCK";
    /**
     * @generated from enum value: BROWSER_INSERT_LOG_BLOCK = 218;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_LOG_BLOCK"] = 218] = "BROWSER_INSERT_LOG_BLOCK";
    /**
     * @generated from enum value: BROWSER_INSERT_CONSOLE_OUTPUT = 219;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_CONSOLE_OUTPUT"] = 219] = "BROWSER_INSERT_CONSOLE_OUTPUT";
    /**
     * @generated from enum value: BROWSER_INSERT_DOM_ELEMENT = 220;
     */
    ProductEventType[ProductEventType["BROWSER_INSERT_DOM_ELEMENT"] = 220] = "BROWSER_INSERT_DOM_ELEMENT";
    /**
     * Supercomplete Events
     *
     * @generated from enum value: SUPERCOMPLETE_REQUEST_STARTED = 195;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_REQUEST_STARTED"] = 195] = "SUPERCOMPLETE_REQUEST_STARTED";
    /**
     * @generated from enum value: SUPERCOMPLETE_CACHE_HIT = 196;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_CACHE_HIT"] = 196] = "SUPERCOMPLETE_CACHE_HIT";
    /**
     * @generated from enum value: SUPERCOMPLETE_ERROR_GETTING_RESPONSE = 197;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_ERROR_GETTING_RESPONSE"] = 197] = "SUPERCOMPLETE_ERROR_GETTING_RESPONSE";
    /**
     * @generated from enum value: SUPERCOMPLETE_NO_RESPONSE = 185;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_NO_RESPONSE"] = 185] = "SUPERCOMPLETE_NO_RESPONSE";
    /**
     * @generated from enum value: SUPERCOMPLETE_REQUEST_SUCCEEDED = 186;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_REQUEST_SUCCEEDED"] = 186] = "SUPERCOMPLETE_REQUEST_SUCCEEDED";
    /**
     * @generated from enum value: SUPERCOMPLETE_FILTERED = 187;
     */
    ProductEventType[ProductEventType["SUPERCOMPLETE_FILTERED"] = 187] = "SUPERCOMPLETE_FILTERED";
    /**
     * Tab Jump Events
     *
     * @generated from enum value: TAB_JUMP_REQUEST_STARTED = 188;
     */
    ProductEventType[ProductEventType["TAB_JUMP_REQUEST_STARTED"] = 188] = "TAB_JUMP_REQUEST_STARTED";
    /**
     * @generated from enum value: TAB_JUMP_CACHE_HIT = 189;
     */
    ProductEventType[ProductEventType["TAB_JUMP_CACHE_HIT"] = 189] = "TAB_JUMP_CACHE_HIT";
    /**
     * @generated from enum value: TAB_JUMP_ERROR_GETTING_RESPONSE = 190;
     */
    ProductEventType[ProductEventType["TAB_JUMP_ERROR_GETTING_RESPONSE"] = 190] = "TAB_JUMP_ERROR_GETTING_RESPONSE";
    /**
     * @generated from enum value: TAB_JUMP_NO_RESPONSE = 191;
     */
    ProductEventType[ProductEventType["TAB_JUMP_NO_RESPONSE"] = 191] = "TAB_JUMP_NO_RESPONSE";
    /**
     * @generated from enum value: TAB_JUMP_PROCESSING_COMPLETE = 192;
     */
    ProductEventType[ProductEventType["TAB_JUMP_PROCESSING_COMPLETE"] = 192] = "TAB_JUMP_PROCESSING_COMPLETE";
    /**
     * @generated from enum value: TAB_JUMP_FILTERED = 193;
     */
    ProductEventType[ProductEventType["TAB_JUMP_FILTERED"] = 193] = "TAB_JUMP_FILTERED";
    /**
     * @generated from enum value: TAB_JUMP_ERROR_UI_RENDERED = 194;
     */
    ProductEventType[ProductEventType["TAB_JUMP_ERROR_UI_RENDERED"] = 194] = "TAB_JUMP_ERROR_UI_RENDERED";
    /**
     * Windsurf Reviews events
     *
     * @generated from enum value: AUTO_CASCADE_PR_TITLE_GENERATED = 198;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_PR_TITLE_GENERATED"] = 198] = "AUTO_CASCADE_PR_TITLE_GENERATED";
    /**
     * @generated from enum value: AUTO_CASCADE_PR_DESCRIPTION_GENERATED = 199;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_PR_DESCRIPTION_GENERATED"] = 199] = "AUTO_CASCADE_PR_DESCRIPTION_GENERATED";
    /**
     * @generated from enum value: AUTO_CASCADE_PR_REVIEW_REQUESTED = 200;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_PR_REVIEW_REQUESTED"] = 200] = "AUTO_CASCADE_PR_REVIEW_REQUESTED";
    /**
     * @generated from enum value: AUTO_CASCADE_PR_REVIEW_GENERATED = 201;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_PR_REVIEW_GENERATED"] = 201] = "AUTO_CASCADE_PR_REVIEW_GENERATED";
    /**
     * @generated from enum value: AUTO_CASCADE_GITHUB_CONNECTION_ADDED = 204;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_GITHUB_CONNECTION_ADDED"] = 204] = "AUTO_CASCADE_GITHUB_CONNECTION_ADDED";
    /**
     * @generated from enum value: AUTO_CASCADE_GITHUB_CONNECTION_REMOVED = 205;
     */
    ProductEventType[ProductEventType["AUTO_CASCADE_GITHUB_CONNECTION_REMOVED"] = 205] = "AUTO_CASCADE_GITHUB_CONNECTION_REMOVED";
    /**
     * Chat Autocomplete Events
     *
     * @generated from enum value: AUTOCOMPLETE_CHAT_NO_RESPONSE = 221;
     */
    ProductEventType[ProductEventType["AUTOCOMPLETE_CHAT_NO_RESPONSE"] = 221] = "AUTOCOMPLETE_CHAT_NO_RESPONSE";
    /**
     * @generated from enum value: AUTOCOMPLETE_CHAT_ERROR_GETTING_RESPONSE = 222;
     */
    ProductEventType[ProductEventType["AUTOCOMPLETE_CHAT_ERROR_GETTING_RESPONSE"] = 222] = "AUTOCOMPLETE_CHAT_ERROR_GETTING_RESPONSE";
    /**
     * @generated from enum value: AUTOCOMPLETE_CHAT_REQUEST_ACCEPTED = 223;
     */
    ProductEventType[ProductEventType["AUTOCOMPLETE_CHAT_REQUEST_ACCEPTED"] = 223] = "AUTOCOMPLETE_CHAT_REQUEST_ACCEPTED";
})(ProductEventType || (ProductEventType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ProductEventType)
proto3.util.setEnumType(ProductEventType, "exa.codeium_common_pb.ProductEventType", [
    { no: 0, name: "EVENT_UNSPECIFIED" },
    { no: 251, name: "WINDSURF_EDITOR_READY" },
    { no: 253, name: "WINDSURF_EXTENSION_START" },
    { no: 32, name: "WINDSURF_EXTENSION_ACTIVATED" },
    { no: 1, name: "LS_DOWNLOAD_START" },
    { no: 2, name: "LS_DOWNLOAD_COMPLETE" },
    { no: 5, name: "LS_DOWNLOAD_FAILURE" },
    { no: 250, name: "LS_BINARY_STARTUP" },
    { no: 3, name: "LS_STARTUP" },
    { no: 4, name: "LS_FAILURE" },
    { no: 6, name: "AUTOCOMPLETE_ACCEPTED" },
    { no: 7, name: "AUTOCOMPLETE_ONE_WORD_ACCEPTED" },
    { no: 8, name: "CHAT_MESSAGE_SENT" },
    { no: 13, name: "CHAT_MENTION_INSERT" },
    { no: 19, name: "CHAT_MENTION_MENU_OPEN" },
    { no: 14, name: "CHAT_OPEN_SETTINGS" },
    { no: 15, name: "CHAT_OPEN_CONTEXT_SETTINGS" },
    { no: 16, name: "CHAT_WITH_CODEBASE" },
    { no: 17, name: "CHAT_NEW_CONVERSATION" },
    { no: 18, name: "CHAT_CHANGE_MODEL" },
    { no: 34, name: "CHAT_TOGGLE_FOCUS_INSERT_TEXT" },
    { no: 28, name: "FUNCTION_REFACTOR" },
    { no: 29, name: "EXPLAIN_CODE_BLOCK" },
    { no: 30, name: "FUNCTION_ADD_DOCSTRING" },
    { no: 31, name: "EXPLAIN_PROBLEM" },
    { no: 9, name: "COMMAND_BOX_OPENED" },
    { no: 10, name: "COMMAND_SUBMITTED" },
    { no: 11, name: "COMMAND_ACCEPTED" },
    { no: 12, name: "COMMAND_REJECTED" },
    { no: 20, name: "WS_ONBOARDING_LANDING_PAGE_OPENED" },
    { no: 21, name: "WS_ONBOARDING_SETUP_PAGE_OPENED" },
    { no: 22, name: "WS_ONBOARDING_KEYBINDINGS_PAGE_OPENED" },
    { no: 23, name: "WS_ONBOARDING_MIGRATION_SCOPE_PAGE_OPENED" },
    { no: 24, name: "WS_ONBOARDING_IMPORT_PAGE_OPENED" },
    { no: 25, name: "WS_ONBOARDING_AUTH_PAGE_OPENED" },
    { no: 26, name: "WS_ONBOARDING_AUTH_MANUAL_PAGE_OPENED" },
    { no: 35, name: "WS_ONBOARDING_CHOOSE_THEME_PAGE_OPENED" },
    { no: 27, name: "WS_ONBOARDING_COMPLETED" },
    { no: 69, name: "WS_SKIPPED_ONBOARDING" },
    { no: 72, name: "WS_SETTINGS_PAGE_OPEN" },
    { no: 73, name: "WS_SETTINGS_PAGE_OPEN_WITH_SETTING_FOCUS" },
    { no: 209, name: "EMPTY_WORKSPACE_PAGE_OPENED" },
    { no: 210, name: "EMPTY_WORKSPACE_PAGE_RECENT_FOLDERS_CLICKED" },
    { no: 211, name: "EMPTY_WORKSPACE_PAGE_OPEN_FOLDER_CLICKED" },
    { no: 212, name: "EMPTY_WORKSPACE_PAGE_GENERATE_PROJECT_CLICKED" },
    { no: 33, name: "PROVIDE_FEEDBACK" },
    { no: 36, name: "CASCADE_MESSAGE_SENT" },
    { no: 38, name: "WS_OPEN_CASCADE_MEMORIES_PANEL" },
    { no: 41, name: "PROVIDE_MESSAGE_FEEDBACK" },
    { no: 42, name: "CASCADE_MEMORY_DELETED" },
    { no: 43, name: "CASCADE_STEP_COMPLETED" },
    { no: 44, name: "ACKNOWLEDGE_CASCADE_CODE_EDIT" },
    { no: 45, name: "CASCADE_WEB_TOOLS_OPEN_READ_URL_MARKDOWN" },
    { no: 46, name: "CASCADE_WEB_TOOLS_OPEN_CHUNK_MARKDOWN" },
    { no: 64, name: "CASCADE_MCP_SERVER_INIT" },
    { no: 113, name: "CASCADE_KNOWLEDGE_BASE_ITEM_OPENED" },
    { no: 119, name: "CASCADE_VIEW_LOADED" },
    { no: 173, name: "CASCADE_CONTEXT_SCOPE_ITEM_ATTACHED" },
    { no: 65, name: "CASCADE_CLICK_EVENT" },
    { no: 67, name: "CASCADE_IMPRESSION_EVENT" },
    { no: 37, name: "OPEN_CHANGELOG" },
    { no: 39, name: "CURSOR_DETECTED" },
    { no: 40, name: "VSCODE_DETECTED" },
    { no: 153, name: "JETBRAINS_DETECTED" },
    { no: 47, name: "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_CLICK" },
    { no: 48, name: "CROSS_SELL_EXTENSION_DOWNLOAD_WINDSURF_NUDGE_IMPRESSION" },
    { no: 49, name: "WS_PROBLEMS_TAB_SEND_ALL_TO_CASCADE" },
    { no: 50, name: "WS_PROBLEMS_TAB_SEND_ALL_IN_FILE_TO_CASCADE" },
    { no: 51, name: "WS_CASCADE_BAR_FILE_NAV" },
    { no: 52, name: "WS_CASCADE_BAR_HUNK_NAV" },
    { no: 53, name: "WS_CASCADE_BAR_ACCEPT_FILE" },
    { no: 54, name: "WS_CASCADE_BAR_REJECT_FILE" },
    { no: 55, name: "WS_CUSTOM_APP_ICON_MODAL_OPEN" },
    { no: 56, name: "WS_CUSTOM_APP_ICON_SELECT_CLASSIC" },
    { no: 57, name: "WS_CUSTOM_APP_ICON_SELECT_CLASSIC_LIGHT" },
    { no: 58, name: "WS_CUSTOM_APP_ICON_SELECT_RETRO" },
    { no: 59, name: "WS_CUSTOM_APP_ICON_SELECT_BLUEPRINT" },
    { no: 60, name: "WS_CUSTOM_APP_ICON_SELECT_HAND_DRAWN" },
    { no: 61, name: "WS_CUSTOM_APP_ICON_SELECT_SUNSET" },
    { no: 66, name: "WS_CUSTOM_APP_ICON_SELECT_VALENTINE" },
    { no: 82, name: "WS_CUSTOM_APP_ICON_SELECT_PIXEL_SURF" },
    { no: 63, name: "ENTERED_MCP_TOOLBAR_TAB" },
    { no: 62, name: "CLICKED_TO_CONFIGURE_MCP" },
    { no: 68, name: "WS_SETTINGS_UPDATED" },
    { no: 70, name: "BROWSER_PREVIEW_DOM_ELEMENT" },
    { no: 71, name: "BROWSER_PREVIEW_CONSOLE_OUTPUT" },
    { no: 74, name: "WS_SETTINGS_CHANGED_BY_USER" },
    { no: 75, name: "WS_GENERATE_COMMIT_MESSAGE_CLICKED" },
    { no: 76, name: "WS_GENERATE_COMMIT_MESSAGE_ERRORED" },
    { no: 77, name: "WS_CLICKED_COMMIT_FROM_SCM_PANEL" },
    { no: 79, name: "WS_CANCELED_GENERATE_COMMIT_MESSAGE" },
    { no: 78, name: "USING_DEV_EXTENSION" },
    { no: 80, name: "WS_APP_DEPLOYMENT_CREATE_PROJECT" },
    { no: 81, name: "WS_APP_DEPLOYMENT_DEPLOY_PROJECT" },
    { no: 114, name: "CASCADE_OPEN_ACTIVE_CONVERSATION_DROPDOWN" },
    { no: 115, name: "CASCADE_SELECT_ACTIVE_CONVERSATION_ON_DROPDOWN" },
    { no: 122, name: "CASCADE_NAVIGATE_ACTIVE_CONVERSATION_ON_DROPDOWN" },
    { no: 123, name: "CASCADE_SNOOZE_CONVERSATION_ON_DROPDOWN" },
    { no: 124, name: "CASCADE_TOGGLE_NOTIFICATION_ON_DROPDOWN" },
    { no: 125, name: "CASCADE_SELECT_NOTIFICATION_ON_DROPDOWN" },
    { no: 126, name: "CASCADE_NAVIGATE_NOTIFICATION_ON_DROPDOWN" },
    { no: 127, name: "CASCADE_DISMISS_NOTIFICATION_ON_DROPDOWN" },
    { no: 137, name: "CASCADE_TRAJECTORY_SHARE_COPY_LINK" },
    { no: 138, name: "CASCADE_TRAJECTORY_SHARE_CREATE_LINK" },
    { no: 139, name: "CASCADE_CUSTOMIZATIONS_TAB_CHANGE" },
    { no: 140, name: "CASCADE_WORKFLOW_OPEN" },
    { no: 141, name: "CASCADE_NEW_WORKFLOW_CLICKED" },
    { no: 184, name: "CASCADE_NEW_GLOBAL_WORKFLOW_CLICKED" },
    { no: 142, name: "CASCADE_WORKFLOW_REFRESH_CLICKED" },
    { no: 143, name: "CASCADE_RULE_OPEN" },
    { no: 144, name: "CASCADE_NEW_RULE_CLICKED" },
    { no: 145, name: "CASCADE_NEW_GLOBAL_RULE_CLICKED" },
    { no: 146, name: "CASCADE_RULE_REFRESH_CLICKED" },
    { no: 147, name: "CASCADE_IMPORT_RULES_FROM_CURSOR_CLICKED" },
    { no: 152, name: "WS_IMPORT_CURSOR_RULES_COMMAND_PALETTE" },
    { no: 83, name: "CASCADE_CHANGES_ACCEPT_ALL" },
    { no: 84, name: "CASCADE_CHANGES_REJECT_ALL" },
    { no: 85, name: "CASCADE_MEMORIES_EDIT" },
    { no: 86, name: "CASCADE_MEMORIES_VIEW" },
    { no: 136, name: "KEYBOARD_SHORTCUT" },
    { no: 87, name: "CASCADE_INSERT_AT_MENTION" },
    { no: 120, name: "CASCADE_ERROR_STEP" },
    { no: 121, name: "CASCADE_SUGGESTED_RESPONSES_SUGGESTION_CLICKED" },
    { no: 128, name: "CASCADE_PLUGIN_PANEL_OPENED" },
    { no: 129, name: "CASCADE_PLUGIN_PAGE_OPENED" },
    { no: 130, name: "CASCADE_PLUGIN_INSTALLED" },
    { no: 131, name: "CASCADE_PLUGIN_DISABLED" },
    { no: 132, name: "CASCADE_PLUGIN_ENABLED" },
    { no: 133, name: "CASCADE_PLUGIN_INSTALLATION_ERROR" },
    { no: 134, name: "CASCADE_PLUGIN_TOOL_ENABLED" },
    { no: 135, name: "CASCADE_PLUGIN_TOOL_DISABLED" },
    { no: 88, name: "WEBSITE_NOT_FOUND_PAGE" },
    { no: 89, name: "WEBSITE_AUTH_REDIRECT_LONG_WAIT" },
    { no: 90, name: "WEBSITE_AUTH_REDIRECT_ERROR" },
    { no: 112, name: "WEBSITE_AUTH_REDIRECT_SUCCESS" },
    { no: 175, name: "WEBSITE_PAGE_VISIT" },
    { no: 176, name: "WEBSITE_SIGNUP_INFO" },
    { no: 177, name: "WEBSITE_START_PLAN_CHECKOUT" },
    { no: 202, name: "WEBSITE_START_UPDATE_PAYMENT" },
    { no: 203, name: "WEBSITE_START_VIEW_INVOICES" },
    { no: 214, name: "WEBSITE_UNIVERSITY_LECTURE_VIEW" },
    { no: 224, name: "WEBSITE_DISALLOW_ENTERPRISE_LOGIN" },
    { no: 225, name: "WEBSITE_SSO_LOGIN_REDIRECT" },
    { no: 226, name: "WEBSITE_ATTEMPT_TO_LOGIN" },
    { no: 227, name: "WEBSITE_SUCCESSFUL_LOGIN" },
    { no: 228, name: "WEBSITE_FAILED_LOGIN" },
    { no: 91, name: "JB_OPEN_PLAN_INFO" },
    { no: 92, name: "JB_SNOOZE_PLUGIN" },
    { no: 93, name: "JB_TOGGLE_PLUGIN_STATUS" },
    { no: 94, name: "JB_SWITCH_CHANNEL" },
    { no: 95, name: "JB_OPEN_SETTINGS" },
    { no: 96, name: "JB_PLUGIN_LOG_IN" },
    { no: 97, name: "JB_PLUGIN_LOG_OUT" },
    { no: 98, name: "JB_OPEN_QUICK_REFERENCE" },
    { no: 99, name: "JB_EDIT_KEYBOARD_SHORTCUTS" },
    { no: 100, name: "JB_CASCADE_BAR_CASCADE_ICON" },
    { no: 101, name: "JB_CASCADE_BAR_FILE_NAV" },
    { no: 102, name: "JB_CASCADE_BAR_HUNK_NAV" },
    { no: 103, name: "JB_CASCADE_BAR_ACCEPT_FILE" },
    { no: 104, name: "JB_CASCADE_BAR_REJECT_FILE" },
    { no: 105, name: "JB_INLAY_HUNK_ACCEPT" },
    { no: 106, name: "JB_INLAY_HUNK_REJECT" },
    { no: 107, name: "JB_DIFF_RE_RENDER" },
    { no: 108, name: "JB_ONBOARDING_OPENED" },
    { no: 109, name: "JB_ONBOARDING_COMPLETED" },
    { no: 110, name: "JB_ONBOARDING_SKIPPED" },
    { no: 111, name: "JB_ONBOARDING_LEARN_MORE" },
    { no: 116, name: "JB_DIFF_RESOLUTION_ERRORED" },
    { no: 117, name: "JB_ACKNOWLEDGE_CODE_EDIT_ERRORED" },
    { no: 118, name: "JB_OPEN_SETTINGS_NOTIFICATION" },
    { no: 148, name: "JB_MCP_ADD_SERVER" },
    { no: 149, name: "JB_MCP_SAVE_CONFIG" },
    { no: 150, name: "JB_MCP_EXPAND_TOOLS" },
    { no: 151, name: "JB_DISABLE_AUTOGEN_MEMORY" },
    { no: 154, name: "JB_TOGGLE_AUTOCOMPLETE" },
    { no: 174, name: "JB_LOGIN_MANUAL_AUTH_TOKEN" },
    { no: 179, name: "JB_AUTO_UPDATED" },
    { no: 182, name: "JB_DRAG_DROP_FILE" },
    { no: 183, name: "JB_AUTO_OPEN_CHAT_WINDOW" },
    { no: 155, name: "WS_TERMINAL_INTEGRATION_FORCE_EXIT" },
    { no: 156, name: "KNOWLEDGE_BASE_ITEM_CREATED" },
    { no: 157, name: "KNOWLEDGE_BASE_ITEM_EDITED" },
    { no: 158, name: "KNOWLEDGE_BASE_ITEM_DELETED" },
    { no: 159, name: "KNOWLEDGE_BASE_ITEM_READ" },
    { no: 160, name: "KNOWLEDGE_BASE_CONNECTION_CREATE" },
    { no: 161, name: "KNOWLEDGE_BASE_CONNECTION_REMOVE" },
    { no: 162, name: "TEAM_CONFIG_TOGGLE_AUTO_RUN_COMMANDS" },
    { no: 163, name: "TEAM_CONFIG_TOGGLE_MCP_SERVERS" },
    { no: 164, name: "TEAM_CONFIG_TOGGLE_APP_DEPLOYMENTS" },
    { no: 165, name: "TEAM_CONFIG_TOGGLE_SANDBOX_APP_DEPLOYMENTS" },
    { no: 166, name: "TEAM_CONFIG_TOGGLE_TEAMS_APP_DEPLOYMENTS" },
    { no: 167, name: "TEAM_CONFIG_TOGGLE_GITHUB_REVIEWS" },
    { no: 168, name: "TEAM_CONFIG_TOGGLE_GITHUB_DESCRIPTION_EDITS" },
    { no: 169, name: "TEAM_CONFIG_TOGGLE_PR_REVIEW_GUIDELINES" },
    { no: 170, name: "TEAM_CONFIG_TOGGLE_PR_DESCRIPTION_GUIDELINES" },
    { no: 171, name: "TEAM_CONFIG_TOGGLE_INDIVIDUAL_LEVEL_ANALYTICS" },
    { no: 172, name: "TEAM_CONFIG_TOGGLE_CONVERSATION_SHARING" },
    { no: 178, name: "TEAM_CONFIG_UPDATE_MCP_SERVERS" },
    { no: 207, name: "TEAM_CONFIG_TOGGLE_GITHUB_AUTO_REVIEWS" },
    { no: 213, name: "TEAM_CONFIG_UPDATE_TOP_UP_SETTINGS" },
    { no: 180, name: "BROWSER_OPEN" },
    { no: 181, name: "CASCADE_WEB_TOOLS_OPEN_BROWSER_MARKDOWN" },
    { no: 206, name: "BROWSER_PAGE_LOAD_SUCCESS" },
    { no: 208, name: "BROWSER_TOOLBAR_INSERT_PAGE_MENTION" },
    { no: 215, name: "BROWSER_INSERT_TEXT_CONTENT" },
    { no: 216, name: "BROWSER_INSERT_SCREENSHOT" },
    { no: 217, name: "BROWSER_INSERT_CODE_BLOCK" },
    { no: 218, name: "BROWSER_INSERT_LOG_BLOCK" },
    { no: 219, name: "BROWSER_INSERT_CONSOLE_OUTPUT" },
    { no: 220, name: "BROWSER_INSERT_DOM_ELEMENT" },
    { no: 195, name: "SUPERCOMPLETE_REQUEST_STARTED" },
    { no: 196, name: "SUPERCOMPLETE_CACHE_HIT" },
    { no: 197, name: "SUPERCOMPLETE_ERROR_GETTING_RESPONSE" },
    { no: 185, name: "SUPERCOMPLETE_NO_RESPONSE" },
    { no: 186, name: "SUPERCOMPLETE_REQUEST_SUCCEEDED" },
    { no: 187, name: "SUPERCOMPLETE_FILTERED" },
    { no: 188, name: "TAB_JUMP_REQUEST_STARTED" },
    { no: 189, name: "TAB_JUMP_CACHE_HIT" },
    { no: 190, name: "TAB_JUMP_ERROR_GETTING_RESPONSE" },
    { no: 191, name: "TAB_JUMP_NO_RESPONSE" },
    { no: 192, name: "TAB_JUMP_PROCESSING_COMPLETE" },
    { no: 193, name: "TAB_JUMP_FILTERED" },
    { no: 194, name: "TAB_JUMP_ERROR_UI_RENDERED" },
    { no: 198, name: "AUTO_CASCADE_PR_TITLE_GENERATED" },
    { no: 199, name: "AUTO_CASCADE_PR_DESCRIPTION_GENERATED" },
    { no: 200, name: "AUTO_CASCADE_PR_REVIEW_REQUESTED" },
    { no: 201, name: "AUTO_CASCADE_PR_REVIEW_GENERATED" },
    { no: 204, name: "AUTO_CASCADE_GITHUB_CONNECTION_ADDED" },
    { no: 205, name: "AUTO_CASCADE_GITHUB_CONNECTION_REMOVED" },
    { no: 221, name: "AUTOCOMPLETE_CHAT_NO_RESPONSE" },
    { no: 222, name: "AUTOCOMPLETE_CHAT_ERROR_GETTING_RESPONSE" },
    { no: 223, name: "AUTOCOMPLETE_CHAT_REQUEST_ACCEPTED" },
]);
/**
 * @generated from enum exa.codeium_common_pb.IndexChoice
 */
export var IndexChoice;
(function (IndexChoice) {
    /**
     * @generated from enum value: INDEX_CHOICE_UNSPECIFIED = 0;
     */
    IndexChoice[IndexChoice["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: INDEX_CHOICE_GITHUB_BASE = 1;
     */
    IndexChoice[IndexChoice["GITHUB_BASE"] = 1] = "GITHUB_BASE";
    /**
     * @generated from enum value: INDEX_CHOICE_SLACK_BASE = 2;
     */
    IndexChoice[IndexChoice["SLACK_BASE"] = 2] = "SLACK_BASE";
    /**
     * @generated from enum value: INDEX_CHOICE_SLACK_AGGREGATE = 3 [deprecated = true];
     * @deprecated
     */
    IndexChoice[IndexChoice["SLACK_AGGREGATE"] = 3] = "SLACK_AGGREGATE";
    /**
     * @generated from enum value: INDEX_CHOICE_GOOGLE_DRIVE_BASE = 4;
     */
    IndexChoice[IndexChoice["GOOGLE_DRIVE_BASE"] = 4] = "GOOGLE_DRIVE_BASE";
    /**
     * @generated from enum value: INDEX_CHOICE_JIRA_BASE = 5;
     */
    IndexChoice[IndexChoice["JIRA_BASE"] = 5] = "JIRA_BASE";
    /**
     * @generated from enum value: INDEX_CHOICE_SCM = 6;
     */
    IndexChoice[IndexChoice["SCM"] = 6] = "SCM";
})(IndexChoice || (IndexChoice = {}));
// Retrieve enum metadata with: proto3.getEnumType(IndexChoice)
proto3.util.setEnumType(IndexChoice, "exa.codeium_common_pb.IndexChoice", [
    { no: 0, name: "INDEX_CHOICE_UNSPECIFIED" },
    { no: 1, name: "INDEX_CHOICE_GITHUB_BASE" },
    { no: 2, name: "INDEX_CHOICE_SLACK_BASE" },
    { no: 3, name: "INDEX_CHOICE_SLACK_AGGREGATE" },
    { no: 4, name: "INDEX_CHOICE_GOOGLE_DRIVE_BASE" },
    { no: 5, name: "INDEX_CHOICE_JIRA_BASE" },
    { no: 6, name: "INDEX_CHOICE_SCM" },
]);
/**
 * Types of markdown nodes that we parse out of markdown. Note: not every markdown node is parsed.
 *
 * @generated from enum exa.codeium_common_pb.MarkdownNodeType
 */
export var MarkdownNodeType;
(function (MarkdownNodeType) {
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_UNSPECIFIED = 0;
     */
    MarkdownNodeType[MarkdownNodeType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_1 = 1;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_1"] = 1] = "HEADER_1";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_2 = 2;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_2"] = 2] = "HEADER_2";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_3 = 3;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_3"] = 3] = "HEADER_3";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_4 = 4;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_4"] = 4] = "HEADER_4";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_5 = 5;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_5"] = 5] = "HEADER_5";
    /**
     * @generated from enum value: MARKDOWN_NODE_TYPE_HEADER_6 = 6;
     */
    MarkdownNodeType[MarkdownNodeType["HEADER_6"] = 6] = "HEADER_6";
})(MarkdownNodeType || (MarkdownNodeType = {}));
// Retrieve enum metadata with: proto3.getEnumType(MarkdownNodeType)
proto3.util.setEnumType(MarkdownNodeType, "exa.codeium_common_pb.MarkdownNodeType", [
    { no: 0, name: "MARKDOWN_NODE_TYPE_UNSPECIFIED" },
    { no: 1, name: "MARKDOWN_NODE_TYPE_HEADER_1" },
    { no: 2, name: "MARKDOWN_NODE_TYPE_HEADER_2" },
    { no: 3, name: "MARKDOWN_NODE_TYPE_HEADER_3" },
    { no: 4, name: "MARKDOWN_NODE_TYPE_HEADER_4" },
    { no: 5, name: "MARKDOWN_NODE_TYPE_HEADER_5" },
    { no: 6, name: "MARKDOWN_NODE_TYPE_HEADER_6" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TerminalShellCommandSource
 */
export var TerminalShellCommandSource;
(function (TerminalShellCommandSource) {
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_SOURCE_UNSPECIFIED = 0;
     */
    TerminalShellCommandSource[TerminalShellCommandSource["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_SOURCE_USER = 1;
     */
    TerminalShellCommandSource[TerminalShellCommandSource["USER"] = 1] = "USER";
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_SOURCE_CASCADE = 2;
     */
    TerminalShellCommandSource[TerminalShellCommandSource["CASCADE"] = 2] = "CASCADE";
})(TerminalShellCommandSource || (TerminalShellCommandSource = {}));
// Retrieve enum metadata with: proto3.getEnumType(TerminalShellCommandSource)
proto3.util.setEnumType(TerminalShellCommandSource, "exa.codeium_common_pb.TerminalShellCommandSource", [
    { no: 0, name: "TERMINAL_SHELL_COMMAND_SOURCE_UNSPECIFIED" },
    { no: 1, name: "TERMINAL_SHELL_COMMAND_SOURCE_USER" },
    { no: 2, name: "TERMINAL_SHELL_COMMAND_SOURCE_CASCADE" },
]);
/**
 * @generated from enum exa.codeium_common_pb.TerminalShellCommandStatus
 */
export var TerminalShellCommandStatus;
(function (TerminalShellCommandStatus) {
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_STATUS_UNSPECIFIED = 0;
     */
    TerminalShellCommandStatus[TerminalShellCommandStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_STATUS_RUNNING = 1;
     */
    TerminalShellCommandStatus[TerminalShellCommandStatus["RUNNING"] = 1] = "RUNNING";
    /**
     * @generated from enum value: TERMINAL_SHELL_COMMAND_STATUS_COMPLETED = 2;
     */
    TerminalShellCommandStatus[TerminalShellCommandStatus["COMPLETED"] = 2] = "COMPLETED";
})(TerminalShellCommandStatus || (TerminalShellCommandStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(TerminalShellCommandStatus)
proto3.util.setEnumType(TerminalShellCommandStatus, "exa.codeium_common_pb.TerminalShellCommandStatus", [
    { no: 0, name: "TERMINAL_SHELL_COMMAND_STATUS_UNSPECIFIED" },
    { no: 1, name: "TERMINAL_SHELL_COMMAND_STATUS_RUNNING" },
    { no: 2, name: "TERMINAL_SHELL_COMMAND_STATUS_COMPLETED" },
]);
/**
 * BuildStatus represents the current status of a web app deployment build
 *
 * @generated from enum exa.codeium_common_pb.DeploymentBuildStatus
 */
export var DeploymentBuildStatus;
(function (DeploymentBuildStatus) {
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_UNSPECIFIED = 0;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_QUEUED = 1;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["QUEUED"] = 1] = "QUEUED";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_INITIALIZING = 2;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["INITIALIZING"] = 2] = "INITIALIZING";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_BUILDING = 3;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["BUILDING"] = 3] = "BUILDING";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_ERROR = 4;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["ERROR"] = 4] = "ERROR";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_READY = 5;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["READY"] = 5] = "READY";
    /**
     * @generated from enum value: DEPLOYMENT_BUILD_STATUS_CANCELED = 6;
     */
    DeploymentBuildStatus[DeploymentBuildStatus["CANCELED"] = 6] = "CANCELED";
})(DeploymentBuildStatus || (DeploymentBuildStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(DeploymentBuildStatus)
proto3.util.setEnumType(DeploymentBuildStatus, "exa.codeium_common_pb.DeploymentBuildStatus", [
    { no: 0, name: "DEPLOYMENT_BUILD_STATUS_UNSPECIFIED" },
    { no: 1, name: "DEPLOYMENT_BUILD_STATUS_QUEUED" },
    { no: 2, name: "DEPLOYMENT_BUILD_STATUS_INITIALIZING" },
    { no: 3, name: "DEPLOYMENT_BUILD_STATUS_BUILDING" },
    { no: 4, name: "DEPLOYMENT_BUILD_STATUS_ERROR" },
    { no: 5, name: "DEPLOYMENT_BUILD_STATUS_READY" },
    { no: 6, name: "DEPLOYMENT_BUILD_STATUS_CANCELED" },
]);
/**
 * Deployment provider for Windsurf JS app deployments.
 *
 * @generated from enum exa.codeium_common_pb.DeploymentProvider
 */
export var DeploymentProvider;
(function (DeploymentProvider) {
    /**
     * @generated from enum value: DEPLOYMENT_PROVIDER_UNSPECIFIED = 0;
     */
    DeploymentProvider[DeploymentProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: DEPLOYMENT_PROVIDER_VERCEL = 1;
     */
    DeploymentProvider[DeploymentProvider["VERCEL"] = 1] = "VERCEL";
    /**
     * @generated from enum value: DEPLOYMENT_PROVIDER_NETLIFY = 2;
     */
    DeploymentProvider[DeploymentProvider["NETLIFY"] = 2] = "NETLIFY";
    /**
     * @generated from enum value: DEPLOYMENT_PROVIDER_CLOUDFLARE = 3;
     */
    DeploymentProvider[DeploymentProvider["CLOUDFLARE"] = 3] = "CLOUDFLARE";
})(DeploymentProvider || (DeploymentProvider = {}));
// Retrieve enum metadata with: proto3.getEnumType(DeploymentProvider)
proto3.util.setEnumType(DeploymentProvider, "exa.codeium_common_pb.DeploymentProvider", [
    { no: 0, name: "DEPLOYMENT_PROVIDER_UNSPECIFIED" },
    { no: 1, name: "DEPLOYMENT_PROVIDER_VERCEL" },
    { no: 2, name: "DEPLOYMENT_PROVIDER_NETLIFY" },
    { no: 3, name: "DEPLOYMENT_PROVIDER_CLOUDFLARE" },
]);
/**
 * ValidationStatus represents the validation status of a Windsurf JS application project name
 *
 * @generated from enum exa.codeium_common_pb.ValidationStatus
 */
export var ValidationStatus;
(function (ValidationStatus) {
    /**
     * @generated from enum value: VALIDATION_STATUS_UNSPECIFIED = 0;
     */
    ValidationStatus[ValidationStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * Project name is not in use.
     *
     * @generated from enum value: VALIDATION_STATUS_AVAILABLE = 1;
     */
    ValidationStatus[ValidationStatus["AVAILABLE"] = 1] = "AVAILABLE";
    /**
     * Project name is already used by this user (can redeploy).
     *
     * @generated from enum value: VALIDATION_STATUS_IN_USE = 2;
     */
    ValidationStatus[ValidationStatus["IN_USE"] = 2] = "IN_USE";
    /**
     * Project name is already used by another user.
     *
     * @generated from enum value: VALIDATION_STATUS_TAKEN = 3;
     */
    ValidationStatus[ValidationStatus["TAKEN"] = 3] = "TAKEN";
    /**
     * Project name has invalid format/characters.
     *
     * @generated from enum value: VALIDATION_STATUS_INVALID = 4;
     */
    ValidationStatus[ValidationStatus["INVALID"] = 4] = "INVALID";
})(ValidationStatus || (ValidationStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(ValidationStatus)
proto3.util.setEnumType(ValidationStatus, "exa.codeium_common_pb.ValidationStatus", [
    { no: 0, name: "VALIDATION_STATUS_UNSPECIFIED" },
    { no: 1, name: "VALIDATION_STATUS_AVAILABLE" },
    { no: 2, name: "VALIDATION_STATUS_IN_USE" },
    { no: 3, name: "VALIDATION_STATUS_TAKEN" },
    { no: 4, name: "VALIDATION_STATUS_INVALID" },
]);
/**
 * @generated from enum exa.codeium_common_pb.PromptTemplaterType
 */
export var PromptTemplaterType;
(function (PromptTemplaterType) {
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_UNSPECIFIED = 0;
     */
    PromptTemplaterType[PromptTemplaterType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_LLAMA_2 = 1;
     */
    PromptTemplaterType[PromptTemplaterType["LLAMA_2"] = 1] = "LLAMA_2";
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_LLAMA_3 = 2;
     */
    PromptTemplaterType[PromptTemplaterType["LLAMA_3"] = 2] = "LLAMA_3";
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_CHATML = 3;
     */
    PromptTemplaterType[PromptTemplaterType["CHATML"] = 3] = "CHATML";
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_CHAT_TRANSCRIPT = 4;
     */
    PromptTemplaterType[PromptTemplaterType["CHAT_TRANSCRIPT"] = 4] = "CHAT_TRANSCRIPT";
    /**
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_DEEPSEEK_V2 = 5;
     */
    PromptTemplaterType[PromptTemplaterType["DEEPSEEK_V2"] = 5] = "DEEPSEEK_V2";
    /**
     * Also used for V2.5
     *
     * @generated from enum value: PROMPT_TEMPLATER_TYPE_DEEPSEEK_V3 = 6;
     */
    PromptTemplaterType[PromptTemplaterType["DEEPSEEK_V3"] = 6] = "DEEPSEEK_V3";
})(PromptTemplaterType || (PromptTemplaterType = {}));
// Retrieve enum metadata with: proto3.getEnumType(PromptTemplaterType)
proto3.util.setEnumType(PromptTemplaterType, "exa.codeium_common_pb.PromptTemplaterType", [
    { no: 0, name: "PROMPT_TEMPLATER_TYPE_UNSPECIFIED" },
    { no: 1, name: "PROMPT_TEMPLATER_TYPE_LLAMA_2" },
    { no: 2, name: "PROMPT_TEMPLATER_TYPE_LLAMA_3" },
    { no: 3, name: "PROMPT_TEMPLATER_TYPE_CHATML" },
    { no: 4, name: "PROMPT_TEMPLATER_TYPE_CHAT_TRANSCRIPT" },
    { no: 5, name: "PROMPT_TEMPLATER_TYPE_DEEPSEEK_V2" },
    { no: 6, name: "PROMPT_TEMPLATER_TYPE_DEEPSEEK_V3" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ToolFormatterType
 */
export var ToolFormatterType;
(function (ToolFormatterType) {
    /**
     * @generated from enum value: TOOL_FORMATTER_TYPE_UNSPECIFIED = 0;
     */
    ToolFormatterType[ToolFormatterType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TOOL_FORMATTER_TYPE_LLAMA_3 = 1;
     */
    ToolFormatterType[ToolFormatterType["LLAMA_3"] = 1] = "LLAMA_3";
    /**
     * @generated from enum value: TOOL_FORMATTER_TYPE_HERMES = 2;
     */
    ToolFormatterType[ToolFormatterType["HERMES"] = 2] = "HERMES";
    /**
     * @generated from enum value: TOOL_FORMATTER_TYPE_XML = 3;
     */
    ToolFormatterType[ToolFormatterType["XML"] = 3] = "XML";
    /**
     * @generated from enum value: TOOL_FORMATTER_TYPE_CHAT_TRANSCRIPT = 4;
     */
    ToolFormatterType[ToolFormatterType["CHAT_TRANSCRIPT"] = 4] = "CHAT_TRANSCRIPT";
})(ToolFormatterType || (ToolFormatterType = {}));
// Retrieve enum metadata with: proto3.getEnumType(ToolFormatterType)
proto3.util.setEnumType(ToolFormatterType, "exa.codeium_common_pb.ToolFormatterType", [
    { no: 0, name: "TOOL_FORMATTER_TYPE_UNSPECIFIED" },
    { no: 1, name: "TOOL_FORMATTER_TYPE_LLAMA_3" },
    { no: 2, name: "TOOL_FORMATTER_TYPE_HERMES" },
    { no: 3, name: "TOOL_FORMATTER_TYPE_XML" },
    { no: 4, name: "TOOL_FORMATTER_TYPE_CHAT_TRANSCRIPT" },
]);
/**
 * Status of browser installation (Playwright or otherwise)
 *
 * @generated from enum exa.codeium_common_pb.BrowserInstallationStatus
 */
export var BrowserInstallationStatus;
(function (BrowserInstallationStatus) {
    /**
     * @generated from enum value: BROWSER_INSTALLATION_STATUS_UNSPECIFIED = 0;
     */
    BrowserInstallationStatus[BrowserInstallationStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: BROWSER_INSTALLATION_STATUS_NOT_INSTALLED = 1;
     */
    BrowserInstallationStatus[BrowserInstallationStatus["NOT_INSTALLED"] = 1] = "NOT_INSTALLED";
    /**
     * @generated from enum value: BROWSER_INSTALLATION_STATUS_IN_PROGRESS = 2;
     */
    BrowserInstallationStatus[BrowserInstallationStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
    /**
     * @generated from enum value: BROWSER_INSTALLATION_STATUS_COMPLETE = 3;
     */
    BrowserInstallationStatus[BrowserInstallationStatus["COMPLETE"] = 3] = "COMPLETE";
    /**
     * @generated from enum value: BROWSER_INSTALLATION_STATUS_ERROR = 4;
     */
    BrowserInstallationStatus[BrowserInstallationStatus["ERROR"] = 4] = "ERROR";
})(BrowserInstallationStatus || (BrowserInstallationStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(BrowserInstallationStatus)
proto3.util.setEnumType(BrowserInstallationStatus, "exa.codeium_common_pb.BrowserInstallationStatus", [
    { no: 0, name: "BROWSER_INSTALLATION_STATUS_UNSPECIFIED" },
    { no: 1, name: "BROWSER_INSTALLATION_STATUS_NOT_INSTALLED" },
    { no: 2, name: "BROWSER_INSTALLATION_STATUS_IN_PROGRESS" },
    { no: 3, name: "BROWSER_INSTALLATION_STATUS_COMPLETE" },
    { no: 4, name: "BROWSER_INSTALLATION_STATUS_ERROR" },
]);
/**
 * Enum for specifying the type of trajectory search.
 *
 * @generated from enum exa.codeium_common_pb.TrajectoryType
 */
export var TrajectoryType;
(function (TrajectoryType) {
    /**
     * @generated from enum value: TRAJECTORY_TYPE_UNSPECIFIED = 0;
     */
    TrajectoryType[TrajectoryType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: TRAJECTORY_TYPE_CASCADE = 1;
     */
    TrajectoryType[TrajectoryType["CASCADE"] = 1] = "CASCADE";
    /**
     * @generated from enum value: TRAJECTORY_TYPE_MAINLINE_TRAJECTORY = 2;
     */
    TrajectoryType[TrajectoryType["MAINLINE_TRAJECTORY"] = 2] = "MAINLINE_TRAJECTORY";
})(TrajectoryType || (TrajectoryType = {}));
// Retrieve enum metadata with: proto3.getEnumType(TrajectoryType)
proto3.util.setEnumType(TrajectoryType, "exa.codeium_common_pb.TrajectoryType", [
    { no: 0, name: "TRAJECTORY_TYPE_UNSPECIFIED" },
    { no: 1, name: "TRAJECTORY_TYPE_CASCADE" },
    { no: 2, name: "TRAJECTORY_TYPE_MAINLINE_TRAJECTORY" },
]);
/**
 * @generated from enum exa.codeium_common_pb.RefreshCustomizationType
 */
export var RefreshCustomizationType;
(function (RefreshCustomizationType) {
    /**
     * @generated from enum value: REFRESH_CUSTOMIZATION_TYPE_UNSPECIFIED = 0;
     */
    RefreshCustomizationType[RefreshCustomizationType["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: REFRESH_CUSTOMIZATION_TYPE_RULE = 1;
     */
    RefreshCustomizationType[RefreshCustomizationType["RULE"] = 1] = "RULE";
    /**
     * @generated from enum value: REFRESH_CUSTOMIZATION_TYPE_WORKFLOW = 2;
     */
    RefreshCustomizationType[RefreshCustomizationType["WORKFLOW"] = 2] = "WORKFLOW";
})(RefreshCustomizationType || (RefreshCustomizationType = {}));
// Retrieve enum metadata with: proto3.getEnumType(RefreshCustomizationType)
proto3.util.setEnumType(RefreshCustomizationType, "exa.codeium_common_pb.RefreshCustomizationType", [
    { no: 0, name: "REFRESH_CUSTOMIZATION_TYPE_UNSPECIFIED" },
    { no: 1, name: "REFRESH_CUSTOMIZATION_TYPE_RULE" },
    { no: 2, name: "REFRESH_CUSTOMIZATION_TYPE_WORKFLOW" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ThirdPartyWebSearchProvider
 */
export var ThirdPartyWebSearchProvider;
(function (ThirdPartyWebSearchProvider) {
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_PROVIDER_UNSPECIFIED = 0;
     */
    ThirdPartyWebSearchProvider[ThirdPartyWebSearchProvider["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_PROVIDER_OPENAI = 1;
     */
    ThirdPartyWebSearchProvider[ThirdPartyWebSearchProvider["OPENAI"] = 1] = "OPENAI";
})(ThirdPartyWebSearchProvider || (ThirdPartyWebSearchProvider = {}));
// Retrieve enum metadata with: proto3.getEnumType(ThirdPartyWebSearchProvider)
proto3.util.setEnumType(ThirdPartyWebSearchProvider, "exa.codeium_common_pb.ThirdPartyWebSearchProvider", [
    { no: 0, name: "THIRD_PARTY_WEB_SEARCH_PROVIDER_UNSPECIFIED" },
    { no: 1, name: "THIRD_PARTY_WEB_SEARCH_PROVIDER_OPENAI" },
]);
/**
 * @generated from enum exa.codeium_common_pb.ThirdPartyWebSearchModel
 */
export var ThirdPartyWebSearchModel;
(function (ThirdPartyWebSearchModel) {
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_MODEL_UNSPECIFIED = 0;
     */
    ThirdPartyWebSearchModel[ThirdPartyWebSearchModel["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_MODEL_O3 = 1;
     */
    ThirdPartyWebSearchModel[ThirdPartyWebSearchModel["O3"] = 1] = "O3";
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_MODEL_GPT_4_1 = 2;
     */
    ThirdPartyWebSearchModel[ThirdPartyWebSearchModel["GPT_4_1"] = 2] = "GPT_4_1";
    /**
     * @generated from enum value: THIRD_PARTY_WEB_SEARCH_MODEL_O4_MINI = 3;
     */
    ThirdPartyWebSearchModel[ThirdPartyWebSearchModel["O4_MINI"] = 3] = "O4_MINI";
})(ThirdPartyWebSearchModel || (ThirdPartyWebSearchModel = {}));
// Retrieve enum metadata with: proto3.getEnumType(ThirdPartyWebSearchModel)
proto3.util.setEnumType(ThirdPartyWebSearchModel, "exa.codeium_common_pb.ThirdPartyWebSearchModel", [
    { no: 0, name: "THIRD_PARTY_WEB_SEARCH_MODEL_UNSPECIFIED" },
    { no: 1, name: "THIRD_PARTY_WEB_SEARCH_MODEL_O3" },
    { no: 2, name: "THIRD_PARTY_WEB_SEARCH_MODEL_GPT_4_1" },
    { no: 3, name: "THIRD_PARTY_WEB_SEARCH_MODEL_O4_MINI" },
]);
/**
 * Next ID: 26, Previous field: uid.
 *
 * @generated from message exa.codeium_common_pb.CompletionsRequest
 */
export class CompletionsRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string prompt = 2;
         */
        this.prompt = "";
        /**
         * @generated from field: string context_prompt = 21;
         */
        this.contextPrompt = "";
        /**
         * Uid is set by the API server. It is used for prompt cache sticky load
         * balancing and management of prompt cache lookups / evictions.
         *
         * @generated from field: string uid = 25;
         */
        this.uid = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.PromptElementRange prompt_element_ranges = 8;
         */
        this.promptElementRanges = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.PromptElementKindInfo prompt_element_kind_infos = 9;
         */
        this.promptElementKindInfos = [];
        /**
         * Prompt generation latency.
         *
         * @generated from field: uint64 prompt_latency_ms = 11;
         */
        this.promptLatencyMs = protoInt64.zero;
        /**
         * Latencies for stages of prompt creation (included in prompt_latency_ms).
         *
         * @generated from field: repeated exa.codeium_common_pb.PromptStageLatency prompt_stage_latencies = 12;
         */
        this.promptStageLatencies = [];
        /**
         * @generated from field: uint64 num_tokenized_bytes = 20;
         */
        this.numTokenizedBytes = protoInt64.zero;
        /**
         * @generated from field: string editor_language = 3;
         */
        this.editorLanguage = "";
        /**
         * @generated from field: exa.codeium_common_pb.Language language = 4;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * This used to be an absolute path but is now a URI.
         *
         * @generated from field: string absolute_path_uri_for_telemetry = 5;
         */
        this.absolutePathUriForTelemetry = "";
        /**
         * @generated from field: string relative_path_for_telemetry = 6;
         */
        this.relativePathForTelemetry = "";
        /**
         * This used to be an absolute path but is now a URI.
         *
         * @generated from field: string workspace_uri_for_telemetry = 13;
         */
        this.workspaceUriForTelemetry = "";
        /**
         * @generated from field: string experiment_features_json = 7;
         */
        this.experimentFeaturesJson = "";
        /**
         * @generated from field: string experiment_variant_json = 19;
         */
        this.experimentVariantJson = "";
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 10;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        /**
         * @generated from field: bool has_line_suffix = 14;
         */
        this.hasLineSuffix = false;
        /**
         * @generated from field: bool should_inline_fim = 15;
         */
        this.shouldInlineFim = false;
        /**
         * Model tag, which will determine which LoRA parameters we use for inference.
         * All valid model tags must be nonempty strings (otherwise they will be
         * ignored and no LoRA parameters will be used).
         *
         * @generated from field: string model_tag = 17;
         */
        this.modelTag = "";
        /**
         * Free-form string tags for tagging experiments. There may be situations in
         * which an experiment is "on", but the prerequisite for it has not been met,
         * in which case this field may be of use.
         *
         * @generated from field: repeated string experiment_tags = 18;
         */
        this.experimentTags = [];
        /**
         * Evaluation suffix. If specified, the CompletionsResponse will return
         * a set of logits corresponding to this eval suffix. Used for lm-eval.
         *
         * @generated from field: string eval_suffix = 22;
         */
        this.evalSuffix = "";
        /**
         * Prompt annotated ranges used for inference.
         *
         * @generated from field: repeated exa.codeium_common_pb.PromptAnnotationRange prompt_annotation_ranges = 23;
         */
        this.promptAnnotationRanges = [];
        /**
         * Whether the client supports PackedStreamingCompletionMaps. This should be
         * true for updated language servers.
         *
         * @generated from field: bool supports_packed_streaming_completion_maps = 24;
         */
        this.supportsPackedStreamingCompletionMaps = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionsRequest, a, b);
    }
}
CompletionsRequest.runtime = proto3;
CompletionsRequest.typeName = "exa.codeium_common_pb.CompletionsRequest";
CompletionsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "configuration", kind: "message", T: CompletionConfiguration },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "context_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "prompt_element_ranges", kind: "message", T: PromptElementRange, repeated: true },
    { no: 9, name: "prompt_element_kind_infos", kind: "message", T: PromptElementKindInfo, repeated: true },
    { no: 11, name: "prompt_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "prompt_stage_latencies", kind: "message", T: PromptStageLatency, repeated: true },
    { no: 20, name: "num_tokenized_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "editor_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "absolute_path_uri_for_telemetry", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "relative_path_for_telemetry", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "workspace_uri_for_telemetry", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "experiment_features_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "experiment_variant_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 14, name: "has_line_suffix", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "should_inline_fim", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "repository", kind: "message", T: Repository },
    { no: 17, name: "model_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "experiment_tags", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 22, name: "eval_suffix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "prompt_annotation_ranges", kind: "message", T: PromptAnnotationRange, repeated: true },
    { no: 24, name: "supports_packed_streaming_completion_maps", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Next ID: 15, Previous field: sqrt_len_normalized_log_prob_score.
 * Configuration parameters for completion generation.
 *
 * @generated from message exa.codeium_common_pb.CompletionConfiguration
 */
export class CompletionConfiguration extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 num_completions = 1;
         */
        this.numCompletions = protoInt64.zero;
        /**
         * @generated from field: uint64 max_tokens = 2;
         */
        this.maxTokens = protoInt64.zero;
        /**
         * @generated from field: uint64 max_newlines = 3;
         */
        this.maxNewlines = protoInt64.zero;
        /**
         * @generated from field: double min_log_probability = 4;
         */
        this.minLogProbability = 0;
        /**
         * @generated from field: double temperature = 5;
         */
        this.temperature = 0;
        /**
         * @generated from field: double first_temperature = 6;
         */
        this.firstTemperature = 0;
        /**
         * @generated from field: uint64 top_k = 7;
         */
        this.topK = protoInt64.zero;
        /**
         * @generated from field: double top_p = 8;
         */
        this.topP = 0;
        /**
         * @generated from field: repeated string stop_patterns = 9;
         */
        this.stopPatterns = [];
        /**
         * @generated from field: uint64 seed = 10;
         */
        this.seed = protoInt64.zero;
        /**
         * @generated from field: double fim_eot_prob_threshold = 11;
         */
        this.fimEotProbThreshold = 0;
        /**
         * Whether we use the EOT threshold for FIM generations.
         *
         * @generated from field: bool use_fim_eot_threshold = 12;
         */
        this.useFimEotThreshold = false;
        /**
         * If true, do not include stop token log probs in the scores.
         *
         * @generated from field: bool do_not_score_stop_tokens = 13;
         */
        this.doNotScoreStopTokens = false;
        /**
         * If true, scores = sum(log probs) / sqrt(completion len)
         *
         * @generated from field: bool sqrt_len_normalized_log_prob_score = 14;
         */
        this.sqrtLenNormalizedLogProbScore = false;
        /**
         * For internal chat completions, whether the last chat message is a partial message that should be completed,
         * or whether we should start a new message.
         *
         * @generated from field: bool last_message_is_partial = 15;
         */
        this.lastMessageIsPartial = false;
        /**
         * Whether to return log probabilities for each token in the completion.
         *
         * @generated from field: bool return_logprob = 16;
         */
        this.returnLogprob = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionConfiguration().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionConfiguration().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionConfiguration().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionConfiguration, a, b);
    }
}
CompletionConfiguration.runtime = proto3;
CompletionConfiguration.typeName = "exa.codeium_common_pb.CompletionConfiguration";
CompletionConfiguration.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "num_completions", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "max_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "max_newlines", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "min_log_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "temperature", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "first_temperature", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "top_k", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "top_p", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "stop_patterns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "seed", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 11, name: "fim_eot_prob_threshold", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 12, name: "use_fim_eot_threshold", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "do_not_score_stop_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "sqrt_len_normalized_log_prob_score", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "last_message_is_partial", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "return_logprob", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Next ID: 6, Previous field: token_offset_end.
 *
 * @generated from message exa.codeium_common_pb.PromptElementRange
 */
export class PromptElementRange extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.PromptElementKind kind = 1;
         */
        this.kind = PromptElementKind.UNSPECIFIED;
        /**
         * @generated from field: uint64 byte_offset_start = 2;
         */
        this.byteOffsetStart = protoInt64.zero;
        /**
         * exclusive
         *
         * @generated from field: uint64 byte_offset_end = 3;
         */
        this.byteOffsetEnd = protoInt64.zero;
        /**
         * @generated from field: uint64 token_offset_start = 4;
         */
        this.tokenOffsetStart = protoInt64.zero;
        /**
         * exclusive
         *
         * @generated from field: uint64 token_offset_end = 5;
         */
        this.tokenOffsetEnd = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptElementRange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptElementRange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptElementRange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptElementRange, a, b);
    }
}
PromptElementRange.runtime = proto3;
PromptElementRange.typeName = "exa.codeium_common_pb.PromptElementRange";
PromptElementRange.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(PromptElementKind) },
    { no: 2, name: "byte_offset_start", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "byte_offset_end", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "token_offset_start", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "token_offset_end", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * Points to a corresponding action in a plan.
 *
 * @generated from message exa.codeium_common_pb.ActionPointer
 */
export class ActionPointer extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string cortex_plan_id = 1;
         */
        this.cortexPlanId = "";
        /**
         * @generated from field: string code_plan_id = 2;
         */
        this.codePlanId = "";
        /**
         * -1 is for the latest action in the plan.
         *
         * @generated from field: int32 action_index = 3;
         */
        this.actionIndex = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ActionPointer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ActionPointer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ActionPointer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ActionPointer, a, b);
    }
}
ActionPointer.runtime = proto3;
ActionPointer.typeName = "exa.codeium_common_pb.ActionPointer";
ActionPointer.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "cortex_plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "code_plan_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "action_index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PromptAnnotationRange
 */
export class PromptAnnotationRange extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.PromptAnnotationKind kind = 1;
         */
        this.kind = PromptAnnotationKind.UNSPECIFIED;
        /**
         * @generated from field: uint64 byte_offset_start = 2;
         */
        this.byteOffsetStart = protoInt64.zero;
        /**
         * exclusive
         *
         * @generated from field: uint64 byte_offset_end = 3;
         */
        this.byteOffsetEnd = protoInt64.zero;
        /**
         * Additional string to be used with speculative copy.
         *
         * @generated from field: string suffix = 4;
         */
        this.suffix = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptAnnotationRange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptAnnotationRange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptAnnotationRange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptAnnotationRange, a, b);
    }
}
PromptAnnotationRange.runtime = proto3;
PromptAnnotationRange.typeName = "exa.codeium_common_pb.PromptAnnotationRange";
PromptAnnotationRange.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(PromptAnnotationKind) },
    { no: 2, name: "byte_offset_start", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "byte_offset_end", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "suffix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Next ID: 8, Previous field: source.
 *
 * @generated from message exa.codeium_common_pb.ExperimentWithVariant
 */
export class ExperimentWithVariant extends Message {
    constructor(data) {
        super();
        /**
         * Optionally set if the key_string is in the set of ExperimentKey enums the client
         * knows about.
         *
         * @generated from field: exa.codeium_common_pb.ExperimentKey key = 1 [deprecated = true];
         * @deprecated
         */
        this.key = ExperimentKey.UNSPECIFIED;
        /**
         * For new clients, this is required.
         *
         * @generated from field: string key_string = 5;
         */
        this.keyString = "";
        /**
         * @generated from field: bool disabled = 6;
         */
        this.disabled = false;
        /**
         * If there is no variant, payload is not set.
         *
         * @generated from oneof exa.codeium_common_pb.ExperimentWithVariant.payload
         */
        this.payload = { case: undefined };
        /**
         * The part of the stack where the experiment was resolved.
         *
         * @generated from field: exa.codeium_common_pb.ExperimentSource source = 7;
         */
        this.source = ExperimentSource.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentWithVariant().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentWithVariant().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentWithVariant().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentWithVariant, a, b);
    }
}
ExperimentWithVariant.runtime = proto3;
ExperimentWithVariant.typeName = "exa.codeium_common_pb.ExperimentWithVariant";
ExperimentWithVariant.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "key", kind: "enum", T: proto3.getEnumType(ExperimentKey) },
    { no: 5, name: "key_string", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "string", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "payload" },
    { no: 3, name: "json", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "payload" },
    { no: 4, name: "csv", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "payload" },
    { no: 7, name: "source", kind: "enum", T: proto3.getEnumType(ExperimentSource) },
]);
/**
 * Next ID: 7, Previous field: experiments.
 *
 * @generated from message exa.codeium_common_pb.ExperimentConfig
 */
export class ExperimentConfig extends Message {
    constructor(data) {
        super();
        /**
         * All experiments.
         *
         * @generated from field: repeated exa.codeium_common_pb.ExperimentWithVariant experiments = 6;
         */
        this.experiments = [];
        /**
         * TODO(prem): Add back "[(buf.validate.field).repeated.unique = true]" after https://github.com/bufbuild/protovalidate-go/issues/87 is resolved.
         *
         * @generated from field: repeated exa.codeium_common_pb.ExperimentKey force_enable_experiments = 1;
         */
        this.forceEnableExperiments = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.ExperimentKey force_disable_experiments = 2;
         */
        this.forceDisableExperiments = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.ExperimentWithVariant force_enable_experiments_with_variants = 3;
         */
        this.forceEnableExperimentsWithVariants = [];
        /**
         * Experiment keys are parsed by the extension. However, there are cases when the language server may
         * expect experiment keys not known to the compiled version of the extension. In these cases, we can attempt
         * to parse the strings directly. This will be best-effort and unioned with the keys in the previous fields.
         *
         * @generated from field: repeated string force_enable_experiment_strings = 4;
         */
        this.forceEnableExperimentStrings = [];
        /**
         * @generated from field: repeated string force_disable_experiment_strings = 5;
         */
        this.forceDisableExperimentStrings = [];
        /**
         * @generated from field: bool dev_mode = 7;
         */
        this.devMode = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentConfig, a, b);
    }
}
ExperimentConfig.runtime = proto3;
ExperimentConfig.typeName = "exa.codeium_common_pb.ExperimentConfig";
ExperimentConfig.fields = proto3.util.newFieldList(() => [
    { no: 6, name: "experiments", kind: "message", T: ExperimentWithVariant, repeated: true },
    { no: 1, name: "force_enable_experiments", kind: "enum", T: proto3.getEnumType(ExperimentKey), repeated: true },
    { no: 2, name: "force_disable_experiments", kind: "enum", T: proto3.getEnumType(ExperimentKey), repeated: true },
    { no: 3, name: "force_enable_experiments_with_variants", kind: "message", T: ExperimentWithVariant, repeated: true },
    { no: 4, name: "force_enable_experiment_strings", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "force_disable_experiment_strings", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "dev_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * This is used as the value of the variant for the experiment LANGUAGE_SERVER_VERSION.
 *
 * @generated from message exa.codeium_common_pb.ExperimentLanguageServerVersionPayload
 */
export class ExperimentLanguageServerVersionPayload extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string sha = 1;
         */
        this.sha = "";
        /**
         * @generated from field: string crc32c_linux_x64 = 2;
         */
        this.crc32cLinuxX64 = "";
        /**
         * @generated from field: string crc32c_linux_arm = 3;
         */
        this.crc32cLinuxArm = "";
        /**
         * @generated from field: string crc32c_macos_x64 = 4;
         */
        this.crc32cMacosX64 = "";
        /**
         * @generated from field: string crc32c_macos_arm = 5;
         */
        this.crc32cMacosArm = "";
        /**
         * @generated from field: string crc32c_windows_x64 = 6;
         */
        this.crc32cWindowsX64 = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentLanguageServerVersionPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentLanguageServerVersionPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentLanguageServerVersionPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentLanguageServerVersionPayload, a, b);
    }
}
ExperimentLanguageServerVersionPayload.runtime = proto3;
ExperimentLanguageServerVersionPayload.typeName = "exa.codeium_common_pb.ExperimentLanguageServerVersionPayload";
ExperimentLanguageServerVersionPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "sha", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "crc32c_linux_x64", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "crc32c_linux_arm", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "crc32c_macos_x64", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "crc32c_macos_arm", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "crc32c_windows_x64", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ExperimentModelConfigPayload
 */
export class ExperimentModelConfigPayload extends Message {
    constructor(data) {
        super();
        /**
         * Generation model.
         *
         * @generated from field: string model_name = 1;
         */
        this.modelName = "";
        /**
         * Context check model.
         *
         * @generated from field: string context_check_model_name = 2;
         */
        this.contextCheckModelName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentModelConfigPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentModelConfigPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentModelConfigPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentModelConfigPayload, a, b);
    }
}
ExperimentModelConfigPayload.runtime = proto3;
ExperimentModelConfigPayload.typeName = "exa.codeium_common_pb.ExperimentModelConfigPayload";
ExperimentModelConfigPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "context_check_model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ExperimentMiddleModeTokenPayload
 */
export class ExperimentMiddleModeTokenPayload extends Message {
    constructor(data) {
        super();
        /**
         * Mode token.
         *
         * @generated from field: string mode_token = 1;
         */
        this.modeToken = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentMiddleModeTokenPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentMiddleModeTokenPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentMiddleModeTokenPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentMiddleModeTokenPayload, a, b);
    }
}
ExperimentMiddleModeTokenPayload.runtime = proto3;
ExperimentMiddleModeTokenPayload.typeName = "exa.codeium_common_pb.ExperimentMiddleModeTokenPayload";
ExperimentMiddleModeTokenPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "mode_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ExperimentMultilineModelThresholdPayload
 */
export class ExperimentMultilineModelThresholdPayload extends Message {
    constructor(data) {
        super();
        /**
         * Multiline model threshold.
         *
         * @generated from field: float threshold = 1;
         */
        this.threshold = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentMultilineModelThresholdPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentMultilineModelThresholdPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentMultilineModelThresholdPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentMultilineModelThresholdPayload, a, b);
    }
}
ExperimentMultilineModelThresholdPayload.runtime = proto3;
ExperimentMultilineModelThresholdPayload.typeName = "exa.codeium_common_pb.ExperimentMultilineModelThresholdPayload";
ExperimentMultilineModelThresholdPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "threshold", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ExperimentSentryPayload
 */
export class ExperimentSentryPayload extends Message {
    constructor(data) {
        super();
        /**
         * Sample rate for errors. Used if there is no procedure-specific rate/ignore string-specific rate.
         *
         * @generated from field: double sample_rate = 2;
         */
        this.sampleRate = 0;
        /**
         * Sample rate for errors with a matching procedure. Used if there is no ignore string-specific rate.
         *
         * @generated from field: map<string, double> procedure_to_sample_rate = 3;
         */
        this.procedureToSampleRate = {};
        /**
         * Sample rate for errors with a matching ignore string.
         *
         * @generated from field: map<string, double> error_match_to_sample_rate = 5;
         */
        this.errorMatchToSampleRate = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentSentryPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentSentryPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentSentryPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentSentryPayload, a, b);
    }
}
ExperimentSentryPayload.runtime = proto3;
ExperimentSentryPayload.typeName = "exa.codeium_common_pb.ExperimentSentryPayload";
ExperimentSentryPayload.fields = proto3.util.newFieldList(() => [
    { no: 2, name: "sample_rate", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "procedure_to_sample_rate", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 1 /* ScalarType.DOUBLE */ } },
    { no: 5, name: "error_match_to_sample_rate", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 1 /* ScalarType.DOUBLE */ } },
]);
/**
 * TeamOrganizationalControls represents the model labels that can be used by a team
 *
 * @generated from message exa.codeium_common_pb.TeamOrganizationalControls
 */
export class TeamOrganizationalControls extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string team_id = 1;
         */
        this.teamId = "";
        /**
         * List of model labels like "Claude 3.5 Sonnet" that can be used by Cascade.
         *
         * @generated from field: repeated string cascade_model_labels = 2;
         */
        this.cascadeModelLabels = [];
        /**
         * List of model labels like "Claude 3.5 Sonnet" that can be used by Command.
         *
         * @generated from field: repeated string command_model_labels = 3;
         */
        this.commandModelLabels = [];
        /**
         * List of model labels like "Claude 3.5 Sonnet" that can be used by the extension.
         *
         * @generated from field: repeated string extension_model_labels = 6;
         */
        this.extensionModelLabels = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TeamOrganizationalControls().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamOrganizationalControls().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamOrganizationalControls().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamOrganizationalControls, a, b);
    }
}
TeamOrganizationalControls.runtime = proto3;
TeamOrganizationalControls.typeName = "exa.codeium_common_pb.TeamOrganizationalControls";
TeamOrganizationalControls.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cascade_model_labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "command_model_labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "created_at", kind: "message", T: Timestamp },
    { no: 5, name: "updated_at", kind: "message", T: Timestamp },
    { no: 6, name: "extension_model_labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * This is used as the value of the variant for the experiment PROFILING_TELEMETRY_SAMPLE_RATE.
 *
 * @generated from message exa.codeium_common_pb.ExperimentProfilingTelemetrySampleRatePayload
 */
export class ExperimentProfilingTelemetrySampleRatePayload extends Message {
    constructor(data) {
        super();
        /**
         * Sample rate for profiling telemetry by memory usage.
         *
         * @generated from field: map<string, double> memory_usage_to_sample_rate = 1;
         */
        this.memoryUsageToSampleRate = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExperimentProfilingTelemetrySampleRatePayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExperimentProfilingTelemetrySampleRatePayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExperimentProfilingTelemetrySampleRatePayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExperimentProfilingTelemetrySampleRatePayload, a, b);
    }
}
ExperimentProfilingTelemetrySampleRatePayload.runtime = proto3;
ExperimentProfilingTelemetrySampleRatePayload.typeName = "exa.codeium_common_pb.ExperimentProfilingTelemetrySampleRatePayload";
ExperimentProfilingTelemetrySampleRatePayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "memory_usage_to_sample_rate", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 1 /* ScalarType.DOUBLE */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.ModelOrAlias
 */
export class ModelOrAlias extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.ModelOrAlias.choice
         */
        this.choice = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelOrAlias().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelOrAlias().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelOrAlias().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelOrAlias, a, b);
    }
}
ModelOrAlias.runtime = proto3;
ModelOrAlias.typeName = "exa.codeium_common_pb.ModelOrAlias";
ModelOrAlias.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(Model), oneof: "choice" },
    { no: 2, name: "alias", kind: "enum", T: proto3.getEnumType(ModelAlias), oneof: "choice" },
]);
/**
 * Next ID: 6, Previous field: num_included.
 * TODO(nick): track grouped / excluded prompt element kinds.
 *
 * @generated from message exa.codeium_common_pb.PromptElementKindInfo
 */
export class PromptElementKindInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.PromptElementKind kind = 1;
         */
        this.kind = PromptElementKind.UNSPECIFIED;
        /**
         * The key for the associated experiment if it exists.
         *
         * @generated from field: exa.codeium_common_pb.ExperimentKey experiment_key = 2;
         */
        this.experimentKey = ExperimentKey.UNSPECIFIED;
        /**
         * Whether the experiment is enabled (should be true if no associated
         * experiment).
         *
         * @generated from field: bool enabled = 3;
         */
        this.enabled = false;
        /**
         * The number of elements of this kind considered when constructing the
         * prompt. If the experiment is disabled, this will be the number considered
         * as if the experiment were enabled.
         *
         * @generated from field: uint64 num_considered = 4;
         */
        this.numConsidered = protoInt64.zero;
        /**
         * The number of elements of this kind included when constructing the prompt.
         * If the experiment is disabled, this will be the number included as if the
         * experiment were enabled.
         *
         * @generated from field: uint64 num_included = 5;
         */
        this.numIncluded = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptElementKindInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptElementKindInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptElementKindInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptElementKindInfo, a, b);
    }
}
PromptElementKindInfo.runtime = proto3;
PromptElementKindInfo.typeName = "exa.codeium_common_pb.PromptElementKindInfo";
PromptElementKindInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "kind", kind: "enum", T: proto3.getEnumType(PromptElementKind) },
    { no: 2, name: "experiment_key", kind: "enum", T: proto3.getEnumType(ExperimentKey) },
    { no: 3, name: "enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "num_considered", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "num_included", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PromptElementInclusionMetadata
 */
export class PromptElementInclusionMetadata extends Message {
    constructor(data) {
        super();
        /**
         * Whether prompt item was included in the prompt.
         *
         * @generated from field: bool included = 1;
         */
        this.included = false;
        /**
         * Only populated if not `included`.
         *
         * @generated from field: exa.codeium_common_pb.PromptElementExclusionReason exclusion_reason = 2;
         */
        this.exclusionReason = PromptElementExclusionReason.EXCLUSION_UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptElementInclusionMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptElementInclusionMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptElementInclusionMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptElementInclusionMetadata, a, b);
    }
}
PromptElementInclusionMetadata.runtime = proto3;
PromptElementInclusionMetadata.typeName = "exa.codeium_common_pb.PromptElementInclusionMetadata";
PromptElementInclusionMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "included", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "exclusion_reason", kind: "enum", T: proto3.getEnumType(PromptElementExclusionReason) },
]);
/**
 * Next ID: 3, Previous field: latency_ms.
 *
 * @generated from message exa.codeium_common_pb.PromptStageLatency
 */
export class PromptStageLatency extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: uint64 latency_ms = 2;
         */
        this.latencyMs = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptStageLatency().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptStageLatency().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptStageLatency().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptStageLatency, a, b);
    }
}
PromptStageLatency.runtime = proto3;
PromptStageLatency.typeName = "exa.codeium_common_pb.PromptStageLatency";
PromptStageLatency.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * Next ID: 11, Previous field: model_tag.
 *
 * @generated from message exa.codeium_common_pb.CompletionResponse
 */
export class CompletionResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.Completion completions = 1;
         */
        this.completions = [];
        /**
         * @generated from field: uint64 max_tokens = 2;
         */
        this.maxTokens = protoInt64.zero;
        /**
         * @generated from field: double temperature = 3;
         */
        this.temperature = 0;
        /**
         * @generated from field: uint64 top_k = 4;
         */
        this.topK = protoInt64.zero;
        /**
         * @generated from field: double top_p = 5;
         */
        this.topP = 0;
        /**
         * @generated from field: repeated string stop_patterns = 6;
         */
        this.stopPatterns = [];
        /**
         * @generated from field: uint64 prompt_length = 7;
         */
        this.promptLength = protoInt64.zero;
        /**
         * Populated by the API server.
         *
         * @generated from field: string prompt_id = 8;
         */
        this.promptId = "";
        /**
         * @generated from field: string model_tag = 10;
         */
        this.modelTag = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionResponse, a, b);
    }
}
CompletionResponse.runtime = proto3;
CompletionResponse.typeName = "exa.codeium_common_pb.CompletionResponse";
CompletionResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completions", kind: "message", T: Completion, repeated: true },
    { no: 2, name: "max_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "temperature", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "top_k", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "top_p", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "stop_patterns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "prompt_length", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "model_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "completion_profile", kind: "message", T: CompletionProfile, opt: true },
]);
/**
 * Next ID: 16, Previous field: tool_calls.
 *
 * @generated from message exa.codeium_common_pb.Completion
 */
export class Completion extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string completion_id = 1;
         */
        this.completionId = "";
        /**
         * @generated from field: string text = 2;
         */
        this.text = "";
        /**
         * @generated from field: string stop = 4;
         */
        this.stop = "";
        /**
         * Populated / overwritten on the language server, derived from probabilities.
         *
         * @generated from field: double score = 5;
         */
        this.score = 0;
        /**
         * @generated from field: repeated uint64 tokens = 6;
         */
        this.tokens = [];
        /**
         * @generated from field: repeated string decoded_tokens = 7;
         */
        this.decodedTokens = [];
        /**
         * @generated from field: repeated double probabilities = 8;
         */
        this.probabilities = [];
        /**
         * @generated from field: repeated double adjusted_probabilities = 9;
         */
        this.adjustedProbabilities = [];
        /**
         * @generated from field: repeated double logprobs = 16;
         */
        this.logprobs = [];
        /**
         * @generated from field: uint64 generated_length = 10;
         */
        this.generatedLength = protoInt64.zero;
        /**
         * Reason that the completion was stopped. Can be populated by the inference server or the
         * language server.
         *
         * @generated from field: exa.codeium_common_pb.StopReason stop_reason = 12;
         */
        this.stopReason = StopReason.UNSPECIFIED;
        /**
         * Reasons that the completion was filtered (if filtered). Will be populated by the language
         * server.
         *
         * @generated from field: repeated exa.codeium_common_pb.FilterReason filter_reasons = 13;
         */
        this.filterReasons = [];
        /**
         * Original text prior to cutoff / cleaning. Will be populated by the language server.
         *
         * @generated from field: string original_text = 14;
         */
        this.originalText = "";
        /**
         * Tool calls generated by the model. Populated by the language server / api server.
         *
         * @generated from field: repeated exa.codeium_common_pb.ChatToolCall tool_calls = 15;
         */
        this.toolCalls = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Completion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Completion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Completion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Completion, a, b);
    }
}
Completion.runtime = proto3;
Completion.typeName = "exa.codeium_common_pb.Completion";
Completion.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completion_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "stop", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "score", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */, repeated: true },
    { no: 7, name: "decoded_tokens", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "probabilities", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 9, name: "adjusted_probabilities", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 16, name: "logprobs", kind: "scalar", T: 1 /* ScalarType.DOUBLE */, repeated: true },
    { no: 10, name: "generated_length", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "stop_reason", kind: "enum", T: proto3.getEnumType(StopReason) },
    { no: 13, name: "filter_reasons", kind: "enum", T: proto3.getEnumType(FilterReason), repeated: true },
    { no: 14, name: "original_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tool_calls", kind: "message", T: ChatToolCall, repeated: true },
]);
/**
 * Next ID: 12, Previous field: eval_suffix_info.
 *
 * @generated from message exa.codeium_common_pb.StreamingCompletionInfo
 */
export class StreamingCompletionInfo extends Message {
    constructor(data) {
        super();
        /**
         * List of the completion uuid strings corresponding to each completion for a
         * sequence. The length of this list shall equal num_completions.
         * The i-th element of completion_ids will be the completion uuid for completion index
         * i (that is, the i-th completion of this sequence).
         *
         * @generated from field: repeated string completion_ids = 1;
         */
        this.completionIds = [];
        /**
         * @generated from field: uint64 max_tokens = 2;
         */
        this.maxTokens = protoInt64.zero;
        /**
         * @generated from field: double temperature = 3;
         */
        this.temperature = 0;
        /**
         * @generated from field: uint64 top_k = 4;
         */
        this.topK = protoInt64.zero;
        /**
         * @generated from field: double top_p = 5;
         */
        this.topP = 0;
        /**
         * @generated from field: repeated string stop_patterns = 6;
         */
        this.stopPatterns = [];
        /**
         * @generated from field: uint64 prompt_length = 7;
         */
        this.promptLength = protoInt64.zero;
        /**
         * Populated by the API server.
         *
         * @generated from field: string prompt_id = 9;
         */
        this.promptId = "";
        /**
         * @generated from field: string model_tag = 8;
         */
        this.modelTag = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingCompletionInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingCompletionInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingCompletionInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StreamingCompletionInfo, a, b);
    }
}
StreamingCompletionInfo.runtime = proto3;
StreamingCompletionInfo.typeName = "exa.codeium_common_pb.StreamingCompletionInfo";
StreamingCompletionInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completion_ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "max_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "temperature", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "top_k", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "top_p", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "stop_patterns", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "prompt_length", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "model_tag", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "completions_request", kind: "message", T: CompletionsRequest },
    { no: 11, name: "eval_suffix_info", kind: "message", T: StreamingEvalSuffixInfo },
]);
/**
 * @generated from message exa.codeium_common_pb.SingleModelCompletionProfile
 */
export class SingleModelCompletionProfile extends Message {
    constructor(data) {
        super();
        /**
         * Profile information for the completion
         *
         * @generated from field: double total_prefill_pass_time = 1;
         */
        this.totalPrefillPassTime = 0;
        /**
         * @generated from field: double avg_prefill_pass_time = 2;
         */
        this.avgPrefillPassTime = 0;
        /**
         * @generated from field: uint64 num_prefill_passes = 3;
         */
        this.numPrefillPasses = protoInt64.zero;
        /**
         * @generated from field: double total_spec_copy_pass_time = 7;
         */
        this.totalSpecCopyPassTime = 0;
        /**
         * @generated from field: double avg_spec_copy_pass_time = 8;
         */
        this.avgSpecCopyPassTime = 0;
        /**
         * @generated from field: uint64 num_spec_copy_passes = 9;
         */
        this.numSpecCopyPasses = protoInt64.zero;
        /**
         * @generated from field: double total_generation_pass_time = 4;
         */
        this.totalGenerationPassTime = 0;
        /**
         * @generated from field: double avg_generation_pass_time = 5;
         */
        this.avgGenerationPassTime = 0;
        /**
         * @generated from field: uint64 num_generation_passes = 6;
         */
        this.numGenerationPasses = protoInt64.zero;
        /**
         * @generated from field: double total_model_time = 10;
         */
        this.totalModelTime = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SingleModelCompletionProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SingleModelCompletionProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SingleModelCompletionProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SingleModelCompletionProfile, a, b);
    }
}
SingleModelCompletionProfile.runtime = proto3;
SingleModelCompletionProfile.typeName = "exa.codeium_common_pb.SingleModelCompletionProfile";
SingleModelCompletionProfile.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "total_prefill_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 2, name: "avg_prefill_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 3, name: "num_prefill_passes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "total_spec_copy_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 8, name: "avg_spec_copy_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "num_spec_copy_passes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "total_generation_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "avg_generation_pass_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "num_generation_passes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "total_model_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
]);
/**
 * @generated from message exa.codeium_common_pb.CompletionProfile
 */
export class CompletionProfile extends Message {
    constructor(data) {
        super();
        /**
         * Time from server receiving completion request to first prefill pass (i.e. time waiting in the
         * prefill queue)
         *
         * @generated from field: double time_to_first_prefill_pass = 3;
         */
        this.timeToFirstPrefillPass = 0;
        /**
         * Time from server receiving completion request to prefill completion
         *
         * @generated from field: double time_to_first_token = 4;
         */
        this.timeToFirstToken = 0;
        /**
         * Total time from server receiving completion request to end of completion
         *
         * @generated from field: double total_completion_time = 5;
         */
        this.totalCompletionTime = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionProfile().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionProfile().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionProfile().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionProfile, a, b);
    }
}
CompletionProfile.runtime = proto3;
CompletionProfile.typeName = "exa.codeium_common_pb.CompletionProfile";
CompletionProfile.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_profile", kind: "message", T: SingleModelCompletionProfile },
    { no: 2, name: "draft_model_profile", kind: "message", T: SingleModelCompletionProfile, opt: true },
    { no: 3, name: "time_to_first_prefill_pass", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "time_to_first_token", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "total_completion_time", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 6, name: "model_usage", kind: "message", T: ModelUsageStats, opt: true },
]);
/**
 * @generated from message exa.codeium_common_pb.StreamingCompletion
 */
export class StreamingCompletion extends Message {
    constructor(data) {
        super();
        /**
         * Note that we report back the decoded_token as bytes, because a single
         * token's corresponding bytes may not be valid UTF-8. It is the caller's
         * responsibility to concatenate these bytes and decode them in a valid manner.
         *
         * @generated from field: bytes decoded_token = 1;
         */
        this.decodedToken = new Uint8Array(0);
        /**
         * @generated from field: uint64 token = 2;
         */
        this.token = protoInt64.zero;
        /**
         * @generated from field: double probability = 3;
         */
        this.probability = 0;
        /**
         * @generated from field: double adjusted_probability = 4;
         */
        this.adjustedProbability = 0;
        /**
         * @generated from field: double logprob = 9;
         */
        this.logprob = 0;
        /**
         * If true, we are signaling to the caller that the completion is finished (i.e.
         * encountered stop pattern or reached max tokens), and guarantee that this will
         * never appear in the StreamingCompletionMap for subsequently written
         * StreamingCompletionResponse messages for this sequence.
         *
         * @generated from field: bool completion_finished = 5;
         */
        this.completionFinished = false;
        /**
         * Stop pattern for the completion if applicable.
         *
         * @generated from field: string stop = 6;
         */
        this.stop = "";
        /**
         * Optional server-side stop reason. Should be set when completion_finished is set
         * to true.
         *
         * @generated from field: exa.codeium_common_pb.StopReason stop_reason = 7;
         */
        this.stopReason = StopReason.UNSPECIFIED;
        /**
         * Map from offset within the decoded token to attribution status. This will
         * have entries for each newline byte or beginning of EOM token in the chunk.
         *
         * @generated from field: map<uint32, exa.codeium_common_pb.AttributionStatus> attribution_statuses = 8;
         */
        this.attributionStatuses = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingCompletion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingCompletion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingCompletion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StreamingCompletion, a, b);
    }
}
StreamingCompletion.runtime = proto3;
StreamingCompletion.typeName = "exa.codeium_common_pb.StreamingCompletion";
StreamingCompletion.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "decoded_token", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 2, name: "token", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 4, name: "adjusted_probability", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 9, name: "logprob", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 5, name: "completion_finished", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "stop", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "stop_reason", kind: "enum", T: proto3.getEnumType(StopReason) },
    { no: 8, name: "attribution_statuses", kind: "map", K: 13 /* ScalarType.UINT32 */, V: { kind: "enum", T: proto3.getEnumType(AttributionStatus) } },
]);
/**
 * @generated from message exa.codeium_common_pb.StreamingCompletionMap
 */
export class StreamingCompletionMap extends Message {
    constructor(data) {
        super();
        /**
         * Map the completion index to the StreamingCompletion containing the next token
         * for that completion. That is, completions[i] contains the next token for the i-th
         * completion of this sequence. Note that we need this because different completions
         * may end at different points, and after a completion reaches a stop pattern we
         * should stop writing StreamingCompletions for it to the stream.
         *
         * @generated from field: map<int32, exa.codeium_common_pb.StreamingCompletion> completions = 1;
         */
        this.completions = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingCompletionMap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingCompletionMap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingCompletionMap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StreamingCompletionMap, a, b);
    }
}
StreamingCompletionMap.runtime = proto3;
StreamingCompletionMap.typeName = "exa.codeium_common_pb.StreamingCompletionMap";
StreamingCompletionMap.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completions", kind: "map", K: 5 /* ScalarType.INT32 */, V: { kind: "message", T: StreamingCompletion } },
]);
/**
 * @generated from message exa.codeium_common_pb.PackedStreamingCompletionMaps
 */
export class PackedStreamingCompletionMaps extends Message {
    constructor(data) {
        super();
        /**
         * Packs StreamingCompletionMaps for multiple tokens into a single message.
         *
         * @generated from field: repeated exa.codeium_common_pb.StreamingCompletionMap completion_maps = 1;
         */
        this.completionMaps = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PackedStreamingCompletionMaps().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PackedStreamingCompletionMaps().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PackedStreamingCompletionMaps().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PackedStreamingCompletionMaps, a, b);
    }
}
PackedStreamingCompletionMaps.runtime = proto3;
PackedStreamingCompletionMaps.typeName = "exa.codeium_common_pb.PackedStreamingCompletionMaps";
PackedStreamingCompletionMaps.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completion_maps", kind: "message", T: StreamingCompletionMap, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.StreamingEvalSuffixInfo
 */
export class StreamingEvalSuffixInfo extends Message {
    constructor(data) {
        super();
        /**
         * The per-token log likelihood of the "eval suffix", which is a suffix
         * that is concatenated onto the "original" prompt (i.e. the prompt field
         * in the CompletionsRequest). Note that these log likelihoods are computed
         * conditional on the original prompt.
         *
         * @generated from field: repeated float per_token_log_likelihoods = 1;
         */
        this.perTokenLogLikelihoods = [];
        /**
         * Whether the eval suffix would have been generated by greedy sampling.
         *
         * @generated from field: bool is_greedy = 2;
         */
        this.isGreedy = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingEvalSuffixInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingEvalSuffixInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingEvalSuffixInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StreamingEvalSuffixInfo, a, b);
    }
}
StreamingEvalSuffixInfo.runtime = proto3;
StreamingEvalSuffixInfo.typeName = "exa.codeium_common_pb.StreamingEvalSuffixInfo";
StreamingEvalSuffixInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "per_token_log_likelihoods", kind: "scalar", T: 2 /* ScalarType.FLOAT */, repeated: true },
    { no: 2, name: "is_greedy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * When generating a completion, we shall first write a StreamingCompletionResponse
 * containing StreamingCompletionInfo to the stream. We shall then repeatedly write
 * StreamingCompletionResponse and/or PackedStreamingCompletionMaps messages
 * containing the StreamingCompletionMap for each generated token until all
 * completions are finished for this sequence.
 * We shall finally write a CompletionProfile containing latency profiling info
 * for the sequence
 *
 * @generated from message exa.codeium_common_pb.StreamingCompletionResponse
 */
export class StreamingCompletionResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.StreamingCompletionResponse.payload
         */
        this.payload = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new StreamingCompletionResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StreamingCompletionResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StreamingCompletionResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StreamingCompletionResponse, a, b);
    }
}
StreamingCompletionResponse.runtime = proto3;
StreamingCompletionResponse.typeName = "exa.codeium_common_pb.StreamingCompletionResponse";
StreamingCompletionResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completion_info", kind: "message", T: StreamingCompletionInfo, oneof: "payload" },
    { no: 2, name: "completion_map", kind: "message", T: StreamingCompletionMap, oneof: "payload" },
    { no: 4, name: "packed_completion_maps", kind: "message", T: PackedStreamingCompletionMaps, oneof: "payload" },
    { no: 5, name: "completion_profile", kind: "message", T: CompletionProfile, opt: true },
]);
/**
 * @generated from message exa.codeium_common_pb.CompletionLatencyInfo
 */
export class CompletionLatencyInfo extends Message {
    constructor(data) {
        super();
        /**
         * Full completion latencies.
         * API server-measured API server RPC latency.
         *
         * @generated from field: uint64 api_server_latency_ms = 1;
         */
        this.apiServerLatencyMs = protoInt64.zero;
        /**
         * Language server-measured API server RPC latency.
         *
         * @generated from field: uint64 language_server_latency_ms = 2;
         */
        this.languageServerLatencyMs = protoInt64.zero;
        /**
         * Network latency for API server RPC.
         *
         * @generated from field: uint64 network_latency_ms = 3;
         */
        this.networkLatencyMs = protoInt64.zero;
        /**
         * First byte latencies.
         *
         * @generated from field: uint64 api_server_first_byte_latency_ms = 4;
         */
        this.apiServerFirstByteLatencyMs = protoInt64.zero;
        /**
         * @generated from field: uint64 language_server_first_byte_latency_ms = 5;
         */
        this.languageServerFirstByteLatencyMs = protoInt64.zero;
        /**
         * @generated from field: uint64 network_first_byte_latency_ms = 6;
         */
        this.networkFirstByteLatencyMs = protoInt64.zero;
        /**
         * First line latencies.
         *
         * @generated from field: uint64 api_server_first_line_latency_ms = 7;
         */
        this.apiServerFirstLineLatencyMs = protoInt64.zero;
        /**
         * @generated from field: uint64 language_server_first_line_latency_ms = 8;
         */
        this.languageServerFirstLineLatencyMs = protoInt64.zero;
        /**
         * @generated from field: uint64 network_first_line_latency_ms = 9;
         */
        this.networkFirstLineLatencyMs = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionLatencyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionLatencyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionLatencyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionLatencyInfo, a, b);
    }
}
CompletionLatencyInfo.runtime = proto3;
CompletionLatencyInfo.typeName = "exa.codeium_common_pb.CompletionLatencyInfo";
CompletionLatencyInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "api_server_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "language_server_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "network_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "api_server_first_byte_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "language_server_first_byte_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "network_first_byte_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "api_server_first_line_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "language_server_first_line_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "network_first_line_latency_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.CompletionWithLatencyInfo
 */
export class CompletionWithLatencyInfo extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionWithLatencyInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionWithLatencyInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionWithLatencyInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionWithLatencyInfo, a, b);
    }
}
CompletionWithLatencyInfo.runtime = proto3;
CompletionWithLatencyInfo.typeName = "exa.codeium_common_pb.CompletionWithLatencyInfo";
CompletionWithLatencyInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completion", kind: "message", T: Completion },
    { no: 2, name: "latency_info", kind: "message", T: CompletionLatencyInfo },
]);
/**
 * @generated from message exa.codeium_common_pb.EmbeddingsRequest
 */
export class EmbeddingsRequest extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string prompts = 1;
         */
        this.prompts = [];
        /**
         * @generated from field: exa.codeium_common_pb.EmbeddingPriority priority = 2;
         */
        this.priority = EmbeddingPriority.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.EmbeddingPrefix prefix = 3;
         */
        this.prefix = EmbeddingPrefix.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 4;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EmbeddingsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbeddingsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbeddingsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbeddingsRequest, a, b);
    }
}
EmbeddingsRequest.runtime = proto3;
EmbeddingsRequest.typeName = "exa.codeium_common_pb.EmbeddingsRequest";
EmbeddingsRequest.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "prompts", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "priority", kind: "enum", T: proto3.getEnumType(EmbeddingPriority) },
    { no: 3, name: "prefix", kind: "enum", T: proto3.getEnumType(EmbeddingPrefix) },
    { no: 4, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
]);
/**
 * @generated from message exa.codeium_common_pb.Embedding
 */
export class Embedding extends Message {
    constructor(data) {
        super();
        /**
         * Represents a single embedding. values shall have length = embed_dim of the
         * embedding model.
         *
         * @generated from field: repeated float values = 1;
         */
        this.values = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Embedding().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Embedding().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Embedding().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Embedding, a, b);
    }
}
Embedding.runtime = proto3;
Embedding.typeName = "exa.codeium_common_pb.Embedding";
Embedding.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "scalar", T: 2 /* ScalarType.FLOAT */, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.EmbeddingResponse
 */
export class EmbeddingResponse extends Message {
    constructor(data) {
        super();
        /**
         * Embeddings returned in the same order as the prompts that were submitted in
         * the EmbeddingsRequest.
         *
         * @generated from field: repeated exa.codeium_common_pb.Embedding embeddings = 1;
         */
        this.embeddings = [];
        /**
         * @generated from field: bool prompts_exceeded_context_length = 2;
         */
        this.promptsExceededContextLength = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EmbeddingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbeddingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbeddingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbeddingResponse, a, b);
    }
}
EmbeddingResponse.runtime = proto3;
EmbeddingResponse.typeName = "exa.codeium_common_pb.EmbeddingResponse";
EmbeddingResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "embeddings", kind: "message", T: Embedding, repeated: true },
    { no: 2, name: "prompts_exceeded_context_length", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * NOTE: This is experimental, not used in production.
 * No longer supports batching -- only single request with a prefix and items.
 *
 * @generated from message exa.codeium_common_pb.RewardsRequest
 */
export class RewardsRequest extends Message {
    constructor(data) {
        super();
        /**
         * repeated string prompts = 1; // Items to score
         *
         * Prefix to items
         *
         * @generated from field: string prefix = 2;
         */
        this.prefix = "";
        /**
         * items should already be wrapped with any special tokens in string form.
         * The model relies on the hidden state of the last token, so that should usually
         * be a special token.
         *
         * @generated from field: repeated string items = 3;
         */
        this.items = [];
        /**
         * For llama models, wrap entire prompt in "[INST][/INST]\nRESPONSE:\n"
         *
         * @generated from field: bool has_instruct_tokens = 4;
         */
        this.hasInstructTokens = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RewardsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RewardsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RewardsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RewardsRequest, a, b);
    }
}
RewardsRequest.runtime = proto3;
RewardsRequest.typeName = "exa.codeium_common_pb.RewardsRequest";
RewardsRequest.fields = proto3.util.newFieldList(() => [
    { no: 2, name: "prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "items", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "has_instruct_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.RewardsResponse
 */
export class RewardsResponse extends Message {
    constructor(data) {
        super();
        /**
         * Scores returned in the same order as the prompts that were submitted in.
         *
         * @generated from field: repeated float values = 1;
         */
        this.values = [];
        /**
         * @generated from field: bool prompts_exceeded_context_length = 2;
         */
        this.promptsExceededContextLength = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RewardsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RewardsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RewardsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RewardsResponse, a, b);
    }
}
RewardsResponse.runtime = proto3;
RewardsResponse.typeName = "exa.codeium_common_pb.RewardsResponse";
RewardsResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "values", kind: "scalar", T: 2 /* ScalarType.FLOAT */, repeated: true },
    { no: 2, name: "prompts_exceeded_context_length", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Next ID: 29, Previous field: ide_type.
 *
 * @generated from message exa.codeium_common_pb.Metadata
 */
export class Metadata extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string ide_name = 1;
         */
        this.ideName = "";
        /**
         * @generated from field: string ide_version = 7;
         */
        this.ideVersion = "";
        /**
         * ide type example: "IntelliJ IDEA Ultimate Edition 2024.3.5"
         *
         * @generated from field: string ide_type = 28;
         */
        this.ideType = "";
        /**
         * @generated from field: string extension_name = 12;
         */
        this.extensionName = "";
        /**
         * @generated from field: string extension_version = 2;
         */
        this.extensionVersion = "";
        /**
         * Not a UUID check due to external auth source support.
         *
         * @generated from field: string api_key = 3;
         */
        this.apiKey = "";
        /**
         * TODO(prem): Should this be mandatory?
         *
         * @generated from field: string locale = 4;
         */
        this.locale = "";
        /**
         * JSON encoding of os version.
         *
         * @generated from field: string os = 5;
         */
        this.os = "";
        /**
         * JSON encoding of hardware version.
         *
         * @generated from field: string hardware = 8;
         */
        this.hardware = "";
        /**
         * Whether telemetry is disabled at an IDE level. Note that this is separate from
         * disabling code snippet telemetry.
         *
         * @generated from field: bool disable_telemetry = 6;
         */
        this.disableTelemetry = false;
        /**
         * UID identifying a single session for the given user.
         *
         * @generated from field: string session_id = 10;
         */
        this.sessionId = "";
        /**
         * Used purely in language server to cancel in flight requests.
         * If request_id is 0, then the request is not cancelable.
         * This should be a strictly monotonically increasing number
         * for the duration of a session.
         *
         * @generated from field: uint64 request_id = 9;
         */
        this.requestId = protoInt64.zero;
        /**
         * @generated from field: string source_address = 11;
         */
        this.sourceAddress = "";
        /**
         * Browser-specific information.
         *
         * @generated from field: string user_agent = 13;
         */
        this.userAgent = "";
        /**
         * @generated from field: string url = 14;
         */
        this.url = "";
        /**
         * Authentication source information.
         *
         * @generated from field: exa.codeium_common_pb.AuthSource auth_source = 15;
         */
        this.authSource = AuthSource.CODEIUM;
        /**
         * Path for extension (to determine VSCode Fork).
         *
         * @generated from field: string extension_path = 17;
         */
        this.extensionPath = "";
        /**
         * Metadata for origin of request.
         *
         * @generated from field: string user_id = 20;
         */
        this.userId = "";
        /**
         * JWT for authed user. Will be used instead of auth if provided (for supported API server RPCs).
         *
         * @generated from field: string user_jwt = 21;
         */
        this.userJwt = "";
        /**
         * Only used by Codeium internal team to forcefully target a specific service
         *
         * @generated from field: string force_team_id = 22;
         */
        this.forceTeamId = "";
        /**
         * @generated from field: string windsurf_version = 23;
         */
        this.windsurfVersion = "";
        /**
         * Used to prevent users from generating duplicate trial accounts. Populated by a library in Windsurf client.
         *
         * @generated from field: string device_fingerprint = 24;
         */
        this.deviceFingerprint = "";
        /**
         * Optional field to link different kinds of completion requests together.
         *
         * @generated from field: string trigger_id = 25;
         */
        this.triggerId = "";
        /**
         * Plan name of the user.
         *
         * @generated from field: string plan_name = 26;
         */
        this.planName = "";
        /**
         * Used to verify the authenticity of requests, currently only utilized by GetChatMessage.
         *
         * @generated from field: string id = 27;
         */
        this.id = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Metadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Metadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Metadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Metadata, a, b);
    }
}
Metadata.runtime = proto3;
Metadata.typeName = "exa.codeium_common_pb.Metadata";
Metadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "ide_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ide_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "ide_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "extension_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "extension_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "locale", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "os", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "hardware", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "disable_telemetry", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "ls_timestamp", kind: "message", T: Timestamp },
    { no: 9, name: "request_id", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 11, name: "source_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "user_agent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "auth_source", kind: "enum", T: proto3.getEnumType(AuthSource) },
    { no: 17, name: "extension_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 21, name: "user_jwt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "force_team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 23, name: "windsurf_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "device_fingerprint", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "trigger_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Next ID: 3, Previous field: insert_spaces.
 *
 * @generated from message exa.codeium_common_pb.EditorOptions
 */
export class EditorOptions extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 tab_size = 1;
         */
        this.tabSize = protoInt64.zero;
        /**
         * @generated from field: bool insert_spaces = 2;
         */
        this.insertSpaces = false;
        /**
         * @generated from field: bool disable_autocomplete_in_comments = 3;
         */
        this.disableAutocompleteInComments = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EditorOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EditorOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EditorOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EditorOptions, a, b);
    }
}
EditorOptions.runtime = proto3;
EditorOptions.typeName = "exa.codeium_common_pb.EditorOptions";
EditorOptions.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tab_size", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "insert_spaces", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "disable_autocomplete_in_comments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ErrorTrace
 */
export class ErrorTrace extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string error_id = 1;
         */
        this.errorId = "";
        /**
         * @generated from field: int64 timestamp_unix_ms = 2;
         */
        this.timestampUnixMs = protoInt64.zero;
        /**
         * @generated from field: string stacktrace = 3;
         */
        this.stacktrace = "";
        /**
         * @generated from field: bool recovered = 4;
         */
        this.recovered = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ErrorTrace().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ErrorTrace().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ErrorTrace().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ErrorTrace, a, b);
    }
}
ErrorTrace.runtime = proto3;
ErrorTrace.typeName = "exa.codeium_common_pb.ErrorTrace";
ErrorTrace.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "error_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "timestamp_unix_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "stacktrace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "recovered", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.Event
 */
export class Event extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.EventType event_type = 1;
         */
        this.eventType = EventType.UNSPECIFIED;
        /**
         * @generated from field: string event_json = 2;
         */
        this.eventJson = "";
        /**
         * @generated from field: int64 timestamp_unix_ms = 3;
         */
        this.timestampUnixMs = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Event().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Event().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Event().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Event, a, b);
    }
}
Event.runtime = proto3;
Event.typeName = "exa.codeium_common_pb.Event";
Event.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_type", kind: "enum", T: proto3.getEnumType(EventType) },
    { no: 2, name: "event_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "timestamp_unix_ms", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.SearchResultRecord
 */
export class SearchResultRecord extends Message {
    constructor(data) {
        super();
        /**
         * UUID for each search query.
         *
         * @generated from field: string search_id = 1;
         */
        this.searchId = "";
        /**
         * UUID for each search result.
         *
         * @generated from field: string result_id = 2;
         */
        this.resultId = "";
        /**
         * @generated from field: string absolute_path = 3;
         */
        this.absolutePath = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.WorkspacePath workspace_paths = 4;
         */
        this.workspacePaths = [];
        /**
         * The full text of the embedding match.
         *
         * @generated from field: string text = 5;
         */
        this.text = "";
        /**
         * @generated from field: float similarity_score = 7;
         */
        this.similarityScore = 0;
        /**
         * @generated from field: int64 num_results_in_cluster = 8;
         */
        this.numResultsInCluster = protoInt64.zero;
        /**
         * @generated from field: string representative_path = 9;
         */
        this.representativePath = "";
        /**
         * @generated from field: float mean_similarity_score = 10;
         */
        this.meanSimilarityScore = 0;
        /**
         * @generated from field: exa.codeium_common_pb.SearchResultType search_result_type = 11;
         */
        this.searchResultType = SearchResultType.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SearchResultRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SearchResultRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SearchResultRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SearchResultRecord, a, b);
    }
}
SearchResultRecord.runtime = proto3;
SearchResultRecord.typeName = "exa.codeium_common_pb.SearchResultRecord";
SearchResultRecord.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "search_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "result_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "absolute_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "workspace_paths", kind: "message", T: WorkspacePath, repeated: true },
    { no: 5, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "embedding_metadata", kind: "message", T: EmbeddingMetadata },
    { no: 7, name: "similarity_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 8, name: "num_results_in_cluster", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "representative_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "mean_similarity_score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 11, name: "search_result_type", kind: "enum", T: proto3.getEnumType(SearchResultType) },
]);
/**
 * Next ID: 4, Previous field: workspace_uri.
 *
 * @generated from message exa.codeium_common_pb.WorkspacePath
 */
export class WorkspacePath extends Message {
    constructor(data) {
        super();
        /**
         * Absolute path to root of the workspace.
         *
         * @generated from field: string workspace_migrate_me_to_uri = 1 [deprecated = true];
         * @deprecated
         */
        this.workspaceMigrateMeToUri = "";
        /**
         * @generated from field: string workspace_uri = 3;
         */
        this.workspaceUri = "";
        /**
         * Relative path to the search result file.
         *
         * @generated from field: string relative_path = 2;
         */
        this.relativePath = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WorkspacePath().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspacePath().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspacePath().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspacePath, a, b);
    }
}
WorkspacePath.runtime = proto3;
WorkspacePath.typeName = "exa.codeium_common_pb.WorkspacePath";
WorkspacePath.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace_migrate_me_to_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "workspace_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "relative_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Next ID: 5, Previous field: embed_type.
 *
 * @generated from message exa.codeium_common_pb.EmbeddingMetadata
 */
export class EmbeddingMetadata extends Message {
    constructor(data) {
        super();
        /**
         * Name of search result node in the file.
         *
         * @generated from field: string node_name = 1;
         */
        this.nodeName = "";
        /**
         * Line in the file where the search result starts. Inclusive.
         *
         * @generated from field: uint32 start_line = 2;
         */
        this.startLine = 0;
        /**
         * Line in the file where the search result ends. Inclusive.
         *
         * @generated from field: uint32 end_line = 3;
         */
        this.endLine = 0;
        /**
         * Embed type of the search result.
         *
         * @generated from field: exa.codeium_common_pb.EmbedType embed_type = 4;
         */
        this.embedType = EmbedType.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new EmbeddingMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new EmbeddingMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new EmbeddingMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(EmbeddingMetadata, a, b);
    }
}
EmbeddingMetadata.runtime = proto3;
EmbeddingMetadata.typeName = "exa.codeium_common_pb.EmbeddingMetadata";
EmbeddingMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "node_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "end_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "embed_type", kind: "enum", T: proto3.getEnumType(EmbedType) },
]);
/**
 * @generated from message exa.codeium_common_pb.MockResponseData
 */
export class MockResponseData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.Completion completions = 1;
         */
        this.completions = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MockResponseData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MockResponseData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MockResponseData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MockResponseData, a, b);
    }
}
MockResponseData.runtime = proto3;
MockResponseData.typeName = "exa.codeium_common_pb.MockResponseData";
MockResponseData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "completions", kind: "message", T: Completion, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.WorkspaceIndexData
 */
export class WorkspaceIndexData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string workspace_uri_for_telemetry = 1;
         */
        this.workspaceUriForTelemetry = "";
        /**
         * @generated from field: int64 num_files_total = 5;
         */
        this.numFilesTotal = protoInt64.zero;
        /**
         * @generated from field: int64 num_files_to_embed = 6;
         */
        this.numFilesToEmbed = protoInt64.zero;
        /**
         * @generated from field: int64 num_nodes_total = 7;
         */
        this.numNodesTotal = protoInt64.zero;
        /**
         * @generated from field: int64 num_nodes_to_embed = 8;
         */
        this.numNodesToEmbed = protoInt64.zero;
        /**
         * @generated from field: int64 num_tokens = 9;
         */
        this.numTokens = protoInt64.zero;
        /**
         * @generated from field: int64 num_high_priority_nodes_to_embed = 10;
         */
        this.numHighPriorityNodesToEmbed = protoInt64.zero;
        /**
         * @generated from field: string error = 11;
         */
        this.error = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WorkspaceIndexData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceIndexData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceIndexData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceIndexData, a, b);
    }
}
WorkspaceIndexData.runtime = proto3;
WorkspaceIndexData.typeName = "exa.codeium_common_pb.WorkspaceIndexData";
WorkspaceIndexData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "workspace_uri_for_telemetry", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "indexing_start", kind: "message", T: Timestamp },
    { no: 3, name: "indexing_end", kind: "message", T: Timestamp },
    { no: 4, name: "embedding_duration", kind: "message", T: Duration },
    { no: 5, name: "num_files_total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 6, name: "num_files_to_embed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "num_nodes_total", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "num_nodes_to_embed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "num_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "num_high_priority_nodes_to_embed", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.WorkspaceStats
 */
export class WorkspaceStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string workspace = 3;
         */
        this.workspace = "";
        /**
         * The keys are Languages.
         *
         * @generated from field: map<int32, int64> num_files = 1;
         */
        this.numFiles = {};
        /**
         * The keys are Languages.
         *
         * @generated from field: map<int32, int64> num_bytes = 2;
         */
        this.numBytes = {};
        /**
         * False if not all known files have been indexed, data may be incomplete.
         *
         * @generated from field: bool initial_scan_completed = 4;
         */
        this.initialScanCompleted = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WorkspaceStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WorkspaceStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WorkspaceStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WorkspaceStats, a, b);
    }
}
WorkspaceStats.runtime = proto3;
WorkspaceStats.typeName = "exa.codeium_common_pb.WorkspaceStats";
WorkspaceStats.fields = proto3.util.newFieldList(() => [
    { no: 3, name: "workspace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "num_files", kind: "map", K: 5 /* ScalarType.INT32 */, V: { kind: "scalar", T: 3 /* ScalarType.INT64 */ } },
    { no: 2, name: "num_bytes", kind: "map", K: 5 /* ScalarType.INT32 */, V: { kind: "scalar", T: 3 /* ScalarType.INT64 */ } },
    { no: 4, name: "initial_scan_completed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PartialIndexMetadata
 */
export class PartialIndexMetadata extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint32 num_total_files = 1;
         */
        this.numTotalFiles = 0;
        /**
         * @generated from field: uint32 num_indexed_files = 2;
         */
        this.numIndexedFiles = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PartialIndexMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PartialIndexMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PartialIndexMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PartialIndexMetadata, a, b);
    }
}
PartialIndexMetadata.runtime = proto3;
PartialIndexMetadata.typeName = "exa.codeium_common_pb.PartialIndexMetadata";
PartialIndexMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "num_total_files", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "num_indexed_files", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "cutoff_timestamp", kind: "message", T: Timestamp },
]);
/**
 * Proto representation for a FunctionInfo
 *
 * @generated from message exa.codeium_common_pb.FunctionInfo
 */
export class FunctionInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string raw_source = 1;
         */
        this.rawSource = "";
        /**
         * @generated from field: string clean_function = 2;
         */
        this.cleanFunction = "";
        /**
         * @generated from field: string docstring = 3;
         */
        this.docstring = "";
        /**
         * @generated from field: string node_name = 4;
         */
        this.nodeName = "";
        /**
         * @generated from field: string params = 5;
         */
        this.params = "";
        /**
         * @generated from field: int32 definition_line = 6;
         */
        this.definitionLine = 0;
        /**
         * 0-indexed (start & end).
         *
         * @generated from field: int32 start_line = 7;
         */
        this.startLine = 0;
        /**
         * @generated from field: int32 end_line = 8;
         */
        this.endLine = 0;
        /**
         * @generated from field: int32 start_col = 9;
         */
        this.startCol = 0;
        /**
         * Exclusive of (end_line, end_col).
         *
         * @generated from field: int32 end_col = 10;
         */
        this.endCol = 0;
        /**
         * @generated from field: string leading_whitespace = 11;
         */
        this.leadingWhitespace = "";
        /**
         * @generated from field: exa.codeium_common_pb.Language language = 12;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * @generated from field: int32 body_start_line = 13;
         */
        this.bodyStartLine = 0;
        /**
         * @generated from field: int32 body_start_col = 14;
         */
        this.bodyStartCol = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FunctionInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FunctionInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FunctionInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FunctionInfo, a, b);
    }
}
FunctionInfo.runtime = proto3;
FunctionInfo.typeName = "exa.codeium_common_pb.FunctionInfo";
FunctionInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "raw_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "clean_function", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "docstring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "node_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "params", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "definition_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "end_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "start_col", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "end_col", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "leading_whitespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 13, name: "body_start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "body_start_col", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * Proto representation for a ClassInfo
 *
 * @generated from message exa.codeium_common_pb.ClassInfo
 */
export class ClassInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string raw_source = 1;
         */
        this.rawSource = "";
        /**
         * @generated from field: int32 start_line = 2;
         */
        this.startLine = 0;
        /**
         * @generated from field: int32 end_line = 3;
         */
        this.endLine = 0;
        /**
         * @generated from field: int32 start_col = 4;
         */
        this.startCol = 0;
        /**
         * @generated from field: int32 end_col = 5;
         */
        this.endCol = 0;
        /**
         * @generated from field: string leading_whitespace = 6;
         */
        this.leadingWhitespace = "";
        /**
         * @generated from field: repeated string fields_and_constructors = 7;
         */
        this.fieldsAndConstructors = [];
        /**
         * @generated from field: string docstring = 8;
         */
        this.docstring = "";
        /**
         * @generated from field: string node_name = 9;
         */
        this.nodeName = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.FunctionInfo methods = 10;
         */
        this.methods = [];
        /**
         * @generated from field: repeated string node_lineage = 11;
         */
        this.nodeLineage = [];
        /**
         * @generated from field: bool is_exported = 12;
         */
        this.isExported = false;
        /**
         * @generated from field: exa.codeium_common_pb.Language language = 13;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * @generated from field: int32 definition_line = 14;
         */
        this.definitionLine = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClassInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClassInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClassInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClassInfo, a, b);
    }
}
ClassInfo.runtime = proto3;
ClassInfo.typeName = "exa.codeium_common_pb.ClassInfo";
ClassInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "raw_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "end_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "start_col", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "end_col", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "leading_whitespace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "fields_and_constructors", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "docstring", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "node_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "methods", kind: "message", T: FunctionInfo, repeated: true },
    { no: 11, name: "node_lineage", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "is_exported", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 14, name: "definition_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.TeamsFeaturesMetadata
 */
export class TeamsFeaturesMetadata extends Message {
    constructor(data) {
        super();
        /**
         * Whether the feature is currently used by the team
         *
         * @generated from field: bool is_active = 1;
         */
        this.isActive = false;
        /**
         * Stripe subscription ID for the feature if it's an add-on
         *
         * @generated from field: string stripe_subscription_id = 2;
         */
        this.stripeSubscriptionId = "";
        /**
         * Whether the team has access to the feature
         *
         * @generated from field: bool has_access = 3;
         */
        this.hasAccess = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TeamsFeaturesMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamsFeaturesMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamsFeaturesMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamsFeaturesMetadata, a, b);
    }
}
TeamsFeaturesMetadata.runtime = proto3;
TeamsFeaturesMetadata.typeName = "exa.codeium_common_pb.TeamsFeaturesMetadata";
TeamsFeaturesMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "is_active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "stripe_subscription_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "has_access", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Next ID: 14, Previous field: pricing_type
 *
 * @generated from message exa.codeium_common_pb.ClientModelConfig
 */
export class ClientModelConfig extends Message {
    constructor(data) {
        super();
        /**
         * Display name and used as a unique identifier
         *
         * @generated from field: string label = 1;
         */
        this.label = "";
        /**
         * Multiplier applied to credits used for this model.
         * Only applicable to MODEL_PRICING_TYPE_STATIC_CREDIT.
         *
         * @generated from field: float credit_multiplier = 3;
         */
        this.creditMultiplier = 0;
        /**
         * Pricing type for this model.
         *
         * @generated from field: exa.codeium_common_pb.ModelPricingType pricing_type = 13;
         */
        this.pricingType = ModelPricingType.UNSPECIFIED;
        /**
         * If true, the model is still rendered in the UI but is disabled.
         *
         * @generated from field: bool disabled = 4;
         */
        this.disabled = false;
        /**
         * @generated from field: bool supports_images = 5;
         */
        this.supportsImages = false;
        /**
         * If true, the model can be used in legacy mode.
         *
         * @generated from field: bool supports_legacy = 6;
         */
        this.supportsLegacy = false;
        /**
         * If true, the model will be shown in the premium models section.
         *
         * @generated from field: bool is_premium = 7;
         */
        this.isPremium = false;
        /**
         * A message to display when the model is beta.
         *
         * @generated from field: string beta_warning_message = 8;
         */
        this.betaWarningMessage = "";
        /**
         * If true, the model is beta.
         *
         * @generated from field: bool is_beta = 9;
         */
        this.isBeta = false;
        /**
         * The provider of the model.
         *
         * @generated from field: exa.codeium_common_pb.ModelProvider provider = 10;
         */
        this.provider = ModelProvider.UNSPECIFIED;
        /**
         * If true, the model is recommended to users.
         *
         * @generated from field: bool is_recommended = 11;
         */
        this.isRecommended = false;
        /**
         * Allowed Tiers for Command Models
         *
         * @generated from field: repeated exa.codeium_common_pb.TeamsTier allowed_tiers = 12;
         */
        this.allowedTiers = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClientModelConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientModelConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientModelConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientModelConfig, a, b);
    }
}
ClientModelConfig.runtime = proto3;
ClientModelConfig.typeName = "exa.codeium_common_pb.ClientModelConfig";
ClientModelConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "model_or_alias", kind: "message", T: ModelOrAlias },
    { no: 3, name: "credit_multiplier", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 13, name: "pricing_type", kind: "enum", T: proto3.getEnumType(ModelPricingType) },
    { no: 4, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "supports_images", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "supports_legacy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "is_premium", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "beta_warning_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "is_beta", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "provider", kind: "enum", T: proto3.getEnumType(ModelProvider) },
    { no: 11, name: "is_recommended", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "allowed_tiers", kind: "enum", T: proto3.getEnumType(TeamsTier), repeated: true },
]);
/**
 * Config to set the defaulted selected model for new users or override current users.
 *
 * @generated from message exa.codeium_common_pb.DefaultOverrideModelConfig
 */
export class DefaultOverrideModelConfig extends Message {
    constructor(data) {
        super();
        /**
         * Version to differentiate when the client should override or keep last selected user model.
         *
         * @generated from field: string version_id = 2;
         */
        this.versionId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DefaultOverrideModelConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DefaultOverrideModelConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DefaultOverrideModelConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DefaultOverrideModelConfig, a, b);
    }
}
DefaultOverrideModelConfig.runtime = proto3;
DefaultOverrideModelConfig.typeName = "exa.codeium_common_pb.DefaultOverrideModelConfig";
DefaultOverrideModelConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_or_alias", kind: "message", T: ModelOrAlias },
    { no: 2, name: "version_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ClientModelSort
 */
export class ClientModelSort extends Message {
    constructor(data) {
        super();
        /**
         * Name of the sort within the Cascade model selector (e.g. "Recommended", "Provider", "Cost").
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * Groups of models within this sort.
         *
         * @generated from field: repeated exa.codeium_common_pb.ClientModelGroup groups = 2;
         */
        this.groups = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClientModelSort().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientModelSort().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientModelSort().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientModelSort, a, b);
    }
}
ClientModelSort.runtime = proto3;
ClientModelSort.typeName = "exa.codeium_common_pb.ClientModelSort";
ClientModelSort.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "groups", kind: "message", T: ClientModelGroup, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.ClientModelGroup
 */
export class ClientModelGroup extends Message {
    constructor(data) {
        super();
        /**
         * Name of the group in a ClientModelSort. Can be empty if sort is ungrouped (e.g. "Recommended" sort).
         *
         * @generated from field: string group_name = 1;
         */
        this.groupName = "";
        /**
         * List of model labels in this group.
         *
         * @generated from field: repeated string model_labels = 2;
         */
        this.modelLabels = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClientModelGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClientModelGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClientModelGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClientModelGroup, a, b);
    }
}
ClientModelGroup.runtime = proto3;
ClientModelGroup.typeName = "exa.codeium_common_pb.ClientModelGroup";
ClientModelGroup.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "group_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "model_labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * Encapsulates all cascade model configuration data for the user
 *
 * @generated from message exa.codeium_common_pb.CascadeModelConfigData
 */
export class CascadeModelConfigData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.ClientModelConfig client_model_configs = 1;
         */
        this.clientModelConfigs = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.ClientModelSort client_model_sorts = 2;
         */
        this.clientModelSorts = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CascadeModelConfigData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CascadeModelConfigData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CascadeModelConfigData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CascadeModelConfigData, a, b);
    }
}
CascadeModelConfigData.runtime = proto3;
CascadeModelConfigData.typeName = "exa.codeium_common_pb.CascadeModelConfigData";
CascadeModelConfigData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "client_model_configs", kind: "message", T: ClientModelConfig, repeated: true },
    { no: 2, name: "client_model_sorts", kind: "message", T: ClientModelSort, repeated: true },
    { no: 3, name: "default_override_model_config", kind: "message", T: DefaultOverrideModelConfig, opt: true },
]);
/**
 * @generated from message exa.codeium_common_pb.AllowedModelConfig
 */
export class AllowedModelConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: float credit_multiplier = 2;
         */
        this.creditMultiplier = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new AllowedModelConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new AllowedModelConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new AllowedModelConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(AllowedModelConfig, a, b);
    }
}
AllowedModelConfig.runtime = proto3;
AllowedModelConfig.typeName = "exa.codeium_common_pb.AllowedModelConfig";
AllowedModelConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_or_alias", kind: "message", T: ModelOrAlias },
    { no: 2, name: "credit_multiplier", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
]);
/**
 * Encodes all information about a plan for all users (free and paid).
 * IMPORTANT: it is not safe to rename or remove (but reserve is ok) any fields since this object
 * is serialized in JSON format when passed in the UserStatus JWT.
 * NEXT ID: 31, Previous field: default_team_features
 * Reserved field "max_unclaimed_sites" (26) moved to TeamConfig
 *
 * @generated from message exa.codeium_common_pb.PlanInfo
 */
export class PlanInfo extends Message {
    constructor(data) {
        super();
        /**
         * If the user is not on a team, this will be UNSPECIFIED.
         *
         * @generated from field: exa.codeium_common_pb.TeamsTier teams_tier = 1;
         */
        this.teamsTier = TeamsTier.UNSPECIFIED;
        /**
         * Human readable name of the plan to display to the user.
         *
         * @generated from field: string plan_name = 2;
         */
        this.planName = "";
        /**
         * Boolean feature gates
         *
         * @generated from field: bool has_autocomplete_fast_mode = 3;
         */
        this.hasAutocompleteFastMode = false;
        /**
         * @generated from field: bool allow_sticky_premium_models = 4;
         */
        this.allowStickyPremiumModels = false;
        /**
         * @generated from field: bool has_forge_access = 5;
         */
        this.hasForgeAccess = false;
        /**
         * @generated from field: bool disable_code_snippet_telemetry = 11;
         */
        this.disableCodeSnippetTelemetry = false;
        /**
         * @generated from field: bool allow_premium_command_models = 15;
         */
        this.allowPremiumCommandModels = false;
        /**
         * @generated from field: bool has_tab_to_jump = 23;
         */
        this.hasTabToJump = false;
        /**
         * Feature limits & quotas. A value of -1 would indicate unlimited.
         *
         * @generated from field: int64 max_num_premium_chat_messages = 6;
         */
        this.maxNumPremiumChatMessages = protoInt64.zero;
        /**
         * Limit on the number of tokens in a user's chat message.
         *
         * @generated from field: int64 max_num_chat_input_tokens = 7;
         */
        this.maxNumChatInputTokens = protoInt64.zero;
        /**
         * @generated from field: int64 max_custom_chat_instruction_characters = 8;
         */
        this.maxCustomChatInstructionCharacters = protoInt64.zero;
        /**
         * @generated from field: int64 max_num_pinned_context_items = 9;
         */
        this.maxNumPinnedContextItems = protoInt64.zero;
        /**
         * @generated from field: int64 max_local_index_size = 10;
         */
        this.maxLocalIndexSize = protoInt64.zero;
        /**
         * Maximum number of unclaimed sites for Windsurf deployments a user can have based on their plan.
         * This field is deprecated; and moved into TeamConfig instead.
         *
         * @generated from field: int32 max_unclaimed_sites = 26 [deprecated = true];
         * @deprecated
         */
        this.maxUnclaimedSites = 0;
        /**
         * @generated from field: int32 monthly_prompt_credits = 12;
         */
        this.monthlyPromptCredits = 0;
        /**
         * @generated from field: int32 monthly_flow_credits = 13;
         */
        this.monthlyFlowCredits = 0;
        /**
         * @generated from field: int32 monthly_flex_credit_purchase_amount = 14;
         */
        this.monthlyFlexCreditPurchaseAmount = 0;
        /**
         * Properties of the Plan
         * If the plan allows multiple users.
         *
         * @generated from field: bool is_teams = 17;
         */
        this.isTeams = false;
        /**
         * If the plan is enterprise.
         *
         * @generated from field: bool is_enterprise = 16;
         */
        this.isEnterprise = false;
        /**
         * Only users with a paid plan can purchase more credits. Free/trial will need to upgrade first.
         *
         * @generated from field: bool can_buy_more_credits = 18;
         */
        this.canBuyMoreCredits = false;
        /**
         * Whether the user has web search enabled (enterprise admins have the option to enable or disable it).
         *
         * @generated from field: bool cascade_web_search_enabled = 19;
         */
        this.cascadeWebSearchEnabled = false;
        /**
         * Whether we permit the user to customize their app icon.
         *
         * @generated from field: bool can_customize_app_icon = 20;
         */
        this.canCustomizeAppIcon = false;
        /**
         * Whether the user can enable Cascade to automatically run commands.
         *
         * @generated from field: bool cascade_can_auto_run_commands = 22;
         */
        this.cascadeCanAutoRunCommands = false;
        /**
         * Whether the user can use the AI-generated commit message feature.
         *
         * @generated from field: bool can_generate_commit_messages = 25;
         */
        this.canGenerateCommitMessages = false;
        /**
         * Whether the knowledge base feature is enabled for this user.
         *
         * @generated from field: bool knowledge_base_enabled = 27;
         */
        this.knowledgeBaseEnabled = false;
        /**
         * List of models this user is allowed to use and their credit multipliers.
         *
         * @generated from field: repeated exa.codeium_common_pb.AllowedModelConfig cascade_allowed_models_config = 21 [deprecated = true];
         * @deprecated
         */
        this.cascadeAllowedModelsConfig = [];
        /**
         * Whether the user can share conversations.
         *
         * @generated from field: bool can_share_conversations = 28;
         */
        this.canShareConversations = false;
        /**
         * Whether the user can allow Cascade to run in the background.
         *
         * @generated from field: bool can_allow_cascade_in_background = 29;
         */
        this.canAllowCascadeInBackground = false;
        /**
         * Map of team features that are enabled by default for this plan
         * Key is the int32 value of TeamsFeatures enum, value is whether it's enabled
         *
         * @generated from field: map<int32, exa.codeium_common_pb.TeamsFeaturesMetadata> default_team_features = 30;
         */
        this.defaultTeamFeatures = {};
        /**
         * Whether the user can access Browser.
         *
         * @generated from field: bool browser_enabled = 31;
         */
        this.browserEnabled = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlanInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlanInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlanInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlanInfo, a, b);
    }
}
PlanInfo.runtime = proto3;
PlanInfo.typeName = "exa.codeium_common_pb.PlanInfo";
PlanInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "teams_tier", kind: "enum", T: proto3.getEnumType(TeamsTier) },
    { no: 2, name: "plan_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "has_autocomplete_fast_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "allow_sticky_premium_models", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "has_forge_access", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "disable_code_snippet_telemetry", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "allow_premium_command_models", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "has_tab_to_jump", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "max_num_premium_chat_messages", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: "max_num_chat_input_tokens", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 8, name: "max_custom_chat_instruction_characters", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "max_num_pinned_context_items", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 10, name: "max_local_index_size", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 26, name: "max_unclaimed_sites", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "monthly_prompt_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 13, name: "monthly_flow_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "monthly_flex_credit_purchase_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 17, name: "is_teams", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 16, name: "is_enterprise", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "can_buy_more_credits", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "cascade_web_search_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "can_customize_app_icon", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "cascade_can_auto_run_commands", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "can_generate_commit_messages", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "knowledge_base_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "cascade_allowed_models_config", kind: "message", T: AllowedModelConfig, repeated: true },
    { no: 24, name: "default_team_config", kind: "message", T: TeamConfig },
    { no: 28, name: "can_share_conversations", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 29, name: "can_allow_cascade_in_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "default_team_features", kind: "map", K: 5 /* ScalarType.INT32 */, V: { kind: "message", T: TeamsFeaturesMetadata } },
    { no: 31, name: "browser_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.TopUpStatus
 */
export class TopUpStatus extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.TransactionStatus top_up_transaction_status = 1;
         */
        this.topUpTransactionStatus = TransactionStatus.UNSPECIFIED;
        /**
         * @generated from field: bool top_up_enabled = 2;
         */
        this.topUpEnabled = false;
        /**
         * @generated from field: int32 monthly_top_up_amount = 3;
         */
        this.monthlyTopUpAmount = 0;
        /**
         * @generated from field: int32 top_up_spent = 4;
         */
        this.topUpSpent = 0;
        /**
         * @generated from field: int32 top_up_increment = 5;
         */
        this.topUpIncrement = 0;
        /**
         * @generated from field: bool top_up_criteria_met = 6;
         */
        this.topUpCriteriaMet = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TopUpStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TopUpStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TopUpStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TopUpStatus, a, b);
    }
}
TopUpStatus.runtime = proto3;
TopUpStatus.typeName = "exa.codeium_common_pb.TopUpStatus";
TopUpStatus.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "top_up_transaction_status", kind: "enum", T: proto3.getEnumType(TransactionStatus) },
    { no: 2, name: "top_up_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "monthly_top_up_amount", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "top_up_spent", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "top_up_increment", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "top_up_criteria_met", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PlanStatus
 */
export class PlanStatus extends Message {
    constructor(data) {
        super();
        /**
         * All credits will return in cents. (ie 1 flow usage uses 100 credits).
         *
         * @generated from field: int32 available_prompt_credits = 8;
         */
        this.availablePromptCredits = 0;
        /**
         * Available flow credits = monthly flow credits * # users.
         *
         * @generated from field: int32 available_flow_credits = 9;
         */
        this.availableFlowCredits = 0;
        /**
         * @generated from field: int32 available_flex_credits = 4;
         */
        this.availableFlexCredits = 0;
        /**
         * @generated from field: int32 used_flex_credits = 7;
         */
        this.usedFlexCredits = 0;
        /**
         * @generated from field: int32 used_flow_credits = 5;
         */
        this.usedFlowCredits = 0;
        /**
         * @generated from field: int32 used_prompt_credits = 6;
         */
        this.usedPromptCredits = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PlanStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PlanStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PlanStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PlanStatus, a, b);
    }
}
PlanStatus.runtime = proto3;
PlanStatus.typeName = "exa.codeium_common_pb.PlanStatus";
PlanStatus.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_info", kind: "message", T: PlanInfo },
    { no: 2, name: "plan_start", kind: "message", T: Timestamp },
    { no: 3, name: "plan_end", kind: "message", T: Timestamp },
    { no: 8, name: "available_prompt_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "available_flow_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "available_flex_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "used_flex_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "used_flow_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "used_prompt_credits", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "top_up_status", kind: "message", T: TopUpStatus },
]);
/**
 * Next ID: 34; Reserved: 10; Previous field: cascade_model_config_data
 *
 * @generated from message exa.codeium_common_pb.UserStatus
 */
export class UserStatus extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool pro = 1;
         */
        this.pro = false;
        /**
         * Whether the user has opted out of code-snippet telemetry. Note that this is separate from
         * disabling telemetry at an IDE level.
         *
         * @generated from field: bool disable_telemetry = 2;
         */
        this.disableTelemetry = false;
        /**
         * @generated from field: string name = 3;
         */
        this.name = "";
        /**
         * @generated from field: bool ignore_chat_telemetry_setting = 4;
         */
        this.ignoreChatTelemetrySetting = false;
        /**
         * WARNING: naming is a bit misleading (for legacy reasons). If this field is nonempty, then the user is a paid user. This is separate from the Teams plan tier; see the isTeams field on PlanInfo.
         *
         * @generated from field: string team_id = 5;
         */
        this.teamId = "";
        /**
         * @generated from field: exa.codeium_common_pb.UserTeamStatus team_status = 6;
         */
        this.teamStatus = UserTeamStatus.UNSPECIFIED;
        /**
         * @generated from field: string email = 7;
         */
        this.email = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.UserFeatures user_features = 9;
         */
        this.userFeatures = [];
        /**
         * Only applicable if user is approved in a valid team.
         *
         * @generated from field: repeated exa.codeium_common_pb.TeamsFeatures teams_features = 8;
         */
        this.teamsFeatures = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.Permission permissions = 11;
         */
        this.permissions = [];
        /**
         * @generated from field: bool has_used_windsurf = 31;
         */
        this.hasUsedWindsurf = false;
        /**
         * All credits will return in cents. (ie 1 flow usage uses 100 credits).
         *
         * @generated from field: int64 user_used_prompt_credits = 28;
         */
        this.userUsedPromptCredits = protoInt64.zero;
        /**
         * @generated from field: int64 user_used_flow_credits = 29;
         */
        this.userUsedFlowCredits = protoInt64.zero;
        /**
         * @generated from field: bool has_fingerprint_set = 30;
         */
        this.hasFingerprintSet = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UserStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserStatus, a, b);
    }
}
UserStatus.runtime = proto3;
UserStatus.typeName = "exa.codeium_common_pb.UserStatus";
UserStatus.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "pro", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "disable_telemetry", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ignore_chat_telemetry_setting", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "team_status", kind: "enum", T: proto3.getEnumType(UserTeamStatus) },
    { no: 7, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "user_features", kind: "enum", T: proto3.getEnumType(UserFeatures), repeated: true },
    { no: 8, name: "teams_features", kind: "enum", T: proto3.getEnumType(TeamsFeatures), repeated: true },
    { no: 11, name: "permissions", kind: "enum", T: proto3.getEnumType(Permission), repeated: true },
    { no: 12, name: "plan_info", kind: "message", T: PlanInfo },
    { no: 13, name: "plan_status", kind: "message", T: PlanStatus },
    { no: 31, name: "has_used_windsurf", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 28, name: "user_used_prompt_credits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 29, name: "user_used_flow_credits", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 30, name: "has_fingerprint_set", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 32, name: "team_config", kind: "message", T: TeamConfig },
    { no: 33, name: "cascade_model_config_data", kind: "message", T: CascadeModelConfigData },
]);
/**
 * @generated from message exa.codeium_common_pb.ScmWorkspaceInfo
 */
export class ScmWorkspaceInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.ScmWorkspaceInfo.info
         */
        this.info = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ScmWorkspaceInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ScmWorkspaceInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ScmWorkspaceInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ScmWorkspaceInfo, a, b);
    }
}
ScmWorkspaceInfo.runtime = proto3;
ScmWorkspaceInfo.typeName = "exa.codeium_common_pb.ScmWorkspaceInfo";
ScmWorkspaceInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "perforce_info", kind: "message", T: PerforceDepotInfo, oneof: "info" },
    { no: 2, name: "git_info", kind: "message", T: GitRepoInfo, oneof: "info" },
]);
/**
 * @generated from message exa.codeium_common_pb.PerforceDepotInfo
 */
export class PerforceDepotInfo extends Message {
    constructor(data) {
        super();
        /**
         * Unique name of the repository, commonly //depot/project.
         *
         * @generated from field: string depot_name = 1;
         */
        this.depotName = "";
        /**
         * Optional name to identify the version of this repo.
         *
         * @generated from field: string version_alias = 2;
         */
        this.versionAlias = "";
        /**
         * e.g p4d://host:port
         *
         * @generated from field: string base_p4d_url = 3;
         */
        this.baseP4dUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PerforceDepotInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PerforceDepotInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PerforceDepotInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PerforceDepotInfo, a, b);
    }
}
PerforceDepotInfo.runtime = proto3;
PerforceDepotInfo.typeName = "exa.codeium_common_pb.PerforceDepotInfo";
PerforceDepotInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "depot_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version_alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "base_p4d_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.GitRepoInfo
 */
export class GitRepoInfo extends Message {
    constructor(data) {
        super();
        /**
         * Prefer using repo_name.
         *
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: string owner = 2;
         */
        this.owner = "";
        /**
         * Unique name of the repository, commonly owner/name.
         *
         * @generated from field: string repo_name = 5;
         */
        this.repoName = "";
        /**
         * @generated from field: string commit = 3;
         */
        this.commit = "";
        /**
         * Optional name to identify the version of this repo.
         *
         * @generated from field: string version_alias = 4;
         */
        this.versionAlias = "";
        /**
         * @generated from field: exa.codeium_common_pb.ScmProvider scm_provider = 6;
         */
        this.scmProvider = ScmProvider.UNSPECIFIED;
        /**
         * e.g https://github.com/ or https://gitent.exafunction.com/
         *
         * @generated from field: string base_git_url = 7;
         */
        this.baseGitUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GitRepoInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GitRepoInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GitRepoInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GitRepoInfo, a, b);
    }
}
GitRepoInfo.runtime = proto3;
GitRepoInfo.typeName = "exa.codeium_common_pb.GitRepoInfo";
GitRepoInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "repo_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "commit", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "version_alias", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "scm_provider", kind: "enum", T: proto3.getEnumType(ScmProvider) },
    { no: 7, name: "base_git_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Next ID: 17, Previous field: absolute_uri.
 *
 * @generated from message exa.codeium_common_pb.CodeContextItem
 */
export class CodeContextItem extends Message {
    constructor(data) {
        super();
        /**
         * Absolute path to file this CodeContextItem belongs to.
         *
         * @generated from field: string absolute_path_migrate_me_to_uri = 1 [deprecated = true];
         * @deprecated
         */
        this.absolutePathMigrateMeToUri = "";
        /**
         * @generated from field: string absolute_uri = 16;
         */
        this.absoluteUri = "";
        /**
         * Path relative to workspace roots. CodeContextItem may not always be within a workspace.
         *
         * @generated from field: repeated exa.codeium_common_pb.WorkspacePath workspace_paths = 2;
         */
        this.workspacePaths = [];
        /**
         * Name of node in the file.
         *
         * @generated from field: string node_name = 3;
         */
        this.nodeName = "";
        /**
         * List of parent nodes in descending order.
         *
         * @generated from field: repeated string node_lineage = 4;
         */
        this.nodeLineage = [];
        /**
         * 0-indexed (everything).
         * Line in the file where the CodeContextItem starts. Inclusive.
         *
         * @generated from field: uint32 start_line = 5;
         */
        this.startLine = 0;
        /**
         * Col in the file where the CodeContextItem starts. Inclusive.
         *
         * @generated from field: uint32 start_col = 12;
         */
        this.startCol = 0;
        /**
         * Line in the file where the CodeContextItem ends. Inclusive.
         *
         * @generated from field: uint32 end_line = 6;
         */
        this.endLine = 0;
        /**
         * Col in the file where the CodeContextItem ends. Exclusive.
         *
         * @generated from field: uint32 end_col = 13;
         */
        this.endCol = 0;
        /**
         * What kind of code snippet it is.
         *
         * @generated from field: exa.codeium_common_pb.CodeContextType context_type = 7;
         */
        this.contextType = CodeContextType.UNSPECIFIED;
        /**
         * Language.
         *
         * @generated from field: exa.codeium_common_pb.Language language = 10;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * A map for each ContextSnippetType representation of this CodeContextItem to a SnippetWithWordcount item.
         *
         * @generated from field: map<string, exa.codeium_common_pb.SnippetWithWordCount> snippet_by_type = 11;
         */
        this.snippetByType = {};
        /**
         * MD5 sum of the file contents that this code context item belongs to.
         *
         * @generated from field: bytes file_content_hash = 15;
         */
        this.fileContentHash = new Uint8Array(0);
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodeContextItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodeContextItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodeContextItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodeContextItem, a, b);
    }
}
CodeContextItem.runtime = proto3;
CodeContextItem.typeName = "exa.codeium_common_pb.CodeContextItem";
CodeContextItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "absolute_path_migrate_me_to_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "absolute_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_paths", kind: "message", T: WorkspacePath, repeated: true },
    { no: 3, name: "node_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "node_lineage", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "start_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "start_col", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "end_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 13, name: "end_col", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "context_type", kind: "enum", T: proto3.getEnumType(CodeContextType) },
    { no: 10, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 11, name: "snippet_by_type", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: SnippetWithWordCount } },
    { no: 14, name: "repo_info", kind: "message", T: GitRepoInfo },
    { no: 15, name: "file_content_hash", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
/**
 * A string representation of the CodeContextItem, together with the word counts of that representation.
 *
 * @generated from message exa.codeium_common_pb.SnippetWithWordCount
 */
export class SnippetWithWordCount extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string snippet = 1;
         */
        this.snippet = "";
        /**
         * There is one word count per Word Splitter type, where a Word Splitter is a particular algorithm for breaking a string into "words".
         *
         * @generated from field: map<string, exa.codeium_common_pb.WordCount> word_count_by_splitter = 2;
         */
        this.wordCountBySplitter = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SnippetWithWordCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SnippetWithWordCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SnippetWithWordCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SnippetWithWordCount, a, b);
    }
}
SnippetWithWordCount.runtime = proto3;
SnippetWithWordCount.typeName = "exa.codeium_common_pb.SnippetWithWordCount";
SnippetWithWordCount.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "word_count_by_splitter", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: WordCount } },
]);
/**
 * A map for each word for the number of times each word appears in the snippet.
 *
 * @generated from message exa.codeium_common_pb.WordCount
 */
export class WordCount extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: map<string, int64> word_count_map = 1;
         */
        this.wordCountMap = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WordCount().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WordCount().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WordCount().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WordCount, a, b);
    }
}
WordCount.runtime = proto3;
WordCount.typeName = "exa.codeium_common_pb.WordCount";
WordCount.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "word_count_map", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 3 /* ScalarType.INT64 */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.Repository
 */
export class Repository extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string computed_name = 1;
         */
        this.computedName = "";
        /**
         * @generated from field: string git_origin_url = 2;
         */
        this.gitOriginUrl = "";
        /**
         * @generated from field: string git_upstream_url = 3;
         */
        this.gitUpstreamUrl = "";
        /**
         * @generated from field: string reported_name = 4;
         */
        this.reportedName = "";
        /**
         * @generated from field: string model_name = 5;
         */
        this.modelName = "";
        /**
         * @generated from field: string submodule_url = 6;
         */
        this.submoduleUrl = "";
        /**
         * @generated from field: string submodule_path = 7;
         */
        this.submodulePath = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Repository().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Repository().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Repository().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Repository, a, b);
    }
}
Repository.runtime = proto3;
Repository.typeName = "exa.codeium_common_pb.Repository";
Repository.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "computed_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "git_origin_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "git_upstream_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reported_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "submodule_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "submodule_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * General data shared between capture file protos.
 *
 * @generated from message exa.codeium_common_pb.CaptureFileRequestData
 */
export class CaptureFileRequestData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string prompt_id = 2;
         */
        this.promptId = "";
        /**
         * absolute file path.
         *
         * @generated from field: string file_path = 3;
         */
        this.filePath = "";
        /**
         * @generated from field: string original_file_content = 4;
         */
        this.originalFileContent = "";
        /**
         * @generated from field: string completion_text = 5;
         */
        this.completionText = "";
        /**
         * start of replacement range for completion (measured in bytes).
         *
         * @generated from field: uint64 start_offset = 6;
         */
        this.startOffset = protoInt64.zero;
        /**
         * start of replacement range for completion (measured in bytes).
         *
         * @generated from field: uint64 end_offset = 7;
         */
        this.endOffset = protoInt64.zero;
        /**
         * what line the cursor is on.
         *
         * @generated from field: uint64 cursor_line = 8;
         */
        this.cursorLine = protoInt64.zero;
        /**
         * which column within that line is the cursor on.
         *
         * @generated from field: uint64 cursor_column = 9;
         */
        this.cursorColumn = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CaptureFileRequestData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CaptureFileRequestData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CaptureFileRequestData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CaptureFileRequestData, a, b);
    }
}
CaptureFileRequestData.runtime = proto3;
CaptureFileRequestData.typeName = "exa.codeium_common_pb.CaptureFileRequestData";
CaptureFileRequestData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "metadata", kind: "message", T: Metadata },
    { no: 2, name: "prompt_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "original_file_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "completion_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "start_offset", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "end_offset", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "cursor_line", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "cursor_column", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * Aggregated completion statistics.
 *
 * @generated from message exa.codeium_common_pb.CompletionStatistics
 */
export class CompletionStatistics extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint32 num_acceptances = 1;
         */
        this.numAcceptances = 0;
        /**
         * @generated from field: uint32 num_rejections = 2;
         */
        this.numRejections = 0;
        /**
         * @generated from field: uint32 num_lines_accepted = 3;
         */
        this.numLinesAccepted = 0;
        /**
         * @generated from field: uint32 num_bytes_accepted = 4;
         */
        this.numBytesAccepted = 0;
        /**
         * @generated from field: uint32 num_users = 5;
         */
        this.numUsers = 0;
        /**
         * The total number of days spent using the tool across all developers during the period.
         *
         * @generated from field: uint32 active_developer_days = 6;
         */
        this.activeDeveloperDays = 0;
        /**
         * The total number of hours spent using the tool across all developers during the period.
         *
         * @generated from field: uint32 active_developer_hours = 7;
         */
        this.activeDeveloperHours = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionStatistics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionStatistics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionStatistics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionStatistics, a, b);
    }
}
CompletionStatistics.runtime = proto3;
CompletionStatistics.typeName = "exa.codeium_common_pb.CompletionStatistics";
CompletionStatistics.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "num_acceptances", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "num_rejections", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "num_lines_accepted", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "num_bytes_accepted", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "num_users", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "active_developer_days", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "active_developer_hours", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * Completion statistics for a single day.
 *
 * @generated from message exa.codeium_common_pb.CompletionByDateEntry
 */
export class CompletionByDateEntry extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionByDateEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionByDateEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionByDateEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionByDateEntry, a, b);
    }
}
CompletionByDateEntry.runtime = proto3;
CompletionByDateEntry.typeName = "exa.codeium_common_pb.CompletionByDateEntry";
CompletionByDateEntry.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "completion_statistics", kind: "message", T: CompletionStatistics },
]);
/**
 * Completion statistics for a single language.
 *
 * @generated from message exa.codeium_common_pb.CompletionByLanguageEntry
 */
export class CompletionByLanguageEntry extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Language language = 1;
         */
        this.language = Language.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionByLanguageEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionByLanguageEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionByLanguageEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionByLanguageEntry, a, b);
    }
}
CompletionByLanguageEntry.runtime = proto3;
CompletionByLanguageEntry.typeName = "exa.codeium_common_pb.CompletionByLanguageEntry";
CompletionByLanguageEntry.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 2, name: "completion_statistics", kind: "message", T: CompletionStatistics },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatStats
 */
export class ChatStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 chats_sent = 1;
         */
        this.chatsSent = protoInt64.zero;
        /**
         * @generated from field: uint64 chats_received = 2;
         */
        this.chatsReceived = protoInt64.zero;
        /**
         * @generated from field: uint64 chats_accepted = 3;
         */
        this.chatsAccepted = protoInt64.zero;
        /**
         * @generated from field: uint64 chats_inserted_at_cursor = 4;
         */
        this.chatsInsertedAtCursor = protoInt64.zero;
        /**
         * @generated from field: uint64 chats_applied = 5;
         */
        this.chatsApplied = protoInt64.zero;
        /**
         * loc = lines of code
         *
         * @generated from field: uint64 chat_loc_used = 6;
         */
        this.chatLocUsed = protoInt64.zero;
        /**
         * @generated from field: uint64 chat_code_blocks_used = 7;
         */
        this.chatCodeBlocksUsed = protoInt64.zero;
        /**
         * @generated from field: uint64 function_explain_count = 8;
         */
        this.functionExplainCount = protoInt64.zero;
        /**
         * @generated from field: uint64 function_docstring_count = 9;
         */
        this.functionDocstringCount = protoInt64.zero;
        /**
         * @generated from field: uint64 function_refactor_count = 10;
         */
        this.functionRefactorCount = protoInt64.zero;
        /**
         * @generated from field: uint64 code_block_explain_count = 11;
         */
        this.codeBlockExplainCount = protoInt64.zero;
        /**
         * @generated from field: uint64 code_block_refactor_count = 12;
         */
        this.codeBlockRefactorCount = protoInt64.zero;
        /**
         * @generated from field: uint64 problem_explain_count = 13;
         */
        this.problemExplainCount = protoInt64.zero;
        /**
         * @generated from field: uint64 function_unit_tests_count = 14;
         */
        this.functionUnitTestsCount = protoInt64.zero;
        /**
         * The total number of days spent using the tool across all developers during the period.
         *
         * @generated from field: uint32 active_developer_days = 15;
         */
        this.activeDeveloperDays = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatStats, a, b);
    }
}
ChatStats.runtime = proto3;
ChatStats.typeName = "exa.codeium_common_pb.ChatStats";
ChatStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "chats_sent", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "chats_received", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "chats_accepted", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "chats_inserted_at_cursor", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "chats_applied", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "chat_loc_used", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "chat_code_blocks_used", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "function_explain_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "function_docstring_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "function_refactor_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 11, name: "code_block_explain_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "code_block_refactor_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 13, name: "problem_explain_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 14, name: "function_unit_tests_count", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 15, name: "active_developer_days", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatStatsByDateEntry
 */
export class ChatStatsByDateEntry extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatStatsByDateEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatStatsByDateEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatStatsByDateEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatStatsByDateEntry, a, b);
    }
}
ChatStatsByDateEntry.runtime = proto3;
ChatStatsByDateEntry.typeName = "exa.codeium_common_pb.ChatStatsByDateEntry";
ChatStatsByDateEntry.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "chat_stats", kind: "message", T: ChatStats },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatStatsByModelEntry
 */
export class ChatStatsByModelEntry extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model_id = 1;
         */
        this.modelId = Model.MODEL_UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatStatsByModelEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatStatsByModelEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatStatsByModelEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatStatsByModelEntry, a, b);
    }
}
ChatStatsByModelEntry.runtime = proto3;
ChatStatsByModelEntry.typeName = "exa.codeium_common_pb.ChatStatsByModelEntry";
ChatStatsByModelEntry.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_id", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "chat_stats", kind: "message", T: ChatStats },
]);
/**
 * @generated from message exa.codeium_common_pb.CommandStats
 */
export class CommandStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 num_commands = 1;
         */
        this.numCommands = protoInt64.zero;
        /**
         * @generated from field: uint64 num_commands_accepted = 2;
         */
        this.numCommandsAccepted = protoInt64.zero;
        /**
         * @generated from field: uint64 num_commands_rejected = 3;
         */
        this.numCommandsRejected = protoInt64.zero;
        /**
         * @generated from field: uint64 num_edits = 4;
         */
        this.numEdits = protoInt64.zero;
        /**
         * @generated from field: uint64 num_generations = 5;
         */
        this.numGenerations = protoInt64.zero;
        /**
         * @generated from field: uint64 loc_added = 6;
         */
        this.locAdded = protoInt64.zero;
        /**
         * @generated from field: uint64 loc_removed = 7;
         */
        this.locRemoved = protoInt64.zero;
        /**
         * @generated from field: uint64 bytes_added = 8;
         */
        this.bytesAdded = protoInt64.zero;
        /**
         * @generated from field: uint64 bytes_removed = 9;
         */
        this.bytesRemoved = protoInt64.zero;
        /**
         * @generated from field: uint64 loc_selected = 10;
         */
        this.locSelected = protoInt64.zero;
        /**
         * @generated from field: uint64 bytes_selected = 11;
         */
        this.bytesSelected = protoInt64.zero;
        /**
         * @generated from field: map<string, uint64> num_commands_by_source = 12;
         */
        this.numCommandsBySource = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CommandStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommandStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommandStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommandStats, a, b);
    }
}
CommandStats.runtime = proto3;
CommandStats.typeName = "exa.codeium_common_pb.CommandStats";
CommandStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "num_commands", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "num_commands_accepted", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "num_commands_rejected", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "num_edits", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "num_generations", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "loc_added", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 7, name: "loc_removed", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "bytes_added", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "bytes_removed", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 10, name: "loc_selected", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 11, name: "bytes_selected", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 12, name: "num_commands_by_source", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 4 /* ScalarType.UINT64 */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.CommandStatsByDateEntry
 */
export class CommandStatsByDateEntry extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CommandStatsByDateEntry().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CommandStatsByDateEntry().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CommandStatsByDateEntry().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CommandStatsByDateEntry, a, b);
    }
}
CommandStatsByDateEntry.runtime = proto3;
CommandStatsByDateEntry.typeName = "exa.codeium_common_pb.CommandStatsByDateEntry";
CommandStatsByDateEntry.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "command_stats", kind: "message", T: CommandStats },
]);
/**
 * @generated from message exa.codeium_common_pb.UserTableStats
 */
export class UserTableStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: string email = 2;
         */
        this.email = "";
        /**
         * @generated from field: string api_key = 4;
         */
        this.apiKey = "";
        /**
         * @generated from field: bool disable_codeium = 5;
         */
        this.disableCodeium = false;
        /**
         * @generated from field: uint32 active_days = 6;
         */
        this.activeDays = 0;
        /**
         * @generated from field: string role = 7;
         */
        this.role = "";
        /**
         * @generated from field: int64 prompt_credits_used = 12;
         */
        this.promptCreditsUsed = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UserTableStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserTableStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserTableStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserTableStats, a, b);
    }
}
UserTableStats.runtime = proto3;
UserTableStats.typeName = "exa.codeium_common_pb.UserTableStats";
UserTableStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_update_time", kind: "message", T: Timestamp },
    { no: 4, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "disable_codeium", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "active_days", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 7, name: "role", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "signup_time", kind: "message", T: Timestamp },
    { no: 9, name: "last_autocomplete_usage_time", kind: "message", T: Timestamp },
    { no: 10, name: "last_chat_usage_time", kind: "message", T: Timestamp },
    { no: 11, name: "last_command_usage_time", kind: "message", T: Timestamp },
    { no: 12, name: "prompt_credits_used", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.CascadeNUXState
 */
export class CascadeNUXState extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.CascadeNUXEvent event = 1;
         */
        this.event = CascadeNUXEvent.CASCADE_NUX_EVENT_UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CascadeNUXState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CascadeNUXState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CascadeNUXState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CascadeNUXState, a, b);
    }
}
CascadeNUXState.runtime = proto3;
CascadeNUXState.typeName = "exa.codeium_common_pb.CascadeNUXState";
CascadeNUXState.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "enum", T: proto3.getEnumType(CascadeNUXEvent) },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
]);
/**
 * @generated from message exa.codeium_common_pb.UserNUXState
 */
export class UserNUXState extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.UserNUXEvent event = 1;
         */
        this.event = UserNUXEvent.USER_NUX_EVENT_UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UserNUXState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserNUXState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserNUXState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserNUXState, a, b);
    }
}
UserNUXState.runtime = proto3;
UserNUXState.typeName = "exa.codeium_common_pb.UserNUXState";
UserNUXState.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event", kind: "enum", T: proto3.getEnumType(UserNUXEvent) },
    { no: 2, name: "timestamp", kind: "message", T: Timestamp },
]);
/**
 * Client-side config for brain functionalities that are scoped to the per-conversation level.
 *
 * @generated from message exa.codeium_common_pb.ConversationBrainConfig
 */
export class ConversationBrainConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.PlanMode plan_mode = 1;
         */
        this.planMode = PlanMode.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ConversationBrainConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConversationBrainConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConversationBrainConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConversationBrainConfig, a, b);
    }
}
ConversationBrainConfig.runtime = proto3;
ConversationBrainConfig.typeName = "exa.codeium_common_pb.ConversationBrainConfig";
ConversationBrainConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "plan_mode", kind: "enum", T: proto3.getEnumType(PlanMode) },
]);
/**
 * @generated from message exa.codeium_common_pb.FeatureUsageData
 */
export class FeatureUsageData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool has_used = 1;
         */
        this.hasUsed = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FeatureUsageData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FeatureUsageData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FeatureUsageData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FeatureUsageData, a, b);
    }
}
FeatureUsageData.runtime = proto3;
FeatureUsageData.typeName = "exa.codeium_common_pb.FeatureUsageData";
FeatureUsageData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "has_used", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * *
 * Configuration for a Cascade NUX. Fully controls where the nux is shown, when it will be shown,
 * and the content of the nux.
 *
 * The `position` of the nux, i.e. whether the NUX is shown below or above a particular element is
 * determined on the client side depending on the state of the conversation, and is not specified in
 * the NUX config.
 *
 * @generated from message exa.codeium_common_pb.CascadeNUXConfig
 */
export class CascadeNUXConfig extends Message {
    constructor(data) {
        super();
        /**
         * The UID for the nux. Users can only see a nux with a particular UID once.
         * These should be assigned monotonically increasing IDs.
         *
         * @generated from field: uint32 uid = 1;
         */
        this.uid = 0;
        /**
         * The location of the NUX. A nux will be shown at the location when the location mounts.
         *
         * @generated from field: exa.codeium_common_pb.CascadeNUXLocation location = 2;
         */
        this.location = CascadeNUXLocation.CASCADE_NUX_LOCATION_UNSPECIFIED;
        /**
         * If provided, the NUX will only be shown when the trigger is met.
         *
         * @generated from field: exa.codeium_common_pb.CascadeNUXTrigger trigger = 3;
         */
        this.trigger = CascadeNUXTrigger.CASCADE_NUX_TRIGGER_UNSPECIFIED;
        /**
         * Name to log the nux to analytics
         *
         * @generated from field: string analytics_event_name = 4;
         */
        this.analyticsEventName = "";
        /**
         * The main text of the NUX. This is a required, nice (short) message.
         *
         * @generated from field: string main_text = 5;
         */
        this.mainText = "";
        /**
         * An optional tooltip that when provided adds a question mark icon to the nux
         * which will show this explanation on hover.
         *
         * @generated from field: string on_hover_explanation = 6;
         */
        this.onHoverExplanation = "";
        /**
         * An optional URL to learn more about the NUX. Shown in a little "Learn More" button.
         * Usually points to windsurf docs.
         *
         * @generated from field: string learn_more_url = 7;
         */
        this.learnMoreUrl = "";
        /**
         * Higher for NUXes that will be shown first. Usually should be zero.
         *
         * @generated from field: int32 priority = 8;
         */
        this.priority = 0;
        /**
         * For NUXes that replace old client side nuxes, specifies the old nux event to prevent showing
         * it to users who have already seen the old nux. If not replacing an old nux, leave this as
         * the default (CASCADE_NUX_EVENT_UNSPECIFIED).
         *
         * @generated from field: exa.codeium_common_pb.CascadeNUXEvent old_nux_event = 9;
         */
        this.oldNuxEvent = CascadeNUXEvent.CASCADE_NUX_EVENT_UNSPECIFIED;
        /**
         * An optional icon for the NUX.
         *
         * @generated from field: exa.codeium_common_pb.CascadeNUXIcon icon = 10;
         */
        this.icon = CascadeNUXIcon.CASCADE_NUX_ICON_UNSPECIFIED;
        /**
         * If true, the NUX will only be shown when Cascade is idle.
         *
         * @generated from field: bool requires_idle_cascade = 11;
         */
        this.requiresIdleCascade = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CascadeNUXConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CascadeNUXConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CascadeNUXConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CascadeNUXConfig, a, b);
    }
}
CascadeNUXConfig.runtime = proto3;
CascadeNUXConfig.typeName = "exa.codeium_common_pb.CascadeNUXConfig";
CascadeNUXConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "location", kind: "enum", T: proto3.getEnumType(CascadeNUXLocation) },
    { no: 3, name: "trigger", kind: "enum", T: proto3.getEnumType(CascadeNUXTrigger) },
    { no: 4, name: "analytics_event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "main_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "on_hover_explanation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "learn_more_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "priority", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "old_nux_event", kind: "enum", T: proto3.getEnumType(CascadeNUXEvent) },
    { no: 10, name: "icon", kind: "enum", T: proto3.getEnumType(CascadeNUXIcon) },
    { no: 11, name: "requires_idle_cascade", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * User settings for the extension that are stored on the user's local machine
 * Note: If you are adding a new field has enable/disable-style boolean semantics, please try to use the
 * boolean type directly instead of an enum, unless we want to have server-side control over this fields.
 * Next ID: 67; Previous field: browser_experimental_features_config.
 *
 * @generated from message exa.codeium_common_pb.UserSettings
 */
export class UserSettings extends Message {
    constructor(data) {
        super();
        /**
         * Whether or not to start a new conversation or open to the most recent one when opening
         * the chat panel in Codeium.
         *
         * @generated from field: bool open_most_recent_chat_conversation = 1;
         */
        this.openMostRecentChatConversation = false;
        /**
         * Last selected chat model ID. Used to make the model preference sticky between panel sessions.
         *
         * @generated from field: exa.codeium_common_pb.Model last_selected_model = 2;
         */
        this.lastSelectedModel = Model.MODEL_UNSPECIFIED;
        /**
         * The preference for the theme of the chat panel.
         *
         * @generated from field: exa.codeium_common_pb.ThemePreference theme_preference = 3;
         */
        this.themePreference = ThemePreference.UNSPECIFIED;
        /**
         * The current tab that is opened in the extension
         *
         * @generated from field: exa.codeium_common_pb.ExtensionPanelTab extension_panel_tab = 4;
         */
        this.extensionPanelTab = ExtensionPanelTab.UNSPECIFIED;
        /**
         * The Font size of the chat panel
         *
         * @generated from field: exa.codeium_common_pb.FontSize font_size = 5;
         */
        this.fontSize = FontSize.UNSPECIFIED;
        /**
         * Whether or not to remember last model choice (for chat & cascade) and persist it. Only allowed for some plans (not free)
         *
         * @generated from field: exa.codeium_common_pb.RememberLastModelSelection remember_last_model_selection = 7;
         */
        this.rememberLastModelSelection = RememberLastModelSelection.UNSPECIFIED;
        /**
         * The current mode of the autocomplete speed
         *
         * @generated from field: exa.codeium_common_pb.AutocompleteSpeed autocomplete_speed = 6;
         */
        this.autocompleteSpeed = AutocompleteSpeed.UNSPECIFIED;
        /**
         * Name of the last model used for chat (needed for Enterprise external models)
         *
         * @generated from field: string last_selected_model_name = 8;
         */
        this.lastSelectedModelName = "";
        /**
         * The current state of the user's Cascade new user experience.
         * To be deprecated in favor of seen_nux_uids shortly.
         *
         * @generated from field: repeated exa.codeium_common_pb.CascadeNUXState cascade_nux_states = 11;
         */
        this.cascadeNuxStates = [];
        /**
         * The uids of the NUXes that the user has seen (true if seen, false/undefined if not seen)
         *
         * @generated from field: map<uint32, bool> seen_nux_uids = 60;
         */
        this.seenNuxUids = {};
        /**
         * User-added allow list of commands that can be run by Cascade
         *
         * @generated from field: repeated string cascade_allowed_commands = 14;
         */
        this.cascadeAllowedCommands = [];
        /**
         * User-added deny list of commands that can be run by Cascade
         *
         * @generated from field: repeated string cascade_denied_commands = 15;
         */
        this.cascadeDeniedCommands = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.UserNUXState user_nux_states = 17;
         */
        this.userNuxStates = [];
        /**
         * Whether Cascade's web search is disabled. This is set to disabled so that it defaults to "on"
         * when used in a headless environment without user settings.
         *
         * @generated from field: bool cascade_web_search_disabled = 18 [deprecated = true];
         * @deprecated
         */
        this.cascadeWebSearchDisabled = false;
        /**
         * Disable autocomplete in windsurf
         *
         * @generated from field: bool disable_autocomplete = 19;
         */
        this.disableAutocomplete = false;
        /**
         * Disable supercomplete in windsurf
         *
         * @generated from field: bool disable_supercomplete = 20;
         */
        this.disableSupercomplete = false;
        /**
         * Disable the popup that appears when selecting code in windsurf
         *
         * @generated from field: bool disable_selection_popup = 21;
         */
        this.disableSelectionPopup = false;
        /**
         * Disable inline hints for explain problem in windsurf
         *
         * @generated from field: bool disable_explain_problem_inlay_hint = 22;
         */
        this.disableExplainProblemInlayHint = false;
        /**
         * Disable inlay hints shortcuts in windsurf
         *
         * @generated from field: bool disable_inlay_hint_shortcuts = 23;
         */
        this.disableInlayHintShortcuts = false;
        /**
         * Disable automatically opening Cascade when reloading the editor
         *
         * @generated from field: bool disable_open_cascade_on_reload = 24;
         */
        this.disableOpenCascadeOnReload = false;
        /**
         * Disable automatically opening files that were edited by Cascade
         *
         * @generated from field: bool disable_auto_open_edited_files = 25;
         */
        this.disableAutoOpenEditedFiles = false;
        /**
         * Disable tab jump in windsurf
         *
         * @generated from field: bool disable_tab_to_jump = 26 [deprecated = true];
         * @deprecated
         */
        this.disableTabToJump = false;
        /**
         * Cascade terminal commands auto execution mode
         *
         * @generated from field: exa.codeium_common_pb.CascadeCommandsAutoExecution cascade_auto_execution_policy = 27;
         */
        this.cascadeAutoExecutionPolicy = CascadeCommandsAutoExecution.UNSPECIFIED;
        /**
         * Whether to send explain and fix problems to current conversation if there is a cascade id.
         *
         * @generated from field: bool explain_and_fix_in_current_conversation = 29;
         */
        this.explainAndFixInCurrentConversation = false;
        /**
         * Whether Cascade can view or edit .gitignore files. Default to false.
         *
         * @generated from field: bool allow_cascade_access_gitignore_files = 31;
         */
        this.allowCascadeAccessGitignoreFiles = false;
        /**
         * Whether to disable auto fix lint functionality for Cascade.
         *
         * @generated from field: bool disable_cascade_auto_fix_lints = 32;
         */
        this.disableCascadeAutoFixLints = false;
        /**
         * @generated from field: bool disable_cascade_browser_previews = 33;
         */
        this.disableCascadeBrowserPreviews = false;
        /**
         * @generated from field: bool detect_proxy = 34;
         */
        this.detectProxy = false;
        /**
         * @generated from field: bool disable_tab_to_import = 35;
         */
        this.disableTabToImport = false;
        /**
         * @generated from field: bool use_clipboard_for_completions = 36;
         */
        this.useClipboardForCompletions = false;
        /**
         * @generated from field: bool disable_highlight_after_accept = 37;
         */
        this.disableHighlightAfterAccept = false;
        /**
         * Cascade last selected new convo tab.
         *
         * @generated from field: string last_selected_new_convo_tab = 38;
         */
        this.lastSelectedNewConvoTab = "";
        /**
         * If true, Cascade does not create autogenerated memories unless explicitly asked
         *
         * @generated from field: bool disable_auto_generate_memories = 39;
         */
        this.disableAutoGenerateMemories = false;
        /**
         * If true, the IDE plays sounds on certain events, e.g. when Cascade finishes generating a response
         *
         * @generated from field: bool enable_sounds_for_special_events = 40;
         */
        this.enableSoundsForSpecialEvents = false;
        /**
         * If true, the IDE plays sounds (in sequence, forming a melody) when accepting Windsurf Tab suggestions.
         * This is a temporary feature for April Fool's.
         *
         * @generated from field: bool enable_tab_sounds = 41;
         */
        this.enableTabSounds = false;
        /**
         * Deprecated flag to determine if Cascade can run in the background.
         * disable_cascade_in_background is the new flag to control this behavior since
         * we want this to be enabled by default now.
         *
         * @generated from field: bool allow_cascade_in_background = 42 [deprecated = true];
         * @deprecated
         */
        this.allowCascadeInBackground = false;
        /**
         * @generated from field: exa.codeium_common_pb.TabToJump tab_to_jump = 43;
         */
        this.tabToJump = TabToJump.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.CascadeWebSearchTool cascade_web_search = 44;
         */
        this.cascadeWebSearch = CascadeWebSearchTool.UNSPECIFIED;
        /**
         * Whether to enable terminal completions
         *
         * @generated from field: bool enable_terminal_completion = 45;
         */
        this.enableTerminalCompletion = false;
        /**
         * Whether Windsurf Tab completions are snoozed
         *
         * @generated from field: bool is_snoozed = 55;
         */
        this.isSnoozed = false;
        /**
         * Whether to enable command cascade mode
         *
         * @generated from field: bool enable_command_cascade_mode = 49;
         */
        this.enableCommandCascadeMode = false;
        /**
         * Tracks feature usage for the user. The key is the `enumToString` of the `FeatureUsageType` enum.
         *
         * @generated from field: map<string, exa.codeium_common_pb.FeatureUsageData> feature_usage_data = 47;
         */
        this.featureUsageData = {};
        /**
         * Whether to disable Cascade from running in the background
         *
         * @generated from field: bool disable_cascade_in_background = 48;
         */
        this.disableCascadeInBackground = false;
        /**
         * Custom workspaces for Enterprise Users. Tool calls will always pass for these workspaces.
         * Tool calls currently fail outside tracked worskspace if GetEnforceWorkspaceValidation is set.
         *
         * @generated from field: repeated string custom_workspace = 50;
         */
        this.customWorkspace = [];
        /**
         * Deprecated: this field records per-conversation settings about the user's
         * "brain config" (i.e. plan mode), but we have decided to go with a global toggle instead.
         *
         * @generated from field: map<string, exa.codeium_common_pb.ConversationBrainConfig> conversation_brain_configs = 51 [deprecated = true];
         * @deprecated
         */
        this.conversationBrainConfigs = {};
        /**
         * The user's global plan mode preference.
         *
         * @generated from field: exa.codeium_common_pb.PlanMode global_plan_mode_preference = 54;
         */
        this.globalPlanModePreference = PlanMode.UNSPECIFIED;
        /**
         * Cached model configurations for Cascade
         *
         * @generated from field: repeated exa.codeium_common_pb.ClientModelConfig cached_cascade_model_configs = 52;
         */
        this.cachedCascadeModelConfigs = [];
        /**
         * Cached model sorts for Cascade
         *
         * @generated from field: repeated exa.codeium_common_pb.ClientModelSort cached_cascade_model_sorts = 53;
         */
        this.cachedCascadeModelSorts = [];
        /**
         * Whether to enable Cascade extension code execution
         *
         * @generated from field: exa.codeium_common_pb.CascadeRunExtensionCode cascade_run_extension_code = 56;
         */
        this.cascadeRunExtensionCode = CascadeRunExtensionCode.UNSPECIFIED;
        /**
         * Whether to enable Cascade extension code auto-run
         *
         * @generated from field: exa.codeium_common_pb.CascadeRunExtensionCodeAutoRun cascade_run_extension_code_auto_run = 57;
         */
        this.cascadeRunExtensionCodeAutoRun = CascadeRunExtensionCodeAutoRun.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.CascadeInputAutocomplete cascade_input_autocomplete = 65;
         */
        this.cascadeInputAutocomplete = CascadeInputAutocomplete.UNSPECIFIED;
        /**
         * Global auto-continue-on-max-invocator-generations setting
         *
         * @generated from field: exa.codeium_common_pb.AutoContinueOnMaxGeneratorInvocations auto_continue_on_max_generator_invocations = 59;
         */
        this.autoContinueOnMaxGeneratorInvocations = AutoContinueOnMaxGeneratorInvocations.UNSPECIFIED;
        /**
         * List of recently used cascade models (LRU order, max 3 items)
         *
         * @generated from field: repeated string recently_used_cascade_models = 61;
         */
        this.recentlyUsedCascadeModels = [];
        /**
         * @generated from field: repeated string cascade_dismissed_suggestion_workspaces = 62;
         */
        this.cascadeDismissedSuggestionWorkspaces = [];
        /**
         * Whether to enable annotations
         *
         * @generated from field: exa.codeium_common_pb.AnnotationsConfig annotations_config = 63;
         */
        this.annotationsConfig = AnnotationsConfig.UNSPECIFIED;
        /**
         * If true, automatically capture and attach a screenshot when sending a message (if model supports images).
         *
         * @generated from field: bool enable_automatic_screenshot = 64;
         */
        this.enableAutomaticScreenshot = false;
        /**
         * Whether to enable browser experimental features
         *
         * @generated from field: exa.codeium_common_pb.BrowserExperimentalFeaturesConfig browser_experimental_features_config = 66;
         */
        this.browserExperimentalFeaturesConfig = BrowserExperimentalFeaturesConfig.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UserSettings().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserSettings().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserSettings().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserSettings, a, b);
    }
}
UserSettings.runtime = proto3;
UserSettings.typeName = "exa.codeium_common_pb.UserSettings";
UserSettings.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "open_most_recent_chat_conversation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "last_selected_model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 3, name: "theme_preference", kind: "enum", T: proto3.getEnumType(ThemePreference) },
    { no: 4, name: "extension_panel_tab", kind: "enum", T: proto3.getEnumType(ExtensionPanelTab) },
    { no: 5, name: "font_size", kind: "enum", T: proto3.getEnumType(FontSize) },
    { no: 7, name: "remember_last_model_selection", kind: "enum", T: proto3.getEnumType(RememberLastModelSelection) },
    { no: 6, name: "autocomplete_speed", kind: "enum", T: proto3.getEnumType(AutocompleteSpeed) },
    { no: 8, name: "last_selected_model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "cascade_nux_states", kind: "message", T: CascadeNUXState, repeated: true },
    { no: 60, name: "seen_nux_uids", kind: "map", K: 13 /* ScalarType.UINT32 */, V: { kind: "scalar", T: 8 /* ScalarType.BOOL */ } },
    { no: 9, name: "last_selected_cascade_model", kind: "enum", T: proto3.getEnumType(Model), opt: true },
    { no: 30, name: "last_selected_cascade_model_or_alias", kind: "message", T: ModelOrAlias, opt: true },
    { no: 13, name: "cascade_planner_mode", kind: "enum", T: proto3.getEnumType(ConversationalPlannerMode), opt: true },
    { no: 46, name: "last_model_override", kind: "enum", T: proto3.getEnumType(Model), opt: true },
    { no: 58, name: "last_model_default_override_version_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 14, name: "cascade_allowed_commands", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 15, name: "cascade_denied_commands", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 17, name: "user_nux_states", kind: "message", T: UserNUXState, repeated: true },
    { no: 18, name: "cascade_web_search_disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "disable_autocomplete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "disable_supercomplete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 21, name: "disable_selection_popup", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 22, name: "disable_explain_problem_inlay_hint", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "disable_inlay_hint_shortcuts", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 24, name: "disable_open_cascade_on_reload", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "disable_auto_open_edited_files", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 26, name: "disable_tab_to_jump", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 27, name: "cascade_auto_execution_policy", kind: "enum", T: proto3.getEnumType(CascadeCommandsAutoExecution) },
    { no: 28, name: "last_selected_cascade_id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 29, name: "explain_and_fix_in_current_conversation", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 31, name: "allow_cascade_access_gitignore_files", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 32, name: "disable_cascade_auto_fix_lints", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 33, name: "disable_cascade_browser_previews", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 34, name: "detect_proxy", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 35, name: "disable_tab_to_import", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 36, name: "use_clipboard_for_completions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 37, name: "disable_highlight_after_accept", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 38, name: "last_selected_new_convo_tab", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 39, name: "disable_auto_generate_memories", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 40, name: "enable_sounds_for_special_events", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 41, name: "enable_tab_sounds", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 42, name: "allow_cascade_in_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 43, name: "tab_to_jump", kind: "enum", T: proto3.getEnumType(TabToJump) },
    { no: 44, name: "cascade_web_search", kind: "enum", T: proto3.getEnumType(CascadeWebSearchTool) },
    { no: 45, name: "enable_terminal_completion", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 55, name: "is_snoozed", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 49, name: "enable_command_cascade_mode", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 47, name: "feature_usage_data", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: FeatureUsageData } },
    { no: 48, name: "disable_cascade_in_background", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 50, name: "custom_workspace", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 51, name: "conversation_brain_configs", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: ConversationBrainConfig } },
    { no: 54, name: "global_plan_mode_preference", kind: "enum", T: proto3.getEnumType(PlanMode) },
    { no: 52, name: "cached_cascade_model_configs", kind: "message", T: ClientModelConfig, repeated: true },
    { no: 53, name: "cached_cascade_model_sorts", kind: "message", T: ClientModelSort, repeated: true },
    { no: 56, name: "cascade_run_extension_code", kind: "enum", T: proto3.getEnumType(CascadeRunExtensionCode) },
    { no: 57, name: "cascade_run_extension_code_auto_run", kind: "enum", T: proto3.getEnumType(CascadeRunExtensionCodeAutoRun) },
    { no: 65, name: "cascade_input_autocomplete", kind: "enum", T: proto3.getEnumType(CascadeInputAutocomplete) },
    { no: 59, name: "auto_continue_on_max_generator_invocations", kind: "enum", T: proto3.getEnumType(AutoContinueOnMaxGeneratorInvocations) },
    { no: 61, name: "recently_used_cascade_models", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 62, name: "cascade_dismissed_suggestion_workspaces", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 63, name: "annotations_config", kind: "enum", T: proto3.getEnumType(AnnotationsConfig) },
    { no: 64, name: "enable_automatic_screenshot", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 66, name: "browser_experimental_features_config", kind: "enum", T: proto3.getEnumType(BrowserExperimentalFeaturesConfig) },
]);
/**
 * Features supported by the model. These should be boolean and either of form supports_ or
 * requires_.
 * TODO(nick): if features end up being completely split by model type, create a per-model type
 * features message and change the model_type field in ModelInfo into a oneof across these messages.
 * Next ID: 21; Previous field: supports_image_captions.
 *
 * @generated from message exa.codeium_common_pb.ModelFeatures
 */
export class ModelFeatures extends Message {
    constructor(data) {
        super();
        /**
         * Context token FT models. When true, prompts will use special tokens to wrap code context items
         * instead of adding them as commented code blocks.
         *
         * @generated from field: bool supports_context_tokens = 2;
         */
        this.supportsContextTokens = false;
        /**
         * Chat-based codeium command IFT models. When true, command prompts will use llama-instruct
         * [INST] and [/INST] tags.
         *
         * @generated from field: bool requires_instruct_tags = 3;
         */
        this.requiresInstructTags = false;
        /**
         * Training examples use FIM at a per-example level. When true, prompts will wrap the context
         * section of the prompt in a FIM block. Regardless of whether or not this is set, the context
         * section will always occur before the current document FIM block in the prompt.
         *
         * @generated from field: bool requires_fim_context = 4;
         */
        this.requiresFimContext = false;
        /**
         * Context snippet prefix. When true, prompts will include "Context from" in the prefix before
         * context item snippets. Regardless of whether or not this is set, the context type and node path
         * will be included in the context item snippet prefix.
         *
         * @generated from field: bool requires_context_snippet_prefix = 5;
         */
        this.requiresContextSnippetPrefix = false;
        /**
         * Context relevance tags instead of special tokens for the context check task.
         * When true, prompts will use no special tokens for the context check task.
         *
         * @generated from field: bool requires_context_relevance_tags = 6;
         */
        this.requiresContextRelevanceTags = false;
        /**
         * Whether to inject LLama3 header tokens when formatting chat prompt.
         * https://llama.meta.com/docs/model-cards-and-prompt-formats/meta-llama-3
         *
         * @generated from field: bool requires_llama3_tokens = 7;
         */
        this.requiresLlama3Tokens = false;
        /**
         * Whether model can support arbitrary prompt text. Used for configuring prompt based experiments.
         *
         * @generated from field: bool zero_shot_capable = 8;
         */
        this.zeroShotCapable = false;
        /**
         * Whether the model uses the autocomplete as command formatting
         * (Formatting an autocomplete request as a generalized "command generate" prompt that supports inline prefix/suffix.
         * Generally, only used by FIM capable chat models.)
         *
         * @generated from field: bool requires_autocomplete_as_command = 9;
         */
        this.requiresAutocompleteAsCommand = false;
        /**
         * Whether the model supports putting <|cursor|> in the supercomplete selection to signify where the cursor is.
         * NOTE(anthonywang): Making this "supports" for now since it is worse for a cursor unaware model to
         * receive a cursor aware prompt (because it will start leaking the cursor) than for a cursor aware model
         * to receive a cursor unaware prompt, although the cursor aware model will likely have unknown behavior
         * if given the cursor unaware prompt.
         * This field is used for both autocomplete and supercomplete prompt construction right now.
         *
         * @generated from field: bool supports_cursor_aware_supercomplete = 10;
         */
        this.supportsCursorAwareSupercomplete = false;
        /**
         * Whether the model supports vision
         *
         * @generated from field: bool supports_images = 11;
         */
        this.supportsImages = false;
        /**
         * Whether the model supports AI generated image captions instead of images. Requires a supported PromptTemplater
         * and support_images must also be marked true
         *
         * @generated from field: bool supports_image_captions = 20;
         */
        this.supportsImageCaptions = false;
        /**
         * Whether the model supports tool calls
         *
         * @generated from field: bool supports_tool_calls = 12;
         */
        this.supportsToolCalls = false;
        /**
         * Whether the model supports cache-aware prompts, where different kinds of context can be interleaved.
         * TODO(devin): Making this "supports" for now, since even though the format is completely different from
         * existing models, the old prompt format could hypothetically be expressed as a cumulative format, and
         * maybe we'll train models in the new format but without interleaving.
         * In practice, this routes prompt construction to a completely different code path.
         *
         * @generated from field: bool supports_cumulative_context = 13;
         */
        this.supportsCumulativeContext = false;
        /**
         * Whether the model supports printing line range in tab jump instructions
         *
         * @generated from field: bool tab_jump_print_line_range = 14;
         */
        this.tabJumpPrintLineRange = false;
        /**
         * Whether the model supports thinking.
         *
         * @generated from field: bool supports_thinking = 15;
         */
        this.supportsThinking = false;
        /**
         * Whether the model can use the estimate tokenizer (estimates number of tokens after tokenization)
         * instead of its real tokenizer in the LS and api server. Note that these estimates are NOT expected to be conservative.
         * This requires the model/inference server to be robust to both over and under estimates of prompt length in tokens.
         *
         * @generated from field: bool supports_estimate_token_counter = 17;
         */
        this.supportsEstimateTokenCounter = false;
        /**
         * Whether the model supports adding cursor markers in the find replace target
         *
         * @generated from field: bool add_cursor_to_find_replace_target = 18;
         */
        this.addCursorToFindReplaceTarget = false;
        /**
         * Whether the model supports jumping to the whole document instead of just in the selection.
         * This is used for controlling what we match against.
         * NOTE: Having this model feature REQUIRES tab_jump_print_line_range to be true.
         *
         * @generated from field: bool supports_tab_jump_use_whole_document = 19;
         */
        this.supportsTabJumpUseWholeDocument = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelFeatures().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelFeatures().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelFeatures().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelFeatures, a, b);
    }
}
ModelFeatures.runtime = proto3;
ModelFeatures.typeName = "exa.codeium_common_pb.ModelFeatures";
ModelFeatures.fields = proto3.util.newFieldList(() => [
    { no: 2, name: "supports_context_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "requires_instruct_tags", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "requires_fim_context", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "requires_context_snippet_prefix", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "requires_context_relevance_tags", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "requires_llama3_tokens", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "zero_shot_capable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "requires_autocomplete_as_command", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "supports_cursor_aware_supercomplete", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "supports_images", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "supports_image_captions", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "supports_tool_calls", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "supports_cumulative_context", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "tab_jump_print_line_range", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 15, name: "supports_thinking", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "supports_estimate_token_counter", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "add_cursor_to_find_replace_target", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "supports_tab_jump_use_whole_document", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ExternalModel
 */
export class ExternalModel extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool is_internal = 1;
         */
        this.isInternal = false;
        /**
         * @generated from field: exa.codeium_common_pb.Model model_id = 2;
         */
        this.modelId = Model.MODEL_UNSPECIFIED;
        /**
         * @generated from field: string model_name = 3;
         */
        this.modelName = "";
        /**
         * @generated from field: string base_url = 4;
         */
        this.baseUrl = "";
        /**
         * @generated from field: string api_key = 5;
         */
        this.apiKey = "";
        /**
         * @generated from field: string access_key = 6;
         */
        this.accessKey = "";
        /**
         * @generated from field: string secret_access_key = 7;
         */
        this.secretAccessKey = "";
        /**
         * @generated from field: string region = 8;
         */
        this.region = "";
        /**
         * @generated from field: string project_id = 9;
         */
        this.projectId = "";
        /**
         * @generated from field: uint32 id = 10;
         */
        this.id = 0;
        /**
         * @generated from field: int32 max_completion_tokens = 11;
         */
        this.maxCompletionTokens = 0;
        /**
         * @generated from field: int32 max_input_tokens = 12;
         */
        this.maxInputTokens = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ExternalModel().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ExternalModel().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ExternalModel().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ExternalModel, a, b);
    }
}
ExternalModel.runtime = proto3;
ExternalModel.typeName = "exa.codeium_common_pb.ExternalModel";
ExternalModel.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "is_internal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "model_id", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 3, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "base_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "access_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "secret_access_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "region", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "id", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 11, name: "max_completion_tokens", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "max_input_tokens", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * TODO(matt, nmoy): The ApiProvider field is now slightly misleading, since it couples two things
 * (1) the source of who trained the model, and (2) the source who is providng the API endpoint. We should
 * decouple these things, as they serve different purposes.
 * See https://github.com/Exafunction/Exafunction/pull/17587/files#r1896940028 for discussion.
 *
 * @generated from message exa.codeium_common_pb.ModelInfo
 */
export class ModelInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model_id = 1;
         */
        this.modelId = Model.MODEL_UNSPECIFIED;
        /**
         * This is used to indicate whether the model is finetuned with an internal prompt
         * format.
         * TODO(nick, pavan): This should be deprecated since it we should now be using api_provider
         * to indicate model is served internally and model features for prompt-related features.
         *
         * @generated from field: bool is_internal = 2;
         */
        this.isInternal = false;
        /**
         * @generated from field: exa.codeium_common_pb.ModelType model_type = 3;
         */
        this.modelType = ModelType.UNSPECIFIED;
        /**
         * Total max tokens for the model including generation and prompt.
         *
         * @generated from field: int32 max_tokens = 4;
         */
        this.maxTokens = 0;
        /**
         * String representing tokenizer type of model.
         *
         * @generated from field: string tokenizer_type = 5;
         */
        this.tokenizerType = "";
        /**
         * @generated from field: exa.codeium_common_pb.APIProvider api_provider = 7;
         */
        this.apiProvider = APIProvider.API_PROVIDER_UNSPECIFIED;
        /**
         * Model name for api calls.
         *
         * @generated from field: string model_name = 8;
         */
        this.modelName = "";
        /**
         * @generated from field: bool supports_context = 9;
         */
        this.supportsContext = false;
        /**
         * Embedding dimension for the model.
         *
         * @generated from field: int32 embed_dim = 10;
         */
        this.embedDim = 0;
        /**
         * @generated from field: string base_url = 11;
         */
        this.baseUrl = "";
        /**
         * Set within api server for easier use of external models
         *
         * @generated from field: string chat_model_name = 12;
         */
        this.chatModelName = "";
        /**
         * since MaxOutputTokens is set on the inference server for any internal models.
         *
         * @generated from field: int32 max_output_tokens = 13;
         */
        this.maxOutputTokens = 0;
        /**
         * Default type of chat prompt template to use for this model.
         *
         * @generated from field: exa.codeium_common_pb.PromptTemplaterType prompt_templater_type = 14;
         */
        this.promptTemplaterType = PromptTemplaterType.UNSPECIFIED;
        /**
         * Default type of tool formatter to use for this model.
         *
         * @generated from field: exa.codeium_common_pb.ToolFormatterType tool_formatter_type = 15;
         */
        this.toolFormatterType = ToolFormatterType.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelInfo, a, b);
    }
}
ModelInfo.runtime = proto3;
ModelInfo.typeName = "exa.codeium_common_pb.ModelInfo";
ModelInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_id", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "is_internal", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "model_type", kind: "enum", T: proto3.getEnumType(ModelType) },
    { no: 4, name: "max_tokens", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "tokenizer_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "model_features", kind: "message", T: ModelFeatures },
    { no: 7, name: "api_provider", kind: "enum", T: proto3.getEnumType(APIProvider) },
    { no: 8, name: "model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "supports_context", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 10, name: "embed_dim", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "base_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "chat_model_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "max_output_tokens", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 14, name: "prompt_templater_type", kind: "enum", T: proto3.getEnumType(PromptTemplaterType) },
    { no: 15, name: "tool_formatter_type", kind: "enum", T: proto3.getEnumType(ToolFormatterType) },
]);
/**
 * @generated from message exa.codeium_common_pb.ApiProviderRoutingConfig
 */
export class ApiProviderRoutingConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: map<string, exa.codeium_common_pb.ApiProviderConfigMap> model_map = 1;
         */
        this.modelMap = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ApiProviderRoutingConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApiProviderRoutingConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApiProviderRoutingConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApiProviderRoutingConfig, a, b);
    }
}
ApiProviderRoutingConfig.runtime = proto3;
ApiProviderRoutingConfig.typeName = "exa.codeium_common_pb.ApiProviderRoutingConfig";
ApiProviderRoutingConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_map", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: ApiProviderConfigMap } },
]);
/**
 * @generated from message exa.codeium_common_pb.ApiProviderConfigMap
 */
export class ApiProviderConfigMap extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: map<string, exa.codeium_common_pb.ApiProviderConfig> provider_map = 1;
         */
        this.providerMap = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ApiProviderConfigMap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApiProviderConfigMap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApiProviderConfigMap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApiProviderConfigMap, a, b);
    }
}
ApiProviderConfigMap.runtime = proto3;
ApiProviderConfigMap.typeName = "exa.codeium_common_pb.ApiProviderConfigMap";
ApiProviderConfigMap.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "provider_map", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: ApiProviderConfig } },
]);
/**
 * @generated from message exa.codeium_common_pb.ApiProviderConfig
 */
export class ApiProviderConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint32 weight = 1;
         */
        this.weight = 0;
        /**
         * @generated from field: uint32 cache_ttl_minutes = 2;
         */
        this.cacheTtlMinutes = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ApiProviderConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ApiProviderConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ApiProviderConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ApiProviderConfig, a, b);
    }
}
ApiProviderConfig.runtime = proto3;
ApiProviderConfig.typeName = "exa.codeium_common_pb.ApiProviderConfig";
ApiProviderConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "weight", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "cache_ttl_minutes", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ModelConfig
 */
export class ModelConfig extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelConfig, a, b);
    }
}
ModelConfig.runtime = proto3;
ModelConfig.typeName = "exa.codeium_common_pb.ModelConfig";
ModelConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "generation_model", kind: "message", T: ModelInfo },
    { no: 2, name: "context_check_model", kind: "message", T: ModelInfo },
]);
/**
 * @generated from message exa.codeium_common_pb.ModelStatusInfo
 */
export class ModelStatusInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 1;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        /**
         * @generated from field: exa.codeium_common_pb.ModelStatus status = 3;
         */
        this.status = ModelStatus.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelStatusInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelStatusInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelStatusInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelStatusInfo, a, b);
    }
}
ModelStatusInfo.runtime = proto3;
ModelStatusInfo.typeName = "exa.codeium_common_pb.ModelStatusInfo";
ModelStatusInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "enum", T: proto3.getEnumType(ModelStatus) },
]);
/**
 * @generated from message exa.codeium_common_pb.CompletionExample
 */
export class CompletionExample extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uid = 1;
         */
        this.uid = "";
        /**
         * @generated from field: string completion_id = 2;
         */
        this.completionId = "";
        /**
         * @generated from field: string file_path = 3;
         */
        this.filePath = "";
        /**
         * @generated from field: string short_prefix = 4;
         */
        this.shortPrefix = "";
        /**
         * @generated from field: string completion_text = 5;
         */
        this.completionText = "";
        /**
         * @generated from field: string short_suffix = 6;
         */
        this.shortSuffix = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionExample().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionExample().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionExample().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionExample, a, b);
    }
}
CompletionExample.runtime = proto3;
CompletionExample.typeName = "exa.codeium_common_pb.CompletionExample";
CompletionExample.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "completion_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "short_prefix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "completion_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "short_suffix", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.CompletionExampleWithMetadata
 */
export class CompletionExampleWithMetadata extends Message {
    constructor(data) {
        super();
        /**
         * Display name from users.name.
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionExampleWithMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionExampleWithMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionExampleWithMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionExampleWithMetadata, a, b);
    }
}
CompletionExampleWithMetadata.runtime = proto3;
CompletionExampleWithMetadata.typeName = "exa.codeium_common_pb.CompletionExampleWithMetadata";
CompletionExampleWithMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "example", kind: "message", T: CompletionExample },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "time", kind: "message", T: Timestamp },
]);
/**
 * CodeContextItem with a sub-range, to give finer-grained control over the context.
 *
 * @generated from message exa.codeium_common_pb.CciWithSubrange
 */
export class CciWithSubrange extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CciWithSubrange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CciWithSubrange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CciWithSubrange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CciWithSubrange, a, b);
    }
}
CciWithSubrange.runtime = proto3;
CciWithSubrange.typeName = "exa.codeium_common_pb.CciWithSubrange";
CciWithSubrange.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "cci", kind: "message", T: CodeContextItem },
    { no: 2, name: "subrange", kind: "message", T: ContextSubrange },
]);
/**
 * TODO(Nmoy): add line start and end and content hash for staleness check.
 *
 * @generated from message exa.codeium_common_pb.ContextSubrange
 */
export class ContextSubrange extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.ContextSnippetType snippet_type = 1;
         */
        this.snippetType = ContextSnippetType.UNSPECIFIED;
        /**
         * Zero-indexed byte offset in the snippet string corresponding to ContextSnippetType. Inclusive.
         * A value of 0 for start and end-offset indicates that the subrange covers the whole snippet.
         *
         * @generated from field: int64 start_offset = 2;
         */
        this.startOffset = protoInt64.zero;
        /**
         * @generated from field: int64 end_offset = 3;
         */
        this.endOffset = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ContextSubrange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContextSubrange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContextSubrange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContextSubrange, a, b);
    }
}
ContextSubrange.runtime = proto3;
ContextSubrange.typeName = "exa.codeium_common_pb.ContextSubrange";
ContextSubrange.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "snippet_type", kind: "enum", T: proto3.getEnumType(ContextSnippetType) },
    { no: 2, name: "start_offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "end_offset", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PathScopeItem
 */
export class PathScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string absolute_path_migrate_me_to_uri = 1 [deprecated = true];
         * @deprecated
         */
        this.absolutePathMigrateMeToUri = "";
        /**
         * @generated from field: string absolute_uri = 5;
         */
        this.absoluteUri = "";
        /**
         * Map from workspace path to relative path.
         *
         * @generated from field: map<string, string> workspace_relative_paths_migrate_me_to_workspace_uris = 2 [deprecated = true];
         * @deprecated
         */
        this.workspaceRelativePathsMigrateMeToWorkspaceUris = {};
        /**
         * @generated from field: map<string, string> workspace_uris_to_relative_paths = 6;
         */
        this.workspaceUrisToRelativePaths = {};
        /**
         * Data within this scope.
         *
         * @generated from field: uint32 num_files = 3;
         */
        this.numFiles = 0;
        /**
         * @generated from field: uint64 num_bytes = 4;
         */
        this.numBytes = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PathScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PathScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PathScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PathScopeItem, a, b);
    }
}
PathScopeItem.runtime = proto3;
PathScopeItem.typeName = "exa.codeium_common_pb.PathScopeItem";
PathScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "absolute_path_migrate_me_to_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "absolute_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_relative_paths_migrate_me_to_workspace_uris", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 6, name: "workspace_uris_to_relative_paths", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 3, name: "num_files", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "num_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.FileLineRange
 */
export class FileLineRange extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string absolute_uri = 1;
         */
        this.absoluteUri = "";
        /**
         * 0-indexed
         *
         * @generated from field: uint32 start_line = 2;
         */
        this.startLine = 0;
        /**
         * inclusive, ignored if 0 or equal to start_line
         *
         * @generated from field: uint32 end_line = 3;
         */
        this.endLine = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FileLineRange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FileLineRange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FileLineRange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FileLineRange, a, b);
    }
}
FileLineRange.runtime = proto3;
FileLineRange.typeName = "exa.codeium_common_pb.FileLineRange";
FileLineRange.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "absolute_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "end_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.TextBlock
 */
export class TextBlock extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string content = 1;
         */
        this.content = "";
        /**
         * @generated from oneof exa.codeium_common_pb.TextBlock.identifier
         */
        this.identifier = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TextBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TextBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TextBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TextBlock, a, b);
    }
}
TextBlock.runtime = proto3;
TextBlock.typeName = "exa.codeium_common_pb.TextBlock";
TextBlock.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "file_line_range", kind: "message", T: FileLineRange, oneof: "identifier" },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "identifier" },
]);
/**
 * @generated from message exa.codeium_common_pb.RepositoryScopeItem
 */
export class RepositoryScopeItem extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RepositoryScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RepositoryScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RepositoryScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RepositoryScopeItem, a, b);
    }
}
RepositoryScopeItem.runtime = proto3;
RepositoryScopeItem.typeName = "exa.codeium_common_pb.RepositoryScopeItem";
RepositoryScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "repo_info", kind: "message", T: GitRepoInfo },
]);
/**
 * @generated from message exa.codeium_common_pb.RepositoryPathScopeItem
 */
export class RepositoryPathScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string relative_path = 2;
         */
        this.relativePath = "";
        /**
         * @generated from field: bool is_dir = 3;
         */
        this.isDir = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RepositoryPathScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RepositoryPathScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RepositoryPathScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RepositoryPathScopeItem, a, b);
    }
}
RepositoryPathScopeItem.runtime = proto3;
RepositoryPathScopeItem.typeName = "exa.codeium_common_pb.RepositoryPathScopeItem";
RepositoryPathScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "repo_info", kind: "message", T: GitRepoInfo },
    { no: 2, name: "relative_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "is_dir", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Next ID: 9
 *
 * @generated from message exa.codeium_common_pb.KnowledgeBaseScopeItem
 */
export class KnowledgeBaseScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Internal fields for retrieval.
         *
         * @generated from field: string document_id = 1;
         */
        this.documentId = "";
        /**
         * @generated from field: exa.codeium_common_pb.IndexChoice index = 7;
         */
        this.index = IndexChoice.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.DocumentType document_type = 8;
         */
        this.documentType = DocumentType.UNSPECIFIED;
        /**
         * User facing fields.
         *
         * @generated from field: string display_name = 3;
         */
        this.displayName = "";
        /**
         * @generated from field: string description = 4;
         */
        this.description = "";
        /**
         * @generated from field: string display_source = 5;
         */
        this.displaySource = "";
        /**
         * Url to the knowledge base item if available.
         *
         * @generated from field: string url = 6;
         */
        this.url = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KnowledgeBaseScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KnowledgeBaseScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KnowledgeBaseScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KnowledgeBaseScopeItem, a, b);
    }
}
KnowledgeBaseScopeItem.runtime = proto3;
KnowledgeBaseScopeItem.typeName = "exa.codeium_common_pb.KnowledgeBaseScopeItem";
KnowledgeBaseScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "index", kind: "enum", T: proto3.getEnumType(IndexChoice) },
    { no: 8, name: "document_type", kind: "enum", T: proto3.getEnumType(DocumentType) },
    { no: 3, name: "display_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "display_source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ConsoleLogLine
 */
export class ConsoleLogLine extends Message {
    constructor(data) {
        super();
        /**
         * Timestamp when the log was created.
         *
         * @generated from field: string timestamp_str = 1;
         */
        this.timestampStr = "";
        /**
         * Type of the log (error, warn, info, debug).
         *
         * @generated from field: string type = 2;
         */
        this.type = "";
        /**
         * Actual output of the log.
         *
         * @generated from field: string output = 3;
         */
        this.output = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ConsoleLogLine().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConsoleLogLine().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConsoleLogLine().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConsoleLogLine, a, b);
    }
}
ConsoleLogLine.runtime = proto3;
ConsoleLogLine.typeName = "exa.codeium_common_pb.ConsoleLogLine";
ConsoleLogLine.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp_str", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "output", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents mentioning logs from JS console for a web application.
 *
 * @generated from message exa.codeium_common_pb.ConsoleLogScopeItem
 */
export class ConsoleLogScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Output of the console log.
         *
         * @generated from field: repeated exa.codeium_common_pb.ConsoleLogLine lines = 1;
         */
        this.lines = [];
        /**
         * Address of web server (or proxy server).
         *
         * @generated from field: string server_address = 2;
         */
        this.serverAddress = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ConsoleLogScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConsoleLogScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConsoleLogScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConsoleLogScopeItem, a, b);
    }
}
ConsoleLogScopeItem.runtime = proto3;
ConsoleLogScopeItem.typeName = "exa.codeium_common_pb.ConsoleLogScopeItem";
ConsoleLogScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "lines", kind: "message", T: ConsoleLogLine, repeated: true },
    { no: 2, name: "server_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents a DOM element.
 * TODO(nick): consider adding more info about parent / contained content.
 *
 * @generated from message exa.codeium_common_pb.DOMElementScopeItem
 */
export class DOMElementScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Tag name of the element (e.g. "div", "span", "button").
         *
         * @generated from field: string tag_name = 1;
         */
        this.tagName = "";
        /**
         * Outer HTML of the element (may be truncated).
         *
         * @generated from field: string outer_html = 2;
         */
        this.outerHtml = "";
        /**
         * ID of the element (if applicable).
         *
         * @generated from field: string id = 3;
         */
        this.id = "";
        /**
         * Name of the containing React component (if applicable).
         *
         * @generated from field: string react_component_name = 4;
         */
        this.reactComponentName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DOMElementScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DOMElementScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DOMElementScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DOMElementScopeItem, a, b);
    }
}
DOMElementScopeItem.runtime = proto3;
DOMElementScopeItem.typeName = "exa.codeium_common_pb.DOMElementScopeItem";
DOMElementScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "tag_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "outer_html", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "react_component_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "file_line_range", kind: "message", T: FileLineRange },
]);
/**
 * Represents a complete DOM tree structure.
 *
 * @generated from message exa.codeium_common_pb.DOMTree
 */
export class DOMTree extends Message {
    constructor(data) {
        super();
        /**
         * Total number of nodes in the tree.
         *
         * @generated from field: uint32 num_nodes = 2;
         */
        this.numNodes = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DOMTree().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DOMTree().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DOMTree().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DOMTree, a, b);
    }
}
DOMTree.runtime = proto3;
DOMTree.typeName = "exa.codeium_common_pb.DOMTree";
DOMTree.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "root", kind: "message", T: DOMTree_DOMNode },
    { no: 2, name: "num_nodes", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * Bounding box for DOM elements.
 *
 * @generated from message exa.codeium_common_pb.DOMTree.BoundingBox
 */
export class DOMTree_BoundingBox extends Message {
    constructor(data) {
        super();
        /**
         * X coordinate in pixels.
         *
         * @generated from field: float x = 1;
         */
        this.x = 0;
        /**
         * Y coordinate in pixels.
         *
         * @generated from field: float y = 2;
         */
        this.y = 0;
        /**
         * Width in pixels.
         *
         * @generated from field: float width = 3;
         */
        this.width = 0;
        /**
         * Height in pixels.
         *
         * @generated from field: float height = 4;
         */
        this.height = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DOMTree_BoundingBox().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DOMTree_BoundingBox().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DOMTree_BoundingBox().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DOMTree_BoundingBox, a, b);
    }
}
DOMTree_BoundingBox.runtime = proto3;
DOMTree_BoundingBox.typeName = "exa.codeium_common_pb.DOMTree.BoundingBox";
DOMTree_BoundingBox.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "x", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "y", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "width", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "height", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
]);
/**
 * Represents a DOM node in a hierarchical tree structure.
 *
 * @generated from message exa.codeium_common_pb.DOMTree.DOMNode
 */
export class DOMTree_DOMNode extends Message {
    constructor(data) {
        super();
        /**
         * Child DOM nodes.
         *
         * @generated from field: repeated exa.codeium_common_pb.DOMTree.DOMNode children = 1;
         */
        this.children = [];
        /**
         * Tag name of the element (e.g. "div", "span", "button").
         *
         * @generated from field: string tag_name = 2;
         */
        this.tagName = "";
        /**
         * ID of the element (if applicable).
         *
         * @generated from field: string id = 3;
         */
        this.id = "";
        /**
         * CSS class names of the element.
         *
         * @generated from field: repeated string class_names = 4;
         */
        this.classNames = [];
        /**
         * Trimmed inner text content (limited to 100 chars).
         *
         * @generated from field: string text_content = 5;
         */
        this.textContent = "";
        /**
         * ARIA label for accessibility.
         *
         * @generated from field: string aria_label = 7;
         */
        this.ariaLabel = "";
        /**
         * Title attribute (tooltip text).
         *
         * @generated from field: string title = 8;
         */
        this.title = "";
        /**
         * Alt text for images.
         *
         * @generated from field: string alt = 9;
         */
        this.alt = "";
        /**
         * Placeholder text for inputs.
         *
         * @generated from field: string placeholder = 10;
         */
        this.placeholder = "";
        /**
         * Href attribute for links.
         *
         * @generated from field: string href = 11;
         */
        this.href = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DOMTree_DOMNode().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DOMTree_DOMNode().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DOMTree_DOMNode().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DOMTree_DOMNode, a, b);
    }
}
DOMTree_DOMNode.runtime = proto3;
DOMTree_DOMNode.typeName = "exa.codeium_common_pb.DOMTree.DOMNode";
DOMTree_DOMNode.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "children", kind: "message", T: DOMTree_DOMNode, repeated: true },
    { no: 2, name: "tag_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "class_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "text_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "bbox", kind: "message", T: DOMTree_BoundingBox },
    { no: 7, name: "aria_label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "alt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "placeholder", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "href", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * TODO before merging: I can't reference CustomToolSpec here since it's in cortex_pb and
 * referencing it would cause a circular dependency. Can I extract the most important fields?
 *
 * @generated from message exa.codeium_common_pb.RecipeScopeItem
 */
export class RecipeScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string recipe_id = 1;
         */
        this.recipeId = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * @generated from field: string description = 3;
         */
        this.description = "";
        /**
         * @generated from field: string system_prompt = 4;
         */
        this.systemPrompt = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RecipeScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RecipeScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RecipeScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RecipeScopeItem, a, b);
    }
}
RecipeScopeItem.runtime = proto3;
RecipeScopeItem.typeName = "exa.codeium_common_pb.RecipeScopeItem";
RecipeScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "recipe_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "system_prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message exa.codeium_common_pb.RuleScopeItem
 */
export class RuleScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string rule_path = 1;
         */
        this.rulePath = "";
        /**
         * @generated from field: string rule_name = 2;
         */
        this.ruleName = "";
        /**
         * TODO(sean): This is actually the content, will rename after cut to minimize risk of bricking my local state
         *
         * @generated from field: string description = 3;
         */
        this.description = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RuleScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleScopeItem, a, b);
    }
}
RuleScopeItem.runtime = proto3;
RuleScopeItem.typeName = "exa.codeium_common_pb.RuleScopeItem";
RuleScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "rule_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rule_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.McpResourceItem
 */
export class McpResourceItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string uri = 1;
         */
        this.uri = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string server_name = 5;
         */
        this.serverName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpResourceItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpResourceItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpResourceItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpResourceItem, a, b);
    }
}
McpResourceItem.runtime = proto3;
McpResourceItem.typeName = "exa.codeium_common_pb.McpResourceItem";
McpResourceItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 5, name: "server_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents all visible text content from a browser page
 *
 * @generated from message exa.codeium_common_pb.BrowserPageScopeItem
 */
export class BrowserPageScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * URL of the page
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * Title of the page
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * All visible text content from the page
         *
         * @generated from field: string visible_text_content = 3;
         */
        this.visibleTextContent = "";
        /**
         * ID of the page in the browser session
         *
         * @generated from field: string page_id = 4;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserPageScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserPageScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserPageScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserPageScopeItem, a, b);
    }
}
BrowserPageScopeItem.runtime = proto3;
BrowserPageScopeItem.typeName = "exa.codeium_common_pb.BrowserPageScopeItem";
BrowserPageScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "visible_text_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents a selected block of code from a browser page
 *
 * @generated from message exa.codeium_common_pb.BrowserCodeBlockScopeItem
 */
export class BrowserCodeBlockScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * URL of the page where the code block is located
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * Title of the page
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * The text content of the code block
         *
         * @generated from field: string code_content = 3;
         */
        this.codeContent = "";
        /**
         * Detected or user-specified language of the code
         *
         * @generated from field: exa.codeium_common_pb.Language language = 4;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * ID of the page in the browser session
         *
         * @generated from field: string page_id = 6;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserCodeBlockScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserCodeBlockScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserCodeBlockScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserCodeBlockScopeItem, a, b);
    }
}
BrowserCodeBlockScopeItem.runtime = proto3;
BrowserCodeBlockScopeItem.typeName = "exa.codeium_common_pb.BrowserCodeBlockScopeItem";
BrowserCodeBlockScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "code_content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 5, name: "context_text", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 6, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents text content from a specific DOM element on a browser page
 *
 * @generated from message exa.codeium_common_pb.BrowserTextScopeItem
 */
export class BrowserTextScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * URL of the page containing the element
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * The inner text content of the selected element
         *
         * @generated from field: string visible_text = 2;
         */
        this.visibleText = "";
        /**
         * ID of the page in the browser session
         *
         * @generated from field: string page_id = 3;
         */
        this.pageId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserTextScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserTextScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserTextScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserTextScopeItem, a, b);
    }
}
BrowserTextScopeItem.runtime = proto3;
BrowserTextScopeItem.typeName = "exa.codeium_common_pb.BrowserTextScopeItem";
BrowserTextScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "visible_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Represents a reference to a trajectory search, used for @-mentions.
 *
 * @generated from message exa.codeium_common_pb.ConversationScopeItem
 */
export class ConversationScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Cascade ID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Conversation title
         *
         * @generated from field: string title = 2;
         */
        this.title = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ConversationScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ConversationScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ConversationScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ConversationScopeItem, a, b);
    }
}
ConversationScopeItem.runtime = proto3;
ConversationScopeItem.typeName = "exa.codeium_common_pb.ConversationScopeItem";
ConversationScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_modified_time", kind: "message", T: Timestamp },
]);
/**
 * Represents a reference to a user activity, used for @-mentions.
 *
 * @generated from message exa.codeium_common_pb.UserActivityScopeItem
 */
export class UserActivityScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Trajectory ID
         *
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * Git branch associated with activity ("" if there is no branch)
         *
         * @generated from field: string branch = 2;
         */
        this.branch = "";
        /**
         * Whether this is the active trajectory for an active workspace
         *
         * @generated from field: bool current = 3;
         */
        this.current = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UserActivityScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UserActivityScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UserActivityScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UserActivityScopeItem, a, b);
    }
}
UserActivityScopeItem.runtime = proto3;
UserActivityScopeItem.typeName = "exa.codeium_common_pb.UserActivityScopeItem";
UserActivityScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "current", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * Represents a reference to a terminal session, used for @-mentions.
 *
 * @generated from message exa.codeium_common_pb.TerminalScopeItem
 */
export class TerminalScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * Process ID of the terminal
         *
         * @generated from field: string process_id = 1;
         */
        this.processId = "";
        /**
         * Terminal name
         *
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * Last command executed in the terminal
         *
         * @generated from field: string last_command = 3;
         */
        this.lastCommand = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalScopeItem, a, b);
    }
}
TerminalScopeItem.runtime = proto3;
TerminalScopeItem.typeName = "exa.codeium_common_pb.TerminalScopeItem";
TerminalScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "process_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "last_command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.GithubPullRequestItem
 */
export class GithubPullRequestItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * @generated from field: string owner = 3;
         */
        this.owner = "";
        /**
         * @generated from field: string number = 4;
         */
        this.number = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GithubPullRequestItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GithubPullRequestItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GithubPullRequestItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GithubPullRequestItem, a, b);
    }
}
GithubPullRequestItem.runtime = proto3;
GithubPullRequestItem.typeName = "exa.codeium_common_pb.GithubPullRequestItem";
GithubPullRequestItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ContextScopeItem
 */
export class ContextScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.ContextScopeItem.scope_item
         */
        this.scopeItem = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ContextScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContextScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContextScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContextScopeItem, a, b);
    }
}
ContextScopeItem.runtime = proto3;
ContextScopeItem.typeName = "exa.codeium_common_pb.ContextScopeItem";
ContextScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "file", kind: "message", T: PathScopeItem, oneof: "scope_item" },
    { no: 2, name: "directory", kind: "message", T: PathScopeItem, oneof: "scope_item" },
    { no: 3, name: "repository", kind: "message", T: RepositoryScopeItem, oneof: "scope_item" },
    { no: 4, name: "code_context", kind: "message", T: CodeContextItem, oneof: "scope_item" },
    { no: 6, name: "cci_with_subrange", kind: "message", T: CciWithSubrange, oneof: "scope_item" },
    { no: 7, name: "repository_path", kind: "message", T: RepositoryPathScopeItem, oneof: "scope_item" },
    { no: 8, name: "slack", kind: "message", T: KnowledgeBaseScopeItem, oneof: "scope_item" },
    { no: 9, name: "github", kind: "message", T: KnowledgeBaseScopeItem, oneof: "scope_item" },
    { no: 10, name: "file_line_range", kind: "message", T: FileLineRange, oneof: "scope_item" },
    { no: 11, name: "text_block", kind: "message", T: TextBlock, oneof: "scope_item" },
    { no: 12, name: "jira", kind: "message", T: KnowledgeBaseScopeItem, oneof: "scope_item" },
    { no: 13, name: "google_drive", kind: "message", T: KnowledgeBaseScopeItem, oneof: "scope_item" },
    { no: 14, name: "console_log", kind: "message", T: ConsoleLogScopeItem, oneof: "scope_item" },
    { no: 15, name: "dom_element", kind: "message", T: DOMElementScopeItem, oneof: "scope_item" },
    { no: 16, name: "recipe", kind: "message", T: RecipeScopeItem, oneof: "scope_item" },
    { no: 17, name: "knowledge", kind: "message", T: KnowledgeBaseScopeItem, oneof: "scope_item" },
    { no: 18, name: "rule", kind: "message", T: RuleScopeItem, oneof: "scope_item" },
    { no: 19, name: "mcp_resource", kind: "message", T: McpResourceItem, oneof: "scope_item" },
    { no: 20, name: "browser_page", kind: "message", T: BrowserPageScopeItem, oneof: "scope_item" },
    { no: 21, name: "browser_code_block", kind: "message", T: BrowserCodeBlockScopeItem, oneof: "scope_item" },
    { no: 22, name: "browser_text", kind: "message", T: BrowserTextScopeItem, oneof: "scope_item" },
    { no: 23, name: "conversation", kind: "message", T: ConversationScopeItem, oneof: "scope_item" },
    { no: 24, name: "user_activity", kind: "message", T: UserActivityScopeItem, oneof: "scope_item" },
    { no: 25, name: "terminal", kind: "message", T: TerminalScopeItem, oneof: "scope_item" },
    { no: 26, name: "github_pull_request", kind: "message", T: GithubPullRequestItem, oneof: "scope_item" },
]);
/**
 * @generated from message exa.codeium_common_pb.ContextScope
 */
export class ContextScope extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.ContextScopeItem items = 1;
         */
        this.items = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ContextScope().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ContextScope().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ContextScope().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ContextScope, a, b);
    }
}
ContextScope.runtime = proto3;
ContextScope.typeName = "exa.codeium_common_pb.ContextScope";
ContextScope.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: ContextScopeItem, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.NodeExecutionRecord
 */
export class NodeExecutionRecord extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string node_name = 1;
         */
        this.nodeName = "";
        /**
         * Serialized state of the graph at the end of this node.
         *
         * @generated from field: bytes graph_state_json = 5;
         */
        this.graphStateJson = new Uint8Array(0);
        /**
         * @generated from field: uint64 graph_state_json_num_bytes = 6;
         */
        this.graphStateJsonNumBytes = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new NodeExecutionRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new NodeExecutionRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new NodeExecutionRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(NodeExecutionRecord, a, b);
    }
}
NodeExecutionRecord.runtime = proto3;
NodeExecutionRecord.typeName = "exa.codeium_common_pb.NodeExecutionRecord";
NodeExecutionRecord.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "node_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "start_time", kind: "message", T: Timestamp },
    { no: 3, name: "end_time", kind: "message", T: Timestamp },
    { no: 5, name: "graph_state_json", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 6, name: "graph_state_json_num_bytes", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "subgraph_execution", kind: "message", T: GraphExecutionState },
]);
/**
 * @generated from message exa.codeium_common_pb.GraphExecutionState
 */
export class GraphExecutionState extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.NodeExecutionRecord history = 2;
         */
        this.history = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GraphExecutionState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GraphExecutionState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GraphExecutionState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GraphExecutionState, a, b);
    }
}
GraphExecutionState.runtime = proto3;
GraphExecutionState.typeName = "exa.codeium_common_pb.GraphExecutionState";
GraphExecutionState.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "current", kind: "message", T: NodeExecutionRecord },
    { no: 2, name: "history", kind: "message", T: NodeExecutionRecord, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.Guideline
 */
export class Guideline extends Message {
    constructor(data) {
        super();
        /**
         * GuidelineItem is a free form guideline attached as a context to chat, command and autocomplete
         *
         * @generated from field: repeated exa.codeium_common_pb.GuidelineItem items = 1;
         */
        this.items = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Guideline().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Guideline().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Guideline().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Guideline, a, b);
    }
}
Guideline.runtime = proto3;
Guideline.typeName = "exa.codeium_common_pb.Guideline";
Guideline.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "items", kind: "message", T: GuidelineItem, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.GuidelineItem
 */
export class GuidelineItem extends Message {
    constructor(data) {
        super();
        /**
         * Free form guideline applied as a context item
         *
         * @generated from field: string guideline = 1;
         */
        this.guideline = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GuidelineItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GuidelineItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GuidelineItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GuidelineItem, a, b);
    }
}
GuidelineItem.runtime = proto3;
GuidelineItem.typeName = "exa.codeium_common_pb.GuidelineItem";
GuidelineItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "guideline", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatNodeConfig
 */
export class ChatNodeConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 1;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        /**
         * TODO(matt): Move these settings under CompletionConfiguration.
         *
         * @generated from field: uint32 max_input_tokens = 2;
         */
        this.maxInputTokens = 0;
        /**
         * @generated from field: float temperature = 3;
         */
        this.temperature = 0;
        /**
         * @generated from field: uint32 max_output_tokens = 4;
         */
        this.maxOutputTokens = 0;
        /**
         * @generated from field: bool order_snippets_by_file = 5;
         */
        this.orderSnippetsByFile = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatNodeConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatNodeConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatNodeConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatNodeConfig, a, b);
    }
}
ChatNodeConfig.runtime = proto3;
ChatNodeConfig.typeName = "exa.codeium_common_pb.ChatNodeConfig";
ChatNodeConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "max_input_tokens", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "temperature", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "max_output_tokens", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "order_snippets_by_file", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * MQueryConfig is the configuration for a query to the model.
 *
 * @generated from message exa.codeium_common_pb.MQueryConfig
 */
export class MQueryConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool should_batch_ccis = 1;
         */
        this.shouldBatchCcis = false;
        /**
         * @generated from field: int64 max_tokens_per_subrange = 2;
         */
        this.maxTokensPerSubrange = protoInt64.zero;
        /**
         * @generated from field: int64 num_parser_workers = 3;
         */
        this.numParserWorkers = protoInt64.zero;
        /**
         * @generated from field: int64 num_workers_per_distributed_scorer = 4;
         */
        this.numWorkersPerDistributedScorer = protoInt64.zero;
        /**
         * @generated from field: bool verbose = 5;
         */
        this.verbose = false;
        /**
         * Files with these extensions should be ignored
         *
         * @generated from field: repeated string ignore_extensions = 6;
         */
        this.ignoreExtensions = [];
        /**
         * Directories that include this in their path should be ignored.
         *
         * @generated from field: repeated string ignore_directory_stubs = 7;
         */
        this.ignoreDirectoryStubs = [];
        /**
         * @generated from field: uint32 min_token_space_for_context = 8;
         */
        this.minTokenSpaceForContext = 0;
        /**
         * Bounded by MaxMaxTargetFiles (10_000)
         *
         * @generated from field: uint32 max_target_files = 9;
         */
        this.maxTargetFiles = 0;
        /**
         * Will filter out ccis outside of the top count.
         *
         * @generated from field: uint32 top_cci_count = 10;
         */
        this.topCciCount = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MQueryConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MQueryConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MQueryConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MQueryConfig, a, b);
    }
}
MQueryConfig.runtime = proto3;
MQueryConfig.typeName = "exa.codeium_common_pb.MQueryConfig";
MQueryConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "should_batch_ccis", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "max_tokens_per_subrange", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "num_parser_workers", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "num_workers_per_distributed_scorer", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "verbose", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "ignore_extensions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "ignore_directory_stubs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "min_token_space_for_context", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 9, name: "max_target_files", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 10, name: "top_cci_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * CompletionDelta is primarily used in the ModelAPIClientInterface interface in streaming
 * back delta chunks for GetStreamingTextCompletion.
 *
 * @generated from message exa.codeium_common_pb.CompletionDelta
 */
export class CompletionDelta extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string delta_text = 1;
         */
        this.deltaText = "";
        /**
         * @generated from field: uint32 delta_tokens = 2;
         */
        this.deltaTokens = 0;
        /**
         * The following are only populated on the last delta.
         *
         * @generated from field: exa.codeium_common_pb.StopReason stop_reason = 3;
         */
        this.stopReason = StopReason.UNSPECIFIED;
        /**
         * @generated from field: repeated exa.codeium_common_pb.ChatToolCall delta_tool_calls = 5;
         */
        this.deltaToolCalls = [];
        /**
         * @generated from field: string delta_thinking = 6;
         */
        this.deltaThinking = "";
        /**
         * When using OpenAI’s Responses API, this field stores a JSON-encoded array of reasoning
         * content items. Each item includes an ID and encrypted content and must be returned in
         * subsequent requests as separate objects. The entire list of items is returned in the final delta.
         *
         * @generated from field: string delta_signature = 7;
         */
        this.deltaSignature = "";
        /**
         * If this is true, then delta_signature is fully populated and this chunk should be interpreted
         * as a full thinking_redacted delta.
         *
         * @generated from field: bool thinking_redacted = 8;
         */
        this.thinkingRedacted = false;
        /**
         * OpenAI's Responses API returns an id with each content item that needs to be passed back on future API requests.
         *
         * @generated from field: string output_id = 9;
         */
        this.outputId = "";
        /**
         * @generated from field: string thinking_id = 10 [deprecated = true];
         * @deprecated
         */
        this.thinkingId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionDelta().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionDelta().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionDelta().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionDelta, a, b);
    }
}
CompletionDelta.runtime = proto3;
CompletionDelta.typeName = "exa.codeium_common_pb.CompletionDelta";
CompletionDelta.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "delta_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "delta_tokens", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "stop_reason", kind: "enum", T: proto3.getEnumType(StopReason) },
    { no: 4, name: "usage", kind: "message", T: ModelUsageStats },
    { no: 5, name: "delta_tool_calls", kind: "message", T: ChatToolCall, repeated: true },
    { no: 6, name: "delta_thinking", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "delta_signature", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "thinking_redacted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "output_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "thinking_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * CompletionDeltaMap is used by GetStreamingTextCompletion to stream back
 * multiple completions for a single prompt.
 *
 * @generated from message exa.codeium_common_pb.CompletionDeltaMap
 */
export class CompletionDeltaMap extends Message {
    constructor(data) {
        super();
        /**
         * A map of completion index (within a sequence) to CompletionDelta messages.
         * Note that not all completions may be included in this map, if some of them
         * finish early. (For example, our internal model API client will only
         * include CompletionDeltas for completions that have not yet finished.)
         *
         * @generated from field: map<int32, exa.codeium_common_pb.CompletionDelta> deltas = 1;
         */
        this.deltas = {};
        /**
         * The prompt string that was generated by the model API client. This will be
         * empty unless the api server was constructed with EvalMode == true, in which
         * case it will be populated for the first CompletionDeltaMap that is returned.
         * Note that this is best-effort, as we may not be able to construct the true
         * prompt string used by some API providers.
         * Currently only implemented for our internal model API client; prompt will
         * be empty for other providers.
         *
         * @generated from field: string prompt = 2;
         */
        this.prompt = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CompletionDeltaMap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompletionDeltaMap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompletionDeltaMap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompletionDeltaMap, a, b);
    }
}
CompletionDeltaMap.runtime = proto3;
CompletionDeltaMap.typeName = "exa.codeium_common_pb.CompletionDeltaMap";
CompletionDeltaMap.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "deltas", kind: "map", K: 5 /* ScalarType.INT32 */, V: { kind: "message", T: CompletionDelta } },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "completion_profile", kind: "message", T: CompletionProfile },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatCompletionInfo
 */
export class ChatCompletionInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string prompt = 1;
         */
        this.prompt = "";
        /**
         * @generated from field: string inference_address = 2;
         */
        this.inferenceAddress = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatCompletionInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatCompletionInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatCompletionInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatCompletionInfo, a, b);
    }
}
ChatCompletionInfo.runtime = proto3;
ChatCompletionInfo.typeName = "exa.codeium_common_pb.ChatCompletionInfo";
ChatCompletionInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "inference_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ChatToolCall
 */
export class ChatToolCall extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string name = 2;
         */
        this.name = "";
        /**
         * @generated from field: string arguments_json = 3;
         */
        this.argumentsJson = "";
        /**
         * If the JSON provided in the tool call is invalid, then arguments_json will be {} and
         * the underlying invalid_json_str will contain the raw invalid json. Otherwise if the
         * JSON is valid, then invalid_json_str and invalid_json_err will be empty.
         *
         * @generated from field: string invalid_json_str = 4;
         */
        this.invalidJsonStr = "";
        /**
         * Error message describing why the json is invalid.
         *
         * @generated from field: string invalid_json_err = 5;
         */
        this.invalidJsonErr = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ChatToolCall().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ChatToolCall().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ChatToolCall().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ChatToolCall, a, b);
    }
}
ChatToolCall.runtime = proto3;
ChatToolCall.typeName = "exa.codeium_common_pb.ChatToolCall";
ChatToolCall.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "arguments_json", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "invalid_json_str", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "invalid_json_err", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.Status
 */
export class Status extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.StatusLevel level = 1;
         */
        this.level = StatusLevel.UNSPECIFIED;
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Status().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Status().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Status().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Status, a, b);
    }
}
Status.runtime = proto3;
Status.typeName = "exa.codeium_common_pb.Status";
Status.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "level", kind: "enum", T: proto3.getEnumType(StatusLevel) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.DocumentPosition
 */
export class DocumentPosition extends Message {
    constructor(data) {
        super();
        /**
         * 0-indexed.
         *
         * @generated from field: uint64 row = 1;
         */
        this.row = protoInt64.zero;
        /**
         * 0-indexed. Measured in UTF-8 bytes.
         *
         * @generated from field: uint64 col = 2;
         */
        this.col = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DocumentPosition().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentPosition().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentPosition().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentPosition, a, b);
    }
}
DocumentPosition.runtime = proto3;
DocumentPosition.typeName = "exa.codeium_common_pb.DocumentPosition";
DocumentPosition.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "row", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "col", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * Next ID: 5, Previous field: end_position.
 *
 * @generated from message exa.codeium_common_pb.Range
 */
export class Range extends Message {
    constructor(data) {
        super();
        /**
         * 0-indexed (start & end).
         *
         * @generated from field: uint64 start_offset = 1;
         */
        this.startOffset = protoInt64.zero;
        /**
         * Exclusive.
         *
         * @generated from field: uint64 end_offset = 2;
         */
        this.endOffset = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Range().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Range().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Range().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Range, a, b);
    }
}
Range.runtime = proto3;
Range.typeName = "exa.codeium_common_pb.Range";
Range.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "start_offset", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: "end_offset", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "start_position", kind: "message", T: DocumentPosition },
    { no: 4, name: "end_position", kind: "message", T: DocumentPosition },
]);
/**
 * Next ID: 14, Previous field: workspace_uri.
 *
 * @generated from message exa.codeium_common_pb.Document
 */
export class Document extends Message {
    constructor(data) {
        super();
        /**
         * OS specific separators.
         *
         * @generated from field: string absolute_path_migrate_me_to_uri = 1 [deprecated = true];
         * @deprecated
         */
        this.absolutePathMigrateMeToUri = "";
        /**
         * @generated from field: string absolute_uri = 12;
         */
        this.absoluteUri = "";
        /**
         * Path relative to the root of the workspace. Slash separated.
         * Leave empty if the document is not in the workspace.
         *
         * @generated from field: string relative_path_migrate_me_to_workspace_uri = 2 [deprecated = true];
         * @deprecated
         */
        this.relativePathMigrateMeToWorkspaceUri = "";
        /**
         * @generated from field: string workspace_uri = 13;
         */
        this.workspaceUri = "";
        /**
         * @generated from field: string text = 3;
         */
        this.text = "";
        /**
         * Language ID provided by the editor.
         *
         * @generated from field: string editor_language = 4;
         */
        this.editorLanguage = "";
        /**
         * Language enum standardized across editors.
         *
         * @generated from field: exa.codeium_common_pb.Language language = 5;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * Measured in number of UTF-8 bytes.
         *
         * @generated from field: uint64 cursor_offset = 6;
         */
        this.cursorOffset = protoInt64.zero;
        /**
         * \n or \r\n, if known.
         *
         * @generated from field: string line_ending = 7;
         */
        this.lineEnding = "";
        /**
         * Booleans indicating whether this document represents a portion of a full document with the
         * start / end  cutoff. Note that cursor_offset and cursor_position are expected to be valid
         * within text (e.g. if the start of the document is cutoff in text, cursor_offset and
         * cursor_position should be adjusted accordingly).
         * TODO(nmoy): deprecate these bools now that we have lines_cutoff_start/lines_cutoff_end.
         *
         * @generated from field: bool is_cutoff_start = 10;
         */
        this.isCutoffStart = false;
        /**
         * @generated from field: bool is_cutoff_end = 11;
         */
        this.isCutoffEnd = false;
        /**
         * The number of lines from the original document that are cut off and not included in this
         * partial document. If these values are non-zero that means that this is a partial document.
         * If it has not been cutoff, these should both be equal 0.
         *
         * @generated from field: int32 lines_cutoff_start = 14;
         */
        this.linesCutoffStart = 0;
        /**
         * @generated from field: int32 lines_cutoff_end = 15;
         */
        this.linesCutoffEnd = 0;
        /**
         * True if there are unpersisted changes to the document.
         *
         * @generated from field: bool is_dirty = 17;
         */
        this.isDirty = false;
        /**
         * True if the document is not a real document, e.g. chat input.
         *
         * @generated from field: bool is_synthetic = 18;
         */
        this.isSynthetic = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Document().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Document().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Document().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Document, a, b);
    }
}
Document.runtime = proto3;
Document.typeName = "exa.codeium_common_pb.Document";
Document.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "absolute_path_migrate_me_to_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "absolute_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "relative_path_migrate_me_to_workspace_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "workspace_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "editor_language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 6, name: "cursor_offset", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 8, name: "cursor_position", kind: "message", T: DocumentPosition },
    { no: 7, name: "line_ending", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "visible_range", kind: "message", T: Range },
    { no: 10, name: "is_cutoff_start", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "is_cutoff_end", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "lines_cutoff_start", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 15, name: "lines_cutoff_end", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 16, name: "timestamp", kind: "message", T: Timestamp },
    { no: 17, name: "is_dirty", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "is_synthetic", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * TODO(nick): if we have more types of prompts with different component types we should make this a
 * oneof. Move to prompt.proto
 *
 * @generated from message exa.codeium_common_pb.PromptComponents
 */
export class PromptComponents extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.Document other_documents = 2;
         */
        this.otherDocuments = [];
        /**
         * @generated from field: repeated exa.codeium_common_pb.CodeContextItem code_context_items = 3;
         */
        this.codeContextItems = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PromptComponents().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PromptComponents().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PromptComponents().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PromptComponents, a, b);
    }
}
PromptComponents.runtime = proto3;
PromptComponents.typeName = "exa.codeium_common_pb.PromptComponents";
PromptComponents.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "document", kind: "message", T: Document },
    { no: 2, name: "other_documents", kind: "message", T: Document, repeated: true },
    { no: 3, name: "code_context_items", kind: "message", T: CodeContextItem, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.TextOrScopeItem
 */
export class TextOrScopeItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.TextOrScopeItem.chunk
         */
        this.chunk = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TextOrScopeItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TextOrScopeItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TextOrScopeItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TextOrScopeItem, a, b);
    }
}
TextOrScopeItem.runtime = proto3;
TextOrScopeItem.typeName = "exa.codeium_common_pb.TextOrScopeItem";
TextOrScopeItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "chunk" },
    { no: 2, name: "item", kind: "message", T: ContextScopeItem, oneof: "chunk" },
]);
/**
 * User-facing proto to set default pinned context.
 * Not using existing ContextScope proto since that proto
 * is more complex for the user to fill out. Want to make it
 * as simple as possible for users to add new default pinned context.
 *
 * @generated from message exa.codeium_common_pb.PinnedContextConfig
 */
export class PinnedContextConfig extends Message {
    constructor(data) {
        super();
        /**
         * Exact match repo name
         *
         * @generated from field: string match_repo_name = 1;
         */
        this.matchRepoName = "";
        /**
         * Prefix match path.
         *
         * @generated from field: string match_path = 2;
         */
        this.matchPath = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.PinnedContext pinned_contexts = 3;
         */
        this.pinnedContexts = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PinnedContextConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PinnedContextConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PinnedContextConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PinnedContextConfig, a, b);
    }
}
PinnedContextConfig.runtime = proto3;
PinnedContextConfig.typeName = "exa.codeium_common_pb.PinnedContextConfig";
PinnedContextConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "match_repo_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "match_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "pinned_contexts", kind: "message", T: PinnedContext, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.PinnedContext
 */
export class PinnedContext extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.PinnedContext.context_item
         */
        this.contextItem = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PinnedContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PinnedContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PinnedContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PinnedContext, a, b);
    }
}
PinnedContext.runtime = proto3;
PinnedContext.typeName = "exa.codeium_common_pb.PinnedContext";
PinnedContext.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "repository_path", kind: "message", T: RepositoryPath, oneof: "context_item" },
]);
/**
 * @generated from message exa.codeium_common_pb.RepositoryPath
 */
export class RepositoryPath extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string remote_repo_name = 1;
         */
        this.remoteRepoName = "";
        /**
         * empty string for latest
         *
         * @generated from field: string version = 2;
         */
        this.version = "";
        /**
         * empty string for relative_path will pin the whole repo instead
         *
         * @generated from field: string relative_path = 3;
         */
        this.relativePath = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RepositoryPath().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RepositoryPath().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RepositoryPath().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RepositoryPath, a, b);
    }
}
RepositoryPath.runtime = proto3;
RepositoryPath.typeName = "exa.codeium_common_pb.RepositoryPath";
RepositoryPath.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "remote_repo_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "relative_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.DefaultPinnedContextConfig
 */
export class DefaultPinnedContextConfig extends Message {
    constructor(data) {
        super();
        /**
         * Empty string applies to project without a git repo
         *
         * @generated from field: repeated exa.codeium_common_pb.PinnedContextConfig pinned_context_configs = 1;
         */
        this.pinnedContextConfigs = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DefaultPinnedContextConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DefaultPinnedContextConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DefaultPinnedContextConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DefaultPinnedContextConfig, a, b);
    }
}
DefaultPinnedContextConfig.runtime = proto3;
DefaultPinnedContextConfig.typeName = "exa.codeium_common_pb.DefaultPinnedContextConfig";
DefaultPinnedContextConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "pinned_context_configs", kind: "message", T: PinnedContextConfig, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.Rule
 */
export class Rule extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string prompt = 2;
         */
        this.prompt = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new Rule().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new Rule().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new Rule().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(Rule, a, b);
    }
}
Rule.runtime = proto3;
Rule.typeName = "exa.codeium_common_pb.Rule";
Rule.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prompt", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.RuleViolation
 */
export class RuleViolation extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: int32 start_line = 3;
         */
        this.startLine = 0;
        /**
         * @generated from field: int32 end_line = 4;
         */
        this.endLine = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new RuleViolation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RuleViolation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RuleViolation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RuleViolation, a, b);
    }
}
RuleViolation.runtime = proto3;
RuleViolation.typeName = "exa.codeium_common_pb.RuleViolation";
RuleViolation.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "rule", kind: "message", T: Rule },
    { no: 3, name: "start_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "end_line", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.LanguageServerDiagnostics
 */
export class LanguageServerDiagnostics extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated string logs = 1;
         */
        this.logs = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LanguageServerDiagnostics().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LanguageServerDiagnostics().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LanguageServerDiagnostics().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LanguageServerDiagnostics, a, b);
    }
}
LanguageServerDiagnostics.runtime = proto3;
LanguageServerDiagnostics.typeName = "exa.codeium_common_pb.LanguageServerDiagnostics";
LanguageServerDiagnostics.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "logs", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
]);
/**
 * Message with statistics about the indexer database.
 *
 * @generated from message exa.codeium_common_pb.IndexerStats
 */
export class IndexerStats extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new IndexerStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexerStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexerStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexerStats, a, b);
    }
}
IndexerStats.runtime = proto3;
IndexerStats.typeName = "exa.codeium_common_pb.IndexerStats";
IndexerStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "database", kind: "message", T: IndexerDbStats },
]);
/**
 * @generated from message exa.codeium_common_pb.IndexerDbStats
 */
export class IndexerDbStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.IndexerDbStats.backend
         */
        this.backend = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new IndexerDbStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IndexerDbStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IndexerDbStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IndexerDbStats, a, b);
    }
}
IndexerDbStats.runtime = proto3;
IndexerDbStats.typeName = "exa.codeium_common_pb.IndexerDbStats";
IndexerDbStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "local_sqlite_faiss", kind: "message", T: LocalSqliteFaissDbStats, oneof: "backend" },
    { no: 2, name: "postgres", kind: "message", T: PostgresDbStats, oneof: "backend" },
]);
/**
 * @generated from message exa.codeium_common_pb.LocalSqliteFaissDbStats
 */
export class LocalSqliteFaissDbStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.FaissStateStats faiss_state_stats = 1;
         */
        this.faissStateStats = [];
        /**
         * @generated from field: int64 total_item_count = 2;
         */
        this.totalItemCount = protoInt64.zero;
        /**
         * @generated from field: bool quantized = 3;
         */
        this.quantized = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LocalSqliteFaissDbStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LocalSqliteFaissDbStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LocalSqliteFaissDbStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LocalSqliteFaissDbStats, a, b);
    }
}
LocalSqliteFaissDbStats.runtime = proto3;
LocalSqliteFaissDbStats.typeName = "exa.codeium_common_pb.LocalSqliteFaissDbStats";
LocalSqliteFaissDbStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "faiss_state_stats", kind: "message", T: FaissStateStats, repeated: true },
    { no: 2, name: "total_item_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 3, name: "quantized", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.FaissStateStats
 */
export class FaissStateStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.EmbeddingSource embedding_source = 1;
         */
        this.embeddingSource = EmbeddingSource.UNSPECIFIED;
        /**
         * @generated from field: string workspace = 2;
         */
        this.workspace = "";
        /**
         * @generated from field: int64 item_count = 3;
         */
        this.itemCount = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new FaissStateStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FaissStateStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FaissStateStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FaissStateStats, a, b);
    }
}
FaissStateStats.runtime = proto3;
FaissStateStats.typeName = "exa.codeium_common_pb.FaissStateStats";
FaissStateStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "embedding_source", kind: "enum", T: proto3.getEnumType(EmbeddingSource) },
    { no: 2, name: "workspace", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "item_count", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.PostgresDbStats
 */
export class PostgresDbStats extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PostgresDbStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PostgresDbStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PostgresDbStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PostgresDbStats, a, b);
    }
}
PostgresDbStats.runtime = proto3;
PostgresDbStats.typeName = "exa.codeium_common_pb.PostgresDbStats";
PostgresDbStats.fields = proto3.util.newFieldList(() => []);
/**
 * @generated from message exa.codeium_common_pb.LastUpdateRecord
 */
export class LastUpdateRecord extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.LastUpdateType type = 2;
         */
        this.type = LastUpdateType.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LastUpdateRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LastUpdateRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LastUpdateRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LastUpdateRecord, a, b);
    }
}
LastUpdateRecord.runtime = proto3;
LastUpdateRecord.typeName = "exa.codeium_common_pb.LastUpdateRecord";
LastUpdateRecord.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "time", kind: "message", T: Timestamp },
    { no: 2, name: "type", kind: "enum", T: proto3.getEnumType(LastUpdateType) },
]);
/**
 * Information directly from API provider about usage of the model.
 *
 * @generated from message exa.codeium_common_pb.ModelUsageStats
 */
export class ModelUsageStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 1;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        /**
         * @generated from field: uint64 input_tokens = 2;
         */
        this.inputTokens = protoInt64.zero;
        /**
         * For multiple completions, this should be interpreted as the sum of all outputs.
         *
         * @generated from field: uint64 output_tokens = 3;
         */
        this.outputTokens = protoInt64.zero;
        /**
         * The number of tokens written to the cache when creating a new entry. Only applicable
         * for prompt caching, only populated for Anthropic.
         *
         * @generated from field: uint64 cache_write_tokens = 4;
         */
        this.cacheWriteTokens = protoInt64.zero;
        /**
         * The number of tokens successfully read from the cache. Only applicable for
         * prompt caching, only populated for Anthropic.
         *
         * @generated from field: uint64 cache_read_tokens = 5;
         */
        this.cacheReadTokens = protoInt64.zero;
        /**
         * @generated from field: exa.codeium_common_pb.APIProvider api_provider = 6;
         */
        this.apiProvider = APIProvider.API_PROVIDER_UNSPECIFIED;
        /**
         * External message id for this request.
         *
         * @generated from field: string message_id = 7;
         */
        this.messageId = "";
        /**
         * Response headers from the API provider.
         *
         * @generated from field: map<string, string> response_header = 8;
         */
        this.responseHeader = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelUsageStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelUsageStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelUsageStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelUsageStats, a, b);
    }
}
ModelUsageStats.runtime = proto3;
ModelUsageStats.typeName = "exa.codeium_common_pb.ModelUsageStats";
ModelUsageStats.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "input_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 3, name: "output_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 4, name: "cache_write_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 5, name: "cache_read_tokens", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 6, name: "api_provider", kind: "enum", T: proto3.getEnumType(APIProvider) },
    { no: 7, name: "message_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "response_header", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.SuperCompleteFilterReason
 */
export class SuperCompleteFilterReason extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string reason = 1;
         */
        this.reason = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SuperCompleteFilterReason().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SuperCompleteFilterReason().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SuperCompleteFilterReason().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SuperCompleteFilterReason, a, b);
    }
}
SuperCompleteFilterReason.runtime = proto3;
SuperCompleteFilterReason.typeName = "exa.codeium_common_pb.SuperCompleteFilterReason";
SuperCompleteFilterReason.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Proto representation of VSCode's Diagnostic.
 *
 * @generated from message exa.codeium_common_pb.CodeDiagnostic
 */
export class CodeDiagnostic extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        /**
         * @generated from field: string severity = 3;
         */
        this.severity = "";
        /**
         * @generated from field: string source = 4;
         */
        this.source = "";
        /**
         * @generated from field: string uri = 5;
         */
        this.uri = "";
        /**
         * @generated from field: exa.codeium_common_pb.Language language = 7;
         */
        this.language = Language.UNSPECIFIED;
        /**
         * A score of how relevant the diagnostic is to the active file,
         * based on depth of the common path between their URIs.
         *
         * @generated from field: int64 score = 8;
         */
        this.score = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodeDiagnostic().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodeDiagnostic().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodeDiagnostic().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodeDiagnostic, a, b);
    }
}
CodeDiagnostic.runtime = proto3;
CodeDiagnostic.typeName = "exa.codeium_common_pb.CodeDiagnostic";
CodeDiagnostic.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "range", kind: "message", T: Range },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "severity", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "source", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "language", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 8, name: "score", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * Proto representation of VSCode Intellisense Suggestion.
 *
 * @generated from message exa.codeium_common_pb.IntellisenseSuggestion
 */
export class IntellisenseSuggestion extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string text = 2;
         */
        this.text = "";
        /**
         * @generated from field: string label = 3;
         */
        this.label = "";
        /**
         * @generated from field: string label_detail = 4;
         */
        this.labelDetail = "";
        /**
         * @generated from field: string description = 5;
         */
        this.description = "";
        /**
         * @generated from field: string detail = 6;
         */
        this.detail = "";
        /**
         * @generated from field: string documentation = 7;
         */
        this.documentation = "";
        /**
         * @generated from field: string kind = 8;
         */
        this.kind = "";
        /**
         * @generated from field: bool selected = 9;
         */
        this.selected = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new IntellisenseSuggestion().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new IntellisenseSuggestion().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new IntellisenseSuggestion().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(IntellisenseSuggestion, a, b);
    }
}
IntellisenseSuggestion.runtime = proto3;
IntellisenseSuggestion.typeName = "exa.codeium_common_pb.IntellisenseSuggestion";
IntellisenseSuggestion.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "range", kind: "message", T: Range },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "label_detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "detail", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "documentation", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "selected", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.DocumentLinesElement
 */
export class DocumentLinesElement extends Message {
    constructor(data) {
        super();
        /**
         * Ordered list of overlapped code context items including partial overlaps.
         *
         * @generated from field: repeated exa.codeium_common_pb.CodeContextItem overlapped_code_context_items = 2;
         */
        this.overlappedCodeContextItems = [];
        /**
         * How many lines of the first and last overlapped code context items overlap with the document query itself.
         *
         * @generated from field: uint32 first_element_suffix_overlap = 3;
         */
        this.firstElementSuffixOverlap = 0;
        /**
         * @generated from field: uint32 last_element_prefix_overlap = 4;
         */
        this.lastElementPrefixOverlap = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DocumentLinesElement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentLinesElement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentLinesElement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentLinesElement, a, b);
    }
}
DocumentLinesElement.runtime = proto3;
DocumentLinesElement.typeName = "exa.codeium_common_pb.DocumentLinesElement";
DocumentLinesElement.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "document_query", kind: "message", T: DocumentQuery },
    { no: 2, name: "overlapped_code_context_items", kind: "message", T: CodeContextItem, repeated: true },
    { no: 3, name: "first_element_suffix_overlap", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "last_element_prefix_overlap", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.DocumentQuery
 */
export class DocumentQuery extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string text = 1;
         */
        this.text = "";
        /**
         * @generated from field: int32 cursor_offset = 2;
         */
        this.cursorOffset = 0;
        /**
         * @generated from field: uint32 start_line = 3;
         */
        this.startLine = 0;
        /**
         * End exclusive
         *
         * @generated from field: uint32 end_line = 4;
         */
        this.endLine = 0;
        /**
         * @generated from field: bool use_character_position = 5;
         */
        this.useCharacterPosition = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DocumentQuery().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentQuery().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentQuery().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentQuery, a, b);
    }
}
DocumentQuery.runtime = proto3;
DocumentQuery.typeName = "exa.codeium_common_pb.DocumentQuery";
DocumentQuery.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "cursor_offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "start_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "end_line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "use_character_position", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.DocumentOutlineElement
 */
export class DocumentOutlineElement extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.DocumentOutlineElement.element
         */
        this.element = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DocumentOutlineElement().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentOutlineElement().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentOutlineElement().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentOutlineElement, a, b);
    }
}
DocumentOutlineElement.runtime = proto3;
DocumentOutlineElement.typeName = "exa.codeium_common_pb.DocumentOutlineElement";
DocumentOutlineElement.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "code_context_item", kind: "message", T: CodeContextItem, oneof: "element" },
    { no: 2, name: "document_lines_element", kind: "message", T: DocumentLinesElement, oneof: "element" },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "element" },
]);
/**
 * @generated from message exa.codeium_common_pb.DocumentOutline
 */
export class DocumentOutline extends Message {
    constructor(data) {
        super();
        /**
         * The document outline consists of an ordered list of elements in top to bottom order.
         *
         * @generated from field: repeated exa.codeium_common_pb.DocumentOutlineElement elements = 1;
         */
        this.elements = [];
        /**
         * When building a prompt out of the outline with a token limit, we start at this element
         * and radiate outward until hitting a token limit.
         * If unset, then it will just build from top down.
         *
         * @generated from field: int64 start_index = 2;
         */
        this.startIndex = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DocumentOutline().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DocumentOutline().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DocumentOutline().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DocumentOutline, a, b);
    }
}
DocumentOutline.runtime = proto3;
DocumentOutline.typeName = "exa.codeium_common_pb.DocumentOutline";
DocumentOutline.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "elements", kind: "message", T: DocumentOutlineElement, repeated: true },
    { no: 2, name: "start_index", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
]);
/**
 * Proto representing a in-IDE event. Used for lightweight event-based analytics.
 *
 * @generated from message exa.codeium_common_pb.ProductEvent
 */
export class ProductEvent extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string event_name = 1;
         */
        this.eventName = "";
        /**
         * @generated from field: string api_key = 2;
         */
        this.apiKey = "";
        /**
         * @generated from field: string installation_id = 3;
         */
        this.installationId = "";
        /**
         * @generated from field: string ide_name = 4;
         */
        this.ideName = "";
        /**
         * @generated from field: string os = 5;
         */
        this.os = "";
        /**
         * @generated from field: string codeium_version = 6;
         */
        this.codeiumVersion = "";
        /**
         * @generated from field: string ide_version = 7;
         */
        this.ideVersion = "";
        /**
         * @generated from field: uint64 duration_ms = 8;
         */
        this.durationMs = protoInt64.zero;
        /**
         * @generated from field: map<string, string> extra = 9;
         */
        this.extra = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ProductEvent().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProductEvent().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProductEvent().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProductEvent, a, b);
    }
}
ProductEvent.runtime = proto3;
ProductEvent.typeName = "exa.codeium_common_pb.ProductEvent";
ProductEvent.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "event_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "api_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "installation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "ide_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "os", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "codeium_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "ide_version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "duration_ms", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    { no: 9, name: "extra", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.CodebaseCluster
 */
export class CodebaseCluster extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 5;
         */
        this.id = "";
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: string description = 2;
         */
        this.description = "";
        /**
         * The root directory of the codebase in uri format.
         *
         * @generated from field: string codebase_root_uri = 6;
         */
        this.codebaseRootUri = "";
        /**
         * @generated from field: repeated string file_names = 3;
         */
        this.fileNames = [];
        /**
         * @generated from field: repeated string commit_messages = 4;
         */
        this.commitMessages = [];
        /**
         * @generated from field: repeated string commit_sha = 7;
         */
        this.commitSha = [];
        /**
         * @generated from field: repeated string commit_descriptions = 8;
         */
        this.commitDescriptions = [];
        /**
         * @generated from field: repeated string file_descriptions = 9;
         */
        this.fileDescriptions = [];
        /**
         * @generated from field: string intent = 10;
         */
        this.intent = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodebaseCluster().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodebaseCluster().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodebaseCluster().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodebaseCluster, a, b);
    }
}
CodebaseCluster.runtime = proto3;
CodebaseCluster.typeName = "exa.codeium_common_pb.CodebaseCluster";
CodebaseCluster.fields = proto3.util.newFieldList(() => [
    { no: 5, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "codebase_root_uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "file_names", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 4, name: "commit_messages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 7, name: "commit_sha", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 8, name: "commit_descriptions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 9, name: "file_descriptions", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "intent", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * This message is just used for serialization
 *
 * @generated from message exa.codeium_common_pb.CodebaseClusterList
 */
export class CodebaseClusterList extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.CodebaseCluster clusters = 1;
         */
        this.clusters = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodebaseClusterList().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodebaseClusterList().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodebaseClusterList().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodebaseClusterList, a, b);
    }
}
CodebaseClusterList.runtime = proto3;
CodebaseClusterList.typeName = "exa.codeium_common_pb.CodebaseClusterList";
CodebaseClusterList.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "clusters", kind: "message", T: CodebaseCluster, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.KnowledgeBaseChunk
 */
export class KnowledgeBaseChunk extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.KnowledgeBaseChunk.chunk_type
         */
        this.chunkType = { case: undefined };
        /**
         * @generated from field: int32 position = 2;
         */
        this.position = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KnowledgeBaseChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KnowledgeBaseChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KnowledgeBaseChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KnowledgeBaseChunk, a, b);
    }
}
KnowledgeBaseChunk.runtime = proto3;
KnowledgeBaseChunk.typeName = "exa.codeium_common_pb.KnowledgeBaseChunk";
KnowledgeBaseChunk.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "chunk_type" },
    { no: 3, name: "markdown_chunk", kind: "message", T: MarkdownChunk, oneof: "chunk_type" },
    { no: 2, name: "position", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * Next ID: 10, Previous field: dom_tree.
 *
 * @generated from message exa.codeium_common_pb.KnowledgeBaseItem
 */
export class KnowledgeBaseItem extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string document_id = 1;
         */
        this.documentId = "";
        /**
         * @generated from field: string url = 3;
         */
        this.url = "";
        /**
         * @generated from field: string title = 4;
         */
        this.title = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.KnowledgeBaseChunk chunks = 6;
         */
        this.chunks = [];
        /**
         * Optional summary of the knowledge base item.
         *
         * @generated from field: string summary = 7;
         */
        this.summary = "";
        /**
         * Deprecated
         *
         * @generated from field: string text = 2 [deprecated = true];
         * @deprecated
         */
        this.text = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KnowledgeBaseItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KnowledgeBaseItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KnowledgeBaseItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KnowledgeBaseItem, a, b);
    }
}
KnowledgeBaseItem.runtime = proto3;
KnowledgeBaseItem.typeName = "exa.codeium_common_pb.KnowledgeBaseItem";
KnowledgeBaseItem.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "chunks", kind: "message", T: KnowledgeBaseChunk, repeated: true },
    { no: 7, name: "summary", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "image", kind: "message", T: ImageData },
    { no: 9, name: "dom_tree", kind: "message", T: DOMTree },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.KnowledgeBaseItemWithMetadata
 */
export class KnowledgeBaseItemWithMetadata extends Message {
    constructor(data) {
        super();
        /**
         * not being used at the moment
         *
         * @generated from field: float score = 2;
         */
        this.score = 0;
        /**
         * TODO(sean) / TODO(saujasn): remove index_name field
         *
         * always going to be "knowledge_base" for beacon
         *
         * @generated from field: string index_name = 3;
         */
        this.indexName = "";
        /**
         * where the document came from, "slack"/"github"/"google_drive"/"jira"/etc
         *
         * @generated from field: string document_source_name = 4;
         */
        this.documentSourceName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KnowledgeBaseItemWithMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KnowledgeBaseItemWithMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KnowledgeBaseItemWithMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KnowledgeBaseItemWithMetadata, a, b);
    }
}
KnowledgeBaseItemWithMetadata.runtime = proto3;
KnowledgeBaseItemWithMetadata.typeName = "exa.codeium_common_pb.KnowledgeBaseItemWithMetadata";
KnowledgeBaseItemWithMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "knowledge_base_item", kind: "message", T: KnowledgeBaseItem },
    { no: 2, name: "score", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "index_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "document_source_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.KnowledgeBaseGroup
 */
export class KnowledgeBaseGroup extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string description = 1;
         */
        this.description = "";
        /**
         * @generated from field: repeated exa.codeium_common_pb.KnowledgeBaseGroup children = 3;
         */
        this.children = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new KnowledgeBaseGroup().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new KnowledgeBaseGroup().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new KnowledgeBaseGroup().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(KnowledgeBaseGroup, a, b);
    }
}
KnowledgeBaseGroup.runtime = proto3;
KnowledgeBaseGroup.typeName = "exa.codeium_common_pb.KnowledgeBaseGroup";
KnowledgeBaseGroup.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item", kind: "message", T: KnowledgeBaseItemWithMetadata },
    { no: 3, name: "children", kind: "message", T: KnowledgeBaseGroup, repeated: true },
]);
/**
 * @generated from message exa.codeium_common_pb.ImageData
 */
export class ImageData extends Message {
    constructor(data) {
        super();
        /**
         * Base64 encoded image data
         *
         * @generated from field: string base64_data = 1;
         */
        this.base64Data = "";
        /**
         * MIME type of the image (e.g., "image/jpeg", "image/png")
         *
         * @generated from field: string mime_type = 2;
         */
        this.mimeType = "";
        /**
         * AI Generated Caption, populated when using a model that has supportsImageCaptions = true
         *
         * @generated from field: string caption = 3;
         */
        this.caption = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ImageData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ImageData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ImageData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ImageData, a, b);
    }
}
ImageData.runtime = proto3;
ImageData.typeName = "exa.codeium_common_pb.ImageData";
ImageData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "base64_data", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "caption", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.TextData
 */
export class TextData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string text = 1;
         */
        this.text = "";
        /**
         * MIME type of the text (e.g., "text/plain", "text/markdown")
         *
         * @generated from field: string mime_type = 2;
         */
        this.mimeType = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TextData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TextData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TextData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TextData, a, b);
    }
}
TextData.runtime = proto3;
TextData.typeName = "exa.codeium_common_pb.TextData";
TextData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Chunk of markdown text used when parsing markdown.
 *
 * @generated from message exa.codeium_common_pb.MarkdownChunk
 */
export class MarkdownChunk extends Message {
    constructor(data) {
        super();
        /**
         * An array of headers that the text belongs to. The last element of the array is the most
         * recent header that the text belongs to.
         *
         * @generated from field: repeated exa.codeium_common_pb.MarkdownChunk.MarkdownHeader headers = 1;
         */
        this.headers = [];
        /**
         * The text in the markdown chunk.
         *
         * @generated from field: string text = 2;
         */
        this.text = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MarkdownChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkdownChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkdownChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkdownChunk, a, b);
    }
}
MarkdownChunk.runtime = proto3;
MarkdownChunk.typeName = "exa.codeium_common_pb.MarkdownChunk";
MarkdownChunk.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "headers", kind: "message", T: MarkdownChunk_MarkdownHeader, repeated: true },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.MarkdownChunk.MarkdownHeader
 */
export class MarkdownChunk_MarkdownHeader extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.MarkdownNodeType type = 1;
         */
        this.type = MarkdownNodeType.UNSPECIFIED;
        /**
         * @generated from field: string text = 2;
         */
        this.text = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MarkdownChunk_MarkdownHeader().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkdownChunk_MarkdownHeader().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkdownChunk_MarkdownHeader().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkdownChunk_MarkdownHeader, a, b);
    }
}
MarkdownChunk_MarkdownHeader.runtime = proto3;
MarkdownChunk_MarkdownHeader.typeName = "exa.codeium_common_pb.MarkdownChunk.MarkdownHeader";
MarkdownChunk_MarkdownHeader.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(MarkdownNodeType) },
    { no: 2, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Next ID: 8
 *
 * @generated from message exa.codeium_common_pb.TerminalShellCommandHeader
 */
export class TerminalShellCommandHeader extends Message {
    constructor(data) {
        super();
        /**
         * ID of the terminal that the command was executed in.
         *
         * @generated from field: string terminal_id = 1;
         */
        this.terminalId = "";
        /**
         * PID of the shell process that executed the command.
         *
         * @generated from field: uint32 shell_pid = 2;
         */
        this.shellPid = 0;
        /**
         * Shell command line that was executed. Note that this combines the command and the arguments.
         *
         * @generated from field: string command_line = 3;
         */
        this.commandLine = "";
        /**
         * Working directory that the shell command was executed in.
         *
         * @generated from field: string cwd = 4;
         */
        this.cwd = "";
        /**
         * Source of the shell command.
         *
         * @generated from field: exa.codeium_common_pb.TerminalShellCommandSource source = 6;
         */
        this.source = TerminalShellCommandSource.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalShellCommandHeader().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalShellCommandHeader().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalShellCommandHeader().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalShellCommandHeader, a, b);
    }
}
TerminalShellCommandHeader.runtime = proto3;
TerminalShellCommandHeader.typeName = "exa.codeium_common_pb.TerminalShellCommandHeader";
TerminalShellCommandHeader.fields = proto3.util.newFieldList(() => [
    { no: 7, name: "metadata", kind: "message", T: Metadata },
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shell_pid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "command_line", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "cwd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "start_time", kind: "message", T: Timestamp },
    { no: 6, name: "source", kind: "enum", T: proto3.getEnumType(TerminalShellCommandSource) },
]);
/**
 * @generated from message exa.codeium_common_pb.TerminalShellCommandData
 */
export class TerminalShellCommandData extends Message {
    constructor(data) {
        super();
        /**
         * New raw data bytes (delta) from the command output.
         *
         * @generated from field: bytes raw_data = 1;
         */
        this.rawData = new Uint8Array(0);
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalShellCommandData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalShellCommandData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalShellCommandData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalShellCommandData, a, b);
    }
}
TerminalShellCommandData.runtime = proto3;
TerminalShellCommandData.typeName = "exa.codeium_common_pb.TerminalShellCommandData";
TerminalShellCommandData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "raw_data", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
]);
/**
 * @generated from message exa.codeium_common_pb.TerminalShellCommandTrailer
 */
export class TerminalShellCommandTrailer extends Message {
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalShellCommandTrailer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalShellCommandTrailer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalShellCommandTrailer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalShellCommandTrailer, a, b);
    }
}
TerminalShellCommandTrailer.runtime = proto3;
TerminalShellCommandTrailer.typeName = "exa.codeium_common_pb.TerminalShellCommandTrailer";
TerminalShellCommandTrailer.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "exit_code", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
]);
/**
 * Chunk for streaming terminal shell commands.
 *
 * @generated from message exa.codeium_common_pb.TerminalShellCommandStreamChunk
 */
export class TerminalShellCommandStreamChunk extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.TerminalShellCommandStreamChunk.value
         */
        this.value = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalShellCommandStreamChunk().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalShellCommandStreamChunk().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalShellCommandStreamChunk().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalShellCommandStreamChunk, a, b);
    }
}
TerminalShellCommandStreamChunk.runtime = proto3;
TerminalShellCommandStreamChunk.typeName = "exa.codeium_common_pb.TerminalShellCommandStreamChunk";
TerminalShellCommandStreamChunk.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "header", kind: "message", T: TerminalShellCommandHeader, oneof: "value" },
    { no: 2, name: "data", kind: "message", T: TerminalShellCommandData, oneof: "value" },
    { no: 3, name: "trailer", kind: "message", T: TerminalShellCommandTrailer, oneof: "value" },
]);
/**
 * Consolidated terminal shell command info.
 *
 * @generated from message exa.codeium_common_pb.TerminalShellCommand
 */
export class TerminalShellCommand extends Message {
    constructor(data) {
        super();
        /**
         * Unique ID for the shell command.
         *
         * @generated from field: string id = 10;
         */
        this.id = "";
        /**
         * PID of the shell process that executed the command.
         *
         * @generated from field: uint32 shell_pid = 1;
         */
        this.shellPid = 0;
        /**
         * Shell command line that was executed. Note that this combines the command and the arguments.
         *
         * @generated from field: string command_line = 2;
         */
        this.commandLine = "";
        /**
         * Working directory that the shell command was executed in.
         *
         * @generated from field: string cwd = 3;
         */
        this.cwd = "";
        /**
         * Aggregated and processed output.
         *
         * @generated from field: bytes output = 4;
         */
        this.output = new Uint8Array(0);
        /**
         * Status of the shell command.
         *
         * @generated from field: exa.codeium_common_pb.TerminalShellCommandStatus status = 8;
         */
        this.status = TerminalShellCommandStatus.UNSPECIFIED;
        /**
         * Source of the shell command.
         *
         * @generated from field: exa.codeium_common_pb.TerminalShellCommandSource source = 9;
         */
        this.source = TerminalShellCommandSource.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalShellCommand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalShellCommand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalShellCommand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalShellCommand, a, b);
    }
}
TerminalShellCommand.runtime = proto3;
TerminalShellCommand.typeName = "exa.codeium_common_pb.TerminalShellCommand";
TerminalShellCommand.fields = proto3.util.newFieldList(() => [
    { no: 10, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 1, name: "shell_pid", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "command_line", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cwd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "output", kind: "scalar", T: 12 /* ScalarType.BYTES */ },
    { no: 5, name: "exit_code", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 6, name: "start_time", kind: "message", T: Timestamp },
    { no: 7, name: "end_time", kind: "message", T: Timestamp },
    { no: 11, name: "last_updated_time", kind: "message", T: Timestamp },
    { no: 8, name: "status", kind: "enum", T: proto3.getEnumType(TerminalShellCommandStatus) },
    { no: 9, name: "source", kind: "enum", T: proto3.getEnumType(TerminalShellCommandSource) },
]);
/**
 * Data for Terminal Command requests. Note that Command refers to the IDE feature and not shell
 * commands.
 *
 * @generated from message exa.codeium_common_pb.TerminalCommandData
 */
export class TerminalCommandData extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string terminal_id = 1;
         */
        this.terminalId = "";
        /**
         * @generated from field: string platform = 2;
         */
        this.platform = "";
        /**
         * @generated from field: string cwd = 3;
         */
        this.cwd = "";
        /**
         * @generated from field: string shell_name = 4;
         */
        this.shellName = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TerminalCommandData().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TerminalCommandData().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TerminalCommandData().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TerminalCommandData, a, b);
    }
}
TerminalCommandData.runtime = proto3;
TerminalCommandData.typeName = "exa.codeium_common_pb.TerminalCommandData";
TerminalCommandData.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "terminal_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "platform", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "cwd", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "shell_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Windsurf JS project record.
 * Next ID: 15
 *
 * @generated from message exa.codeium_common_pb.WindsurfProject
 */
export class WindsurfProject extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string windsurf_project_id = 1;
         */
        this.windsurfProjectId = "";
        /**
         * @generated from field: string auth_uid = 2;
         */
        this.authUid = "";
        /**
         * @generated from field: exa.codeium_common_pb.DeploymentProvider deployment_provider = 3;
         */
        this.deploymentProvider = DeploymentProvider.UNSPECIFIED;
        /**
         * @generated from field: string provider_project_id = 4;
         */
        this.providerProjectId = "";
        /**
         * The name of the project. This shows up on the provider dashboard and is different from the subdomain name.
         *
         * @generated from field: string project_name = 5;
         */
        this.projectName = "";
        /**
         * The domain the deployment is deployed to. Example: windsurf.build
         *
         * @generated from field: string domain = 8;
         */
        this.domain = "";
        /**
         * The subdomain the deployment is deployed to. Example: my-project
         *
         * @generated from field: string subdomain_name = 9;
         */
        this.subdomainName = "";
        /**
         * Team ID of the provider if this project is not on the Windsurf sandbox account
         *
         * @generated from field: string provider_team_id = 14;
         */
        this.providerTeamId = "";
        /**
         * Public URL to access the app
         *
         * @generated from field: string project_url = 13;
         */
        this.projectUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WindsurfProject().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WindsurfProject().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WindsurfProject().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WindsurfProject, a, b);
    }
}
WindsurfProject.runtime = proto3;
WindsurfProject.typeName = "exa.codeium_common_pb.WindsurfProject";
WindsurfProject.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "windsurf_project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "auth_uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deployment_provider", kind: "enum", T: proto3.getEnumType(DeploymentProvider) },
    { no: 4, name: "provider_project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "project_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "updated_at", kind: "message", T: Timestamp },
    { no: 8, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "subdomain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "expires_at", kind: "message", T: Timestamp },
    { no: 11, name: "claimed_at", kind: "message", T: Timestamp },
    { no: 12, name: "deprovisioned_at", kind: "message", T: Timestamp },
    { no: 14, name: "provider_team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "project_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Windsurf JS app deployment record.
 * Next ID: 21
 *
 * @generated from message exa.codeium_common_pb.WindsurfDeployment
 */
export class WindsurfDeployment extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string windsurf_deployment_id = 1;
         */
        this.windsurfDeploymentId = "";
        /**
         * @generated from field: string auth_uid = 2;
         */
        this.authUid = "";
        /**
         * @generated from field: exa.codeium_common_pb.DeploymentProvider deployment_provider = 3;
         */
        this.deploymentProvider = DeploymentProvider.UNSPECIFIED;
        /**
         * @generated from field: string provider_deployment_id = 14;
         */
        this.providerDeploymentId = "";
        /**
         * This references the windsurf_project_id in the windsurf_projects table
         *
         * @generated from field: string windsurf_project_id = 19;
         */
        this.windsurfProjectId = "";
        /**
         * @generated from field: string project_id = 4;
         */
        this.projectId = "";
        /**
         * @generated from field: string project_name = 5;
         */
        this.projectName = "";
        /**
         * @generated from field: string workspace_path = 6;
         */
        this.workspacePath = "";
        /**
         * The domain the deployment is deployed to. Example: windsurf.build
         *
         * @generated from field: string domain = 16;
         */
        this.domain = "";
        /**
         * The subdomain the deployment is deployed to. Example: my-project
         *
         * @generated from field: string subdomain_name = 17;
         */
        this.subdomainName = "";
        /**
         * Team ID of the provider if this project is not on the Windsurf sandbox account
         *
         * @generated from field: string provider_team_id = 20;
         */
        this.providerTeamId = "";
        /**
         * URL to access this specific deployment. This is different from the <project_name>.windsurf.app URL (which is the public URL).
         *
         * @generated from field: string deployment_url = 12;
         */
        this.deploymentUrl = "";
        /**
         * URL to the build status page on the Codeium website
         *
         * @generated from field: string build_status_url = 9;
         */
        this.buildStatusUrl = "";
        /**
         * Public URL to access the app
         *
         * @generated from field: string project_url = 10;
         */
        this.projectUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WindsurfDeployment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WindsurfDeployment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WindsurfDeployment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WindsurfDeployment, a, b);
    }
}
WindsurfDeployment.runtime = proto3;
WindsurfDeployment.typeName = "exa.codeium_common_pb.WindsurfDeployment";
WindsurfDeployment.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "windsurf_deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "auth_uid", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "deployment_provider", kind: "enum", T: proto3.getEnumType(DeploymentProvider) },
    { no: 14, name: "provider_deployment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 19, name: "windsurf_project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "project_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "workspace_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "created_at", kind: "message", T: Timestamp },
    { no: 8, name: "updated_at", kind: "message", T: Timestamp },
    { no: 16, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "subdomain_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 20, name: "provider_team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "expires_at", kind: "message", T: Timestamp },
    { no: 12, name: "deployment_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "claimed_at", kind: "message", T: Timestamp },
    { no: 13, name: "deprovisioned_at", kind: "message", T: Timestamp },
    { no: 9, name: "build_status_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "project_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Windsurf JS Deployment target
 *
 * @generated from message exa.codeium_common_pb.DeployTarget
 */
export class DeployTarget extends Message {
    constructor(data) {
        super();
        /**
         * Deployment provider (i.e. Netlify)
         *
         * @generated from field: exa.codeium_common_pb.DeploymentProvider deployment_provider = 1;
         */
        this.deploymentProvider = DeploymentProvider.UNSPECIFIED;
        /**
         * Whether the site is on the Windsurf umbrella account
         *
         * @generated from field: bool is_sandbox = 2;
         */
        this.isSandbox = false;
        /**
         * ID of the team that owns the site. Unset if the site is on the umbrella account
         *
         * @generated from field: string provider_team_id = 3;
         */
        this.providerTeamId = "";
        /**
         * Slug of the team that owns the site. This is "windsurf" if the site is on the umbrella account
         *
         * @generated from field: string provider_team_slug = 4;
         */
        this.providerTeamSlug = "";
        /**
         * Domain of the site
         *
         * @generated from field: string domain = 5;
         */
        this.domain = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new DeployTarget().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DeployTarget().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DeployTarget().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DeployTarget, a, b);
    }
}
DeployTarget.runtime = proto3;
DeployTarget.typeName = "exa.codeium_common_pb.DeployTarget";
DeployTarget.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "deployment_provider", kind: "enum", T: proto3.getEnumType(DeploymentProvider) },
    { no: 2, name: "is_sandbox", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "provider_team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "provider_team_slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * A single option for `@docs` web search in Cascade.
 *
 * @generated from message exa.codeium_common_pb.WebDocsOption
 */
export class WebDocsOption extends Message {
    constructor(data) {
        super();
        /**
         * The label of the option. This must not contain any spaces. This is what will be
         * rendered in `[@docs:label](docs_url)`.
         * Allowed characters: a-z, A-Z, 0-9, _, -.
         *
         * @generated from field: string label = 1;
         */
        this.label = "";
        /**
         * The URL of the documentation or human-language instructions to prompt the LLM to
         * lookup live documentation via web search.
         *
         * @generated from oneof exa.codeium_common_pb.WebDocsOption.value
         */
        this.value = { case: undefined };
        /**
         * A space-separated list of synonyms for the option. This is used for searching
         * through options if the user does not enter a match to the `label`.
         *
         * @generated from field: repeated string synonyms = 4;
         */
        this.synonyms = [];
        /**
         * Whether this is a featured docs provider.
         *
         * @generated from field: bool is_featured = 5;
         */
        this.isFeatured = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WebDocsOption().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WebDocsOption().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WebDocsOption().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WebDocsOption, a, b);
    }
}
WebDocsOption.runtime = proto3;
WebDocsOption.typeName = "exa.codeium_common_pb.WebDocsOption";
WebDocsOption.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "docs_url", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 3, name: "docs_search_domain", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "value" },
    { no: 4, name: "synonyms", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 5, name: "is_featured", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * TeamConfig values are stored in UserStatus.TeamConfig and are referenced across
 * Language Server, Chat Client, and Windsurf for all teams and enterprise feature controls.
 * Next ID: 27; Previous field: disable_tool_call_execution_outside_workspace.
 *
 * @generated from message exa.codeium_common_pb.TeamConfig
 */
export class TeamConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string team_id = 1;
         */
        this.teamId = "";
        /**
         * @generated from field: int32 user_prompt_credit_cap = 2;
         */
        this.userPromptCreditCap = 0;
        /**
         * @generated from field: int32 user_flow_credit_cap = 3;
         */
        this.userFlowCreditCap = 0;
        /**
         * @generated from field: bool auto_provision_cascade_seat = 4;
         */
        this.autoProvisionCascadeSeat = false;
        /**
         * @generated from field: bool allow_mcp_servers = 5;
         */
        this.allowMcpServers = false;
        /**
         * TODO(michaelli): Move web search from teams table to team config.
         * bool allow_web_search = 6;
         *
         * @generated from field: bool allow_auto_run_commands = 7;
         */
        this.allowAutoRunCommands = false;
        /**
         * @generated from field: bool allow_custom_recipes = 8;
         */
        this.allowCustomRecipes = false;
        /**
         * Maximum number of unclaimed sites for Windsurf deployments a user can have.
         * Moved from PlanInfo to TeamConfig. This is disconnected from allow_app_deployments
         * and can be > 0 even if allow_app_deployments is false.
         *
         * @generated from field: int32 max_unclaimed_sites = 9;
         */
        this.maxUnclaimedSites = 0;
        /**
         * Whether app deployments are allowed for this team.
         *
         * @generated from field: bool allow_app_deployments = 10;
         */
        this.allowAppDeployments = false;
        /**
         * Whether deployment to the shared sandbox/umbrella account is allowed.
         *
         * @generated from field: bool allow_sandbox_app_deployments = 19;
         */
        this.allowSandboxAppDeployments = false;
        /**
         * Whether deployment directly to user-connected team accounts is allowed.
         *
         * @generated from field: bool allow_teams_app_deployments = 20;
         */
        this.allowTeamsAppDeployments = false;
        /**
         * Maximum number of new sites a user can create per day. This limits the rate at which users
         * can create new domains. The client should use max_unclaimed_sites and allow_app_deployments
         * to determine if the Deploys feature is enabled.
         *
         * @generated from field: int32 max_new_sites_per_day = 11;
         */
        this.maxNewSitesPerDay = 0;
        /**
         * Whether Windsurf is allowed to create pull request reviews on GitHub for this team.
         *
         * @generated from field: bool allow_github_reviews = 12;
         */
        this.allowGithubReviews = false;
        /**
         * Whether Windsurf is allowed to edit pull request descriptions on GitHub for this team.
         *
         * @generated from field: bool allow_github_description_edits = 13;
         */
        this.allowGithubDescriptionEdits = false;
        /**
         * Guidelines that Windsurf will use when reviewing pull requests.
         *
         * @generated from field: string pull_request_review_guidelines = 14;
         */
        this.pullRequestReviewGuidelines = "";
        /**
         * Guidelines that Windsurf will use when editing pull request descriptions.
         *
         * @generated from field: string pull_request_description_guidelines = 16;
         */
        this.pullRequestDescriptionGuidelines = "";
        /**
         * Whether tool calls are disabled for this team.
         *
         * @generated from field: bool disable_tool_calls = 15;
         */
        this.disableToolCalls = false;
        /**
         * Whether individual level analytics are allowed for this team.
         *
         * @generated from field: bool allow_individual_level_analytics = 17;
         */
        this.allowIndividualLevelAnalytics = false;
        /**
         * Whether attribution is allowed for this team.
         *
         * @generated from field: bool allow_attribution = 22;
         */
        this.allowAttribution = false;
        /**
         * MCP servers that are allowed for this team.
         *
         * @generated from field: repeated exa.codeium_common_pb.McpServerConfig allowed_mcp_servers = 23;
         */
        this.allowedMcpServers = [];
        /**
         * Whether auto reviews are allowed for this team.
         *
         * @generated from field: bool allow_github_auto_reviews = 24;
         */
        this.allowGithubAutoReviews = false;
        /**
         * Whether browser experimental features are allowed for this team.
         *
         * @generated from field: bool allow_browser_experimental_features = 25;
         */
        this.allowBrowserExperimentalFeatures = false;
        /**
         * Whether tool call execution outside of the workspace is disabled for this team.
         *
         * @generated from field: bool disable_tool_call_execution_outside_workspace = 26;
         */
        this.disableToolCallExecutionOutsideWorkspace = false;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TeamConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TeamConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TeamConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TeamConfig, a, b);
    }
}
TeamConfig.runtime = proto3;
TeamConfig.typeName = "exa.codeium_common_pb.TeamConfig";
TeamConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "team_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "user_prompt_credit_cap", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "user_flow_credit_cap", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "auto_provision_cascade_seat", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "allow_mcp_servers", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 7, name: "allow_auto_run_commands", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "allow_custom_recipes", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 9, name: "max_unclaimed_sites", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 10, name: "allow_app_deployments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "allow_sandbox_app_deployments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "allow_teams_app_deployments", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 11, name: "max_new_sites_per_day", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 12, name: "allow_github_reviews", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 13, name: "allow_github_description_edits", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "pull_request_review_guidelines", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "pull_request_description_guidelines", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "disable_tool_calls", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 17, name: "allow_individual_level_analytics", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "allow_conversation_sharing", kind: "scalar", T: 8 /* ScalarType.BOOL */, opt: true },
    { no: 21, name: "pull_request_review_rate_limit", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
    { no: 22, name: "allow_attribution", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 23, name: "allowed_mcp_servers", kind: "message", T: McpServerConfig, repeated: true },
    { no: 24, name: "allow_github_auto_reviews", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "allow_browser_experimental_features", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 26, name: "disable_tool_call_execution_outside_workspace", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
]);
/**
 * @generated from message exa.codeium_common_pb.WebAppDeploymentConfig
 */
export class WebAppDeploymentConfig extends Message {
    constructor(data) {
        super();
        /**
         * The ID of the project (different from project name) on the provider's system. This is
         * populated as a way to update existing deployments.
         *
         * @generated from field: string project_id = 1;
         */
        this.projectId = "";
        /**
         * The framework used for the app (examples: nextjs, sveltekit, etc.).
         *
         * @generated from field: string framework = 2;
         */
        this.framework = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new WebAppDeploymentConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new WebAppDeploymentConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new WebAppDeploymentConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(WebAppDeploymentConfig, a, b);
    }
}
WebAppDeploymentConfig.runtime = proto3;
WebAppDeploymentConfig.typeName = "exa.codeium_common_pb.WebAppDeploymentConfig";
WebAppDeploymentConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "project_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "framework", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Template for an MCP server
 *
 * @generated from message exa.codeium_common_pb.McpServerTemplate
 */
export class McpServerTemplate extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string title = 1;
         */
        this.title = "";
        /**
         * @generated from field: string id = 2;
         */
        this.id = "";
        /**
         * @generated from field: string link = 3;
         */
        this.link = "";
        /**
         * @generated from field: string description = 4;
         */
        this.description = "";
        /**
         * Key is the command type (e.g., "npx", "docker")
         *
         * @generated from field: map<string, exa.codeium_common_pb.McpServerCommand> commands = 5;
         */
        this.commands = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpServerTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpServerTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpServerTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpServerTemplate, a, b);
    }
}
McpServerTemplate.runtime = proto3;
McpServerTemplate.typeName = "exa.codeium_common_pb.McpServerTemplate";
McpServerTemplate.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "commands", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "message", T: McpServerCommand } },
]);
/**
 * Command for an MCP server
 *
 * @generated from message exa.codeium_common_pb.McpServerCommand
 */
export class McpServerCommand extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.McpCommandVariable variables = 2;
         */
        this.variables = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpServerCommand().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpServerCommand().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpServerCommand().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpServerCommand, a, b);
    }
}
McpServerCommand.runtime = proto3;
McpServerCommand.typeName = "exa.codeium_common_pb.McpServerCommand";
McpServerCommand.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "template", kind: "message", T: McpCommandTemplate },
    { no: 2, name: "variables", kind: "message", T: McpCommandVariable, repeated: true },
]);
/**
 * Template for an MCP command
 *
 * @generated from message exa.codeium_common_pb.McpCommandTemplate
 */
export class McpCommandTemplate extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string command = 1;
         */
        this.command = "";
        /**
         * @generated from field: repeated string args = 2;
         */
        this.args = [];
        /**
         * @generated from field: map<string, string> env = 3;
         */
        this.env = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpCommandTemplate().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpCommandTemplate().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpCommandTemplate().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpCommandTemplate, a, b);
    }
}
McpCommandTemplate.runtime = proto3;
McpCommandTemplate.typeName = "exa.codeium_common_pb.McpCommandTemplate";
McpCommandTemplate.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "args", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "env", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * Variable for an MCP command
 *
 * @generated from message exa.codeium_common_pb.McpCommandVariable
 */
export class McpCommandVariable extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: string title = 2;
         */
        this.title = "";
        /**
         * @generated from field: string description = 3;
         */
        this.description = "";
        /**
         * @generated from field: string link = 4;
         */
        this.link = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpCommandVariable().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpCommandVariable().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpCommandVariable().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpCommandVariable, a, b);
    }
}
McpCommandVariable.runtime = proto3;
McpCommandVariable.typeName = "exa.codeium_common_pb.McpCommandVariable";
McpCommandVariable.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * Whitelist configuration for an MCP server
 *
 * @generated from message exa.codeium_common_pb.McpServerConfig
 */
export class McpServerConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string server_id = 1;
         */
        this.serverId = "";
        /**
         * @generated from oneof exa.codeium_common_pb.McpServerConfig.configuration
         */
        this.configuration = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpServerConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpServerConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpServerConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpServerConfig, a, b);
    }
}
McpServerConfig.runtime = proto3;
McpServerConfig.typeName = "exa.codeium_common_pb.McpServerConfig";
McpServerConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "server_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "local", kind: "message", T: McpLocalServer, oneof: "configuration" },
    { no: 3, name: "remote", kind: "message", T: McpRemoteServer, oneof: "configuration" },
]);
/**
 * Configuration for a local MCP server
 *
 * @generated from message exa.codeium_common_pb.McpLocalServer
 */
export class McpLocalServer extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string command = 1;
         */
        this.command = "";
        /**
         * @generated from field: repeated string args = 2;
         */
        this.args = [];
        /**
         * @generated from field: map<string, string> env = 3;
         */
        this.env = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpLocalServer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpLocalServer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpLocalServer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpLocalServer, a, b);
    }
}
McpLocalServer.runtime = proto3;
McpLocalServer.typeName = "exa.codeium_common_pb.McpLocalServer";
McpLocalServer.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "command", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "args", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 3, name: "env", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * Configuration for a remote MCP server
 *
 * @generated from message exa.codeium_common_pb.McpRemoteServer
 */
export class McpRemoteServer extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string type = 1;
         */
        this.type = "";
        /**
         * @generated from field: string url = 2;
         */
        this.url = "";
        /**
         * @generated from field: map<string, string> headers = 3;
         */
        this.headers = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new McpRemoteServer().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new McpRemoteServer().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new McpRemoteServer().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(McpRemoteServer, a, b);
    }
}
McpRemoteServer.runtime = proto3;
McpRemoteServer.typeName = "exa.codeium_common_pb.McpRemoteServer";
McpRemoteServer.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "headers", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * @generated from message exa.codeium_common_pb.UnleashContext
 */
export class UnleashContext extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string user_id = 1;
         */
        this.userId = "";
        /**
         * @generated from field: string session_id = 2;
         */
        this.sessionId = "";
        /**
         * @generated from field: map<string, string> properties = 3;
         */
        this.properties = {};
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new UnleashContext().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnleashContext().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnleashContext().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnleashContext, a, b);
    }
}
UnleashContext.runtime = proto3;
UnleashContext.typeName = "exa.codeium_common_pb.UnleashContext";
UnleashContext.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "user_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "session_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "properties", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
]);
/**
 * Metadata associated with a Playwright controlled Browser page.
 *
 * @generated from message exa.codeium_common_pb.BrowserPageMetadata
 */
export class BrowserPageMetadata extends Message {
    constructor(data) {
        super();
        /**
         * URL of the page.
         *
         * @generated from field: string url = 1;
         */
        this.url = "";
        /**
         * Playwright page identifier.
         *
         * @generated from field: string page_id = 2;
         */
        this.pageId = "";
        /**
         * Title of the page.
         *
         * @generated from field: string page_title = 3;
         */
        this.pageTitle = "";
        /**
         * Width of the viewport in pixels.
         *
         * @generated from field: uint32 viewport_width = 4;
         */
        this.viewportWidth = 0;
        /**
         * Height of the viewport in pixels.
         *
         * @generated from field: uint32 viewport_height = 5;
         */
        this.viewportHeight = 0;
        /**
         * URL of the favicon, if available.
         *
         * @generated from field: string favicon_url = 6;
         */
        this.faviconUrl = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserPageMetadata().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserPageMetadata().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserPageMetadata().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserPageMetadata, a, b);
    }
}
BrowserPageMetadata.runtime = proto3;
BrowserPageMetadata.typeName = "exa.codeium_common_pb.BrowserPageMetadata";
BrowserPageMetadata.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "page_title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "viewport_width", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "viewport_height", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 6, name: "favicon_url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "last_visited_time", kind: "message", T: Timestamp },
]);
/**
 * @generated from message exa.codeium_common_pb.BrowserClickInteraction
 */
export class BrowserClickInteraction extends Message {
    constructor(data) {
        super();
        /**
         * Viewport metadata at the time of the click.
         *
         * Horizontal scroll position of the viewport.
         *
         * @generated from field: uint32 viewport_scroll_x = 1;
         */
        this.viewportScrollX = 0;
        /**
         * Vertical scroll position of the viewport.
         *
         * @generated from field: uint32 viewport_scroll_y = 2;
         */
        this.viewportScrollY = 0;
        /**
         * Click position relative to the viewport.
         *
         * X position of the click relative to the viewport.
         *
         * @generated from field: uint32 click_x = 3;
         */
        this.clickX = 0;
        /**
         * Y position of the click relative to the viewport.
         *
         * @generated from field: uint32 click_y = 4;
         */
        this.clickY = 0;
        /**
         * Target element that was clicked.
         *
         * @generated from field: string target_element_tag_name = 5;
         */
        this.targetElementTagName = "";
        /**
         * @generated from field: string target_element_x_path = 6;
         */
        this.targetElementXPath = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserClickInteraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserClickInteraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserClickInteraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserClickInteraction, a, b);
    }
}
BrowserClickInteraction.runtime = proto3;
BrowserClickInteraction.typeName = "exa.codeium_common_pb.BrowserClickInteraction";
BrowserClickInteraction.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "viewport_scroll_x", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "viewport_scroll_y", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 3, name: "click_x", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "click_y", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "target_element_tag_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "target_element_x_path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.BrowserScrollInteraction
 */
export class BrowserScrollInteraction extends Message {
    constructor(data) {
        super();
        /**
         * Viewport metadata after the scroll.
         *
         * Horizontal scroll position of the viewport.
         *
         * @generated from field: uint32 viewport_scroll_x = 1;
         */
        this.viewportScrollX = 0;
        /**
         * Vertical scroll position of the viewport.
         *
         * @generated from field: uint32 viewport_scroll_y = 2;
         */
        this.viewportScrollY = 0;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserScrollInteraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserScrollInteraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserScrollInteraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserScrollInteraction, a, b);
    }
}
BrowserScrollInteraction.runtime = proto3;
BrowserScrollInteraction.typeName = "exa.codeium_common_pb.BrowserScrollInteraction";
BrowserScrollInteraction.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "viewport_scroll_x", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "viewport_scroll_y", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
]);
/**
 * @generated from message exa.codeium_common_pb.BrowserInteraction
 */
export class BrowserInteraction extends Message {
    constructor(data) {
        super();
        /**
         * The interaction that occurred.
         *
         * @generated from oneof exa.codeium_common_pb.BrowserInteraction.interaction
         */
        this.interaction = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new BrowserInteraction().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new BrowserInteraction().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new BrowserInteraction().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(BrowserInteraction, a, b);
    }
}
BrowserInteraction.runtime = proto3;
BrowserInteraction.typeName = "exa.codeium_common_pb.BrowserInteraction";
BrowserInteraction.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "timestamp", kind: "message", T: Timestamp },
    { no: 2, name: "page_metadata", kind: "message", T: BrowserPageMetadata },
    { no: 3, name: "click", kind: "message", T: BrowserClickInteraction, oneof: "interaction" },
    { no: 4, name: "scroll", kind: "message", T: BrowserScrollInteraction, oneof: "interaction" },
]);
/**
 * @generated from message exa.codeium_common_pb.MetricsRecord
 */
export class MetricsRecord extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string name = 1;
         */
        this.name = "";
        /**
         * @generated from field: float value = 2;
         */
        this.value = 0;
        /**
         * @generated from field: map<string, string> details = 3;
         */
        this.details = {};
        /**
         * If a lower value is considered better.
         *
         * @generated from field: bool lower_better = 4;
         */
        this.lowerBetter = false;
        /**
         * If 1 should be interpreted as true and 0 as false.
         *
         * @generated from field: bool is_bool = 5;
         */
        this.isBool = false;
        /**
         * If non-empty, then will be considered an error.
         *
         * @generated from field: string error = 6;
         */
        this.error = "";
        /**
         * Trajectory id corresponding to the generator metadata producing this record.
         * Used primarily for LLM judge-based metrics. Empty if not applicable. If populated
         * assumed to be metadata index 0.
         *
         * @generated from field: string trajectory_id = 7;
         */
        this.trajectoryId = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new MetricsRecord().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MetricsRecord().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MetricsRecord().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MetricsRecord, a, b);
    }
}
MetricsRecord.runtime = proto3;
MetricsRecord.typeName = "exa.codeium_common_pb.MetricsRecord";
MetricsRecord.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "value", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "details", kind: "map", K: 9 /* ScalarType.STRING */, V: { kind: "scalar", T: 9 /* ScalarType.STRING */ } },
    { no: 4, name: "lower_better", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "is_bool", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "error", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "trajectory_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.ModelNotification
 */
export class ModelNotification extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.Model model = 1;
         */
        this.model = Model.MODEL_UNSPECIFIED;
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelNotification().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelNotification().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelNotification().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelNotification, a, b);
    }
}
ModelNotification.runtime = proto3;
ModelNotification.typeName = "exa.codeium_common_pb.ModelNotification";
ModelNotification.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model", kind: "enum", T: proto3.getEnumType(Model) },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * used to show warning messages in the Cascade model dropdown
 *
 * @generated from message exa.codeium_common_pb.ModelNotificationExperimentPayload
 */
export class ModelNotificationExperimentPayload extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.ModelNotification model_notifications = 1;
         */
        this.modelNotifications = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ModelNotificationExperimentPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ModelNotificationExperimentPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ModelNotificationExperimentPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ModelNotificationExperimentPayload, a, b);
    }
}
ModelNotificationExperimentPayload.runtime = proto3;
ModelNotificationExperimentPayload.typeName = "exa.codeium_common_pb.ModelNotificationExperimentPayload";
ModelNotificationExperimentPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "model_notifications", kind: "message", T: ModelNotification, repeated: true },
]);
/**
 * A semantic reference to some symbol. This is not the original symbol being referenced, but rather
 * a location where the symbol is invoked.
 *
 * @generated from message exa.codeium_common_pb.LspReference
 */
export class LspReference extends Message {
    constructor(data) {
        super();
        /**
         * URI string of the file containing the reference
         *
         * @generated from field: string uri = 1;
         */
        this.uri = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new LspReference().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new LspReference().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new LspReference().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(LspReference, a, b);
    }
}
LspReference.runtime = proto3;
LspReference.typeName = "exa.codeium_common_pb.LspReference";
LspReference.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "range", kind: "message", T: Range },
    { no: 3, name: "snippet", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
]);
/**
 * @generated from message exa.codeium_common_pb.CascadeModelHeaderWarningExperimentPayload
 */
export class CascadeModelHeaderWarningExperimentPayload extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string text = 1;
         */
        this.text = "";
        /**
         * @generated from field: string tooltip_text = 2;
         */
        this.tooltipText = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CascadeModelHeaderWarningExperimentPayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CascadeModelHeaderWarningExperimentPayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CascadeModelHeaderWarningExperimentPayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CascadeModelHeaderWarningExperimentPayload, a, b);
    }
}
CascadeModelHeaderWarningExperimentPayload.runtime = proto3;
CascadeModelHeaderWarningExperimentPayload.typeName = "exa.codeium_common_pb.CascadeModelHeaderWarningExperimentPayload";
CascadeModelHeaderWarningExperimentPayload.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "tooltip_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message exa.codeium_common_pb.CodeAnnotation
 */
export class CodeAnnotation extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = "";
        /**
         * @generated from field: string uri = 2;
         */
        this.uri = "";
        /**
         * @generated from field: uint32 line = 3;
         */
        this.line = 0;
        /**
         * @generated from field: string content = 4;
         */
        this.content = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodeAnnotation().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodeAnnotation().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodeAnnotation().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodeAnnotation, a, b);
    }
}
CodeAnnotation.runtime = proto3;
CodeAnnotation.typeName = "exa.codeium_common_pb.CodeAnnotation";
CodeAnnotation.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "uri", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "line", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "content", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_at", kind: "message", T: Timestamp },
]);
/**
 * @generated from message exa.codeium_common_pb.CodeAnnotationsState
 */
export class CodeAnnotationsState extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: repeated exa.codeium_common_pb.CodeAnnotation annotations = 1;
         */
        this.annotations = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CodeAnnotationsState().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CodeAnnotationsState().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CodeAnnotationsState().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CodeAnnotationsState, a, b);
    }
}
CodeAnnotationsState.runtime = proto3;
CodeAnnotationsState.typeName = "exa.codeium_common_pb.CodeAnnotationsState";
CodeAnnotationsState.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "annotations", kind: "message", T: CodeAnnotation, repeated: true },
]);
/**
 * Describes the trajectory that was searched.
 *
 * @generated from message exa.codeium_common_pb.TrajectoryDescription
 */
export class TrajectoryDescription extends Message {
    constructor(data) {
        super();
        /**
         * @generated from oneof exa.codeium_common_pb.TrajectoryDescription.description
         */
        this.description = { case: undefined };
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new TrajectoryDescription().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new TrajectoryDescription().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new TrajectoryDescription().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(TrajectoryDescription, a, b);
    }
}
TrajectoryDescription.runtime = proto3;
TrajectoryDescription.typeName = "exa.codeium_common_pb.TrajectoryDescription";
TrajectoryDescription.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "cascade_conversation_title", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "description" },
    { no: 2, name: "mainline_branch_name", kind: "scalar", T: 9 /* ScalarType.STRING */, oneof: "description" },
]);
/**
 * @generated from message exa.codeium_common_pb.ThirdPartyWebSearchConfig
 */
export class ThirdPartyWebSearchConfig extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: exa.codeium_common_pb.ThirdPartyWebSearchProvider provider = 1;
         */
        this.provider = ThirdPartyWebSearchProvider.UNSPECIFIED;
        /**
         * @generated from field: exa.codeium_common_pb.ThirdPartyWebSearchModel model = 2;
         */
        this.model = ThirdPartyWebSearchModel.UNSPECIFIED;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ThirdPartyWebSearchConfig().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ThirdPartyWebSearchConfig().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ThirdPartyWebSearchConfig().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ThirdPartyWebSearchConfig, a, b);
    }
}
ThirdPartyWebSearchConfig.runtime = proto3;
ThirdPartyWebSearchConfig.typeName = "exa.codeium_common_pb.ThirdPartyWebSearchConfig";
ThirdPartyWebSearchConfig.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "provider", kind: "enum", T: proto3.getEnumType(ThirdPartyWebSearchProvider) },
    { no: 2, name: "model", kind: "enum", T: proto3.getEnumType(ThirdPartyWebSearchModel) },
]);
/**
 * @generated from message exa.codeium_common_pb.GRPCStatus
 */
export class GRPCStatus extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: int32 code = 1;
         */
        this.code = 0;
        /**
         * @generated from field: string message = 2;
         */
        this.message = "";
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new GRPCStatus().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GRPCStatus().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GRPCStatus().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GRPCStatus, a, b);
    }
}
GRPCStatus.runtime = proto3;
GRPCStatus.typeName = "exa.codeium_common_pb.GRPCStatus";
GRPCStatus.fields = proto3.util.newFieldList(() => [
    { no: 1, name: "code", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
